/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Predictions API
 * API documentation for Predictions
 * OpenAPI spec version: 1.24.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import { useCallback } from 'react';

import type {
  AcceptDocumentDto,
  AcceptanceResultDto,
  AcceptanceStatsResponseDto,
  AccessTokenResponseDto,
  ActiveOutcomesDto,
  ActiveShiftResponseDto,
  AddressSuggestionsResponseDto,
  AdminAdminsListParams,
  AdminAuditLogEntryDto,
  AdminAuditLogListParams,
  AdminAuditLogListResponseDto,
  AdminBannerDto,
  AdminCashBackGroupDto,
  AdminCategoryDto,
  AdminCategoryListResponseDto,
  AdminCommentListResponseDto,
  AdminCommentReportListResponseDto,
  AdminCommentsListParams,
  AdminCommentsListReportsParams,
  AdminDepositListResponseDto,
  AdminDepositResponseDto,
  AdminDepositsGetListParams,
  AdminEventListResponseDto,
  AdminEventsListEventsParams,
  AdminEventsMarketsListPriceCubesParams,
  AdminExperienceAssignmentListResponseDto,
  AdminExperienceAssignmentResponseDto,
  AdminExperienceAssignmentsListParams,
  AdminExperienceDetailResponseDto,
  AdminExperienceFullResponseDto,
  AdminExperienceListResponseDto,
  AdminExperiencesListParams,
  AdminGalleryListParams,
  AdminGalleryUploadParams,
  AdminKillSwitchDto,
  AdminListResponseDto,
  AdminLoginRequestDto,
  AdminLoginResponseDto,
  AdminMarketListResponseDto,
  AdminMarketResponseDto,
  AdminMarketsGetListParams,
  AdminMeResponseDto,
  AdminMockUsersListParams,
  AdminMonetizationAnalyticsExperienceParams,
  AdminMonetizationAnalyticsMintVolumeParams,
  AdminMonetizationAnalyticsUserTimelineParams,
  AdminPlaeeCustomerDataResponseDto,
  AdminResponseDto,
  AdminSectionResponseDto,
  AdminSnakeMarketsListPriceCubesParams,
  AdminSubCategoryDto,
  AdminTerritoryCountriesListParams,
  AdminTerritoryStatesListParams,
  AdminTransactionDetailDto,
  AdminTransactionListResponseDto,
  AdminTransactionsBalanceHistoryParams,
  AdminTransactionsCashBackBalanceParams,
  AdminTransactionsCashBackBreakdownParams,
  AdminTransactionsExportTransactionsParams,
  AdminTransactionsListParams,
  AdminUpdateUserDto,
  AdminUserIntercomConversationsDto,
  AdminUserKycActionsResponseDto,
  AdminUserKycResponseDto,
  AdminUserListResponseDto,
  AdminUserMonetizationResponseDto,
  AdminUserNotificationsResponseDto,
  AdminUserShowResponseDto,
  AdminUserWalletResponseDto,
  AdminUserWithdrawalsResponseDto,
  AdminUsersGetUserWithdrawalsParams,
  AdminUsersGetUsersParams,
  AdminWithdrawMethodResponseDto,
  AdminWithdrawalListResponseDto,
  AdminWithdrawalResponseDto,
  AdminWithdrawalsGetListParams,
  AmendOrderDto,
  AssignExperienceDto,
  AssignTagDto,
  AvailableCurrencyDto,
  BalanceHistoryDto,
  BannerAdminListParams,
  BannerBannersParams,
  BannerConfigResponseDto,
  BannersResponseDto,
  BulkAssignDto,
  BulkAssignResultResponseDto,
  BulkRejectWithdrawalsDto,
  BulkWithdrawalIdsDto,
  BulkWithdrawalResultDto,
  BuyInFooterGetParams,
  CancelOrderDto,
  CashBackBalanceDto,
  CashBackSummaryDto,
  CategoryResponseDto,
  CategorySetDetailDto,
  CategorySetEntityDto,
  CategorySetListResponseDto,
  ChangeBannerStatusDto,
  CheckGeoComplianceDto,
  CommentBanDto,
  CommentBanResponseDto,
  CommentLikeResponseDto,
  CommentListResponseDto,
  CommentResponseDto,
  CommentsListParams,
  CommentsMeResponseDto,
  CommentsRepliesParams,
  CreateAdminDto,
  CreateBannerDto,
  CreateCategorySetDto,
  CreateCommentDto,
  CreateCountryDto,
  CreateCurrencyConfigDto,
  CreateDocumentDto,
  CreateExperienceDto,
  CreateFooterDto,
  CreateIdentityLevelRuleDto,
  CreateMockUsersDto,
  CreateMockUsersResponseDto,
  CreatePermissionDto,
  CreatePriceCubeDto,
  CreateResolutionConfigDto,
  CreateRoleDto,
  CreateSegmentDto,
  CreateSnakePriceCubeDto,
  CreateStateDto,
  CreateStoreDto,
  CreateTagDto,
  CreateVariationDto,
  CreateVersionDto,
  CreateWithdrawMethodDto,
  CreateWithdrawalDto,
  CreateWithdrawalSetupSessionDto,
  CurrencyConfigDeleteResponseDto,
  CurrencyConfigResponseDto,
  DashboardMetricsDto,
  DeleteMockUserResponseDto,
  DepositLimitResponseDto,
  DepositListItemDto,
  DepositListParams,
  DepositStatusResponseDto,
  DocumentResponseDto,
  DocumentVersionResponseDto,
  DuplicateExperienceDto,
  DuplicateExperienceResponseDto,
  EmailVerificationStateDto,
  EventDetailDto,
  ExperienceAnalyticsResponseDto,
  ExperienceVersionResponseDto,
  ExperienceVersionWithVariationsResponseDto,
  FooterGetParams,
  FooterResponseDto,
  ForgotPasswordRequestDto,
  FundMockUserDto,
  FundMockUserResponseDto,
  GalleryImageDto,
  GeoComplianceResponseDto,
  GiftRewardResponseDto,
  GoogleAddressAutocompleteParams,
  GoogleAddressDetailsParams,
  GoogleAddressZipLookupParams,
  IdentityLevelRuleDeleteResponseDto,
  IdentityLevelRuleDto,
  IdentityLevelRulesResponseDto,
  IngestNotificationAckDto,
  IngestNotificationDto,
  InitiateDepositDto,
  InitiateDepositResponseDto,
  InstrumentListResponseDto,
  InstrumentSnapshotsResponseDto,
  IntercomIdentityDto,
  KillSwitchTargetsDto,
  KycActionTriggerResponseDto,
  KycApplicantPreviewResponseDto,
  KycOverrideStatusResponseDto,
  KycResetResponseDto,
  KycStatusResponseDto,
  KycTriggerResponseDto,
  KycWebhookEventsResponseDto,
  LivePageConfigResponseDto,
  LivePageResponseDto,
  LobbyConfigResponseDto,
  LobbyResponseDto,
  LoginRequestDto,
  LoginResponseDto,
  MarkAllReadResponseDto,
  MeResponseDto,
  MintVolumeResponseDto,
  MockOrderResultDto,
  MockUserDetailDto,
  MockUserListResponseDto,
  NotificationConfigResponseDto,
  NotificationFeatureResponseDto,
  NotificationGlobalConfigResponseDto,
  NotificationListResponseDto,
  NotificationResponseDto,
  NotificationStatsResponseDto,
  NotificationsListParams,
  NotificationsMarkAllReadParams,
  NotificationsUnreadCountParams,
  OfferOptionResponseDto,
  OrderCountsResponseDto,
  OverrideActionDto,
  OverrideKycDto,
  PaymentSessionResponseDto,
  PendingDocumentDto,
  PermissionDetailResponseDto,
  PermissionListResponseDto,
  PermissionResponseDto,
  PinEventDto,
  PinnedEventResponseDto,
  PlaceDetailsResponseDto,
  PlaceMockOrderDto,
  PlaceOrderDto,
  PlaeeBalanceDto,
  PlaeeBalanceResponseDto,
  PlaeeCreditDto,
  PlaeeCustomerDataResponseDto,
  PlaeeCustomerLoginResponseDto,
  PlaeeDebitDto,
  PlaeeOrderBookResponseDto,
  PlaeeOrderExecutionResultDto,
  PlaeeOrderResponseDto,
  PlaeePnlDataPointDto,
  PlaeePortfolioResponseDto,
  PlaeePositionResponseDto,
  PlaeeRetryAccountsResponseDto,
  PlaeeTradeResponseDto,
  PlaeeWalletOpResponseDto,
  PositionCountsResponseDto,
  PredictionMarketConfigResolvePriceCubeParams,
  PredictionMarketEventsFindLobbyParams,
  PredictionMarketEventsGetPriceHistoryParams,
  PredictionMarketInstrumentsGetSnapshotsParams,
  PredictionMarketSearchParams,
  PriceCubeDeleteResponseDto,
  PriceCubeResolvedDto,
  PriceCubeResponseDto,
  PriceHistoryResponseDto,
  ProvisionResponseDto,
  PublicDocumentDto,
  PublicFooterDto,
  PublishVersionDto,
  PutTargetingDto,
  RealtimeAuthResponseDto,
  RecordActionDto,
  RecordImpressionDto,
  RegisterCustomerDto,
  RejectWithdrawalDto,
  ReorderIdentityLevelRulesDto,
  ReplaceItemsDto,
  ReportCommentDto,
  ResetDepositLimitDto,
  ResolutionConfigDeleteResponseDto,
  ResolutionConfigResponseDto,
  RoleListResponseDto,
  RoleResponseDto,
  RoleWithPermissionsResponseDto,
  RunScenarioDto,
  SaveExperienceDto,
  ScenarioResultDto,
  SearchResponseDto,
  SectionResponseDto,
  SegmentAssignmentEntityDto,
  SegmentAssignmentListResponseDto,
  SegmentMembersDto,
  SegmentResponseDto,
  SegmentStoreAssignmentEntityDto,
  SegmentStoreAssignmentListResponseDto,
  SegmentSummaryResponseDto,
  SendUserNotificationDto,
  ServicesHealthDto,
  SetDepositLimitDto,
  SetGiftRewardDto,
  SetOfferOptionsDto,
  SetPriorityDto,
  ShiftStateResponseDto,
  SkipWithdrawalDto,
  SnakeCurrenciesResponseDto,
  SnakeMarketsFindSeriesHistoryParams,
  SnakeMarketsFindSeriesParams,
  SnakeMarketsGetSeriesPriceHistoryParams,
  SnakeMarketsResolvePriceCubeParams,
  SnakePastMarketResponseDto,
  SnakePriceCubeDeleteResponseDto,
  SnakePriceCubeResponseDto,
  SnakeSectionResponseDto,
  SnakeSeriesHistoryResponseDto,
  SnakeSeriesResponseDto,
  SnakeTabResponseDto,
  SnakeTargetsDto,
  StartTradingSessionDto,
  StopTradingSessionDto,
  StoreConfigResponseDto,
  StoreEntityDto,
  StoreListResponseDto,
  StoreResponseDto,
  SumsubLevelDto,
  SumsubLevelSyncResponseDto,
  SumsubLevelsResponseDto,
  SurfaceItemDto,
  SyncCategoriesResultDto,
  SyncEventsDto,
  SyncEventsResponseDto,
  TagListResponseDto,
  TagResponseDto,
  TargetingResponseDto,
  TerritoryCountryResponseDto,
  TerritoryStateResponseDto,
  ToggleKillSwitchDto,
  TrackRequestDto,
  TradingOrderListOrdersParams,
  TradingPositionGetPnlParams,
  TradingPositionListPositionsParams,
  TradingSessionStatusDto,
  TradingTradeListTradesParams,
  TrendingConfigResponseDto,
  TrendingResponseDto,
  TriggerActionDto,
  UnpinEventResponseDto,
  UnreadCountResponseDto,
  UnreadCountsResponseDto,
  UpdateAdminRoleDto,
  UpdateBannerConfigDto,
  UpdateBannerDto,
  UpdateCategoryDto,
  UpdateCategorySetDto,
  UpdateCountryDto,
  UpdateCurrencyConfigDto,
  UpdateCustomerDto,
  UpdateDocumentDto,
  UpdateDraftDto,
  UpdateFooterDraftDto,
  UpdateFtueStateDto,
  UpdateIdentityLevelRuleDto,
  UpdateLivePageConfigDto,
  UpdateLobbyConfigDto,
  UpdateMarketVisibilityDto,
  UpdateNotificationConfigDto,
  UpdateNotificationGlobalConfigDto,
  UpdatePermissionDto,
  UpdatePriceCubeDto,
  UpdateResolutionConfigDto,
  UpdateRoleDto,
  UpdateSectionsDto,
  UpdateSnakePriceCubeDto,
  UpdateSnakeSectionDto,
  UpdateSnakeSectionsDto,
  UpdateStateDto,
  UpdateStoreDto,
  UpdateSubCategoryDto,
  UpdateSumsubLevelDto,
  UpdateTrendingConfigDto,
  UpdateUsernameDto,
  UpdateVariationDto,
  UpdateVersionDto,
  UpdateWithdrawMethodDto,
  UpdateWithdrawalDto,
  UpsertSegmentAssignmentDto,
  UpsertSegmentStoreAssignmentDto,
  UserExperienceStateDto,
  UserProfileDto,
  UserTimelineResponseDto,
  ValidateAddressDto,
  ValidateAddressResponseDto,
  VariationRemovedResponseDto,
  VariationResponseDto,
  VerifyEmailRequestDto,
  VerifyEmailResponseDto,
  WalletBalanceResponseDto,
  WalletCallbackGetBalanceByQueryParams,
  WithdrawMethodListResponseDto,
  WithdrawMethodResponseDto,
  WithdrawalListParams,
  WithdrawalResponseDto,
  WithdrawalSetupSessionResponseDto,
  ZipLookupResponseDto,
} from './models';

import { useCustomInstance } from './use-custom-instance';

/**
 * @summary Send a client-side log entry
 */
export const useLoggerLogMessageHook = () => {
  const loggerLogMessage = useCustomInstance<void>();

  return useCallback(
    (trackRequestDto: TrackRequestDto, signal?: AbortSignal) => {
      return loggerLogMessage({
        url: `/track`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: trackRequestDto,
        signal,
      });
    },
    [loggerLogMessage],
  );
};

export const useLoggerLogMessageMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useLoggerLogMessageHook>>>,
    TError,
    { data: TrackRequestDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useLoggerLogMessageHook>>>,
  TError,
  { data: TrackRequestDto },
  TContext
> => {
  const mutationKey = ['loggerLogMessage'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const loggerLogMessage = useLoggerLogMessageHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useLoggerLogMessageHook>>>,
    { data: TrackRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return loggerLogMessage(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LoggerLogMessageMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useLoggerLogMessageHook>>>>;
export type LoggerLogMessageMutationBody = TrackRequestDto;
export type LoggerLogMessageMutationError = void;

/**
 * @summary Send a client-side log entry
 */
export const useLoggerLogMessage = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useLoggerLogMessageHook>>>,
      TError,
      { data: TrackRequestDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useLoggerLogMessageHook>>>,
  TError,
  { data: TrackRequestDto },
  TContext
> => {
  const mutationOptions = useLoggerLogMessageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Readiness check
 */
export const useHealthCheckReadinessHook = () => {
  const healthCheckReadiness = useCustomInstance<void>();

  return useCallback(
    (signal?: AbortSignal) => {
      return healthCheckReadiness({ url: `/readyz`, method: 'GET', signal });
    },
    [healthCheckReadiness],
  );
};

export const getHealthCheckReadinessQueryKey = () => {
  return [`/readyz`] as const;
};

export const useHealthCheckReadinessQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useHealthCheckReadinessHook>>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useHealthCheckReadinessHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckReadinessQueryKey();

  const healthCheckReadiness = useHealthCheckReadinessHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useHealthCheckReadinessHook>>>> = ({ signal }) =>
    healthCheckReadiness(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useHealthCheckReadinessHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type HealthCheckReadinessQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useHealthCheckReadinessHook>>>
>;
export type HealthCheckReadinessQueryError = void;

export function useHealthCheckReadiness<
  TData = Awaited<ReturnType<ReturnType<typeof useHealthCheckReadinessHook>>>,
  TError = void,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useHealthCheckReadinessHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useHealthCheckReadinessHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useHealthCheckReadinessHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHealthCheckReadiness<
  TData = Awaited<ReturnType<ReturnType<typeof useHealthCheckReadinessHook>>>,
  TError = void,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useHealthCheckReadinessHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useHealthCheckReadinessHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useHealthCheckReadinessHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHealthCheckReadiness<
  TData = Awaited<ReturnType<ReturnType<typeof useHealthCheckReadinessHook>>>,
  TError = void,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useHealthCheckReadinessHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Readiness check
 */

export function useHealthCheckReadiness<
  TData = Awaited<ReturnType<ReturnType<typeof useHealthCheckReadinessHook>>>,
  TError = void,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useHealthCheckReadinessHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useHealthCheckReadinessQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Liveness check
 */
export const useHealthCheckLivenessHook = () => {
  const healthCheckLiveness = useCustomInstance<void>();

  return useCallback(
    (signal?: AbortSignal) => {
      return healthCheckLiveness({ url: `/healthz`, method: 'GET', signal });
    },
    [healthCheckLiveness],
  );
};

export const getHealthCheckLivenessQueryKey = () => {
  return [`/healthz`] as const;
};

export const useHealthCheckLivenessQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useHealthCheckLivenessHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useHealthCheckLivenessHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getHealthCheckLivenessQueryKey();

  const healthCheckLiveness = useHealthCheckLivenessHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useHealthCheckLivenessHook>>>> = ({ signal }) =>
    healthCheckLiveness(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useHealthCheckLivenessHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type HealthCheckLivenessQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useHealthCheckLivenessHook>>>>;
export type HealthCheckLivenessQueryError = unknown;

export function useHealthCheckLiveness<
  TData = Awaited<ReturnType<ReturnType<typeof useHealthCheckLivenessHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useHealthCheckLivenessHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useHealthCheckLivenessHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useHealthCheckLivenessHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHealthCheckLiveness<
  TData = Awaited<ReturnType<ReturnType<typeof useHealthCheckLivenessHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useHealthCheckLivenessHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useHealthCheckLivenessHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useHealthCheckLivenessHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useHealthCheckLiveness<
  TData = Awaited<ReturnType<ReturnType<typeof useHealthCheckLivenessHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useHealthCheckLivenessHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Liveness check
 */

export function useHealthCheckLiveness<
  TData = Awaited<ReturnType<ReturnType<typeof useHealthCheckLivenessHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useHealthCheckLivenessHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useHealthCheckLivenessQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Prometheus metrics endpoint (scrape-only, basic-auth in prod)
 */
export const useMetricsGetMetricsHook = () => {
  const metricsGetMetrics = useCustomInstance<void>();

  return useCallback(
    (signal?: AbortSignal) => {
      return metricsGetMetrics({ url: `/prediction/metrics`, method: 'GET', signal });
    },
    [metricsGetMetrics],
  );
};

export const getMetricsGetMetricsQueryKey = () => {
  return [`/prediction/metrics`] as const;
};

export const useMetricsGetMetricsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useMetricsGetMetricsHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMetricsGetMetricsHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMetricsGetMetricsQueryKey();

  const metricsGetMetrics = useMetricsGetMetricsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useMetricsGetMetricsHook>>>> = ({ signal }) =>
    metricsGetMetrics(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useMetricsGetMetricsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type MetricsGetMetricsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useMetricsGetMetricsHook>>>>;
export type MetricsGetMetricsQueryError = unknown;

export function useMetricsGetMetrics<
  TData = Awaited<ReturnType<ReturnType<typeof useMetricsGetMetricsHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMetricsGetMetricsHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useMetricsGetMetricsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useMetricsGetMetricsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMetricsGetMetrics<
  TData = Awaited<ReturnType<ReturnType<typeof useMetricsGetMetricsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMetricsGetMetricsHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useMetricsGetMetricsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useMetricsGetMetricsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMetricsGetMetrics<
  TData = Awaited<ReturnType<ReturnType<typeof useMetricsGetMetricsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMetricsGetMetricsHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Prometheus metrics endpoint (scrape-only, basic-auth in prod)
 */

export function useMetricsGetMetrics<
  TData = Awaited<ReturnType<ReturnType<typeof useMetricsGetMetricsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMetricsGetMetricsHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useMetricsGetMetricsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Login with Firebase ID token
 */
export const useAuthenticationLoginHook = () => {
  const authenticationLogin = useCustomInstance<LoginResponseDto>();

  return useCallback(
    (loginRequestDto: LoginRequestDto, signal?: AbortSignal) => {
      return authenticationLogin({
        url: `/auth/login`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: loginRequestDto,
        signal,
      });
    },
    [authenticationLogin],
  );
};

export const useAuthenticationLoginMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAuthenticationLoginHook>>>,
    TError,
    { data: LoginRequestDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAuthenticationLoginHook>>>,
  TError,
  { data: LoginRequestDto },
  TContext
> => {
  const mutationKey = ['authenticationLogin'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const authenticationLogin = useAuthenticationLoginHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAuthenticationLoginHook>>>,
    { data: LoginRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return authenticationLogin(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthenticationLoginMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAuthenticationLoginHook>>>
>;
export type AuthenticationLoginMutationBody = LoginRequestDto;
export type AuthenticationLoginMutationError = void;

/**
 * @summary Login with Firebase ID token
 */
export const useAuthenticationLogin = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAuthenticationLoginHook>>>,
      TError,
      { data: LoginRequestDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAuthenticationLoginHook>>>,
  TError,
  { data: LoginRequestDto },
  TContext
> => {
  const mutationOptions = useAuthenticationLoginMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Call when the signed access token expires: present a freshly force-refreshed Firebase ID token to mint a new access token with up-to-date profile claims. Never registers an account — an unknown user gets 401 and must POST /auth/login.
 * @summary Refresh the access token from a live Firebase session
 */
export const useAuthenticationRefreshHook = () => {
  const authenticationRefresh = useCustomInstance<LoginResponseDto>();

  return useCallback(
    (loginRequestDto: LoginRequestDto, signal?: AbortSignal) => {
      return authenticationRefresh({
        url: `/auth/refresh`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: loginRequestDto,
        signal,
      });
    },
    [authenticationRefresh],
  );
};

export const useAuthenticationRefreshMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAuthenticationRefreshHook>>>,
    TError,
    { data: LoginRequestDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAuthenticationRefreshHook>>>,
  TError,
  { data: LoginRequestDto },
  TContext
> => {
  const mutationKey = ['authenticationRefresh'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const authenticationRefresh = useAuthenticationRefreshHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAuthenticationRefreshHook>>>,
    { data: LoginRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return authenticationRefresh(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthenticationRefreshMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAuthenticationRefreshHook>>>
>;
export type AuthenticationRefreshMutationBody = LoginRequestDto;
export type AuthenticationRefreshMutationError = void;

/**
 * @summary Refresh the access token from a live Firebase session
 */
export const useAuthenticationRefresh = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAuthenticationRefreshHook>>>,
      TError,
      { data: LoginRequestDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAuthenticationRefreshHook>>>,
  TError,
  { data: LoginRequestDto },
  TContext
> => {
  const mutationOptions = useAuthenticationRefreshMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Emails a reset link pointing at our own /reset-password page (the Firebase oobCode is delivered via our branded SES email, never Firebase's hosted page). Always returns 204 regardless of whether the email is registered — the response never discloses account existence. Rate-limited per address.
 * @summary Send a branded Crown Prediction password-reset link
 */
export const useAuthenticationForgotPasswordHook = () => {
  const authenticationForgotPassword = useCustomInstance<void>();

  return useCallback(
    (forgotPasswordRequestDto: ForgotPasswordRequestDto, signal?: AbortSignal) => {
      return authenticationForgotPassword({
        url: `/auth/forgot-password`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: forgotPasswordRequestDto,
        signal,
      });
    },
    [authenticationForgotPassword],
  );
};

export const useAuthenticationForgotPasswordMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAuthenticationForgotPasswordHook>>>,
    TError,
    { data: ForgotPasswordRequestDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAuthenticationForgotPasswordHook>>>,
  TError,
  { data: ForgotPasswordRequestDto },
  TContext
> => {
  const mutationKey = ['authenticationForgotPassword'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const authenticationForgotPassword = useAuthenticationForgotPasswordHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAuthenticationForgotPasswordHook>>>,
    { data: ForgotPasswordRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return authenticationForgotPassword(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthenticationForgotPasswordMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAuthenticationForgotPasswordHook>>>
>;
export type AuthenticationForgotPasswordMutationBody = ForgotPasswordRequestDto;
export type AuthenticationForgotPasswordMutationError = unknown;

/**
 * @summary Send a branded Crown Prediction password-reset link
 */
export const useAuthenticationForgotPassword = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAuthenticationForgotPasswordHook>>>,
      TError,
      { data: ForgotPasswordRequestDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAuthenticationForgotPasswordHook>>>,
  TError,
  { data: ForgotPasswordRequestDto },
  TContext
> => {
  const mutationOptions = useAuthenticationForgotPasswordMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Returns the live auth-service profile (verification flags, address, KYC). Source of truth for status that may be stale in the access-token claims — the FE reads this after a verify step before refreshing its token.
 * @summary Get the authenticated user's current profile
 */
export const useAuthenticationMeHook = () => {
  const authenticationMe = useCustomInstance<MeResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return authenticationMe({ url: `/auth/me`, method: 'GET', signal });
    },
    [authenticationMe],
  );
};

export const getAuthenticationMeQueryKey = () => {
  return [`/auth/me`] as const;
};

export const useAuthenticationMeQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAuthenticationMeHook>>>,
  TError = void,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAuthenticationMeHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAuthenticationMeQueryKey();

  const authenticationMe = useAuthenticationMeHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAuthenticationMeHook>>>> = ({ signal }) =>
    authenticationMe(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAuthenticationMeHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AuthenticationMeQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAuthenticationMeHook>>>>;
export type AuthenticationMeQueryError = void;

export function useAuthenticationMe<TData = Awaited<ReturnType<ReturnType<typeof useAuthenticationMeHook>>>, TError = void>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAuthenticationMeHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAuthenticationMeHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAuthenticationMeHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAuthenticationMe<TData = Awaited<ReturnType<ReturnType<typeof useAuthenticationMeHook>>>, TError = void>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAuthenticationMeHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAuthenticationMeHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAuthenticationMeHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAuthenticationMe<TData = Awaited<ReturnType<ReturnType<typeof useAuthenticationMeHook>>>, TError = void>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAuthenticationMeHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the authenticated user's current profile
 */

export function useAuthenticationMe<TData = Awaited<ReturnType<ReturnType<typeof useAuthenticationMeHook>>>, TError = void>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAuthenticationMeHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAuthenticationMeQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Generates a Firebase email-verification action link and delivers it via SES. No-op if the email is already verified upstream.
 * @summary Send the branded Crown Prediction email-verification link to the authenticated user
 */
export const useAuthenticationSendVerificationEmailHook = () => {
  const authenticationSendVerificationEmail = useCustomInstance<void>();

  return useCallback(
    (signal?: AbortSignal) => {
      return authenticationSendVerificationEmail({ url: `/auth/send-verification-email`, method: 'POST', signal });
    },
    [authenticationSendVerificationEmail],
  );
};

export const useAuthenticationSendVerificationEmailMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAuthenticationSendVerificationEmailHook>>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAuthenticationSendVerificationEmailHook>>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['authenticationSendVerificationEmail'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const authenticationSendVerificationEmail = useAuthenticationSendVerificationEmailHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAuthenticationSendVerificationEmailHook>>>,
    void
  > = () => {
    return authenticationSendVerificationEmail();
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthenticationSendVerificationEmailMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAuthenticationSendVerificationEmailHook>>>
>;

export type AuthenticationSendVerificationEmailMutationError = void;

/**
 * @summary Send the branded Crown Prediction email-verification link to the authenticated user
 */
export const useAuthenticationSendVerificationEmail = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAuthenticationSendVerificationEmailHook>>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAuthenticationSendVerificationEmailHook>>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = useAuthenticationSendVerificationEmailMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Redis-backed: whether a verification email is outstanding, when it was last sent, and the resend cooldown. The FE reads this so a page refresh reflects the real state instead of blindly re-sending.
 * @summary Email-verification send state for the authenticated user
 */
export const useAuthenticationEmailVerificationStateHook = () => {
  const authenticationEmailVerificationState = useCustomInstance<EmailVerificationStateDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return authenticationEmailVerificationState({ url: `/auth/email-verification-state`, method: 'GET', signal });
    },
    [authenticationEmailVerificationState],
  );
};

export const getAuthenticationEmailVerificationStateQueryKey = () => {
  return [`/auth/email-verification-state`] as const;
};

export const useAuthenticationEmailVerificationStateQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAuthenticationEmailVerificationStateHook>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAuthenticationEmailVerificationStateHook>>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAuthenticationEmailVerificationStateQueryKey();

  const authenticationEmailVerificationState = useAuthenticationEmailVerificationStateHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAuthenticationEmailVerificationStateHook>>>> = ({
    signal,
  }) => authenticationEmailVerificationState(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAuthenticationEmailVerificationStateHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AuthenticationEmailVerificationStateQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAuthenticationEmailVerificationStateHook>>>
>;
export type AuthenticationEmailVerificationStateQueryError = void;

export function useAuthenticationEmailVerificationState<
  TData = Awaited<ReturnType<ReturnType<typeof useAuthenticationEmailVerificationStateHook>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAuthenticationEmailVerificationStateHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAuthenticationEmailVerificationStateHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAuthenticationEmailVerificationStateHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAuthenticationEmailVerificationState<
  TData = Awaited<ReturnType<ReturnType<typeof useAuthenticationEmailVerificationStateHook>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAuthenticationEmailVerificationStateHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAuthenticationEmailVerificationStateHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAuthenticationEmailVerificationStateHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAuthenticationEmailVerificationState<
  TData = Awaited<ReturnType<ReturnType<typeof useAuthenticationEmailVerificationStateHook>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAuthenticationEmailVerificationStateHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Email-verification send state for the authenticated user
 */

export function useAuthenticationEmailVerificationState<
  TData = Awaited<ReturnType<ReturnType<typeof useAuthenticationEmailVerificationStateHook>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAuthenticationEmailVerificationStateHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAuthenticationEmailVerificationStateQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Call once the user has opened the Firebase verification link. If the client force-refreshed the ID token the `email_verified` claim is trusted; otherwise the server reads the live Firebase user record so a stale token does not block a genuinely-verified email.
 * @summary Confirm Firebase email verification and mirror the state on auth-service
 */
export const useAuthenticationVerifyEmailHook = () => {
  const authenticationVerifyEmail = useCustomInstance<VerifyEmailResponseDto>();

  return useCallback(
    (verifyEmailRequestDto: VerifyEmailRequestDto, signal?: AbortSignal) => {
      return authenticationVerifyEmail({
        url: `/auth/verify-email`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: verifyEmailRequestDto,
        signal,
      });
    },
    [authenticationVerifyEmail],
  );
};

export const useAuthenticationVerifyEmailMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAuthenticationVerifyEmailHook>>>,
    TError,
    { data: VerifyEmailRequestDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAuthenticationVerifyEmailHook>>>,
  TError,
  { data: VerifyEmailRequestDto },
  TContext
> => {
  const mutationKey = ['authenticationVerifyEmail'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const authenticationVerifyEmail = useAuthenticationVerifyEmailHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAuthenticationVerifyEmailHook>>>,
    { data: VerifyEmailRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return authenticationVerifyEmail(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthenticationVerifyEmailMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAuthenticationVerifyEmailHook>>>
>;
export type AuthenticationVerifyEmailMutationBody = VerifyEmailRequestDto;
export type AuthenticationVerifyEmailMutationError = void;

/**
 * @summary Confirm Firebase email verification and mirror the state on auth-service
 */
export const useAuthenticationVerifyEmail = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAuthenticationVerifyEmailHook>>>,
      TError,
      { data: VerifyEmailRequestDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAuthenticationVerifyEmailHook>>>,
  TError,
  { data: VerifyEmailRequestDto },
  TContext
> => {
  const mutationOptions = useAuthenticationVerifyEmailMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Invalidates the user's Firebase refresh tokens, logging them out across all devices.
 * @summary Logout — revoke the Firebase session
 */
export const useAuthenticationLogoutHook = () => {
  const authenticationLogout = useCustomInstance<void>();

  return useCallback(
    (signal?: AbortSignal) => {
      return authenticationLogout({ url: `/auth/logout`, method: 'POST', signal });
    },
    [authenticationLogout],
  );
};

export const useAuthenticationLogoutMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAuthenticationLogoutHook>>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAuthenticationLogoutHook>>>, TError, void, TContext> => {
  const mutationKey = ['authenticationLogout'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const authenticationLogout = useAuthenticationLogoutHook();

  const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useAuthenticationLogoutHook>>>, void> = () => {
    return authenticationLogout();
  };

  return { mutationFn, ...mutationOptions };
};

export type AuthenticationLogoutMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAuthenticationLogoutHook>>>
>;

export type AuthenticationLogoutMutationError = void;

/**
 * @summary Logout — revoke the Firebase session
 */
export const useAuthenticationLogout = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAuthenticationLogoutHook>>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useAuthenticationLogoutHook>>>, TError, void, TContext> => {
  const mutationOptions = useAuthenticationLogoutMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Current published version of a document by key (pre-login readable)
 */
export const useDocumentsGetPublicHook = () => {
  const documentsGetPublic = useCustomInstance<PublicDocumentDto>();

  return useCallback(
    (key: string, signal?: AbortSignal) => {
      return documentsGetPublic({ url: `/documents/${key}/public`, method: 'GET', signal });
    },
    [documentsGetPublic],
  );
};

export const getDocumentsGetPublicQueryKey = (key: string) => {
  return [`/documents/${key}/public`] as const;
};

export const useDocumentsGetPublicQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useDocumentsGetPublicHook>>>,
  TError = void,
>(
  key: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDocumentsGetPublicHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDocumentsGetPublicQueryKey(key);

  const documentsGetPublic = useDocumentsGetPublicHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useDocumentsGetPublicHook>>>> = ({ signal }) =>
    documentsGetPublic(key, signal);

  return { queryKey, queryFn, enabled: !!key, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useDocumentsGetPublicHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DocumentsGetPublicQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDocumentsGetPublicHook>>>>;
export type DocumentsGetPublicQueryError = void;

export function useDocumentsGetPublic<
  TData = Awaited<ReturnType<ReturnType<typeof useDocumentsGetPublicHook>>>,
  TError = void,
>(
  key: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDocumentsGetPublicHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDocumentsGetPublicHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDocumentsGetPublicHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDocumentsGetPublic<
  TData = Awaited<ReturnType<ReturnType<typeof useDocumentsGetPublicHook>>>,
  TError = void,
>(
  key: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDocumentsGetPublicHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDocumentsGetPublicHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDocumentsGetPublicHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDocumentsGetPublic<
  TData = Awaited<ReturnType<ReturnType<typeof useDocumentsGetPublicHook>>>,
  TError = void,
>(
  key: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDocumentsGetPublicHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Current published version of a document by key (pre-login readable)
 */

export function useDocumentsGetPublic<
  TData = Awaited<ReturnType<ReturnType<typeof useDocumentsGetPublicHook>>>,
  TError = void,
>(
  key: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDocumentsGetPublicHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useDocumentsGetPublicQueryOptions(key, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Documents the current user must still accept
 */
export const useDocumentsGetPendingHook = () => {
  const documentsGetPending = useCustomInstance<PendingDocumentDto[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return documentsGetPending({ url: `/documents/pending`, method: 'GET', signal });
    },
    [documentsGetPending],
  );
};

export const getDocumentsGetPendingQueryKey = () => {
  return [`/documents/pending`] as const;
};

export const useDocumentsGetPendingQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useDocumentsGetPendingHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDocumentsGetPendingHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDocumentsGetPendingQueryKey();

  const documentsGetPending = useDocumentsGetPendingHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useDocumentsGetPendingHook>>>> = ({ signal }) =>
    documentsGetPending(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useDocumentsGetPendingHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DocumentsGetPendingQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDocumentsGetPendingHook>>>>;
export type DocumentsGetPendingQueryError = unknown;

export function useDocumentsGetPending<
  TData = Awaited<ReturnType<ReturnType<typeof useDocumentsGetPendingHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDocumentsGetPendingHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDocumentsGetPendingHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDocumentsGetPendingHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDocumentsGetPending<
  TData = Awaited<ReturnType<ReturnType<typeof useDocumentsGetPendingHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDocumentsGetPendingHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDocumentsGetPendingHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDocumentsGetPendingHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDocumentsGetPending<
  TData = Awaited<ReturnType<ReturnType<typeof useDocumentsGetPendingHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDocumentsGetPendingHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Documents the current user must still accept
 */

export function useDocumentsGetPending<
  TData = Awaited<ReturnType<ReturnType<typeof useDocumentsGetPendingHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDocumentsGetPendingHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useDocumentsGetPendingQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Accept the current published version of a document
 */
export const useDocumentsAcceptHook = () => {
  const documentsAccept = useCustomInstance<AcceptanceResultDto>();

  return useCallback(
    (key: string, acceptDocumentDto: AcceptDocumentDto, signal?: AbortSignal) => {
      return documentsAccept({
        url: `/documents/${key}/accept`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: acceptDocumentDto,
        signal,
      });
    },
    [documentsAccept],
  );
};

export const useDocumentsAcceptMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDocumentsAcceptHook>>>,
    TError,
    { key: string; data: AcceptDocumentDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useDocumentsAcceptHook>>>,
  TError,
  { key: string; data: AcceptDocumentDto },
  TContext
> => {
  const mutationKey = ['documentsAccept'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const documentsAccept = useDocumentsAcceptHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useDocumentsAcceptHook>>>,
    { key: string; data: AcceptDocumentDto }
  > = (props) => {
    const { key, data } = props ?? {};

    return documentsAccept(key, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DocumentsAcceptMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDocumentsAcceptHook>>>>;
export type DocumentsAcceptMutationBody = AcceptDocumentDto;
export type DocumentsAcceptMutationError = void;

/**
 * @summary Accept the current published version of a document
 */
export const useDocumentsAccept = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useDocumentsAcceptHook>>>,
      TError,
      { key: string; data: AcceptDocumentDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useDocumentsAcceptHook>>>,
  TError,
  { key: string; data: AcceptDocumentDto },
  TContext
> => {
  const mutationOptions = useDocumentsAcceptMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Register the authenticated user as a Plaee customer
 */
export const usePlaeeCustomerRegisterHook = () => {
  const plaeeCustomerRegister = useCustomInstance<PlaeeCustomerLoginResponseDto>();

  return useCallback(
    (registerCustomerDto: RegisterCustomerDto, signal?: AbortSignal) => {
      return plaeeCustomerRegister({
        url: `/plaee/customer`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: registerCustomerDto,
        signal,
      });
    },
    [plaeeCustomerRegister],
  );
};

export const usePlaeeCustomerRegisterMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerRegisterHook>>>,
    TError,
    { data: RegisterCustomerDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerRegisterHook>>>,
  TError,
  { data: RegisterCustomerDto },
  TContext
> => {
  const mutationKey = ['plaeeCustomerRegister'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const plaeeCustomerRegister = usePlaeeCustomerRegisterHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerRegisterHook>>>,
    { data: RegisterCustomerDto }
  > = (props) => {
    const { data } = props ?? {};

    return plaeeCustomerRegister(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaeeCustomerRegisterMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerRegisterHook>>>
>;
export type PlaeeCustomerRegisterMutationBody = RegisterCustomerDto;
export type PlaeeCustomerRegisterMutationError = unknown;

/**
 * @summary Register the authenticated user as a Plaee customer
 */
export const usePlaeeCustomerRegister = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerRegisterHook>>>,
      TError,
      { data: RegisterCustomerDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerRegisterHook>>>,
  TError,
  { data: RegisterCustomerDto },
  TContext
> => {
  const mutationOptions = usePlaeeCustomerRegisterMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get the authenticated user as a Plaee customer
 */
export const usePlaeeCustomerGetCustomerHook = () => {
  const plaeeCustomerGetCustomer = useCustomInstance<PlaeeCustomerDataResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return plaeeCustomerGetCustomer({ url: `/plaee/customer`, method: 'GET', signal });
    },
    [plaeeCustomerGetCustomer],
  );
};

export const getPlaeeCustomerGetCustomerQueryKey = () => {
  return [`/plaee/customer`] as const;
};

export const usePlaeeCustomerGetCustomerQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerGetCustomerHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerGetCustomerHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPlaeeCustomerGetCustomerQueryKey();

  const plaeeCustomerGetCustomer = usePlaeeCustomerGetCustomerHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerGetCustomerHook>>>> = ({ signal }) =>
    plaeeCustomerGetCustomer(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerGetCustomerHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlaeeCustomerGetCustomerQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerGetCustomerHook>>>
>;
export type PlaeeCustomerGetCustomerQueryError = unknown;

export function usePlaeeCustomerGetCustomer<
  TData = Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerGetCustomerHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerGetCustomerHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerGetCustomerHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerGetCustomerHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlaeeCustomerGetCustomer<
  TData = Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerGetCustomerHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerGetCustomerHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerGetCustomerHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerGetCustomerHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlaeeCustomerGetCustomer<
  TData = Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerGetCustomerHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerGetCustomerHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the authenticated user as a Plaee customer
 */

export function usePlaeeCustomerGetCustomer<
  TData = Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerGetCustomerHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerGetCustomerHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = usePlaeeCustomerGetCustomerQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update the authenticated user Plaee customer profile
 */
export const usePlaeeCustomerUpdateHook = () => {
  const plaeeCustomerUpdate = useCustomInstance<PlaeeCustomerDataResponseDto>();

  return useCallback(
    (updateCustomerDto: UpdateCustomerDto) => {
      return plaeeCustomerUpdate({
        url: `/plaee/customer`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateCustomerDto,
      });
    },
    [plaeeCustomerUpdate],
  );
};

export const usePlaeeCustomerUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerUpdateHook>>>,
    TError,
    { data: UpdateCustomerDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerUpdateHook>>>,
  TError,
  { data: UpdateCustomerDto },
  TContext
> => {
  const mutationKey = ['plaeeCustomerUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const plaeeCustomerUpdate = usePlaeeCustomerUpdateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerUpdateHook>>>,
    { data: UpdateCustomerDto }
  > = (props) => {
    const { data } = props ?? {};

    return plaeeCustomerUpdate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaeeCustomerUpdateMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerUpdateHook>>>
>;
export type PlaeeCustomerUpdateMutationBody = UpdateCustomerDto;
export type PlaeeCustomerUpdateMutationError = unknown;

/**
 * @summary Update the authenticated user Plaee customer profile
 */
export const usePlaeeCustomerUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerUpdateHook>>>,
      TError,
      { data: UpdateCustomerDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerUpdateHook>>>,
  TError,
  { data: UpdateCustomerDto },
  TContext
> => {
  const mutationOptions = usePlaeeCustomerUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Login the authenticated user as a Plaee customer and return a fresh JWT
 */
export const usePlaeeCustomerLoginHook = () => {
  const plaeeCustomerLogin = useCustomInstance<PlaeeCustomerLoginResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return plaeeCustomerLogin({ url: `/plaee/customer/login`, method: 'POST', signal });
    },
    [plaeeCustomerLogin],
  );
};

export const usePlaeeCustomerLoginMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerLoginHook>>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerLoginHook>>>, TError, void, TContext> => {
  const mutationKey = ['plaeeCustomerLogin'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const plaeeCustomerLogin = usePlaeeCustomerLoginHook();

  const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerLoginHook>>>, void> = () => {
    return plaeeCustomerLogin();
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaeeCustomerLoginMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerLoginHook>>>
>;

export type PlaeeCustomerLoginMutationError = unknown;

/**
 * @summary Login the authenticated user as a Plaee customer and return a fresh JWT
 */
export const usePlaeeCustomerLogin = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerLoginHook>>>, TError, void, TContext>;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerLoginHook>>>, TError, void, TContext> => {
  const mutationOptions = usePlaeeCustomerLoginMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Retry creating failed Plaee accounts for the authenticated customer
 */
export const usePlaeeCustomerRetryAccountsHook = () => {
  const plaeeCustomerRetryAccounts = useCustomInstance<PlaeeRetryAccountsResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return plaeeCustomerRetryAccounts({ url: `/plaee/customer/retry-accounts`, method: 'POST', signal });
    },
    [plaeeCustomerRetryAccounts],
  );
};

export const usePlaeeCustomerRetryAccountsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerRetryAccountsHook>>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerRetryAccountsHook>>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['plaeeCustomerRetryAccounts'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const plaeeCustomerRetryAccounts = usePlaeeCustomerRetryAccountsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerRetryAccountsHook>>>,
    void
  > = () => {
    return plaeeCustomerRetryAccounts();
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaeeCustomerRetryAccountsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerRetryAccountsHook>>>
>;

export type PlaeeCustomerRetryAccountsMutationError = unknown;

/**
 * @summary Retry creating failed Plaee accounts for the authenticated customer
 */
export const usePlaeeCustomerRetryAccounts = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerRetryAccountsHook>>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerRetryAccountsHook>>>, TError, void, TContext> => {
  const mutationOptions = usePlaeeCustomerRetryAccountsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Check whether an IP is allowed under the brand's geo policy
 */
export const usePlaeeCustomerCheckGeoComplianceHook = () => {
  const plaeeCustomerCheckGeoCompliance = useCustomInstance<GeoComplianceResponseDto>();

  return useCallback(
    (checkGeoComplianceDto: CheckGeoComplianceDto, signal?: AbortSignal) => {
      return plaeeCustomerCheckGeoCompliance({
        url: `/plaee/customer/check-geo-compliance`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: checkGeoComplianceDto,
        signal,
      });
    },
    [plaeeCustomerCheckGeoCompliance],
  );
};

export const usePlaeeCustomerCheckGeoComplianceMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerCheckGeoComplianceHook>>>,
    TError,
    { data: CheckGeoComplianceDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerCheckGeoComplianceHook>>>,
  TError,
  { data: CheckGeoComplianceDto },
  TContext
> => {
  const mutationKey = ['plaeeCustomerCheckGeoCompliance'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const plaeeCustomerCheckGeoCompliance = usePlaeeCustomerCheckGeoComplianceHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerCheckGeoComplianceHook>>>,
    { data: CheckGeoComplianceDto }
  > = (props) => {
    const { data } = props ?? {};

    return plaeeCustomerCheckGeoCompliance(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaeeCustomerCheckGeoComplianceMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerCheckGeoComplianceHook>>>
>;
export type PlaeeCustomerCheckGeoComplianceMutationBody = CheckGeoComplianceDto;
export type PlaeeCustomerCheckGeoComplianceMutationError = unknown;

/**
 * @summary Check whether an IP is allowed under the brand's geo policy
 */
export const usePlaeeCustomerCheckGeoCompliance = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerCheckGeoComplianceHook>>>,
      TError,
      { data: CheckGeoComplianceDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof usePlaeeCustomerCheckGeoComplianceHook>>>,
  TError,
  { data: CheckGeoComplianceDto },
  TContext
> => {
  const mutationOptions = usePlaeeCustomerCheckGeoComplianceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get the current order book snapshot for an outcome
 */
export const usePlaeeOrderBookGetOrderBookHook = () => {
  const plaeeOrderBookGetOrderBook = useCustomInstance<PlaeeOrderBookResponseDto>();

  return useCallback(
    (outcomeId: string, signal?: AbortSignal) => {
      return plaeeOrderBookGetOrderBook({ url: `/plaee/orderbook/${outcomeId}`, method: 'GET', signal });
    },
    [plaeeOrderBookGetOrderBook],
  );
};

export const getPlaeeOrderBookGetOrderBookQueryKey = (outcomeId: string) => {
  return [`/plaee/orderbook/${outcomeId}`] as const;
};

export const usePlaeeOrderBookGetOrderBookQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof usePlaeeOrderBookGetOrderBookHook>>>,
  TError = unknown,
>(
  outcomeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePlaeeOrderBookGetOrderBookHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPlaeeOrderBookGetOrderBookQueryKey(outcomeId);

  const plaeeOrderBookGetOrderBook = usePlaeeOrderBookGetOrderBookHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof usePlaeeOrderBookGetOrderBookHook>>>> = ({ signal }) =>
    plaeeOrderBookGetOrderBook(outcomeId, signal);

  return { queryKey, queryFn, enabled: !!outcomeId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof usePlaeeOrderBookGetOrderBookHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PlaeeOrderBookGetOrderBookQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePlaeeOrderBookGetOrderBookHook>>>
>;
export type PlaeeOrderBookGetOrderBookQueryError = unknown;

export function usePlaeeOrderBookGetOrderBook<
  TData = Awaited<ReturnType<ReturnType<typeof usePlaeeOrderBookGetOrderBookHook>>>,
  TError = unknown,
>(
  outcomeId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePlaeeOrderBookGetOrderBookHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof usePlaeeOrderBookGetOrderBookHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof usePlaeeOrderBookGetOrderBookHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlaeeOrderBookGetOrderBook<
  TData = Awaited<ReturnType<ReturnType<typeof usePlaeeOrderBookGetOrderBookHook>>>,
  TError = unknown,
>(
  outcomeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePlaeeOrderBookGetOrderBookHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof usePlaeeOrderBookGetOrderBookHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof usePlaeeOrderBookGetOrderBookHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePlaeeOrderBookGetOrderBook<
  TData = Awaited<ReturnType<ReturnType<typeof usePlaeeOrderBookGetOrderBookHook>>>,
  TError = unknown,
>(
  outcomeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePlaeeOrderBookGetOrderBookHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the current order book snapshot for an outcome
 */

export function usePlaeeOrderBookGetOrderBook<
  TData = Awaited<ReturnType<ReturnType<typeof usePlaeeOrderBookGetOrderBookHook>>>,
  TError = unknown,
>(
  outcomeId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePlaeeOrderBookGetOrderBookHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = usePlaeeOrderBookGetOrderBookQueryOptions(outcomeId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Receive Plaee webhook events
 */
export const useWebhooksHandleWebhookHook = () => {
  const webhooksHandleWebhook = useCustomInstance<void>();

  return useCallback(
    (signal?: AbortSignal) => {
      return webhooksHandleWebhook({ url: `/webhooks/plaee`, method: 'POST', signal });
    },
    [webhooksHandleWebhook],
  );
};

export const useWebhooksHandleWebhookMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useWebhooksHandleWebhookHook>>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useWebhooksHandleWebhookHook>>>, TError, void, TContext> => {
  const mutationKey = ['webhooksHandleWebhook'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const webhooksHandleWebhook = useWebhooksHandleWebhookHook();

  const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useWebhooksHandleWebhookHook>>>, void> = () => {
    return webhooksHandleWebhook();
  };

  return { mutationFn, ...mutationOptions };
};

export type WebhooksHandleWebhookMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useWebhooksHandleWebhookHook>>>
>;

export type WebhooksHandleWebhookMutationError = unknown;

/**
 * @summary Receive Plaee webhook events
 */
export const useWebhooksHandleWebhook = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useWebhooksHandleWebhookHook>>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useWebhooksHandleWebhookHook>>>, TError, void, TContext> => {
  const mutationOptions = useWebhooksHandleWebhookMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Receive Plaee price_updated webhooks (dedicated tick lane)
 */
export const usePriceWebhooksHandlePriceWebhookHook = () => {
  const priceWebhooksHandlePriceWebhook = useCustomInstance<void>();

  return useCallback(
    (signal?: AbortSignal) => {
      return priceWebhooksHandlePriceWebhook({ url: `/webhooks/plaee/prices`, method: 'POST', signal });
    },
    [priceWebhooksHandlePriceWebhook],
  );
};

export const usePriceWebhooksHandlePriceWebhookMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePriceWebhooksHandlePriceWebhookHook>>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof usePriceWebhooksHandlePriceWebhookHook>>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['priceWebhooksHandlePriceWebhook'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const priceWebhooksHandlePriceWebhook = usePriceWebhooksHandlePriceWebhookHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof usePriceWebhooksHandlePriceWebhookHook>>>,
    void
  > = () => {
    return priceWebhooksHandlePriceWebhook();
  };

  return { mutationFn, ...mutationOptions };
};

export type PriceWebhooksHandlePriceWebhookMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePriceWebhooksHandlePriceWebhookHook>>>
>;

export type PriceWebhooksHandlePriceWebhookMutationError = unknown;

/**
 * @summary Receive Plaee price_updated webhooks (dedicated tick lane)
 */
export const usePriceWebhooksHandlePriceWebhook = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof usePriceWebhooksHandlePriceWebhookHook>>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof usePriceWebhooksHandlePriceWebhookHook>>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = usePriceWebhooksHandlePriceWebhookMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Ingest a Plaee private (user-scoped) prediction-market webhook. Canonicalises the body, dedupes by plaeeEventId, and forwards to the user via the internal-emit bus.
 */
export const usePlaeePrivateWebhookIngestHook = () => {
  const plaeePrivateWebhookIngest = useCustomInstance<void>();

  return useCallback(
    (signal?: AbortSignal) => {
      return plaeePrivateWebhookIngest({ url: `/webhooks/plaee/private`, method: 'POST', signal });
    },
    [plaeePrivateWebhookIngest],
  );
};

export const usePlaeePrivateWebhookIngestMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof usePlaeePrivateWebhookIngestHook>>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePlaeePrivateWebhookIngestHook>>>, TError, void, TContext> => {
  const mutationKey = ['plaeePrivateWebhookIngest'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const plaeePrivateWebhookIngest = usePlaeePrivateWebhookIngestHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof usePlaeePrivateWebhookIngestHook>>>,
    void
  > = () => {
    return plaeePrivateWebhookIngest();
  };

  return { mutationFn, ...mutationOptions };
};

export type PlaeePrivateWebhookIngestMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePlaeePrivateWebhookIngestHook>>>
>;

export type PlaeePrivateWebhookIngestMutationError = unknown;

/**
 * @summary Ingest a Plaee private (user-scoped) prediction-market webhook. Canonicalises the body, dedupes by plaeeEventId, and forwards to the user via the internal-emit bus.
 */
export const usePlaeePrivateWebhookIngest = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof usePlaeePrivateWebhookIngestHook>>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<ReturnType<typeof usePlaeePrivateWebhookIngestHook>>>, TError, void, TContext> => {
  const mutationOptions = usePlaeePrivateWebhookIngestMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Exchange a Google ID token for an app-signed admin session token
 */
export const useAdminAuthLoginLoginHook = () => {
  const adminAuthLoginLogin = useCustomInstance<AdminLoginResponseDto>();

  return useCallback(
    (adminLoginRequestDto: AdminLoginRequestDto, signal?: AbortSignal) => {
      return adminAuthLoginLogin({
        url: `/admin/auth/login`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: adminLoginRequestDto,
        signal,
      });
    },
    [adminAuthLoginLogin],
  );
};

export const useAdminAuthLoginLoginMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminAuthLoginLoginHook>>>,
    TError,
    { data: AdminLoginRequestDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminAuthLoginLoginHook>>>,
  TError,
  { data: AdminLoginRequestDto },
  TContext
> => {
  const mutationKey = ['adminAuthLoginLogin'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminAuthLoginLogin = useAdminAuthLoginLoginHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminAuthLoginLoginHook>>>,
    { data: AdminLoginRequestDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminAuthLoginLogin(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminAuthLoginLoginMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminAuthLoginLoginHook>>>
>;
export type AdminAuthLoginLoginMutationBody = AdminLoginRequestDto;
export type AdminAuthLoginLoginMutationError = unknown;

/**
 * @summary Exchange a Google ID token for an app-signed admin session token
 */
export const useAdminAuthLoginLogin = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminAuthLoginLoginHook>>>,
      TError,
      { data: AdminLoginRequestDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminAuthLoginLoginHook>>>,
  TError,
  { data: AdminLoginRequestDto },
  TContext
> => {
  const mutationOptions = useAdminAuthLoginLoginMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List all users with wallet balances
 */
export const useAdminUsersGetUsersHook = () => {
  const adminUsersGetUsers = useCustomInstance<AdminUserListResponseDto>();

  return useCallback(
    (params: AdminUsersGetUsersParams, signal?: AbortSignal) => {
      return adminUsersGetUsers({ url: `/admin/users`, method: 'GET', params, signal });
    },
    [adminUsersGetUsers],
  );
};

export const getAdminUsersGetUsersQueryKey = (params: AdminUsersGetUsersParams) => {
  return [`/admin/users`, ...(params ? [params] : [])] as const;
};

export const useAdminUsersGetUsersQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUsersHook>>>,
  TError = unknown,
>(
  params: AdminUsersGetUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUsersHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminUsersGetUsersQueryKey(params);

  const adminUsersGetUsers = useAdminUsersGetUsersHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUsersHook>>>> = ({ signal }) =>
    adminUsersGetUsers(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUsersHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminUsersGetUsersQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUsersHook>>>>;
export type AdminUsersGetUsersQueryError = unknown;

export function useAdminUsersGetUsers<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUsersHook>>>,
  TError = unknown,
>(
  params: AdminUsersGetUsersParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUsersHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUsersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUsersHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminUsersGetUsers<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUsersHook>>>,
  TError = unknown,
>(
  params: AdminUsersGetUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUsersHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUsersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUsersHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminUsersGetUsers<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUsersHook>>>,
  TError = unknown,
>(
  params: AdminUsersGetUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUsersHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List all users with wallet balances
 */

export function useAdminUsersGetUsers<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUsersHook>>>,
  TError = unknown,
>(
  params: AdminUsersGetUsersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUsersHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminUsersGetUsersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get a single user by id
 */
export const useAdminUsersGetOneHook = () => {
  const adminUsersGetOne = useCustomInstance<AdminUserShowResponseDto>();

  return useCallback(
    (userId: string, signal?: AbortSignal) => {
      return adminUsersGetOne({ url: `/admin/users/${userId}`, method: 'GET', signal });
    },
    [adminUsersGetOne],
  );
};

export const getAdminUsersGetOneQueryKey = (userId: string) => {
  return [`/admin/users/${userId}`] as const;
};

export const useAdminUsersGetOneQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetOneHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetOneHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminUsersGetOneQueryKey(userId);

  const adminUsersGetOne = useAdminUsersGetOneHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetOneHook>>>> = ({ signal }) =>
    adminUsersGetOne(userId, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminUsersGetOneHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminUsersGetOneQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetOneHook>>>>;
export type AdminUsersGetOneQueryError = unknown;

export function useAdminUsersGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetOneHook>>>,
  TError = unknown,
>(
  userId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetOneHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminUsersGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminUsersGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminUsersGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetOneHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetOneHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminUsersGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminUsersGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminUsersGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetOneHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetOneHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a single user by id
 */

export function useAdminUsersGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetOneHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetOneHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminUsersGetOneQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update user fields
 */
export const useAdminUsersUpdateUserHook = () => {
  const adminUsersUpdateUser = useCustomInstance<AdminUserShowResponseDto>();

  return useCallback(
    (userId: string, adminUpdateUserDto: AdminUpdateUserDto) => {
      return adminUsersUpdateUser({
        url: `/admin/users/${userId}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: adminUpdateUserDto,
      });
    },
    [adminUsersUpdateUser],
  );
};

export const useAdminUsersUpdateUserMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminUsersUpdateUserHook>>>,
    TError,
    { userId: string; data: AdminUpdateUserDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminUsersUpdateUserHook>>>,
  TError,
  { userId: string; data: AdminUpdateUserDto },
  TContext
> => {
  const mutationKey = ['adminUsersUpdateUser'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminUsersUpdateUser = useAdminUsersUpdateUserHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminUsersUpdateUserHook>>>,
    { userId: string; data: AdminUpdateUserDto }
  > = (props) => {
    const { userId, data } = props ?? {};

    return adminUsersUpdateUser(userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUsersUpdateUserMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminUsersUpdateUserHook>>>
>;
export type AdminUsersUpdateUserMutationBody = AdminUpdateUserDto;
export type AdminUsersUpdateUserMutationError = unknown;

/**
 * @summary Update user fields
 */
export const useAdminUsersUpdateUser = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminUsersUpdateUserHook>>>,
      TError,
      { userId: string; data: AdminUpdateUserDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminUsersUpdateUserHook>>>,
  TError,
  { userId: string; data: AdminUpdateUserDto },
  TContext
> => {
  const mutationOptions = useAdminUsersUpdateUserMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Register a user as a Plaee customer (admin action)
 */
export const useAdminUsersRegisterPlaeeCustomerHook = () => {
  const adminUsersRegisterPlaeeCustomer = useCustomInstance<PlaeeCustomerLoginResponseDto>();

  return useCallback(
    (userId: string, registerCustomerDto: RegisterCustomerDto, signal?: AbortSignal) => {
      return adminUsersRegisterPlaeeCustomer({
        url: `/admin/users/${userId}/plaee-register`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: registerCustomerDto,
        signal,
      });
    },
    [adminUsersRegisterPlaeeCustomer],
  );
};

export const useAdminUsersRegisterPlaeeCustomerMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminUsersRegisterPlaeeCustomerHook>>>,
    TError,
    { userId: string; data: RegisterCustomerDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminUsersRegisterPlaeeCustomerHook>>>,
  TError,
  { userId: string; data: RegisterCustomerDto },
  TContext
> => {
  const mutationKey = ['adminUsersRegisterPlaeeCustomer'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminUsersRegisterPlaeeCustomer = useAdminUsersRegisterPlaeeCustomerHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminUsersRegisterPlaeeCustomerHook>>>,
    { userId: string; data: RegisterCustomerDto }
  > = (props) => {
    const { userId, data } = props ?? {};

    return adminUsersRegisterPlaeeCustomer(userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUsersRegisterPlaeeCustomerMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminUsersRegisterPlaeeCustomerHook>>>
>;
export type AdminUsersRegisterPlaeeCustomerMutationBody = RegisterCustomerDto;
export type AdminUsersRegisterPlaeeCustomerMutationError = unknown;

/**
 * @summary Register a user as a Plaee customer (admin action)
 */
export const useAdminUsersRegisterPlaeeCustomer = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminUsersRegisterPlaeeCustomerHook>>>,
      TError,
      { userId: string; data: RegisterCustomerDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminUsersRegisterPlaeeCustomerHook>>>,
  TError,
  { userId: string; data: RegisterCustomerDto },
  TContext
> => {
  const mutationOptions = useAdminUsersRegisterPlaeeCustomerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Update a Plaee customer profile (admin action)
 */
export const useAdminUsersUpdatePlaeeCustomerHook = () => {
  const adminUsersUpdatePlaeeCustomer = useCustomInstance<AdminPlaeeCustomerDataResponseDto>();

  return useCallback(
    (userId: string, updateCustomerDto: UpdateCustomerDto) => {
      return adminUsersUpdatePlaeeCustomer({
        url: `/admin/users/${userId}/plaee-update`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateCustomerDto,
      });
    },
    [adminUsersUpdatePlaeeCustomer],
  );
};

export const useAdminUsersUpdatePlaeeCustomerMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminUsersUpdatePlaeeCustomerHook>>>,
    TError,
    { userId: string; data: UpdateCustomerDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminUsersUpdatePlaeeCustomerHook>>>,
  TError,
  { userId: string; data: UpdateCustomerDto },
  TContext
> => {
  const mutationKey = ['adminUsersUpdatePlaeeCustomer'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminUsersUpdatePlaeeCustomer = useAdminUsersUpdatePlaeeCustomerHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminUsersUpdatePlaeeCustomerHook>>>,
    { userId: string; data: UpdateCustomerDto }
  > = (props) => {
    const { userId, data } = props ?? {};

    return adminUsersUpdatePlaeeCustomer(userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUsersUpdatePlaeeCustomerMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminUsersUpdatePlaeeCustomerHook>>>
>;
export type AdminUsersUpdatePlaeeCustomerMutationBody = UpdateCustomerDto;
export type AdminUsersUpdatePlaeeCustomerMutationError = unknown;

/**
 * @summary Update a Plaee customer profile (admin action)
 */
export const useAdminUsersUpdatePlaeeCustomer = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminUsersUpdatePlaeeCustomerHook>>>,
      TError,
      { userId: string; data: UpdateCustomerDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminUsersUpdatePlaeeCustomerHook>>>,
  TError,
  { userId: string; data: UpdateCustomerDto },
  TContext
> => {
  const mutationOptions = useAdminUsersUpdatePlaeeCustomerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Retry creating failed Plaee accounts for a user (admin action)
 */
export const useAdminUsersRetryPlaeeAccountsHook = () => {
  const adminUsersRetryPlaeeAccounts = useCustomInstance<PlaeeRetryAccountsResponseDto>();

  return useCallback(
    (userId: string, signal?: AbortSignal) => {
      return adminUsersRetryPlaeeAccounts({ url: `/admin/users/${userId}/plaee-retry-accounts`, method: 'POST', signal });
    },
    [adminUsersRetryPlaeeAccounts],
  );
};

export const useAdminUsersRetryPlaeeAccountsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminUsersRetryPlaeeAccountsHook>>>,
    TError,
    { userId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminUsersRetryPlaeeAccountsHook>>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationKey = ['adminUsersRetryPlaeeAccounts'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminUsersRetryPlaeeAccounts = useAdminUsersRetryPlaeeAccountsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminUsersRetryPlaeeAccountsHook>>>,
    { userId: string }
  > = (props) => {
    const { userId } = props ?? {};

    return adminUsersRetryPlaeeAccounts(userId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUsersRetryPlaeeAccountsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminUsersRetryPlaeeAccountsHook>>>
>;

export type AdminUsersRetryPlaeeAccountsMutationError = unknown;

/**
 * @summary Retry creating failed Plaee accounts for a user (admin action)
 */
export const useAdminUsersRetryPlaeeAccounts = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminUsersRetryPlaeeAccountsHook>>>,
      TError,
      { userId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminUsersRetryPlaeeAccountsHook>>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationOptions = useAdminUsersRetryPlaeeAccountsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get the live Plaee customer profile for a user (SSN masked to last 4)
 */
export const useAdminUsersGetPlaeeCustomerDataHook = () => {
  const adminUsersGetPlaeeCustomerData = useCustomInstance<AdminPlaeeCustomerDataResponseDto>();

  return useCallback(
    (userId: string, signal?: AbortSignal) => {
      return adminUsersGetPlaeeCustomerData({ url: `/admin/users/${userId}/plaee`, method: 'GET', signal });
    },
    [adminUsersGetPlaeeCustomerData],
  );
};

export const getAdminUsersGetPlaeeCustomerDataQueryKey = (userId: string) => {
  return [`/admin/users/${userId}/plaee`] as const;
};

export const useAdminUsersGetPlaeeCustomerDataQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetPlaeeCustomerDataHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetPlaeeCustomerDataHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminUsersGetPlaeeCustomerDataQueryKey(userId);

  const adminUsersGetPlaeeCustomerData = useAdminUsersGetPlaeeCustomerDataHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetPlaeeCustomerDataHook>>>> = ({
    signal,
  }) => adminUsersGetPlaeeCustomerData(userId, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminUsersGetPlaeeCustomerDataHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminUsersGetPlaeeCustomerDataQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminUsersGetPlaeeCustomerDataHook>>>
>;
export type AdminUsersGetPlaeeCustomerDataQueryError = unknown;

export function useAdminUsersGetPlaeeCustomerData<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetPlaeeCustomerDataHook>>>,
  TError = unknown,
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetPlaeeCustomerDataHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminUsersGetPlaeeCustomerDataHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminUsersGetPlaeeCustomerDataHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminUsersGetPlaeeCustomerData<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetPlaeeCustomerDataHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetPlaeeCustomerDataHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminUsersGetPlaeeCustomerDataHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminUsersGetPlaeeCustomerDataHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminUsersGetPlaeeCustomerData<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetPlaeeCustomerDataHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetPlaeeCustomerDataHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the live Plaee customer profile for a user (SSN masked to last 4)
 */

export function useAdminUsersGetPlaeeCustomerData<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetPlaeeCustomerDataHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetPlaeeCustomerDataHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminUsersGetPlaeeCustomerDataQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get the wallet balance and locked balance for a user
 */
export const useAdminUsersGetUserWalletHook = () => {
  const adminUsersGetUserWallet = useCustomInstance<AdminUserWalletResponseDto>();

  return useCallback(
    (userId: string, signal?: AbortSignal) => {
      return adminUsersGetUserWallet({ url: `/admin/users/${userId}/wallet`, method: 'GET', signal });
    },
    [adminUsersGetUserWallet],
  );
};

export const getAdminUsersGetUserWalletQueryKey = (userId: string) => {
  return [`/admin/users/${userId}/wallet`] as const;
};

export const useAdminUsersGetUserWalletQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWalletHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWalletHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminUsersGetUserWalletQueryKey(userId);

  const adminUsersGetUserWallet = useAdminUsersGetUserWalletHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWalletHook>>>> = ({ signal }) =>
    adminUsersGetUserWallet(userId, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWalletHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminUsersGetUserWalletQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWalletHook>>>
>;
export type AdminUsersGetUserWalletQueryError = unknown;

export function useAdminUsersGetUserWallet<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWalletHook>>>,
  TError = unknown,
>(
  userId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWalletHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWalletHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWalletHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminUsersGetUserWallet<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWalletHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWalletHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWalletHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWalletHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminUsersGetUserWallet<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWalletHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWalletHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the wallet balance and locked balance for a user
 */

export function useAdminUsersGetUserWallet<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWalletHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWalletHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminUsersGetUserWalletQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List a user withdrawals with pagination and optional status filter
 */
export const useAdminUsersGetUserWithdrawalsHook = () => {
  const adminUsersGetUserWithdrawals = useCustomInstance<AdminUserWithdrawalsResponseDto>();

  return useCallback(
    (userId: string, params: AdminUsersGetUserWithdrawalsParams, signal?: AbortSignal) => {
      return adminUsersGetUserWithdrawals({ url: `/admin/users/${userId}/withdrawals`, method: 'GET', params, signal });
    },
    [adminUsersGetUserWithdrawals],
  );
};

export const getAdminUsersGetUserWithdrawalsQueryKey = (userId: string, params: AdminUsersGetUserWithdrawalsParams) => {
  return [`/admin/users/${userId}/withdrawals`, ...(params ? [params] : [])] as const;
};

export const useAdminUsersGetUserWithdrawalsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWithdrawalsHook>>>,
  TError = unknown,
>(
  userId: string,
  params: AdminUsersGetUserWithdrawalsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWithdrawalsHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminUsersGetUserWithdrawalsQueryKey(userId, params);

  const adminUsersGetUserWithdrawals = useAdminUsersGetUserWithdrawalsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWithdrawalsHook>>>> = ({ signal }) =>
    adminUsersGetUserWithdrawals(userId, params, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWithdrawalsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminUsersGetUserWithdrawalsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWithdrawalsHook>>>
>;
export type AdminUsersGetUserWithdrawalsQueryError = unknown;

export function useAdminUsersGetUserWithdrawals<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWithdrawalsHook>>>,
  TError = unknown,
>(
  userId: string,
  params: AdminUsersGetUserWithdrawalsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWithdrawalsHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWithdrawalsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWithdrawalsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminUsersGetUserWithdrawals<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWithdrawalsHook>>>,
  TError = unknown,
>(
  userId: string,
  params: AdminUsersGetUserWithdrawalsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWithdrawalsHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWithdrawalsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWithdrawalsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminUsersGetUserWithdrawals<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWithdrawalsHook>>>,
  TError = unknown,
>(
  userId: string,
  params: AdminUsersGetUserWithdrawalsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWithdrawalsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List a user withdrawals with pagination and optional status filter
 */

export function useAdminUsersGetUserWithdrawals<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWithdrawalsHook>>>,
  TError = unknown,
>(
  userId: string,
  params: AdminUsersGetUserWithdrawalsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserWithdrawalsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminUsersGetUserWithdrawalsQueryOptions(userId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary User monetization summary: assignments, per-experience state, recent events, totals
 */
export const useAdminUsersGetUserMonetizationHook = () => {
  const adminUsersGetUserMonetization = useCustomInstance<AdminUserMonetizationResponseDto>();

  return useCallback(
    (userId: string, signal?: AbortSignal) => {
      return adminUsersGetUserMonetization({ url: `/admin/users/${userId}/monetization`, method: 'GET', signal });
    },
    [adminUsersGetUserMonetization],
  );
};

export const getAdminUsersGetUserMonetizationQueryKey = (userId: string) => {
  return [`/admin/users/${userId}/monetization`] as const;
};

export const useAdminUsersGetUserMonetizationQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserMonetizationHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserMonetizationHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminUsersGetUserMonetizationQueryKey(userId);

  const adminUsersGetUserMonetization = useAdminUsersGetUserMonetizationHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserMonetizationHook>>>> = ({
    signal,
  }) => adminUsersGetUserMonetization(userId, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserMonetizationHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminUsersGetUserMonetizationQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserMonetizationHook>>>
>;
export type AdminUsersGetUserMonetizationQueryError = unknown;

export function useAdminUsersGetUserMonetization<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserMonetizationHook>>>,
  TError = unknown,
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserMonetizationHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserMonetizationHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserMonetizationHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminUsersGetUserMonetization<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserMonetizationHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserMonetizationHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserMonetizationHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserMonetizationHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminUsersGetUserMonetization<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserMonetizationHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserMonetizationHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary User monetization summary: assignments, per-experience state, recent events, totals
 */

export function useAdminUsersGetUserMonetization<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserMonetizationHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetUserMonetizationHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminUsersGetUserMonetizationQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List a user's recent & open Intercom support conversations (deep-linking into the Intercom inbox)
 */
export const useAdminUsersGetIntercomConversationsHook = () => {
  const adminUsersGetIntercomConversations = useCustomInstance<AdminUserIntercomConversationsDto>();

  return useCallback(
    (userId: string, signal?: AbortSignal) => {
      return adminUsersGetIntercomConversations({
        url: `/admin/users/${userId}/intercom-conversations`,
        method: 'GET',
        signal,
      });
    },
    [adminUsersGetIntercomConversations],
  );
};

export const getAdminUsersGetIntercomConversationsQueryKey = (userId: string) => {
  return [`/admin/users/${userId}/intercom-conversations`] as const;
};

export const useAdminUsersGetIntercomConversationsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetIntercomConversationsHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetIntercomConversationsHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminUsersGetIntercomConversationsQueryKey(userId);

  const adminUsersGetIntercomConversations = useAdminUsersGetIntercomConversationsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetIntercomConversationsHook>>>> = ({
    signal,
  }) => adminUsersGetIntercomConversations(userId, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminUsersGetIntercomConversationsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminUsersGetIntercomConversationsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminUsersGetIntercomConversationsHook>>>
>;
export type AdminUsersGetIntercomConversationsQueryError = unknown;

export function useAdminUsersGetIntercomConversations<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetIntercomConversationsHook>>>,
  TError = unknown,
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetIntercomConversationsHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminUsersGetIntercomConversationsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminUsersGetIntercomConversationsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminUsersGetIntercomConversations<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetIntercomConversationsHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetIntercomConversationsHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminUsersGetIntercomConversationsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminUsersGetIntercomConversationsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminUsersGetIntercomConversations<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetIntercomConversationsHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetIntercomConversationsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List a user's recent & open Intercom support conversations (deep-linking into the Intercom inbox)
 */

export function useAdminUsersGetIntercomConversations<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersGetIntercomConversationsHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersGetIntercomConversationsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminUsersGetIntercomConversationsQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Assign a tag to a user (idempotent). Returns the user's tags.
 */
export const useAdminUsersAssignTagHook = () => {
  const adminUsersAssignTag = useCustomInstance<TagResponseDto[]>();

  return useCallback(
    (userId: string, assignTagDto: AssignTagDto, signal?: AbortSignal) => {
      return adminUsersAssignTag({
        url: `/admin/users/${userId}/tags`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: assignTagDto,
        signal,
      });
    },
    [adminUsersAssignTag],
  );
};

export const useAdminUsersAssignTagMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminUsersAssignTagHook>>>,
    TError,
    { userId: string; data: AssignTagDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminUsersAssignTagHook>>>,
  TError,
  { userId: string; data: AssignTagDto },
  TContext
> => {
  const mutationKey = ['adminUsersAssignTag'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminUsersAssignTag = useAdminUsersAssignTagHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminUsersAssignTagHook>>>,
    { userId: string; data: AssignTagDto }
  > = (props) => {
    const { userId, data } = props ?? {};

    return adminUsersAssignTag(userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUsersAssignTagMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminUsersAssignTagHook>>>
>;
export type AdminUsersAssignTagMutationBody = AssignTagDto;
export type AdminUsersAssignTagMutationError = unknown;

/**
 * @summary Assign a tag to a user (idempotent). Returns the user's tags.
 */
export const useAdminUsersAssignTag = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminUsersAssignTagHook>>>,
      TError,
      { userId: string; data: AssignTagDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminUsersAssignTagHook>>>,
  TError,
  { userId: string; data: AssignTagDto },
  TContext
> => {
  const mutationOptions = useAdminUsersAssignTagMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Remove a tag from a user (idempotent). Returns the user's tags.
 */
export const useAdminUsersRemoveTagHook = () => {
  const adminUsersRemoveTag = useCustomInstance<TagResponseDto[]>();

  return useCallback(
    (userId: string, tagId: string) => {
      return adminUsersRemoveTag({ url: `/admin/users/${userId}/tags/${tagId}`, method: 'DELETE' });
    },
    [adminUsersRemoveTag],
  );
};

export const useAdminUsersRemoveTagMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminUsersRemoveTagHook>>>,
    TError,
    { userId: string; tagId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminUsersRemoveTagHook>>>,
  TError,
  { userId: string; tagId: string },
  TContext
> => {
  const mutationKey = ['adminUsersRemoveTag'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminUsersRemoveTag = useAdminUsersRemoveTagHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminUsersRemoveTagHook>>>,
    { userId: string; tagId: string }
  > = (props) => {
    const { userId, tagId } = props ?? {};

    return adminUsersRemoveTag(userId, tagId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUsersRemoveTagMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminUsersRemoveTagHook>>>
>;

export type AdminUsersRemoveTagMutationError = unknown;

/**
 * @summary Remove a tag from a user (idempotent). Returns the user's tags.
 */
export const useAdminUsersRemoveTag = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminUsersRemoveTagHook>>>,
      TError,
      { userId: string; tagId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminUsersRemoveTagHook>>>,
  TError,
  { userId: string; tagId: string },
  TContext
> => {
  const mutationOptions = useAdminUsersRemoveTagMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List a user's deposit limits (one per rolling window)
 */
export const useAdminUsersListDepositLimitsHook = () => {
  const adminUsersListDepositLimits = useCustomInstance<DepositLimitResponseDto[]>();

  return useCallback(
    (userId: string, signal?: AbortSignal) => {
      return adminUsersListDepositLimits({ url: `/admin/users/${userId}/deposit-limits`, method: 'GET', signal });
    },
    [adminUsersListDepositLimits],
  );
};

export const getAdminUsersListDepositLimitsQueryKey = (userId: string) => {
  return [`/admin/users/${userId}/deposit-limits`] as const;
};

export const useAdminUsersListDepositLimitsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersListDepositLimitsHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersListDepositLimitsHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminUsersListDepositLimitsQueryKey(userId);

  const adminUsersListDepositLimits = useAdminUsersListDepositLimitsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminUsersListDepositLimitsHook>>>> = ({ signal }) =>
    adminUsersListDepositLimits(userId, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminUsersListDepositLimitsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminUsersListDepositLimitsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminUsersListDepositLimitsHook>>>
>;
export type AdminUsersListDepositLimitsQueryError = unknown;

export function useAdminUsersListDepositLimits<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersListDepositLimitsHook>>>,
  TError = unknown,
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersListDepositLimitsHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminUsersListDepositLimitsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminUsersListDepositLimitsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminUsersListDepositLimits<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersListDepositLimitsHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersListDepositLimitsHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminUsersListDepositLimitsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminUsersListDepositLimitsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminUsersListDepositLimits<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersListDepositLimitsHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersListDepositLimitsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List a user's deposit limits (one per rolling window)
 */

export function useAdminUsersListDepositLimits<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminUsersListDepositLimitsHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminUsersListDepositLimitsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminUsersListDepositLimitsQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Set (create or replace) a user's deposit cap for a rolling window
 */
export const useAdminUsersSetDepositLimitHook = () => {
  const adminUsersSetDepositLimit = useCustomInstance<DepositLimitResponseDto>();

  return useCallback(
    (userId: string, window: string, setDepositLimitDto: SetDepositLimitDto) => {
      return adminUsersSetDepositLimit({
        url: `/admin/users/${userId}/deposit-limits/${window}`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: setDepositLimitDto,
      });
    },
    [adminUsersSetDepositLimit],
  );
};

export const useAdminUsersSetDepositLimitMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminUsersSetDepositLimitHook>>>,
    TError,
    { userId: string; window: string; data: SetDepositLimitDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminUsersSetDepositLimitHook>>>,
  TError,
  { userId: string; window: string; data: SetDepositLimitDto },
  TContext
> => {
  const mutationKey = ['adminUsersSetDepositLimit'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminUsersSetDepositLimit = useAdminUsersSetDepositLimitHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminUsersSetDepositLimitHook>>>,
    { userId: string; window: string; data: SetDepositLimitDto }
  > = (props) => {
    const { userId, window, data } = props ?? {};

    return adminUsersSetDepositLimit(userId, window, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUsersSetDepositLimitMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminUsersSetDepositLimitHook>>>
>;
export type AdminUsersSetDepositLimitMutationBody = SetDepositLimitDto;
export type AdminUsersSetDepositLimitMutationError = unknown;

/**
 * @summary Set (create or replace) a user's deposit cap for a rolling window
 */
export const useAdminUsersSetDepositLimit = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminUsersSetDepositLimitHook>>>,
      TError,
      { userId: string; window: string; data: SetDepositLimitDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminUsersSetDepositLimitHook>>>,
  TError,
  { userId: string; window: string; data: SetDepositLimitDto },
  TContext
> => {
  const mutationOptions = useAdminUsersSetDepositLimitMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Reset (deactivate) a user's deposit cap for a rolling window
 */
export const useAdminUsersResetDepositLimitHook = () => {
  const adminUsersResetDepositLimit = useCustomInstance<DepositLimitResponseDto>();

  return useCallback(
    (userId: string, window: string, resetDepositLimitDto: ResetDepositLimitDto) => {
      return adminUsersResetDepositLimit({
        url: `/admin/users/${userId}/deposit-limits/${window}`,
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        data: resetDepositLimitDto,
      });
    },
    [adminUsersResetDepositLimit],
  );
};

export const useAdminUsersResetDepositLimitMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminUsersResetDepositLimitHook>>>,
    TError,
    { userId: string; window: string; data: ResetDepositLimitDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminUsersResetDepositLimitHook>>>,
  TError,
  { userId: string; window: string; data: ResetDepositLimitDto },
  TContext
> => {
  const mutationKey = ['adminUsersResetDepositLimit'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminUsersResetDepositLimit = useAdminUsersResetDepositLimitHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminUsersResetDepositLimitHook>>>,
    { userId: string; window: string; data: ResetDepositLimitDto }
  > = (props) => {
    const { userId, window, data } = props ?? {};

    return adminUsersResetDepositLimit(userId, window, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminUsersResetDepositLimitMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminUsersResetDepositLimitHook>>>
>;
export type AdminUsersResetDepositLimitMutationBody = ResetDepositLimitDto;
export type AdminUsersResetDepositLimitMutationError = unknown;

/**
 * @summary Reset (deactivate) a user's deposit cap for a rolling window
 */
export const useAdminUsersResetDepositLimit = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminUsersResetDepositLimitHook>>>,
      TError,
      { userId: string; window: string; data: ResetDepositLimitDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminUsersResetDepositLimitHook>>>,
  TError,
  { userId: string; window: string; data: ResetDepositLimitDto },
  TContext
> => {
  const mutationOptions = useAdminUsersResetDepositLimitMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get customer wallet balance (called by Plaee)
 */
export const useWalletCallbackGetBalanceHook = () => {
  const walletCallbackGetBalance = useCustomInstance<PlaeeBalanceResponseDto>();

  return useCallback(
    (plaeeBalanceDto: PlaeeBalanceDto, signal?: AbortSignal) => {
      return walletCallbackGetBalance({
        url: `/wallet/balance`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: plaeeBalanceDto,
        signal,
      });
    },
    [walletCallbackGetBalance],
  );
};

export const useWalletCallbackGetBalanceMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useWalletCallbackGetBalanceHook>>>,
    TError,
    { data: PlaeeBalanceDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useWalletCallbackGetBalanceHook>>>,
  TError,
  { data: PlaeeBalanceDto },
  TContext
> => {
  const mutationKey = ['walletCallbackGetBalance'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const walletCallbackGetBalance = useWalletCallbackGetBalanceHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useWalletCallbackGetBalanceHook>>>,
    { data: PlaeeBalanceDto }
  > = (props) => {
    const { data } = props ?? {};

    return walletCallbackGetBalance(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WalletCallbackGetBalanceMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useWalletCallbackGetBalanceHook>>>
>;
export type WalletCallbackGetBalanceMutationBody = PlaeeBalanceDto;
export type WalletCallbackGetBalanceMutationError = unknown;

/**
 * @summary Get customer wallet balance (called by Plaee)
 */
export const useWalletCallbackGetBalance = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useWalletCallbackGetBalanceHook>>>,
      TError,
      { data: PlaeeBalanceDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useWalletCallbackGetBalanceHook>>>,
  TError,
  { data: PlaeeBalanceDto },
  TContext
> => {
  const mutationOptions = useWalletCallbackGetBalanceMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get customer wallet balance via query (called by Plaee)
 */
export const useWalletCallbackGetBalanceByQueryHook = () => {
  const walletCallbackGetBalanceByQuery = useCustomInstance<PlaeeBalanceResponseDto>();

  return useCallback(
    (params: WalletCallbackGetBalanceByQueryParams, signal?: AbortSignal) => {
      return walletCallbackGetBalanceByQuery({ url: `/wallet/balance`, method: 'GET', params, signal });
    },
    [walletCallbackGetBalanceByQuery],
  );
};

export const getWalletCallbackGetBalanceByQueryQueryKey = (params: WalletCallbackGetBalanceByQueryParams) => {
  return [`/wallet/balance`, ...(params ? [params] : [])] as const;
};

export const useWalletCallbackGetBalanceByQueryQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useWalletCallbackGetBalanceByQueryHook>>>,
  TError = unknown,
>(
  params: WalletCallbackGetBalanceByQueryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useWalletCallbackGetBalanceByQueryHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWalletCallbackGetBalanceByQueryQueryKey(params);

  const walletCallbackGetBalanceByQuery = useWalletCallbackGetBalanceByQueryHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useWalletCallbackGetBalanceByQueryHook>>>> = ({
    signal,
  }) => walletCallbackGetBalanceByQuery(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useWalletCallbackGetBalanceByQueryHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WalletCallbackGetBalanceByQueryQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useWalletCallbackGetBalanceByQueryHook>>>
>;
export type WalletCallbackGetBalanceByQueryQueryError = unknown;

export function useWalletCallbackGetBalanceByQuery<
  TData = Awaited<ReturnType<ReturnType<typeof useWalletCallbackGetBalanceByQueryHook>>>,
  TError = unknown,
>(
  params: WalletCallbackGetBalanceByQueryParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useWalletCallbackGetBalanceByQueryHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useWalletCallbackGetBalanceByQueryHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useWalletCallbackGetBalanceByQueryHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWalletCallbackGetBalanceByQuery<
  TData = Awaited<ReturnType<ReturnType<typeof useWalletCallbackGetBalanceByQueryHook>>>,
  TError = unknown,
>(
  params: WalletCallbackGetBalanceByQueryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useWalletCallbackGetBalanceByQueryHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useWalletCallbackGetBalanceByQueryHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useWalletCallbackGetBalanceByQueryHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWalletCallbackGetBalanceByQuery<
  TData = Awaited<ReturnType<ReturnType<typeof useWalletCallbackGetBalanceByQueryHook>>>,
  TError = unknown,
>(
  params: WalletCallbackGetBalanceByQueryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useWalletCallbackGetBalanceByQueryHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get customer wallet balance via query (called by Plaee)
 */

export function useWalletCallbackGetBalanceByQuery<
  TData = Awaited<ReturnType<ReturnType<typeof useWalletCallbackGetBalanceByQueryHook>>>,
  TError = unknown,
>(
  params: WalletCallbackGetBalanceByQueryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useWalletCallbackGetBalanceByQueryHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useWalletCallbackGetBalanceByQueryQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Debit customer wallet (called by Plaee)
 */
export const useWalletCallbackDebitHook = () => {
  const walletCallbackDebit = useCustomInstance<PlaeeWalletOpResponseDto>();

  return useCallback(
    (plaeeDebitDto: PlaeeDebitDto, signal?: AbortSignal) => {
      return walletCallbackDebit({
        url: `/wallet/debit`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: plaeeDebitDto,
        signal,
      });
    },
    [walletCallbackDebit],
  );
};

export const useWalletCallbackDebitMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useWalletCallbackDebitHook>>>,
    TError,
    { data: PlaeeDebitDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useWalletCallbackDebitHook>>>,
  TError,
  { data: PlaeeDebitDto },
  TContext
> => {
  const mutationKey = ['walletCallbackDebit'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const walletCallbackDebit = useWalletCallbackDebitHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useWalletCallbackDebitHook>>>,
    { data: PlaeeDebitDto }
  > = (props) => {
    const { data } = props ?? {};

    return walletCallbackDebit(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WalletCallbackDebitMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useWalletCallbackDebitHook>>>
>;
export type WalletCallbackDebitMutationBody = PlaeeDebitDto;
export type WalletCallbackDebitMutationError = unknown;

/**
 * @summary Debit customer wallet (called by Plaee)
 */
export const useWalletCallbackDebit = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useWalletCallbackDebitHook>>>,
      TError,
      { data: PlaeeDebitDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useWalletCallbackDebitHook>>>,
  TError,
  { data: PlaeeDebitDto },
  TContext
> => {
  const mutationOptions = useWalletCallbackDebitMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Credit customer wallet (called by Plaee)
 */
export const useWalletCallbackCreditHook = () => {
  const walletCallbackCredit = useCustomInstance<PlaeeWalletOpResponseDto>();

  return useCallback(
    (plaeeCreditDto: PlaeeCreditDto, signal?: AbortSignal) => {
      return walletCallbackCredit({
        url: `/wallet/credit`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: plaeeCreditDto,
        signal,
      });
    },
    [walletCallbackCredit],
  );
};

export const useWalletCallbackCreditMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useWalletCallbackCreditHook>>>,
    TError,
    { data: PlaeeCreditDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useWalletCallbackCreditHook>>>,
  TError,
  { data: PlaeeCreditDto },
  TContext
> => {
  const mutationKey = ['walletCallbackCredit'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const walletCallbackCredit = useWalletCallbackCreditHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useWalletCallbackCreditHook>>>,
    { data: PlaeeCreditDto }
  > = (props) => {
    const { data } = props ?? {};

    return walletCallbackCredit(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WalletCallbackCreditMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useWalletCallbackCreditHook>>>
>;
export type WalletCallbackCreditMutationBody = PlaeeCreditDto;
export type WalletCallbackCreditMutationError = unknown;

/**
 * @summary Credit customer wallet (called by Plaee)
 */
export const useWalletCallbackCredit = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useWalletCallbackCreditHook>>>,
      TError,
      { data: PlaeeCreditDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useWalletCallbackCreditHook>>>,
  TError,
  { data: PlaeeCreditDto },
  TContext
> => {
  const mutationOptions = useWalletCallbackCreditMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List withdrawals with pagination and filters. Use userId to scope to a single user.
 */
export const useAdminWithdrawalsGetListHook = () => {
  const adminWithdrawalsGetList = useCustomInstance<AdminWithdrawalListResponseDto>();

  return useCallback(
    (params: AdminWithdrawalsGetListParams, signal?: AbortSignal) => {
      return adminWithdrawalsGetList({ url: `/admin/withdrawals`, method: 'GET', params, signal });
    },
    [adminWithdrawalsGetList],
  );
};

export const getAdminWithdrawalsGetListQueryKey = (params: AdminWithdrawalsGetListParams) => {
  return [`/admin/withdrawals`, ...(params ? [params] : [])] as const;
};

export const useAdminWithdrawalsGetListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetListHook>>>,
  TError = unknown,
>(
  params: AdminWithdrawalsGetListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetListHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminWithdrawalsGetListQueryKey(params);

  const adminWithdrawalsGetList = useAdminWithdrawalsGetListHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetListHook>>>> = ({ signal }) =>
    adminWithdrawalsGetList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetListHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminWithdrawalsGetListQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetListHook>>>
>;
export type AdminWithdrawalsGetListQueryError = unknown;

export function useAdminWithdrawalsGetList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetListHook>>>,
  TError = unknown,
>(
  params: AdminWithdrawalsGetListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetListHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminWithdrawalsGetList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetListHook>>>,
  TError = unknown,
>(
  params: AdminWithdrawalsGetListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetListHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminWithdrawalsGetList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetListHook>>>,
  TError = unknown,
>(
  params: AdminWithdrawalsGetListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List withdrawals with pagination and filters. Use userId to scope to a single user.
 */

export function useAdminWithdrawalsGetList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetListHook>>>,
  TError = unknown,
>(
  params: AdminWithdrawalsGetListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminWithdrawalsGetListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get a single withdrawal by id
 */
export const useAdminWithdrawalsGetOneHook = () => {
  const adminWithdrawalsGetOne = useCustomInstance<AdminWithdrawalResponseDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminWithdrawalsGetOne({ url: `/admin/withdrawals/${id}`, method: 'GET', signal });
    },
    [adminWithdrawalsGetOne],
  );
};

export const getAdminWithdrawalsGetOneQueryKey = (id: string) => {
  return [`/admin/withdrawals/${id}`] as const;
};

export const useAdminWithdrawalsGetOneQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetOneHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminWithdrawalsGetOneQueryKey(id);

  const adminWithdrawalsGetOne = useAdminWithdrawalsGetOneHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetOneHook>>>> = ({ signal }) =>
    adminWithdrawalsGetOne(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetOneHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminWithdrawalsGetOneQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetOneHook>>>
>;
export type AdminWithdrawalsGetOneQueryError = unknown;

export function useAdminWithdrawalsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetOneHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminWithdrawalsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetOneHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminWithdrawalsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetOneHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a single withdrawal by id
 */

export function useAdminWithdrawalsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsGetOneHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminWithdrawalsGetOneQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Generic admin status flip — escape hatch for stuck rows. Prefer /approve and /reject. Transitions to FAILED/CANCELLED still refund the user wallet atomically.
 */
export const useAdminWithdrawalsUpdateHook = () => {
  const adminWithdrawalsUpdate = useCustomInstance<AdminWithdrawalResponseDto>();

  return useCallback(
    (id: string, updateWithdrawalDto: UpdateWithdrawalDto) => {
      return adminWithdrawalsUpdate({
        url: `/admin/withdrawals/${id}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateWithdrawalDto,
      });
    },
    [adminWithdrawalsUpdate],
  );
};

export const useAdminWithdrawalsUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsUpdateHook>>>,
    TError,
    { id: string; data: UpdateWithdrawalDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsUpdateHook>>>,
  TError,
  { id: string; data: UpdateWithdrawalDto },
  TContext
> => {
  const mutationKey = ['adminWithdrawalsUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminWithdrawalsUpdate = useAdminWithdrawalsUpdateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsUpdateHook>>>,
    { id: string; data: UpdateWithdrawalDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminWithdrawalsUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWithdrawalsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsUpdateHook>>>
>;
export type AdminWithdrawalsUpdateMutationBody = UpdateWithdrawalDto;
export type AdminWithdrawalsUpdateMutationError = unknown;

/**
 * @summary Generic admin status flip — escape hatch for stuck rows. Prefer /approve and /reject. Transitions to FAILED/CANCELLED still refund the user wallet atomically.
 */
export const useAdminWithdrawalsUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsUpdateHook>>>,
      TError,
      { id: string; data: UpdateWithdrawalDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsUpdateHook>>>,
  TError,
  { id: string; data: UpdateWithdrawalDto },
  TContext
> => {
  const mutationOptions = useAdminWithdrawalsUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Approve a PENDING withdrawal. Caller must hold the active lease (acquired via /shift/next). Status flips to APPROVED; the cron dispatcher sends it to Pay.com on the next tick.
 */
export const useAdminWithdrawalsApproveHook = () => {
  const adminWithdrawalsApprove = useCustomInstance<AdminWithdrawalResponseDto>();

  return useCallback(
    (id: string) => {
      return adminWithdrawalsApprove({ url: `/admin/withdrawals/${id}/approve`, method: 'PATCH' });
    },
    [adminWithdrawalsApprove],
  );
};

export const useAdminWithdrawalsApproveMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsApproveHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsApproveHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminWithdrawalsApprove'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminWithdrawalsApprove = useAdminWithdrawalsApproveHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsApproveHook>>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminWithdrawalsApprove(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWithdrawalsApproveMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsApproveHook>>>
>;

export type AdminWithdrawalsApproveMutationError = unknown;

/**
 * @summary Approve a PENDING withdrawal. Caller must hold the active lease (acquired via /shift/next). Status flips to APPROVED; the cron dispatcher sends it to Pay.com on the next tick.
 */
export const useAdminWithdrawalsApprove = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsApproveHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsApproveHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useAdminWithdrawalsApproveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Reject a PENDING withdrawal. Caller must hold the active lease. Refunds the user wallet atomically and stores the reason.
 */
export const useAdminWithdrawalsRejectHook = () => {
  const adminWithdrawalsReject = useCustomInstance<AdminWithdrawalResponseDto>();

  return useCallback(
    (id: string, rejectWithdrawalDto: RejectWithdrawalDto) => {
      return adminWithdrawalsReject({
        url: `/admin/withdrawals/${id}/reject`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: rejectWithdrawalDto,
      });
    },
    [adminWithdrawalsReject],
  );
};

export const useAdminWithdrawalsRejectMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsRejectHook>>>,
    TError,
    { id: string; data: RejectWithdrawalDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsRejectHook>>>,
  TError,
  { id: string; data: RejectWithdrawalDto },
  TContext
> => {
  const mutationKey = ['adminWithdrawalsReject'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminWithdrawalsReject = useAdminWithdrawalsRejectHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsRejectHook>>>,
    { id: string; data: RejectWithdrawalDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminWithdrawalsReject(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWithdrawalsRejectMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsRejectHook>>>
>;
export type AdminWithdrawalsRejectMutationBody = RejectWithdrawalDto;
export type AdminWithdrawalsRejectMutationError = unknown;

/**
 * @summary Reject a PENDING withdrawal. Caller must hold the active lease. Refunds the user wallet atomically and stores the reason.
 */
export const useAdminWithdrawalsReject = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsRejectHook>>>,
      TError,
      { id: string; data: RejectWithdrawalDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsRejectHook>>>,
  TError,
  { id: string; data: RejectWithdrawalDto },
  TContext
> => {
  const mutationOptions = useAdminWithdrawalsRejectMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Bulk approve PENDING withdrawals from the list (lease-free). Each id is checked independently; returns { succeeded, failed } with a reason per skipped id. Rows being reviewed in an open shift are skipped.
 */
export const useAdminWithdrawalsBulkApproveHook = () => {
  const adminWithdrawalsBulkApprove = useCustomInstance<BulkWithdrawalResultDto>();

  return useCallback(
    (bulkWithdrawalIdsDto: BulkWithdrawalIdsDto, signal?: AbortSignal) => {
      return adminWithdrawalsBulkApprove({
        url: `/admin/withdrawals/bulk/approve`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: bulkWithdrawalIdsDto,
        signal,
      });
    },
    [adminWithdrawalsBulkApprove],
  );
};

export const useAdminWithdrawalsBulkApproveMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsBulkApproveHook>>>,
    TError,
    { data: BulkWithdrawalIdsDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsBulkApproveHook>>>,
  TError,
  { data: BulkWithdrawalIdsDto },
  TContext
> => {
  const mutationKey = ['adminWithdrawalsBulkApprove'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminWithdrawalsBulkApprove = useAdminWithdrawalsBulkApproveHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsBulkApproveHook>>>,
    { data: BulkWithdrawalIdsDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminWithdrawalsBulkApprove(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWithdrawalsBulkApproveMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsBulkApproveHook>>>
>;
export type AdminWithdrawalsBulkApproveMutationBody = BulkWithdrawalIdsDto;
export type AdminWithdrawalsBulkApproveMutationError = unknown;

/**
 * @summary Bulk approve PENDING withdrawals from the list (lease-free). Each id is checked independently; returns { succeeded, failed } with a reason per skipped id. Rows being reviewed in an open shift are skipped.
 */
export const useAdminWithdrawalsBulkApprove = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsBulkApproveHook>>>,
      TError,
      { data: BulkWithdrawalIdsDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsBulkApproveHook>>>,
  TError,
  { data: BulkWithdrawalIdsDto },
  TContext
> => {
  const mutationOptions = useAdminWithdrawalsBulkApproveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Bulk reject PENDING withdrawals from the list (lease-free). Refunds each wallet atomically and stores the shared reason. Returns { succeeded, failed }; rows being reviewed in an open shift are skipped.
 */
export const useAdminWithdrawalsBulkRejectHook = () => {
  const adminWithdrawalsBulkReject = useCustomInstance<BulkWithdrawalResultDto>();

  return useCallback(
    (bulkRejectWithdrawalsDto: BulkRejectWithdrawalsDto, signal?: AbortSignal) => {
      return adminWithdrawalsBulkReject({
        url: `/admin/withdrawals/bulk/reject`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: bulkRejectWithdrawalsDto,
        signal,
      });
    },
    [adminWithdrawalsBulkReject],
  );
};

export const useAdminWithdrawalsBulkRejectMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsBulkRejectHook>>>,
    TError,
    { data: BulkRejectWithdrawalsDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsBulkRejectHook>>>,
  TError,
  { data: BulkRejectWithdrawalsDto },
  TContext
> => {
  const mutationKey = ['adminWithdrawalsBulkReject'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminWithdrawalsBulkReject = useAdminWithdrawalsBulkRejectHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsBulkRejectHook>>>,
    { data: BulkRejectWithdrawalsDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminWithdrawalsBulkReject(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWithdrawalsBulkRejectMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsBulkRejectHook>>>
>;
export type AdminWithdrawalsBulkRejectMutationBody = BulkRejectWithdrawalsDto;
export type AdminWithdrawalsBulkRejectMutationError = unknown;

/**
 * @summary Bulk reject PENDING withdrawals from the list (lease-free). Refunds each wallet atomically and stores the shared reason. Returns { succeeded, failed }; rows being reviewed in an open shift are skipped.
 */
export const useAdminWithdrawalsBulkReject = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsBulkRejectHook>>>,
      TError,
      { data: BulkRejectWithdrawalsDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalsBulkRejectHook>>>,
  TError,
  { data: BulkRejectWithdrawalsDto },
  TContext
> => {
  const mutationOptions = useAdminWithdrawalsBulkRejectMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Start a withdrawal review shift. Idempotent — returns the existing shift if one is already active for this approver.
 */
export const useAdminWithdrawalShiftStartHook = () => {
  const adminWithdrawalShiftStart = useCustomInstance<ShiftStateResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminWithdrawalShiftStart({ url: `/admin/withdrawals/shift/start`, method: 'POST', signal });
    },
    [adminWithdrawalShiftStart],
  );
};

export const useAdminWithdrawalShiftStartMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftStartHook>>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftStartHook>>>, TError, void, TContext> => {
  const mutationKey = ['adminWithdrawalShiftStart'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminWithdrawalShiftStart = useAdminWithdrawalShiftStartHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftStartHook>>>,
    void
  > = () => {
    return adminWithdrawalShiftStart();
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWithdrawalShiftStartMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftStartHook>>>
>;

export type AdminWithdrawalShiftStartMutationError = unknown;

/**
 * @summary Start a withdrawal review shift. Idempotent — returns the existing shift if one is already active for this approver.
 */
export const useAdminWithdrawalShiftStart = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftStartHook>>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftStartHook>>>, TError, void, TContext> => {
  const mutationOptions = useAdminWithdrawalShiftStartMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary End the active withdrawal review shift. Returns the final counters. Releases any lease still held by the approver.
 */
export const useAdminWithdrawalShiftEndHook = () => {
  const adminWithdrawalShiftEnd = useCustomInstance<ShiftStateResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminWithdrawalShiftEnd({ url: `/admin/withdrawals/shift/end`, method: 'POST', signal });
    },
    [adminWithdrawalShiftEnd],
  );
};

export const useAdminWithdrawalShiftEndMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftEndHook>>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftEndHook>>>, TError, void, TContext> => {
  const mutationKey = ['adminWithdrawalShiftEnd'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminWithdrawalShiftEnd = useAdminWithdrawalShiftEndHook();

  const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftEndHook>>>, void> = () => {
    return adminWithdrawalShiftEnd();
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWithdrawalShiftEndMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftEndHook>>>
>;

export type AdminWithdrawalShiftEndMutationError = unknown;

/**
 * @summary End the active withdrawal review shift. Returns the final counters. Releases any lease still held by the approver.
 */
export const useAdminWithdrawalShiftEnd = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftEndHook>>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftEndHook>>>, TError, void, TContext> => {
  const mutationOptions = useAdminWithdrawalShiftEndMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List every approver currently on shift, with counters and the withdrawal each is currently reviewing. Drives the "Active approvers" panel on the shift page.
 */
export const useAdminWithdrawalShiftListActiveHook = () => {
  const adminWithdrawalShiftListActive = useCustomInstance<ActiveShiftResponseDto[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminWithdrawalShiftListActive({ url: `/admin/withdrawals/shift/active`, method: 'GET', signal });
    },
    [adminWithdrawalShiftListActive],
  );
};

export const getAdminWithdrawalShiftListActiveQueryKey = () => {
  return [`/admin/withdrawals/shift/active`] as const;
};

export const useAdminWithdrawalShiftListActiveQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftListActiveHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftListActiveHook>>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminWithdrawalShiftListActiveQueryKey();

  const adminWithdrawalShiftListActive = useAdminWithdrawalShiftListActiveHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftListActiveHook>>>> = ({
    signal,
  }) => adminWithdrawalShiftListActive(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftListActiveHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminWithdrawalShiftListActiveQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftListActiveHook>>>
>;
export type AdminWithdrawalShiftListActiveQueryError = unknown;

export function useAdminWithdrawalShiftListActive<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftListActiveHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftListActiveHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftListActiveHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftListActiveHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminWithdrawalShiftListActive<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftListActiveHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftListActiveHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftListActiveHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftListActiveHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminWithdrawalShiftListActive<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftListActiveHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftListActiveHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List every approver currently on shift, with counters and the withdrawal each is currently reviewing. Drives the "Active approvers" panel on the shift page.
 */

export function useAdminWithdrawalShiftListActive<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftListActiveHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftListActiveHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminWithdrawalShiftListActiveQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Resume-on-reload — returns the current shift state including the withdrawal currently leased to this approver.
 */
export const useAdminWithdrawalShiftMeHook = () => {
  const adminWithdrawalShiftMe = useCustomInstance<ShiftStateResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminWithdrawalShiftMe({ url: `/admin/withdrawals/shift/me`, method: 'GET', signal });
    },
    [adminWithdrawalShiftMe],
  );
};

export const getAdminWithdrawalShiftMeQueryKey = () => {
  return [`/admin/withdrawals/shift/me`] as const;
};

export const useAdminWithdrawalShiftMeQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftMeHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftMeHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminWithdrawalShiftMeQueryKey();

  const adminWithdrawalShiftMe = useAdminWithdrawalShiftMeHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftMeHook>>>> = ({ signal }) =>
    adminWithdrawalShiftMe(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftMeHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminWithdrawalShiftMeQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftMeHook>>>
>;
export type AdminWithdrawalShiftMeQueryError = unknown;

export function useAdminWithdrawalShiftMe<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftMeHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftMeHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftMeHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftMeHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminWithdrawalShiftMe<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftMeHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftMeHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftMeHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftMeHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminWithdrawalShiftMe<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftMeHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftMeHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Resume-on-reload — returns the current shift state including the withdrawal currently leased to this approver.
 */

export function useAdminWithdrawalShiftMe<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftMeHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftMeHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminWithdrawalShiftMeQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lease the next PENDING withdrawal (oldest first by SLA, excluding skip-postponed rows). Resumes the existing lease if the approver already holds one. Returns null if the queue is empty.
 */
export const useAdminWithdrawalShiftNextHook = () => {
  const adminWithdrawalShiftNext = useCustomInstance<AdminWithdrawalResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminWithdrawalShiftNext({ url: `/admin/withdrawals/shift/next`, method: 'POST', signal });
    },
    [adminWithdrawalShiftNext],
  );
};

export const useAdminWithdrawalShiftNextMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftNextHook>>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftNextHook>>>, TError, void, TContext> => {
  const mutationKey = ['adminWithdrawalShiftNext'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminWithdrawalShiftNext = useAdminWithdrawalShiftNextHook();

  const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftNextHook>>>, void> = () => {
    return adminWithdrawalShiftNext();
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWithdrawalShiftNextMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftNextHook>>>
>;

export type AdminWithdrawalShiftNextMutationError = unknown;

/**
 * @summary Lease the next PENDING withdrawal (oldest first by SLA, excluding skip-postponed rows). Resumes the existing lease if the approver already holds one. Returns null if the queue is empty.
 */
export const useAdminWithdrawalShiftNext = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftNextHook>>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftNextHook>>>, TError, void, TContext> => {
  const mutationOptions = useAdminWithdrawalShiftNextMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Lease a specific PENDING withdrawal by id (show-page entry point). Auto-starts a shift if none is active. Throws 409 if the row is already leased by another approver or this approver holds a different lease.
 */
export const useAdminWithdrawalShiftClaimHook = () => {
  const adminWithdrawalShiftClaim = useCustomInstance<AdminWithdrawalResponseDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminWithdrawalShiftClaim({ url: `/admin/withdrawals/shift/${id}/claim`, method: 'POST', signal });
    },
    [adminWithdrawalShiftClaim],
  );
};

export const useAdminWithdrawalShiftClaimMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftClaimHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftClaimHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminWithdrawalShiftClaim'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminWithdrawalShiftClaim = useAdminWithdrawalShiftClaimHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftClaimHook>>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminWithdrawalShiftClaim(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWithdrawalShiftClaimMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftClaimHook>>>
>;

export type AdminWithdrawalShiftClaimMutationError = unknown;

/**
 * @summary Lease a specific PENDING withdrawal by id (show-page entry point). Auto-starts a shift if none is active. Throws 409 if the row is already leased by another approver or this approver holds a different lease.
 */
export const useAdminWithdrawalShiftClaim = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftClaimHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftClaimHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useAdminWithdrawalShiftClaimMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Refresh the lease TTL while the approver has the withdrawal open. Throws 409 if the lease is not held by this caller.
 */
export const useAdminWithdrawalShiftHeartbeatHook = () => {
  const adminWithdrawalShiftHeartbeat = useCustomInstance<void>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminWithdrawalShiftHeartbeat({ url: `/admin/withdrawals/shift/${id}/heartbeat`, method: 'POST', signal });
    },
    [adminWithdrawalShiftHeartbeat],
  );
};

export const useAdminWithdrawalShiftHeartbeatMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftHeartbeatHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftHeartbeatHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminWithdrawalShiftHeartbeat'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminWithdrawalShiftHeartbeat = useAdminWithdrawalShiftHeartbeatHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftHeartbeatHook>>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminWithdrawalShiftHeartbeat(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWithdrawalShiftHeartbeatMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftHeartbeatHook>>>
>;

export type AdminWithdrawalShiftHeartbeatMutationError = unknown;

/**
 * @summary Refresh the lease TTL while the approver has the withdrawal open. Throws 409 if the lease is not held by this caller.
 */
export const useAdminWithdrawalShiftHeartbeat = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftHeartbeatHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftHeartbeatHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useAdminWithdrawalShiftHeartbeatMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Skip this withdrawal for N hours. Sets review_skip_until on the row and releases the lease so the approver can move to the next item.
 */
export const useAdminWithdrawalShiftSkipHook = () => {
  const adminWithdrawalShiftSkip = useCustomInstance<void>();

  return useCallback(
    (id: string, skipWithdrawalDto: SkipWithdrawalDto, signal?: AbortSignal) => {
      return adminWithdrawalShiftSkip({
        url: `/admin/withdrawals/shift/${id}/skip`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: skipWithdrawalDto,
        signal,
      });
    },
    [adminWithdrawalShiftSkip],
  );
};

export const useAdminWithdrawalShiftSkipMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftSkipHook>>>,
    TError,
    { id: string; data: SkipWithdrawalDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftSkipHook>>>,
  TError,
  { id: string; data: SkipWithdrawalDto },
  TContext
> => {
  const mutationKey = ['adminWithdrawalShiftSkip'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminWithdrawalShiftSkip = useAdminWithdrawalShiftSkipHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftSkipHook>>>,
    { id: string; data: SkipWithdrawalDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminWithdrawalShiftSkip(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWithdrawalShiftSkipMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftSkipHook>>>
>;
export type AdminWithdrawalShiftSkipMutationBody = SkipWithdrawalDto;
export type AdminWithdrawalShiftSkipMutationError = unknown;

/**
 * @summary Skip this withdrawal for N hours. Sets review_skip_until on the row and releases the lease so the approver can move to the next item.
 */
export const useAdminWithdrawalShiftSkip = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftSkipHook>>>,
      TError,
      { id: string; data: SkipWithdrawalDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawalShiftSkipHook>>>,
  TError,
  { id: string; data: SkipWithdrawalDto },
  TContext
> => {
  const mutationOptions = useAdminWithdrawalShiftSkipMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List all user tags
 */
export const useAdminTagsListHook = () => {
  const adminTagsList = useCustomInstance<TagListResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminTagsList({ url: `/admin/tags`, method: 'GET', signal });
    },
    [adminTagsList],
  );
};

export const getAdminTagsListQueryKey = () => {
  return [`/admin/tags`] as const;
};

export const useAdminTagsListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTagsListHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTagsListHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminTagsListQueryKey();

  const adminTagsList = useAdminTagsListHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminTagsListHook>>>> = ({ signal }) =>
    adminTagsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminTagsListHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminTagsListQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminTagsListHook>>>>;
export type AdminTagsListQueryError = unknown;

export function useAdminTagsList<TData = Awaited<ReturnType<ReturnType<typeof useAdminTagsListHook>>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTagsListHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminTagsListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminTagsListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminTagsList<TData = Awaited<ReturnType<ReturnType<typeof useAdminTagsListHook>>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTagsListHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminTagsListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminTagsListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminTagsList<TData = Awaited<ReturnType<ReturnType<typeof useAdminTagsListHook>>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTagsListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List all user tags
 */

export function useAdminTagsList<TData = Awaited<ReturnType<ReturnType<typeof useAdminTagsListHook>>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTagsListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminTagsListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a user tag
 */
export const useAdminTagsCreateHook = () => {
  const adminTagsCreate = useCustomInstance<TagResponseDto>();

  return useCallback(
    (createTagDto: CreateTagDto, signal?: AbortSignal) => {
      return adminTagsCreate({
        url: `/admin/tags`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createTagDto,
        signal,
      });
    },
    [adminTagsCreate],
  );
};

export const useAdminTagsCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminTagsCreateHook>>>,
    TError,
    { data: CreateTagDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminTagsCreateHook>>>,
  TError,
  { data: CreateTagDto },
  TContext
> => {
  const mutationKey = ['adminTagsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminTagsCreate = useAdminTagsCreateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminTagsCreateHook>>>,
    { data: CreateTagDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminTagsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminTagsCreateMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminTagsCreateHook>>>>;
export type AdminTagsCreateMutationBody = CreateTagDto;
export type AdminTagsCreateMutationError = unknown;

/**
 * @summary Create a user tag
 */
export const useAdminTagsCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminTagsCreateHook>>>,
      TError,
      { data: CreateTagDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminTagsCreateHook>>>,
  TError,
  { data: CreateTagDto },
  TContext
> => {
  const mutationOptions = useAdminTagsCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Intercom messenger identity (user_id + Identity-Verification hash) for the current player
 */
export const useIntercomGetIdentityHook = () => {
  const intercomGetIdentity = useCustomInstance<IntercomIdentityDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return intercomGetIdentity({ url: `/intercom/identity`, method: 'GET', signal });
    },
    [intercomGetIdentity],
  );
};

export const getIntercomGetIdentityQueryKey = () => {
  return [`/intercom/identity`] as const;
};

export const useIntercomGetIdentityQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useIntercomGetIdentityHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useIntercomGetIdentityHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getIntercomGetIdentityQueryKey();

  const intercomGetIdentity = useIntercomGetIdentityHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useIntercomGetIdentityHook>>>> = ({ signal }) =>
    intercomGetIdentity(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useIntercomGetIdentityHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type IntercomGetIdentityQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useIntercomGetIdentityHook>>>>;
export type IntercomGetIdentityQueryError = unknown;

export function useIntercomGetIdentity<
  TData = Awaited<ReturnType<ReturnType<typeof useIntercomGetIdentityHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useIntercomGetIdentityHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useIntercomGetIdentityHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useIntercomGetIdentityHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useIntercomGetIdentity<
  TData = Awaited<ReturnType<ReturnType<typeof useIntercomGetIdentityHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useIntercomGetIdentityHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useIntercomGetIdentityHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useIntercomGetIdentityHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useIntercomGetIdentity<
  TData = Awaited<ReturnType<ReturnType<typeof useIntercomGetIdentityHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useIntercomGetIdentityHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Intercom messenger identity (user_id + Identity-Verification hash) for the current player
 */

export function useIntercomGetIdentity<
  TData = Awaited<ReturnType<ReturnType<typeof useIntercomGetIdentityHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useIntercomGetIdentityHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useIntercomGetIdentityQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List all base categories with nested sub-categories
 */
export const useAdminCategoriesListHook = () => {
  const adminCategoriesList = useCustomInstance<AdminCategoryListResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminCategoriesList({ url: `/admin/categories`, method: 'GET', signal });
    },
    [adminCategoriesList],
  );
};

export const getAdminCategoriesListQueryKey = () => {
  return [`/admin/categories`] as const;
};

export const useAdminCategoriesListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminCategoriesListHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminCategoriesListHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminCategoriesListQueryKey();

  const adminCategoriesList = useAdminCategoriesListHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminCategoriesListHook>>>> = ({ signal }) =>
    adminCategoriesList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminCategoriesListHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminCategoriesListQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminCategoriesListHook>>>>;
export type AdminCategoriesListQueryError = unknown;

export function useAdminCategoriesList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminCategoriesListHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminCategoriesListHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminCategoriesListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminCategoriesListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminCategoriesList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminCategoriesListHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminCategoriesListHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminCategoriesListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminCategoriesListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminCategoriesList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminCategoriesListHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminCategoriesListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List all base categories with nested sub-categories
 */

export function useAdminCategoriesList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminCategoriesListHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminCategoriesListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminCategoriesListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update a category (displayName, iconImgUrl, active)
 */
export const useAdminCategoriesUpdateCategoryHook = () => {
  const adminCategoriesUpdateCategory = useCustomInstance<AdminCategoryDto>();

  return useCallback(
    (id: string, updateCategoryDto: UpdateCategoryDto) => {
      return adminCategoriesUpdateCategory({
        url: `/admin/categories/${id}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateCategoryDto,
      });
    },
    [adminCategoriesUpdateCategory],
  );
};

export const useAdminCategoriesUpdateCategoryMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminCategoriesUpdateCategoryHook>>>,
    TError,
    { id: string; data: UpdateCategoryDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminCategoriesUpdateCategoryHook>>>,
  TError,
  { id: string; data: UpdateCategoryDto },
  TContext
> => {
  const mutationKey = ['adminCategoriesUpdateCategory'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminCategoriesUpdateCategory = useAdminCategoriesUpdateCategoryHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminCategoriesUpdateCategoryHook>>>,
    { id: string; data: UpdateCategoryDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminCategoriesUpdateCategory(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCategoriesUpdateCategoryMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminCategoriesUpdateCategoryHook>>>
>;
export type AdminCategoriesUpdateCategoryMutationBody = UpdateCategoryDto;
export type AdminCategoriesUpdateCategoryMutationError = unknown;

/**
 * @summary Update a category (displayName, iconImgUrl, active)
 */
export const useAdminCategoriesUpdateCategory = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminCategoriesUpdateCategoryHook>>>,
      TError,
      { id: string; data: UpdateCategoryDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminCategoriesUpdateCategoryHook>>>,
  TError,
  { id: string; data: UpdateCategoryDto },
  TContext
> => {
  const mutationOptions = useAdminCategoriesUpdateCategoryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Update a sub-category (displayName, iconImgUrl, active)
 */
export const useAdminCategoriesUpdateSubCategoryHook = () => {
  const adminCategoriesUpdateSubCategory = useCustomInstance<AdminSubCategoryDto>();

  return useCallback(
    (id: string, updateSubCategoryDto: UpdateSubCategoryDto) => {
      return adminCategoriesUpdateSubCategory({
        url: `/admin/sub-categories/${id}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateSubCategoryDto,
      });
    },
    [adminCategoriesUpdateSubCategory],
  );
};

export const useAdminCategoriesUpdateSubCategoryMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminCategoriesUpdateSubCategoryHook>>>,
    TError,
    { id: string; data: UpdateSubCategoryDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminCategoriesUpdateSubCategoryHook>>>,
  TError,
  { id: string; data: UpdateSubCategoryDto },
  TContext
> => {
  const mutationKey = ['adminCategoriesUpdateSubCategory'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminCategoriesUpdateSubCategory = useAdminCategoriesUpdateSubCategoryHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminCategoriesUpdateSubCategoryHook>>>,
    { id: string; data: UpdateSubCategoryDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminCategoriesUpdateSubCategory(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCategoriesUpdateSubCategoryMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminCategoriesUpdateSubCategoryHook>>>
>;
export type AdminCategoriesUpdateSubCategoryMutationBody = UpdateSubCategoryDto;
export type AdminCategoriesUpdateSubCategoryMutationError = unknown;

/**
 * @summary Update a sub-category (displayName, iconImgUrl, active)
 */
export const useAdminCategoriesUpdateSubCategory = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminCategoriesUpdateSubCategoryHook>>>,
      TError,
      { id: string; data: UpdateSubCategoryDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminCategoriesUpdateSubCategoryHook>>>,
  TError,
  { id: string; data: UpdateSubCategoryDto },
  TContext
> => {
  const mutationOptions = useAdminCategoriesUpdateSubCategoryMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Sync categories from Plaee on demand (synchronous). Invalidates the category cache only when something changed. The same sync also runs automatically every 30 minutes.
 */
export const useAdminCategoriesSyncCategoriesHook = () => {
  const adminCategoriesSyncCategories = useCustomInstance<SyncCategoriesResultDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminCategoriesSyncCategories({ url: `/admin/sync-categories`, method: 'POST', signal });
    },
    [adminCategoriesSyncCategories],
  );
};

export const useAdminCategoriesSyncCategoriesMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminCategoriesSyncCategoriesHook>>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminCategoriesSyncCategoriesHook>>>,
  TError,
  void,
  TContext
> => {
  const mutationKey = ['adminCategoriesSyncCategories'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminCategoriesSyncCategories = useAdminCategoriesSyncCategoriesHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminCategoriesSyncCategoriesHook>>>,
    void
  > = () => {
    return adminCategoriesSyncCategories();
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCategoriesSyncCategoriesMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminCategoriesSyncCategoriesHook>>>
>;

export type AdminCategoriesSyncCategoriesMutationError = unknown;

/**
 * @summary Sync categories from Plaee on demand (synchronous). Invalidates the category cache only when something changed. The same sync also runs automatically every 30 minutes.
 */
export const useAdminCategoriesSyncCategories = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminCategoriesSyncCategoriesHook>>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminCategoriesSyncCategoriesHook>>>,
  TError,
  void,
  TContext
> => {
  const mutationOptions = useAdminCategoriesSyncCategoriesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List category sets with item & assignment counts
 */
export const useAdminCategorySetsListHook = () => {
  const adminCategorySetsList = useCustomInstance<CategorySetListResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminCategorySetsList({ url: `/admin/category-sets`, method: 'GET', signal });
    },
    [adminCategorySetsList],
  );
};

export const getAdminCategorySetsListQueryKey = () => {
  return [`/admin/category-sets`] as const;
};

export const useAdminCategorySetsListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsListHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsListHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminCategorySetsListQueryKey();

  const adminCategorySetsList = useAdminCategorySetsListHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsListHook>>>> = ({ signal }) =>
    adminCategorySetsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsListHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminCategorySetsListQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsListHook>>>
>;
export type AdminCategorySetsListQueryError = unknown;

export function useAdminCategorySetsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsListHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsListHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminCategorySetsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsListHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsListHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminCategorySetsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsListHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List category sets with item & assignment counts
 */

export function useAdminCategorySetsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsListHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminCategorySetsListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a new category set
 */
export const useAdminCategorySetsCreateHook = () => {
  const adminCategorySetsCreate = useCustomInstance<CategorySetEntityDto>();

  return useCallback(
    (createCategorySetDto: CreateCategorySetDto, signal?: AbortSignal) => {
      return adminCategorySetsCreate({
        url: `/admin/category-sets`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createCategorySetDto,
        signal,
      });
    },
    [adminCategorySetsCreate],
  );
};

export const useAdminCategorySetsCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsCreateHook>>>,
    TError,
    { data: CreateCategorySetDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsCreateHook>>>,
  TError,
  { data: CreateCategorySetDto },
  TContext
> => {
  const mutationKey = ['adminCategorySetsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminCategorySetsCreate = useAdminCategorySetsCreateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsCreateHook>>>,
    { data: CreateCategorySetDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminCategorySetsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCategorySetsCreateMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsCreateHook>>>
>;
export type AdminCategorySetsCreateMutationBody = CreateCategorySetDto;
export type AdminCategorySetsCreateMutationError = unknown;

/**
 * @summary Create a new category set
 */
export const useAdminCategorySetsCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsCreateHook>>>,
      TError,
      { data: CreateCategorySetDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsCreateHook>>>,
  TError,
  { data: CreateCategorySetDto },
  TContext
> => {
  const mutationOptions = useAdminCategorySetsCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get a category set with its ordered items
 */
export const useAdminCategorySetsGetOneHook = () => {
  const adminCategorySetsGetOne = useCustomInstance<CategorySetDetailDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminCategorySetsGetOne({ url: `/admin/category-sets/${id}`, method: 'GET', signal });
    },
    [adminCategorySetsGetOne],
  );
};

export const getAdminCategorySetsGetOneQueryKey = (id: string) => {
  return [`/admin/category-sets/${id}`] as const;
};

export const useAdminCategorySetsGetOneQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsGetOneHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminCategorySetsGetOneQueryKey(id);

  const adminCategorySetsGetOne = useAdminCategorySetsGetOneHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsGetOneHook>>>> = ({ signal }) =>
    adminCategorySetsGetOne(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsGetOneHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminCategorySetsGetOneQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsGetOneHook>>>
>;
export type AdminCategorySetsGetOneQueryError = unknown;

export function useAdminCategorySetsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsGetOneHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminCategorySetsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsGetOneHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminCategorySetsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsGetOneHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a category set with its ordered items
 */

export function useAdminCategorySetsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsGetOneHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminCategorySetsGetOneQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Rename, re-describe, or toggle default on a category set
 */
export const useAdminCategorySetsUpdateHook = () => {
  const adminCategorySetsUpdate = useCustomInstance<CategorySetEntityDto>();

  return useCallback(
    (id: string, updateCategorySetDto: UpdateCategorySetDto) => {
      return adminCategorySetsUpdate({
        url: `/admin/category-sets/${id}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateCategorySetDto,
      });
    },
    [adminCategorySetsUpdate],
  );
};

export const useAdminCategorySetsUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsUpdateHook>>>,
    TError,
    { id: string; data: UpdateCategorySetDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsUpdateHook>>>,
  TError,
  { id: string; data: UpdateCategorySetDto },
  TContext
> => {
  const mutationKey = ['adminCategorySetsUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminCategorySetsUpdate = useAdminCategorySetsUpdateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsUpdateHook>>>,
    { id: string; data: UpdateCategorySetDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminCategorySetsUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCategorySetsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsUpdateHook>>>
>;
export type AdminCategorySetsUpdateMutationBody = UpdateCategorySetDto;
export type AdminCategorySetsUpdateMutationError = unknown;

/**
 * @summary Rename, re-describe, or toggle default on a category set
 */
export const useAdminCategorySetsUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsUpdateHook>>>,
      TError,
      { id: string; data: UpdateCategorySetDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsUpdateHook>>>,
  TError,
  { id: string; data: UpdateCategorySetDto },
  TContext
> => {
  const mutationOptions = useAdminCategorySetsUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Delete a category set (blocked if any segment is still assigned to it)
 */
export const useAdminCategorySetsRemoveHook = () => {
  const adminCategorySetsRemove = useCustomInstance<CategorySetEntityDto>();

  return useCallback(
    (id: string) => {
      return adminCategorySetsRemove({ url: `/admin/category-sets/${id}`, method: 'DELETE' });
    },
    [adminCategorySetsRemove],
  );
};

export const useAdminCategorySetsRemoveMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsRemoveHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsRemoveHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminCategorySetsRemove'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminCategorySetsRemove = useAdminCategorySetsRemoveHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsRemoveHook>>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminCategorySetsRemove(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCategorySetsRemoveMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsRemoveHook>>>
>;

export type AdminCategorySetsRemoveMutationError = unknown;

/**
 * @summary Delete a category set (blocked if any segment is still assigned to it)
 */
export const useAdminCategorySetsRemove = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsRemoveHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsRemoveHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useAdminCategorySetsRemoveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Replace the ordered list of categories on a set (index = sortOrder)
 */
export const useAdminCategorySetsReplaceItemsHook = () => {
  const adminCategorySetsReplaceItems = useCustomInstance<CategorySetDetailDto>();

  return useCallback(
    (id: string, replaceItemsDto: ReplaceItemsDto) => {
      return adminCategorySetsReplaceItems({
        url: `/admin/category-sets/${id}/items`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: replaceItemsDto,
      });
    },
    [adminCategorySetsReplaceItems],
  );
};

export const useAdminCategorySetsReplaceItemsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsReplaceItemsHook>>>,
    TError,
    { id: string; data: ReplaceItemsDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsReplaceItemsHook>>>,
  TError,
  { id: string; data: ReplaceItemsDto },
  TContext
> => {
  const mutationKey = ['adminCategorySetsReplaceItems'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminCategorySetsReplaceItems = useAdminCategorySetsReplaceItemsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsReplaceItemsHook>>>,
    { id: string; data: ReplaceItemsDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminCategorySetsReplaceItems(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCategorySetsReplaceItemsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsReplaceItemsHook>>>
>;
export type AdminCategorySetsReplaceItemsMutationBody = ReplaceItemsDto;
export type AdminCategorySetsReplaceItemsMutationError = unknown;

/**
 * @summary Replace the ordered list of categories on a set (index = sortOrder)
 */
export const useAdminCategorySetsReplaceItems = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsReplaceItemsHook>>>,
      TError,
      { id: string; data: ReplaceItemsDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminCategorySetsReplaceItemsHook>>>,
  TError,
  { id: string; data: ReplaceItemsDto },
  TContext
> => {
  const mutationOptions = useAdminCategorySetsReplaceItemsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List segment → category-set assignments
 */
export const useAdminSegmentAssignmentsListHook = () => {
  const adminSegmentAssignmentsList = useCustomInstance<SegmentAssignmentListResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminSegmentAssignmentsList({ url: `/admin/segment-assignments`, method: 'GET', signal });
    },
    [adminSegmentAssignmentsList],
  );
};

export const getAdminSegmentAssignmentsListQueryKey = () => {
  return [`/admin/segment-assignments`] as const;
};

export const useAdminSegmentAssignmentsListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSegmentAssignmentsListHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSegmentAssignmentsListHook>>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminSegmentAssignmentsListQueryKey();

  const adminSegmentAssignmentsList = useAdminSegmentAssignmentsListHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminSegmentAssignmentsListHook>>>> = ({ signal }) =>
    adminSegmentAssignmentsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminSegmentAssignmentsListHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminSegmentAssignmentsListQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminSegmentAssignmentsListHook>>>
>;
export type AdminSegmentAssignmentsListQueryError = unknown;

export function useAdminSegmentAssignmentsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSegmentAssignmentsListHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSegmentAssignmentsListHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminSegmentAssignmentsListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminSegmentAssignmentsListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminSegmentAssignmentsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSegmentAssignmentsListHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSegmentAssignmentsListHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminSegmentAssignmentsListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminSegmentAssignmentsListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminSegmentAssignmentsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSegmentAssignmentsListHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSegmentAssignmentsListHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List segment → category-set assignments
 */

export function useAdminSegmentAssignmentsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSegmentAssignmentsListHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSegmentAssignmentsListHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminSegmentAssignmentsListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Assign a category set to a segment (upsert)
 */
export const useAdminSegmentAssignmentsUpsertHook = () => {
  const adminSegmentAssignmentsUpsert = useCustomInstance<SegmentAssignmentEntityDto>();

  return useCallback(
    (segmentKey: string, upsertSegmentAssignmentDto: UpsertSegmentAssignmentDto) => {
      return adminSegmentAssignmentsUpsert({
        url: `/admin/segment-assignments/${segmentKey}`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: upsertSegmentAssignmentDto,
      });
    },
    [adminSegmentAssignmentsUpsert],
  );
};

export const useAdminSegmentAssignmentsUpsertMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminSegmentAssignmentsUpsertHook>>>,
    TError,
    { segmentKey: string; data: UpsertSegmentAssignmentDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminSegmentAssignmentsUpsertHook>>>,
  TError,
  { segmentKey: string; data: UpsertSegmentAssignmentDto },
  TContext
> => {
  const mutationKey = ['adminSegmentAssignmentsUpsert'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminSegmentAssignmentsUpsert = useAdminSegmentAssignmentsUpsertHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminSegmentAssignmentsUpsertHook>>>,
    { segmentKey: string; data: UpsertSegmentAssignmentDto }
  > = (props) => {
    const { segmentKey, data } = props ?? {};

    return adminSegmentAssignmentsUpsert(segmentKey, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSegmentAssignmentsUpsertMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminSegmentAssignmentsUpsertHook>>>
>;
export type AdminSegmentAssignmentsUpsertMutationBody = UpsertSegmentAssignmentDto;
export type AdminSegmentAssignmentsUpsertMutationError = unknown;

/**
 * @summary Assign a category set to a segment (upsert)
 */
export const useAdminSegmentAssignmentsUpsert = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminSegmentAssignmentsUpsertHook>>>,
      TError,
      { segmentKey: string; data: UpsertSegmentAssignmentDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminSegmentAssignmentsUpsertHook>>>,
  TError,
  { segmentKey: string; data: UpsertSegmentAssignmentDto },
  TContext
> => {
  const mutationOptions = useAdminSegmentAssignmentsUpsertMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Unassign a segment (falls back to default set after this)
 */
export const useAdminSegmentAssignmentsRemoveHook = () => {
  const adminSegmentAssignmentsRemove = useCustomInstance<SegmentAssignmentEntityDto>();

  return useCallback(
    (segmentKey: string) => {
      return adminSegmentAssignmentsRemove({ url: `/admin/segment-assignments/${segmentKey}`, method: 'DELETE' });
    },
    [adminSegmentAssignmentsRemove],
  );
};

export const useAdminSegmentAssignmentsRemoveMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminSegmentAssignmentsRemoveHook>>>,
    TError,
    { segmentKey: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminSegmentAssignmentsRemoveHook>>>,
  TError,
  { segmentKey: string },
  TContext
> => {
  const mutationKey = ['adminSegmentAssignmentsRemove'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminSegmentAssignmentsRemove = useAdminSegmentAssignmentsRemoveHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminSegmentAssignmentsRemoveHook>>>,
    { segmentKey: string }
  > = (props) => {
    const { segmentKey } = props ?? {};

    return adminSegmentAssignmentsRemove(segmentKey);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSegmentAssignmentsRemoveMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminSegmentAssignmentsRemoveHook>>>
>;

export type AdminSegmentAssignmentsRemoveMutationError = unknown;

/**
 * @summary Unassign a segment (falls back to default set after this)
 */
export const useAdminSegmentAssignmentsRemove = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminSegmentAssignmentsRemoveHook>>>,
      TError,
      { segmentKey: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminSegmentAssignmentsRemoveHook>>>,
  TError,
  { segmentKey: string },
  TContext
> => {
  const mutationOptions = useAdminSegmentAssignmentsRemoveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List stores (deposit configurations) with assignment counts
 */
export const useAdminStoresListHook = () => {
  const adminStoresList = useCustomInstance<StoreListResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminStoresList({ url: `/admin/stores`, method: 'GET', signal });
    },
    [adminStoresList],
  );
};

export const getAdminStoresListQueryKey = () => {
  return [`/admin/stores`] as const;
};

export const useAdminStoresListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminStoresListHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminStoresListHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminStoresListQueryKey();

  const adminStoresList = useAdminStoresListHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminStoresListHook>>>> = ({ signal }) =>
    adminStoresList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminStoresListHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminStoresListQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminStoresListHook>>>>;
export type AdminStoresListQueryError = unknown;

export function useAdminStoresList<TData = Awaited<ReturnType<ReturnType<typeof useAdminStoresListHook>>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminStoresListHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminStoresListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminStoresListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminStoresList<TData = Awaited<ReturnType<ReturnType<typeof useAdminStoresListHook>>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminStoresListHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminStoresListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminStoresListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminStoresList<TData = Awaited<ReturnType<ReturnType<typeof useAdminStoresListHook>>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminStoresListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List stores (deposit configurations) with assignment counts
 */

export function useAdminStoresList<TData = Awaited<ReturnType<ReturnType<typeof useAdminStoresListHook>>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminStoresListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminStoresListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a new store
 */
export const useAdminStoresCreateHook = () => {
  const adminStoresCreate = useCustomInstance<StoreEntityDto>();

  return useCallback(
    (createStoreDto: CreateStoreDto, signal?: AbortSignal) => {
      return adminStoresCreate({
        url: `/admin/stores`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createStoreDto,
        signal,
      });
    },
    [adminStoresCreate],
  );
};

export const useAdminStoresCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminStoresCreateHook>>>,
    TError,
    { data: CreateStoreDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminStoresCreateHook>>>,
  TError,
  { data: CreateStoreDto },
  TContext
> => {
  const mutationKey = ['adminStoresCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminStoresCreate = useAdminStoresCreateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminStoresCreateHook>>>,
    { data: CreateStoreDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminStoresCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminStoresCreateMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminStoresCreateHook>>>>;
export type AdminStoresCreateMutationBody = CreateStoreDto;
export type AdminStoresCreateMutationError = unknown;

/**
 * @summary Create a new store
 */
export const useAdminStoresCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminStoresCreateHook>>>,
      TError,
      { data: CreateStoreDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminStoresCreateHook>>>,
  TError,
  { data: CreateStoreDto },
  TContext
> => {
  const mutationOptions = useAdminStoresCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get a single store by id
 */
export const useAdminStoresGetOneHook = () => {
  const adminStoresGetOne = useCustomInstance<StoreResponseDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminStoresGetOne({ url: `/admin/stores/${id}`, method: 'GET', signal });
    },
    [adminStoresGetOne],
  );
};

export const getAdminStoresGetOneQueryKey = (id: string) => {
  return [`/admin/stores/${id}`] as const;
};

export const useAdminStoresGetOneQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminStoresGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminStoresGetOneHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminStoresGetOneQueryKey(id);

  const adminStoresGetOne = useAdminStoresGetOneHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminStoresGetOneHook>>>> = ({ signal }) =>
    adminStoresGetOne(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminStoresGetOneHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminStoresGetOneQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminStoresGetOneHook>>>>;
export type AdminStoresGetOneQueryError = unknown;

export function useAdminStoresGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminStoresGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminStoresGetOneHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminStoresGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminStoresGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminStoresGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminStoresGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminStoresGetOneHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminStoresGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminStoresGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminStoresGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminStoresGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminStoresGetOneHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a single store by id
 */

export function useAdminStoresGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminStoresGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminStoresGetOneHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminStoresGetOneQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update a store (limits, suggested amounts, default/active flags)
 */
export const useAdminStoresUpdateHook = () => {
  const adminStoresUpdate = useCustomInstance<StoreEntityDto>();

  return useCallback(
    (id: string, updateStoreDto: UpdateStoreDto) => {
      return adminStoresUpdate({
        url: `/admin/stores/${id}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateStoreDto,
      });
    },
    [adminStoresUpdate],
  );
};

export const useAdminStoresUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminStoresUpdateHook>>>,
    TError,
    { id: string; data: UpdateStoreDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminStoresUpdateHook>>>,
  TError,
  { id: string; data: UpdateStoreDto },
  TContext
> => {
  const mutationKey = ['adminStoresUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminStoresUpdate = useAdminStoresUpdateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminStoresUpdateHook>>>,
    { id: string; data: UpdateStoreDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminStoresUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminStoresUpdateMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminStoresUpdateHook>>>>;
export type AdminStoresUpdateMutationBody = UpdateStoreDto;
export type AdminStoresUpdateMutationError = unknown;

/**
 * @summary Update a store (limits, suggested amounts, default/active flags)
 */
export const useAdminStoresUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminStoresUpdateHook>>>,
      TError,
      { id: string; data: UpdateStoreDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminStoresUpdateHook>>>,
  TError,
  { id: string; data: UpdateStoreDto },
  TContext
> => {
  const mutationOptions = useAdminStoresUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Delete a store (blocked if default or any segment is assigned to it)
 */
export const useAdminStoresRemoveHook = () => {
  const adminStoresRemove = useCustomInstance<StoreEntityDto>();

  return useCallback(
    (id: string) => {
      return adminStoresRemove({ url: `/admin/stores/${id}`, method: 'DELETE' });
    },
    [adminStoresRemove],
  );
};

export const useAdminStoresRemoveMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminStoresRemoveHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminStoresRemoveHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminStoresRemove'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminStoresRemove = useAdminStoresRemoveHook();

  const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useAdminStoresRemoveHook>>>, { id: string }> = (
    props,
  ) => {
    const { id } = props ?? {};

    return adminStoresRemove(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminStoresRemoveMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminStoresRemoveHook>>>>;

export type AdminStoresRemoveMutationError = unknown;

/**
 * @summary Delete a store (blocked if default or any segment is assigned to it)
 */
export const useAdminStoresRemove = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminStoresRemoveHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useAdminStoresRemoveHook>>>, TError, { id: string }, TContext> => {
  const mutationOptions = useAdminStoresRemoveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List segment → store assignments
 */
export const useAdminSegmentStoreAssignmentsListHook = () => {
  const adminSegmentStoreAssignmentsList = useCustomInstance<SegmentStoreAssignmentListResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminSegmentStoreAssignmentsList({ url: `/admin/segment-store-assignments`, method: 'GET', signal });
    },
    [adminSegmentStoreAssignmentsList],
  );
};

export const getAdminSegmentStoreAssignmentsListQueryKey = () => {
  return [`/admin/segment-store-assignments`] as const;
};

export const useAdminSegmentStoreAssignmentsListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSegmentStoreAssignmentsListHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSegmentStoreAssignmentsListHook>>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminSegmentStoreAssignmentsListQueryKey();

  const adminSegmentStoreAssignmentsList = useAdminSegmentStoreAssignmentsListHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminSegmentStoreAssignmentsListHook>>>> = ({
    signal,
  }) => adminSegmentStoreAssignmentsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminSegmentStoreAssignmentsListHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminSegmentStoreAssignmentsListQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminSegmentStoreAssignmentsListHook>>>
>;
export type AdminSegmentStoreAssignmentsListQueryError = unknown;

export function useAdminSegmentStoreAssignmentsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSegmentStoreAssignmentsListHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSegmentStoreAssignmentsListHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminSegmentStoreAssignmentsListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminSegmentStoreAssignmentsListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminSegmentStoreAssignmentsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSegmentStoreAssignmentsListHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSegmentStoreAssignmentsListHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminSegmentStoreAssignmentsListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminSegmentStoreAssignmentsListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminSegmentStoreAssignmentsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSegmentStoreAssignmentsListHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSegmentStoreAssignmentsListHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List segment → store assignments
 */

export function useAdminSegmentStoreAssignmentsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSegmentStoreAssignmentsListHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSegmentStoreAssignmentsListHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminSegmentStoreAssignmentsListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Assign a store to a segment (upsert)
 */
export const useAdminSegmentStoreAssignmentsUpsertHook = () => {
  const adminSegmentStoreAssignmentsUpsert = useCustomInstance<SegmentStoreAssignmentEntityDto>();

  return useCallback(
    (segmentKey: string, upsertSegmentStoreAssignmentDto: UpsertSegmentStoreAssignmentDto) => {
      return adminSegmentStoreAssignmentsUpsert({
        url: `/admin/segment-store-assignments/${segmentKey}`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: upsertSegmentStoreAssignmentDto,
      });
    },
    [adminSegmentStoreAssignmentsUpsert],
  );
};

export const useAdminSegmentStoreAssignmentsUpsertMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminSegmentStoreAssignmentsUpsertHook>>>,
    TError,
    { segmentKey: string; data: UpsertSegmentStoreAssignmentDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminSegmentStoreAssignmentsUpsertHook>>>,
  TError,
  { segmentKey: string; data: UpsertSegmentStoreAssignmentDto },
  TContext
> => {
  const mutationKey = ['adminSegmentStoreAssignmentsUpsert'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminSegmentStoreAssignmentsUpsert = useAdminSegmentStoreAssignmentsUpsertHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminSegmentStoreAssignmentsUpsertHook>>>,
    { segmentKey: string; data: UpsertSegmentStoreAssignmentDto }
  > = (props) => {
    const { segmentKey, data } = props ?? {};

    return adminSegmentStoreAssignmentsUpsert(segmentKey, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSegmentStoreAssignmentsUpsertMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminSegmentStoreAssignmentsUpsertHook>>>
>;
export type AdminSegmentStoreAssignmentsUpsertMutationBody = UpsertSegmentStoreAssignmentDto;
export type AdminSegmentStoreAssignmentsUpsertMutationError = unknown;

/**
 * @summary Assign a store to a segment (upsert)
 */
export const useAdminSegmentStoreAssignmentsUpsert = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminSegmentStoreAssignmentsUpsertHook>>>,
      TError,
      { segmentKey: string; data: UpsertSegmentStoreAssignmentDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminSegmentStoreAssignmentsUpsertHook>>>,
  TError,
  { segmentKey: string; data: UpsertSegmentStoreAssignmentDto },
  TContext
> => {
  const mutationOptions = useAdminSegmentStoreAssignmentsUpsertMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Unassign a segment from any store (falls back to default after this)
 */
export const useAdminSegmentStoreAssignmentsRemoveHook = () => {
  const adminSegmentStoreAssignmentsRemove = useCustomInstance<SegmentStoreAssignmentEntityDto>();

  return useCallback(
    (segmentKey: string) => {
      return adminSegmentStoreAssignmentsRemove({ url: `/admin/segment-store-assignments/${segmentKey}`, method: 'DELETE' });
    },
    [adminSegmentStoreAssignmentsRemove],
  );
};

export const useAdminSegmentStoreAssignmentsRemoveMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminSegmentStoreAssignmentsRemoveHook>>>,
    TError,
    { segmentKey: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminSegmentStoreAssignmentsRemoveHook>>>,
  TError,
  { segmentKey: string },
  TContext
> => {
  const mutationKey = ['adminSegmentStoreAssignmentsRemove'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminSegmentStoreAssignmentsRemove = useAdminSegmentStoreAssignmentsRemoveHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminSegmentStoreAssignmentsRemoveHook>>>,
    { segmentKey: string }
  > = (props) => {
    const { segmentKey } = props ?? {};

    return adminSegmentStoreAssignmentsRemove(segmentKey);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSegmentStoreAssignmentsRemoveMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminSegmentStoreAssignmentsRemoveHook>>>
>;

export type AdminSegmentStoreAssignmentsRemoveMutationError = unknown;

/**
 * @summary Unassign a segment from any store (falls back to default after this)
 */
export const useAdminSegmentStoreAssignmentsRemove = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminSegmentStoreAssignmentsRemoveHook>>>,
      TError,
      { segmentKey: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminSegmentStoreAssignmentsRemoveHook>>>,
  TError,
  { segmentKey: string },
  TContext
> => {
  const mutationOptions = useAdminSegmentStoreAssignmentsRemoveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List all withdraw methods (active and inactive)
 */
export const useAdminWithdrawMethodsListHook = () => {
  const adminWithdrawMethodsList = useCustomInstance<WithdrawMethodListResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminWithdrawMethodsList({ url: `/admin/withdraw-methods`, method: 'GET', signal });
    },
    [adminWithdrawMethodsList],
  );
};

export const getAdminWithdrawMethodsListQueryKey = () => {
  return [`/admin/withdraw-methods`] as const;
};

export const useAdminWithdrawMethodsListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsListHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsListHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminWithdrawMethodsListQueryKey();

  const adminWithdrawMethodsList = useAdminWithdrawMethodsListHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsListHook>>>> = ({ signal }) =>
    adminWithdrawMethodsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsListHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminWithdrawMethodsListQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsListHook>>>
>;
export type AdminWithdrawMethodsListQueryError = unknown;

export function useAdminWithdrawMethodsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsListHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsListHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminWithdrawMethodsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsListHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsListHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminWithdrawMethodsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsListHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List all withdraw methods (active and inactive)
 */

export function useAdminWithdrawMethodsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsListHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminWithdrawMethodsListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a new withdraw method
 */
export const useAdminWithdrawMethodsCreateHook = () => {
  const adminWithdrawMethodsCreate = useCustomInstance<AdminWithdrawMethodResponseDto>();

  return useCallback(
    (createWithdrawMethodDto: CreateWithdrawMethodDto, signal?: AbortSignal) => {
      return adminWithdrawMethodsCreate({
        url: `/admin/withdraw-methods`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createWithdrawMethodDto,
        signal,
      });
    },
    [adminWithdrawMethodsCreate],
  );
};

export const useAdminWithdrawMethodsCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsCreateHook>>>,
    TError,
    { data: CreateWithdrawMethodDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsCreateHook>>>,
  TError,
  { data: CreateWithdrawMethodDto },
  TContext
> => {
  const mutationKey = ['adminWithdrawMethodsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminWithdrawMethodsCreate = useAdminWithdrawMethodsCreateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsCreateHook>>>,
    { data: CreateWithdrawMethodDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminWithdrawMethodsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWithdrawMethodsCreateMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsCreateHook>>>
>;
export type AdminWithdrawMethodsCreateMutationBody = CreateWithdrawMethodDto;
export type AdminWithdrawMethodsCreateMutationError = unknown;

/**
 * @summary Create a new withdraw method
 */
export const useAdminWithdrawMethodsCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsCreateHook>>>,
      TError,
      { data: CreateWithdrawMethodDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsCreateHook>>>,
  TError,
  { data: CreateWithdrawMethodDto },
  TContext
> => {
  const mutationOptions = useAdminWithdrawMethodsCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get a single withdraw method by code
 */
export const useAdminWithdrawMethodsGetOneHook = () => {
  const adminWithdrawMethodsGetOne = useCustomInstance<AdminWithdrawMethodResponseDto>();

  return useCallback(
    (code: string, signal?: AbortSignal) => {
      return adminWithdrawMethodsGetOne({ url: `/admin/withdraw-methods/${code}`, method: 'GET', signal });
    },
    [adminWithdrawMethodsGetOne],
  );
};

export const getAdminWithdrawMethodsGetOneQueryKey = (code: string) => {
  return [`/admin/withdraw-methods/${code}`] as const;
};

export const useAdminWithdrawMethodsGetOneQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsGetOneHook>>>,
  TError = unknown,
>(
  code: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsGetOneHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminWithdrawMethodsGetOneQueryKey(code);

  const adminWithdrawMethodsGetOne = useAdminWithdrawMethodsGetOneHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsGetOneHook>>>> = ({ signal }) =>
    adminWithdrawMethodsGetOne(code, signal);

  return { queryKey, queryFn, enabled: !!code, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsGetOneHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminWithdrawMethodsGetOneQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsGetOneHook>>>
>;
export type AdminWithdrawMethodsGetOneQueryError = unknown;

export function useAdminWithdrawMethodsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsGetOneHook>>>,
  TError = unknown,
>(
  code: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsGetOneHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminWithdrawMethodsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsGetOneHook>>>,
  TError = unknown,
>(
  code: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsGetOneHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminWithdrawMethodsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsGetOneHook>>>,
  TError = unknown,
>(
  code: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsGetOneHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a single withdraw method by code
 */

export function useAdminWithdrawMethodsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsGetOneHook>>>,
  TError = unknown,
>(
  code: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsGetOneHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminWithdrawMethodsGetOneQueryOptions(code, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update a withdraw method (label, isActive, sortOrder)
 */
export const useAdminWithdrawMethodsUpdateHook = () => {
  const adminWithdrawMethodsUpdate = useCustomInstance<AdminWithdrawMethodResponseDto>();

  return useCallback(
    (code: string, updateWithdrawMethodDto: UpdateWithdrawMethodDto) => {
      return adminWithdrawMethodsUpdate({
        url: `/admin/withdraw-methods/${code}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateWithdrawMethodDto,
      });
    },
    [adminWithdrawMethodsUpdate],
  );
};

export const useAdminWithdrawMethodsUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsUpdateHook>>>,
    TError,
    { code: string; data: UpdateWithdrawMethodDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsUpdateHook>>>,
  TError,
  { code: string; data: UpdateWithdrawMethodDto },
  TContext
> => {
  const mutationKey = ['adminWithdrawMethodsUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminWithdrawMethodsUpdate = useAdminWithdrawMethodsUpdateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsUpdateHook>>>,
    { code: string; data: UpdateWithdrawMethodDto }
  > = (props) => {
    const { code, data } = props ?? {};

    return adminWithdrawMethodsUpdate(code, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWithdrawMethodsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsUpdateHook>>>
>;
export type AdminWithdrawMethodsUpdateMutationBody = UpdateWithdrawMethodDto;
export type AdminWithdrawMethodsUpdateMutationError = unknown;

/**
 * @summary Update a withdraw method (label, isActive, sortOrder)
 */
export const useAdminWithdrawMethodsUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsUpdateHook>>>,
      TError,
      { code: string; data: UpdateWithdrawMethodDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsUpdateHook>>>,
  TError,
  { code: string; data: UpdateWithdrawMethodDto },
  TContext
> => {
  const mutationOptions = useAdminWithdrawMethodsUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Delete a withdraw method (blocked if any payout references it)
 */
export const useAdminWithdrawMethodsRemoveHook = () => {
  const adminWithdrawMethodsRemove = useCustomInstance<AdminWithdrawMethodResponseDto>();

  return useCallback(
    (code: string) => {
      return adminWithdrawMethodsRemove({ url: `/admin/withdraw-methods/${code}`, method: 'DELETE' });
    },
    [adminWithdrawMethodsRemove],
  );
};

export const useAdminWithdrawMethodsRemoveMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsRemoveHook>>>,
    TError,
    { code: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsRemoveHook>>>,
  TError,
  { code: string },
  TContext
> => {
  const mutationKey = ['adminWithdrawMethodsRemove'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminWithdrawMethodsRemove = useAdminWithdrawMethodsRemoveHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsRemoveHook>>>,
    { code: string }
  > = (props) => {
    const { code } = props ?? {};

    return adminWithdrawMethodsRemove(code);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminWithdrawMethodsRemoveMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsRemoveHook>>>
>;

export type AdminWithdrawMethodsRemoveMutationError = unknown;

/**
 * @summary Delete a withdraw method (blocked if any payout references it)
 */
export const useAdminWithdrawMethodsRemove = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsRemoveHook>>>,
      TError,
      { code: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminWithdrawMethodsRemoveHook>>>,
  TError,
  { code: string },
  TContext
> => {
  const mutationOptions = useAdminWithdrawMethodsRemoveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List monetization experiences with their active version (optionally filtered)
 */
export const useAdminExperiencesListHook = () => {
  const adminExperiencesList = useCustomInstance<AdminExperienceListResponseDto>();

  return useCallback(
    (params?: AdminExperiencesListParams, signal?: AbortSignal) => {
      return adminExperiencesList({ url: `/admin/experiences`, method: 'GET', params, signal });
    },
    [adminExperiencesList],
  );
};

export const getAdminExperiencesListQueryKey = (params?: AdminExperiencesListParams) => {
  return [`/admin/experiences`, ...(params ? [params] : [])] as const;
};

export const useAdminExperiencesListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListHook>>>,
  TError = unknown,
>(
  params?: AdminExperiencesListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminExperiencesListQueryKey(params);

  const adminExperiencesList = useAdminExperiencesListHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListHook>>>> = ({ signal }) =>
    adminExperiencesList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminExperiencesListQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListHook>>>
>;
export type AdminExperiencesListQueryError = unknown;

export function useAdminExperiencesList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListHook>>>,
  TError = unknown,
>(
  params: undefined | AdminExperiencesListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminExperiencesList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListHook>>>,
  TError = unknown,
>(
  params?: AdminExperiencesListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminExperiencesList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListHook>>>,
  TError = unknown,
>(
  params?: AdminExperiencesListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List monetization experiences with their active version (optionally filtered)
 */

export function useAdminExperiencesList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListHook>>>,
  TError = unknown,
>(
  params?: AdminExperiencesListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminExperiencesListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create an experience + DRAFT (v1). When variations are supplied, also creates their rewards, provisions the LD flag, and applies targeting (rules + individuals + excludedSegments) — one call.
 */
export const useAdminExperiencesCreateHook = () => {
  const adminExperiencesCreate = useCustomInstance<AdminExperienceFullResponseDto>();

  return useCallback(
    (createExperienceDto: CreateExperienceDto, signal?: AbortSignal) => {
      return adminExperiencesCreate({
        url: `/admin/experiences`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createExperienceDto,
        signal,
      });
    },
    [adminExperiencesCreate],
  );
};

export const useAdminExperiencesCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminExperiencesCreateHook>>>,
    TError,
    { data: CreateExperienceDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesCreateHook>>>,
  TError,
  { data: CreateExperienceDto },
  TContext
> => {
  const mutationKey = ['adminExperiencesCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminExperiencesCreate = useAdminExperiencesCreateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminExperiencesCreateHook>>>,
    { data: CreateExperienceDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminExperiencesCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminExperiencesCreateMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesCreateHook>>>
>;
export type AdminExperiencesCreateMutationBody = CreateExperienceDto;
export type AdminExperiencesCreateMutationError = unknown;

/**
 * @summary Create an experience + DRAFT (v1). When variations are supplied, also creates their rewards, provisions the LD flag, and applies targeting (rules + individuals + excludedSegments) — one call.
 */
export const useAdminExperiencesCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminExperiencesCreateHook>>>,
      TError,
      { data: CreateExperienceDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesCreateHook>>>,
  TError,
  { data: CreateExperienceDto },
  TContext
> => {
  const mutationOptions = useAdminExperiencesCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get a single experience aggregated with its draft, version history, variations (with rewards), and LD targeting state
 */
export const useAdminExperiencesGetOneHook = () => {
  const adminExperiencesGetOne = useCustomInstance<AdminExperienceFullResponseDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminExperiencesGetOne({ url: `/admin/experiences/${id}`, method: 'GET', signal });
    },
    [adminExperiencesGetOne],
  );
};

export const getAdminExperiencesGetOneQueryKey = (id: string) => {
  return [`/admin/experiences/${id}`] as const;
};

export const useAdminExperiencesGetOneQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetOneHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminExperiencesGetOneQueryKey(id);

  const adminExperiencesGetOne = useAdminExperiencesGetOneHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetOneHook>>>> = ({ signal }) =>
    adminExperiencesGetOne(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetOneHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminExperiencesGetOneQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetOneHook>>>
>;
export type AdminExperiencesGetOneQueryError = unknown;

export function useAdminExperiencesGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetOneHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminExperiencesGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetOneHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminExperiencesGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetOneHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a single experience aggregated with its draft, version history, variations (with rewards), and LD targeting state
 */

export function useAdminExperiencesGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetOneHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminExperiencesGetOneQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Aggregate save: persist the draft fields AND upsert variations + rewards + targeting (provision + rules/individuals/excludedSegments) in one call. Returns the full aggregated experience.
 */
export const useAdminExperiencesSaveHook = () => {
  const adminExperiencesSave = useCustomInstance<AdminExperienceFullResponseDto>();

  return useCallback(
    (id: string, saveExperienceDto: SaveExperienceDto) => {
      return adminExperiencesSave({
        url: `/admin/experiences/${id}`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: saveExperienceDto,
      });
    },
    [adminExperiencesSave],
  );
};

export const useAdminExperiencesSaveMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminExperiencesSaveHook>>>,
    TError,
    { id: string; data: SaveExperienceDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesSaveHook>>>,
  TError,
  { id: string; data: SaveExperienceDto },
  TContext
> => {
  const mutationKey = ['adminExperiencesSave'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminExperiencesSave = useAdminExperiencesSaveHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminExperiencesSaveHook>>>,
    { id: string; data: SaveExperienceDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminExperiencesSave(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminExperiencesSaveMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesSaveHook>>>
>;
export type AdminExperiencesSaveMutationBody = SaveExperienceDto;
export type AdminExperiencesSaveMutationError = unknown;

/**
 * @summary Aggregate save: persist the draft fields AND upsert variations + rewards + targeting (provision + rules/individuals/excludedSegments) in one call. Returns the full aggregated experience.
 */
export const useAdminExperiencesSave = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminExperiencesSaveHook>>>,
      TError,
      { id: string; data: SaveExperienceDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesSaveHook>>>,
  TError,
  { id: string; data: SaveExperienceDto },
  TContext
> => {
  const mutationOptions = useAdminExperiencesSaveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get the current draft version of an experience (or null)
 */
export const useAdminExperiencesGetDraftHook = () => {
  const adminExperiencesGetDraft = useCustomInstance<ExperienceVersionWithVariationsResponseDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminExperiencesGetDraft({ url: `/admin/experiences/${id}/draft`, method: 'GET', signal });
    },
    [adminExperiencesGetDraft],
  );
};

export const getAdminExperiencesGetDraftQueryKey = (id: string) => {
  return [`/admin/experiences/${id}/draft`] as const;
};

export const useAdminExperiencesGetDraftQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetDraftHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetDraftHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminExperiencesGetDraftQueryKey(id);

  const adminExperiencesGetDraft = useAdminExperiencesGetDraftHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetDraftHook>>>> = ({ signal }) =>
    adminExperiencesGetDraft(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetDraftHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminExperiencesGetDraftQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetDraftHook>>>
>;
export type AdminExperiencesGetDraftQueryError = unknown;

export function useAdminExperiencesGetDraft<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetDraftHook>>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetDraftHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetDraftHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetDraftHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminExperiencesGetDraft<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetDraftHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetDraftHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetDraftHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetDraftHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminExperiencesGetDraft<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetDraftHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetDraftHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the current draft version of an experience (or null)
 */

export function useAdminExperiencesGetDraft<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetDraftHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperiencesGetDraftHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminExperiencesGetDraftQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update the current DRAFT version's editable content
 */
export const useAdminExperiencesUpdateDraftHook = () => {
  const adminExperiencesUpdateDraft = useCustomInstance<ExperienceVersionResponseDto>();

  return useCallback(
    (id: string, updateDraftDto: UpdateDraftDto) => {
      return adminExperiencesUpdateDraft({
        url: `/admin/experiences/${id}/draft`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateDraftDto,
      });
    },
    [adminExperiencesUpdateDraft],
  );
};

export const useAdminExperiencesUpdateDraftMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminExperiencesUpdateDraftHook>>>,
    TError,
    { id: string; data: UpdateDraftDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesUpdateDraftHook>>>,
  TError,
  { id: string; data: UpdateDraftDto },
  TContext
> => {
  const mutationKey = ['adminExperiencesUpdateDraft'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminExperiencesUpdateDraft = useAdminExperiencesUpdateDraftHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminExperiencesUpdateDraftHook>>>,
    { id: string; data: UpdateDraftDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminExperiencesUpdateDraft(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminExperiencesUpdateDraftMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesUpdateDraftHook>>>
>;
export type AdminExperiencesUpdateDraftMutationBody = UpdateDraftDto;
export type AdminExperiencesUpdateDraftMutationError = unknown;

/**
 * @summary Update the current DRAFT version's editable content
 */
export const useAdminExperiencesUpdateDraft = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminExperiencesUpdateDraftHook>>>,
      TError,
      { id: string; data: UpdateDraftDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesUpdateDraftHook>>>,
  TError,
  { id: string; data: UpdateDraftDto },
  TContext
> => {
  const mutationOptions = useAdminExperiencesUpdateDraftMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List all versions of an experience (most recent first)
 */
export const useAdminExperiencesListVersionsHook = () => {
  const adminExperiencesListVersions = useCustomInstance<ExperienceVersionWithVariationsResponseDto[]>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminExperiencesListVersions({ url: `/admin/experiences/${id}/versions`, method: 'GET', signal });
    },
    [adminExperiencesListVersions],
  );
};

export const getAdminExperiencesListVersionsQueryKey = (id: string) => {
  return [`/admin/experiences/${id}/versions`] as const;
};

export const useAdminExperiencesListVersionsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListVersionsHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListVersionsHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminExperiencesListVersionsQueryKey(id);

  const adminExperiencesListVersions = useAdminExperiencesListVersionsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListVersionsHook>>>> = ({ signal }) =>
    adminExperiencesListVersions(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListVersionsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminExperiencesListVersionsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListVersionsHook>>>
>;
export type AdminExperiencesListVersionsQueryError = unknown;

export function useAdminExperiencesListVersions<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListVersionsHook>>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListVersionsHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListVersionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListVersionsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminExperiencesListVersions<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListVersionsHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListVersionsHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListVersionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListVersionsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminExperiencesListVersions<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListVersionsHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListVersionsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List all versions of an experience (most recent first)
 */

export function useAdminExperiencesListVersions<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListVersionsHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperiencesListVersionsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminExperiencesListVersionsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Fork a non-draft version into a new editable DRAFT (restore its content)
 */
export const useAdminExperiencesRestoreVersionHook = () => {
  const adminExperiencesRestoreVersion = useCustomInstance<ExperienceVersionResponseDto>();

  return useCallback(
    (id: string, versionId: string, signal?: AbortSignal) => {
      return adminExperiencesRestoreVersion({
        url: `/admin/experiences/${id}/versions/${versionId}/restore`,
        method: 'POST',
        signal,
      });
    },
    [adminExperiencesRestoreVersion],
  );
};

export const useAdminExperiencesRestoreVersionMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminExperiencesRestoreVersionHook>>>,
    TError,
    { id: string; versionId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesRestoreVersionHook>>>,
  TError,
  { id: string; versionId: string },
  TContext
> => {
  const mutationKey = ['adminExperiencesRestoreVersion'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminExperiencesRestoreVersion = useAdminExperiencesRestoreVersionHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminExperiencesRestoreVersionHook>>>,
    { id: string; versionId: string }
  > = (props) => {
    const { id, versionId } = props ?? {};

    return adminExperiencesRestoreVersion(id, versionId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminExperiencesRestoreVersionMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesRestoreVersionHook>>>
>;

export type AdminExperiencesRestoreVersionMutationError = unknown;

/**
 * @summary Fork a non-draft version into a new editable DRAFT (restore its content)
 */
export const useAdminExperiencesRestoreVersion = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminExperiencesRestoreVersionHook>>>,
      TError,
      { id: string; versionId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesRestoreVersionHook>>>,
  TError,
  { id: string; versionId: string },
  TContext
> => {
  const mutationOptions = useAdminExperiencesRestoreVersionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Duplicate an experience into a new DRAFT experience (new key, cloned content + rewards)
 */
export const useAdminExperiencesDuplicateHook = () => {
  const adminExperiencesDuplicate = useCustomInstance<DuplicateExperienceResponseDto>();

  return useCallback(
    (id: string, duplicateExperienceDto: DuplicateExperienceDto, signal?: AbortSignal) => {
      return adminExperiencesDuplicate({
        url: `/admin/experiences/${id}/duplicate`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: duplicateExperienceDto,
        signal,
      });
    },
    [adminExperiencesDuplicate],
  );
};

export const useAdminExperiencesDuplicateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminExperiencesDuplicateHook>>>,
    TError,
    { id: string; data: DuplicateExperienceDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesDuplicateHook>>>,
  TError,
  { id: string; data: DuplicateExperienceDto },
  TContext
> => {
  const mutationKey = ['adminExperiencesDuplicate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminExperiencesDuplicate = useAdminExperiencesDuplicateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminExperiencesDuplicateHook>>>,
    { id: string; data: DuplicateExperienceDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminExperiencesDuplicate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminExperiencesDuplicateMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesDuplicateHook>>>
>;
export type AdminExperiencesDuplicateMutationBody = DuplicateExperienceDto;
export type AdminExperiencesDuplicateMutationError = unknown;

/**
 * @summary Duplicate an experience into a new DRAFT experience (new key, cloned content + rewards)
 */
export const useAdminExperiencesDuplicate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminExperiencesDuplicateHook>>>,
      TError,
      { id: string; data: DuplicateExperienceDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesDuplicateHook>>>,
  TError,
  { id: string; data: DuplicateExperienceDto },
  TContext
> => {
  const mutationOptions = useAdminExperiencesDuplicateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Set the Feature Priority Manager ordering weight for an experience
 */
export const useAdminExperiencesSetPriorityHook = () => {
  const adminExperiencesSetPriority = useCustomInstance<AdminExperienceDetailResponseDto>();

  return useCallback(
    (id: string, setPriorityDto: SetPriorityDto) => {
      return adminExperiencesSetPriority({
        url: `/admin/experiences/${id}/priority`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: setPriorityDto,
      });
    },
    [adminExperiencesSetPriority],
  );
};

export const useAdminExperiencesSetPriorityMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminExperiencesSetPriorityHook>>>,
    TError,
    { id: string; data: SetPriorityDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesSetPriorityHook>>>,
  TError,
  { id: string; data: SetPriorityDto },
  TContext
> => {
  const mutationKey = ['adminExperiencesSetPriority'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminExperiencesSetPriority = useAdminExperiencesSetPriorityHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminExperiencesSetPriorityHook>>>,
    { id: string; data: SetPriorityDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminExperiencesSetPriority(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminExperiencesSetPriorityMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesSetPriorityHook>>>
>;
export type AdminExperiencesSetPriorityMutationBody = SetPriorityDto;
export type AdminExperiencesSetPriorityMutationError = unknown;

/**
 * @summary Set the Feature Priority Manager ordering weight for an experience
 */
export const useAdminExperiencesSetPriority = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminExperiencesSetPriorityHook>>>,
      TError,
      { id: string; data: SetPriorityDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesSetPriorityHook>>>,
  TError,
  { id: string; data: SetPriorityDto },
  TContext
> => {
  const mutationOptions = useAdminExperiencesSetPriorityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Fork the active version into a new editable DRAFT
 */
export const useAdminExperiencesCreateDraftFromActiveHook = () => {
  const adminExperiencesCreateDraftFromActive = useCustomInstance<ExperienceVersionResponseDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminExperiencesCreateDraftFromActive({
        url: `/admin/experiences/${id}/draft-from-active`,
        method: 'POST',
        signal,
      });
    },
    [adminExperiencesCreateDraftFromActive],
  );
};

export const useAdminExperiencesCreateDraftFromActiveMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminExperiencesCreateDraftFromActiveHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesCreateDraftFromActiveHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminExperiencesCreateDraftFromActive'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminExperiencesCreateDraftFromActive = useAdminExperiencesCreateDraftFromActiveHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminExperiencesCreateDraftFromActiveHook>>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminExperiencesCreateDraftFromActive(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminExperiencesCreateDraftFromActiveMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesCreateDraftFromActiveHook>>>
>;

export type AdminExperiencesCreateDraftFromActiveMutationError = unknown;

/**
 * @summary Fork the active version into a new editable DRAFT
 */
export const useAdminExperiencesCreateDraftFromActive = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminExperiencesCreateDraftFromActiveHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesCreateDraftFromActiveHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useAdminExperiencesCreateDraftFromActiveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Publish the current DRAFT and make it the active version
 */
export const useAdminExperiencesActivateHook = () => {
  const adminExperiencesActivate = useCustomInstance<AdminExperienceDetailResponseDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminExperiencesActivate({ url: `/admin/experiences/${id}/activate`, method: 'POST', signal });
    },
    [adminExperiencesActivate],
  );
};

export const useAdminExperiencesActivateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminExperiencesActivateHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesActivateHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminExperiencesActivate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminExperiencesActivate = useAdminExperiencesActivateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminExperiencesActivateHook>>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminExperiencesActivate(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminExperiencesActivateMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesActivateHook>>>
>;

export type AdminExperiencesActivateMutationError = unknown;

/**
 * @summary Publish the current DRAFT and make it the active version
 */
export const useAdminExperiencesActivate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminExperiencesActivateHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesActivateHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useAdminExperiencesActivateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Pause an ACTIVE experience
 */
export const useAdminExperiencesPauseHook = () => {
  const adminExperiencesPause = useCustomInstance<AdminExperienceDetailResponseDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminExperiencesPause({ url: `/admin/experiences/${id}/pause`, method: 'POST', signal });
    },
    [adminExperiencesPause],
  );
};

export const useAdminExperiencesPauseMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminExperiencesPauseHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesPauseHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminExperiencesPause'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminExperiencesPause = useAdminExperiencesPauseHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminExperiencesPauseHook>>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminExperiencesPause(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminExperiencesPauseMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesPauseHook>>>
>;

export type AdminExperiencesPauseMutationError = unknown;

/**
 * @summary Pause an ACTIVE experience
 */
export const useAdminExperiencesPause = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminExperiencesPauseHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesPauseHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useAdminExperiencesPauseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Resume a PAUSED experience back to ACTIVE
 */
export const useAdminExperiencesResumeHook = () => {
  const adminExperiencesResume = useCustomInstance<AdminExperienceDetailResponseDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminExperiencesResume({ url: `/admin/experiences/${id}/resume`, method: 'POST', signal });
    },
    [adminExperiencesResume],
  );
};

export const useAdminExperiencesResumeMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminExperiencesResumeHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesResumeHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminExperiencesResume'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminExperiencesResume = useAdminExperiencesResumeHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminExperiencesResumeHook>>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminExperiencesResume(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminExperiencesResumeMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesResumeHook>>>
>;

export type AdminExperiencesResumeMutationError = unknown;

/**
 * @summary Resume a PAUSED experience back to ACTIVE
 */
export const useAdminExperiencesResume = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminExperiencesResumeHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesResumeHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useAdminExperiencesResumeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Archive an experience (terminal)
 */
export const useAdminExperiencesArchiveHook = () => {
  const adminExperiencesArchive = useCustomInstance<AdminExperienceDetailResponseDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminExperiencesArchive({ url: `/admin/experiences/${id}/archive`, method: 'POST', signal });
    },
    [adminExperiencesArchive],
  );
};

export const useAdminExperiencesArchiveMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminExperiencesArchiveHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesArchiveHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminExperiencesArchive'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminExperiencesArchive = useAdminExperiencesArchiveHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminExperiencesArchiveHook>>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminExperiencesArchive(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminExperiencesArchiveMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesArchiveHook>>>
>;

export type AdminExperiencesArchiveMutationError = unknown;

/**
 * @summary Archive an experience (terminal)
 */
export const useAdminExperiencesArchive = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminExperiencesArchiveHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminExperiencesArchiveHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useAdminExperiencesArchiveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List active user assignments for an experience
 */
export const useAdminExperienceAssignmentsListHook = () => {
  const adminExperienceAssignmentsList = useCustomInstance<AdminExperienceAssignmentListResponseDto>();

  return useCallback(
    (id: string, params: AdminExperienceAssignmentsListParams, signal?: AbortSignal) => {
      return adminExperienceAssignmentsList({ url: `/admin/experiences/${id}/assignments`, method: 'GET', params, signal });
    },
    [adminExperienceAssignmentsList],
  );
};

export const getAdminExperienceAssignmentsListQueryKey = (id: string, params: AdminExperienceAssignmentsListParams) => {
  return [`/admin/experiences/${id}/assignments`, ...(params ? [params] : [])] as const;
};

export const useAdminExperienceAssignmentsListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperienceAssignmentsListHook>>>,
  TError = unknown,
>(
  id: string,
  params: AdminExperienceAssignmentsListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperienceAssignmentsListHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminExperienceAssignmentsListQueryKey(id, params);

  const adminExperienceAssignmentsList = useAdminExperienceAssignmentsListHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminExperienceAssignmentsListHook>>>> = ({
    signal,
  }) => adminExperienceAssignmentsList(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminExperienceAssignmentsListHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminExperienceAssignmentsListQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminExperienceAssignmentsListHook>>>
>;
export type AdminExperienceAssignmentsListQueryError = unknown;

export function useAdminExperienceAssignmentsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperienceAssignmentsListHook>>>,
  TError = unknown,
>(
  id: string,
  params: AdminExperienceAssignmentsListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperienceAssignmentsListHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminExperienceAssignmentsListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminExperienceAssignmentsListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminExperienceAssignmentsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperienceAssignmentsListHook>>>,
  TError = unknown,
>(
  id: string,
  params: AdminExperienceAssignmentsListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperienceAssignmentsListHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminExperienceAssignmentsListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminExperienceAssignmentsListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminExperienceAssignmentsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperienceAssignmentsListHook>>>,
  TError = unknown,
>(
  id: string,
  params: AdminExperienceAssignmentsListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperienceAssignmentsListHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List active user assignments for an experience
 */

export function useAdminExperienceAssignmentsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperienceAssignmentsListHook>>>,
  TError = unknown,
>(
  id: string,
  params: AdminExperienceAssignmentsListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperienceAssignmentsListHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminExperienceAssignmentsListQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Bulk assign an experience to one or more users
 */
export const useAdminExperienceAssignmentsBulkAssignHook = () => {
  const adminExperienceAssignmentsBulkAssign = useCustomInstance<BulkAssignResultResponseDto>();

  return useCallback(
    (id: string, bulkAssignDto: BulkAssignDto, signal?: AbortSignal) => {
      return adminExperienceAssignmentsBulkAssign({
        url: `/admin/experiences/${id}/assignments`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: bulkAssignDto,
        signal,
      });
    },
    [adminExperienceAssignmentsBulkAssign],
  );
};

export const useAdminExperienceAssignmentsBulkAssignMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminExperienceAssignmentsBulkAssignHook>>>,
    TError,
    { id: string; data: BulkAssignDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminExperienceAssignmentsBulkAssignHook>>>,
  TError,
  { id: string; data: BulkAssignDto },
  TContext
> => {
  const mutationKey = ['adminExperienceAssignmentsBulkAssign'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminExperienceAssignmentsBulkAssign = useAdminExperienceAssignmentsBulkAssignHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminExperienceAssignmentsBulkAssignHook>>>,
    { id: string; data: BulkAssignDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminExperienceAssignmentsBulkAssign(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminExperienceAssignmentsBulkAssignMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminExperienceAssignmentsBulkAssignHook>>>
>;
export type AdminExperienceAssignmentsBulkAssignMutationBody = BulkAssignDto;
export type AdminExperienceAssignmentsBulkAssignMutationError = unknown;

/**
 * @summary Bulk assign an experience to one or more users
 */
export const useAdminExperienceAssignmentsBulkAssign = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminExperienceAssignmentsBulkAssignHook>>>,
      TError,
      { id: string; data: BulkAssignDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminExperienceAssignmentsBulkAssignHook>>>,
  TError,
  { id: string; data: BulkAssignDto },
  TContext
> => {
  const mutationOptions = useAdminExperienceAssignmentsBulkAssignMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Revoke an experience from a single user
 */
export const useAdminExperienceAssignmentsRevokeHook = () => {
  const adminExperienceAssignmentsRevoke = useCustomInstance<AdminExperienceAssignmentResponseDto>();

  return useCallback(
    (id: string, userId: string) => {
      return adminExperienceAssignmentsRevoke({ url: `/admin/experiences/${id}/assignments/${userId}`, method: 'DELETE' });
    },
    [adminExperienceAssignmentsRevoke],
  );
};

export const useAdminExperienceAssignmentsRevokeMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminExperienceAssignmentsRevokeHook>>>,
    TError,
    { id: string; userId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminExperienceAssignmentsRevokeHook>>>,
  TError,
  { id: string; userId: string },
  TContext
> => {
  const mutationKey = ['adminExperienceAssignmentsRevoke'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminExperienceAssignmentsRevoke = useAdminExperienceAssignmentsRevokeHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminExperienceAssignmentsRevokeHook>>>,
    { id: string; userId: string }
  > = (props) => {
    const { id, userId } = props ?? {};

    return adminExperienceAssignmentsRevoke(id, userId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminExperienceAssignmentsRevokeMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminExperienceAssignmentsRevokeHook>>>
>;

export type AdminExperienceAssignmentsRevokeMutationError = unknown;

/**
 * @summary Revoke an experience from a single user
 */
export const useAdminExperienceAssignmentsRevoke = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminExperienceAssignmentsRevokeHook>>>,
      TError,
      { id: string; userId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminExperienceAssignmentsRevokeHook>>>,
  TError,
  { id: string; userId: string },
  TContext
> => {
  const mutationOptions = useAdminExperienceAssignmentsRevokeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List the experience's variations (current draft if present, else active version)
 */
export const useAdminExperienceVariationsListHook = () => {
  const adminExperienceVariationsList = useCustomInstance<VariationResponseDto[]>();

  return useCallback(
    (experienceId: string, signal?: AbortSignal) => {
      return adminExperienceVariationsList({ url: `/admin/experiences/${experienceId}/variations`, method: 'GET', signal });
    },
    [adminExperienceVariationsList],
  );
};

export const getAdminExperienceVariationsListQueryKey = (experienceId: string) => {
  return [`/admin/experiences/${experienceId}/variations`] as const;
};

export const useAdminExperienceVariationsListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsListHook>>>,
  TError = unknown,
>(
  experienceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsListHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminExperienceVariationsListQueryKey(experienceId);

  const adminExperienceVariationsList = useAdminExperienceVariationsListHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsListHook>>>> = ({
    signal,
  }) => adminExperienceVariationsList(experienceId, signal);

  return { queryKey, queryFn, enabled: !!experienceId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsListHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminExperienceVariationsListQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsListHook>>>
>;
export type AdminExperienceVariationsListQueryError = unknown;

export function useAdminExperienceVariationsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsListHook>>>,
  TError = unknown,
>(
  experienceId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsListHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminExperienceVariationsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsListHook>>>,
  TError = unknown,
>(
  experienceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsListHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminExperienceVariationsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsListHook>>>,
  TError = unknown,
>(
  experienceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsListHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List the experience's variations (current draft if present, else active version)
 */

export function useAdminExperienceVariationsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsListHook>>>,
  TError = unknown,
>(
  experienceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsListHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminExperienceVariationsListQueryOptions(experienceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a variation on the current draft + add the key to the LD flag
 */
export const useAdminExperienceVariationsCreateHook = () => {
  const adminExperienceVariationsCreate = useCustomInstance<VariationResponseDto>();

  return useCallback(
    (experienceId: string, createVariationDto: CreateVariationDto, signal?: AbortSignal) => {
      return adminExperienceVariationsCreate({
        url: `/admin/experiences/${experienceId}/variations`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createVariationDto,
        signal,
      });
    },
    [adminExperienceVariationsCreate],
  );
};

export const useAdminExperienceVariationsCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsCreateHook>>>,
    TError,
    { experienceId: string; data: CreateVariationDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsCreateHook>>>,
  TError,
  { experienceId: string; data: CreateVariationDto },
  TContext
> => {
  const mutationKey = ['adminExperienceVariationsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminExperienceVariationsCreate = useAdminExperienceVariationsCreateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsCreateHook>>>,
    { experienceId: string; data: CreateVariationDto }
  > = (props) => {
    const { experienceId, data } = props ?? {};

    return adminExperienceVariationsCreate(experienceId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminExperienceVariationsCreateMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsCreateHook>>>
>;
export type AdminExperienceVariationsCreateMutationBody = CreateVariationDto;
export type AdminExperienceVariationsCreateMutationError = unknown;

/**
 * @summary Create a variation on the current draft + add the key to the LD flag
 */
export const useAdminExperienceVariationsCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsCreateHook>>>,
      TError,
      { experienceId: string; data: CreateVariationDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsCreateHook>>>,
  TError,
  { experienceId: string; data: CreateVariationDto },
  TContext
> => {
  const mutationOptions = useAdminExperienceVariationsCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Update a variation on the current draft
 */
export const useAdminExperienceVariationsUpdateHook = () => {
  const adminExperienceVariationsUpdate = useCustomInstance<VariationResponseDto>();

  return useCallback(
    (experienceId: string, variationId: string, updateVariationDto: UpdateVariationDto) => {
      return adminExperienceVariationsUpdate({
        url: `/admin/experiences/${experienceId}/variations/${variationId}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateVariationDto,
      });
    },
    [adminExperienceVariationsUpdate],
  );
};

export const useAdminExperienceVariationsUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsUpdateHook>>>,
    TError,
    { experienceId: string; variationId: string; data: UpdateVariationDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsUpdateHook>>>,
  TError,
  { experienceId: string; variationId: string; data: UpdateVariationDto },
  TContext
> => {
  const mutationKey = ['adminExperienceVariationsUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminExperienceVariationsUpdate = useAdminExperienceVariationsUpdateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsUpdateHook>>>,
    { experienceId: string; variationId: string; data: UpdateVariationDto }
  > = (props) => {
    const { experienceId, variationId, data } = props ?? {};

    return adminExperienceVariationsUpdate(experienceId, variationId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminExperienceVariationsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsUpdateHook>>>
>;
export type AdminExperienceVariationsUpdateMutationBody = UpdateVariationDto;
export type AdminExperienceVariationsUpdateMutationError = unknown;

/**
 * @summary Update a variation on the current draft
 */
export const useAdminExperienceVariationsUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsUpdateHook>>>,
      TError,
      { experienceId: string; variationId: string; data: UpdateVariationDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsUpdateHook>>>,
  TError,
  { experienceId: string; variationId: string; data: UpdateVariationDto },
  TContext
> => {
  const mutationOptions = useAdminExperienceVariationsUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Remove a variation. Refused if any LD rule still references its key.
 */
export const useAdminExperienceVariationsRemoveHook = () => {
  const adminExperienceVariationsRemove = useCustomInstance<VariationRemovedResponseDto>();

  return useCallback(
    (experienceId: string, variationId: string) => {
      return adminExperienceVariationsRemove({
        url: `/admin/experiences/${experienceId}/variations/${variationId}`,
        method: 'DELETE',
      });
    },
    [adminExperienceVariationsRemove],
  );
};

export const useAdminExperienceVariationsRemoveMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsRemoveHook>>>,
    TError,
    { experienceId: string; variationId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsRemoveHook>>>,
  TError,
  { experienceId: string; variationId: string },
  TContext
> => {
  const mutationKey = ['adminExperienceVariationsRemove'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminExperienceVariationsRemove = useAdminExperienceVariationsRemoveHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsRemoveHook>>>,
    { experienceId: string; variationId: string }
  > = (props) => {
    const { experienceId, variationId } = props ?? {};

    return adminExperienceVariationsRemove(experienceId, variationId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminExperienceVariationsRemoveMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsRemoveHook>>>
>;

export type AdminExperienceVariationsRemoveMutationError = unknown;

/**
 * @summary Remove a variation. Refused if any LD rule still references its key.
 */
export const useAdminExperienceVariationsRemove = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsRemoveHook>>>,
      TError,
      { experienceId: string; variationId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsRemoveHook>>>,
  TError,
  { experienceId: string; variationId: string },
  TContext
> => {
  const mutationOptions = useAdminExperienceVariationsRemoveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Set/replace a draft variation's GIFT reward (resolves its cash-back scope)
 */
export const useAdminExperienceVariationsSetGiftRewardHook = () => {
  const adminExperienceVariationsSetGiftReward = useCustomInstance<GiftRewardResponseDto>();

  return useCallback(
    (experienceId: string, variationKey: string, setGiftRewardDto: SetGiftRewardDto) => {
      return adminExperienceVariationsSetGiftReward({
        url: `/admin/experiences/${experienceId}/variations/${variationKey}/gift-reward`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: setGiftRewardDto,
      });
    },
    [adminExperienceVariationsSetGiftReward],
  );
};

export const useAdminExperienceVariationsSetGiftRewardMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsSetGiftRewardHook>>>,
    TError,
    { experienceId: string; variationKey: string; data: SetGiftRewardDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsSetGiftRewardHook>>>,
  TError,
  { experienceId: string; variationKey: string; data: SetGiftRewardDto },
  TContext
> => {
  const mutationKey = ['adminExperienceVariationsSetGiftReward'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminExperienceVariationsSetGiftReward = useAdminExperienceVariationsSetGiftRewardHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsSetGiftRewardHook>>>,
    { experienceId: string; variationKey: string; data: SetGiftRewardDto }
  > = (props) => {
    const { experienceId, variationKey, data } = props ?? {};

    return adminExperienceVariationsSetGiftReward(experienceId, variationKey, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminExperienceVariationsSetGiftRewardMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsSetGiftRewardHook>>>
>;
export type AdminExperienceVariationsSetGiftRewardMutationBody = SetGiftRewardDto;
export type AdminExperienceVariationsSetGiftRewardMutationError = unknown;

/**
 * @summary Set/replace a draft variation's GIFT reward (resolves its cash-back scope)
 */
export const useAdminExperienceVariationsSetGiftReward = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsSetGiftRewardHook>>>,
      TError,
      { experienceId: string; variationKey: string; data: SetGiftRewardDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsSetGiftRewardHook>>>,
  TError,
  { experienceId: string; variationKey: string; data: SetGiftRewardDto },
  TContext
> => {
  const mutationOptions = useAdminExperienceVariationsSetGiftRewardMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Set/replace a draft variation's OFFER options (resolves each cash-back scope)
 */
export const useAdminExperienceVariationsSetOfferOptionsHook = () => {
  const adminExperienceVariationsSetOfferOptions = useCustomInstance<OfferOptionResponseDto[]>();

  return useCallback(
    (experienceId: string, variationKey: string, setOfferOptionsDto: SetOfferOptionsDto) => {
      return adminExperienceVariationsSetOfferOptions({
        url: `/admin/experiences/${experienceId}/variations/${variationKey}/offer-options`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: setOfferOptionsDto,
      });
    },
    [adminExperienceVariationsSetOfferOptions],
  );
};

export const useAdminExperienceVariationsSetOfferOptionsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsSetOfferOptionsHook>>>,
    TError,
    { experienceId: string; variationKey: string; data: SetOfferOptionsDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsSetOfferOptionsHook>>>,
  TError,
  { experienceId: string; variationKey: string; data: SetOfferOptionsDto },
  TContext
> => {
  const mutationKey = ['adminExperienceVariationsSetOfferOptions'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminExperienceVariationsSetOfferOptions = useAdminExperienceVariationsSetOfferOptionsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsSetOfferOptionsHook>>>,
    { experienceId: string; variationKey: string; data: SetOfferOptionsDto }
  > = (props) => {
    const { experienceId, variationKey, data } = props ?? {};

    return adminExperienceVariationsSetOfferOptions(experienceId, variationKey, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminExperienceVariationsSetOfferOptionsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsSetOfferOptionsHook>>>
>;
export type AdminExperienceVariationsSetOfferOptionsMutationBody = SetOfferOptionsDto;
export type AdminExperienceVariationsSetOfferOptionsMutationError = unknown;

/**
 * @summary Set/replace a draft variation's OFFER options (resolves each cash-back scope)
 */
export const useAdminExperienceVariationsSetOfferOptions = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsSetOfferOptionsHook>>>,
      TError,
      { experienceId: string; variationKey: string; data: SetOfferOptionsDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminExperienceVariationsSetOfferOptionsHook>>>,
  TError,
  { experienceId: string; variationKey: string; data: SetOfferOptionsDto },
  TContext
> => {
  const mutationOptions = useAdminExperienceVariationsSetOfferOptionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Provision (or sync) the LD flag for this experience
 */
export const useAdminExperienceLaunchDarklyProvisionHook = () => {
  const adminExperienceLaunchDarklyProvision = useCustomInstance<ProvisionResponseDto>();

  return useCallback(
    (experienceId: string, signal?: AbortSignal) => {
      return adminExperienceLaunchDarklyProvision({
        url: `/admin/experiences/${experienceId}/launchdarkly/provision`,
        method: 'POST',
        signal,
      });
    },
    [adminExperienceLaunchDarklyProvision],
  );
};

export const useAdminExperienceLaunchDarklyProvisionMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminExperienceLaunchDarklyProvisionHook>>>,
    TError,
    { experienceId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminExperienceLaunchDarklyProvisionHook>>>,
  TError,
  { experienceId: string },
  TContext
> => {
  const mutationKey = ['adminExperienceLaunchDarklyProvision'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminExperienceLaunchDarklyProvision = useAdminExperienceLaunchDarklyProvisionHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminExperienceLaunchDarklyProvisionHook>>>,
    { experienceId: string }
  > = (props) => {
    const { experienceId } = props ?? {};

    return adminExperienceLaunchDarklyProvision(experienceId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminExperienceLaunchDarklyProvisionMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminExperienceLaunchDarklyProvisionHook>>>
>;

export type AdminExperienceLaunchDarklyProvisionMutationError = unknown;

/**
 * @summary Provision (or sync) the LD flag for this experience
 */
export const useAdminExperienceLaunchDarklyProvision = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminExperienceLaunchDarklyProvisionHook>>>,
      TError,
      { experienceId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminExperienceLaunchDarklyProvisionHook>>>,
  TError,
  { experienceId: string },
  TContext
> => {
  const mutationOptions = useAdminExperienceLaunchDarklyProvisionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Read the segment / individual-user → variation targeting for this experience
 */
export const useAdminExperienceLaunchDarklyGetTargetingHook = () => {
  const adminExperienceLaunchDarklyGetTargeting = useCustomInstance<TargetingResponseDto>();

  return useCallback(
    (experienceId: string, signal?: AbortSignal) => {
      return adminExperienceLaunchDarklyGetTargeting({
        url: `/admin/experiences/${experienceId}/launchdarkly/targeting`,
        method: 'GET',
        signal,
      });
    },
    [adminExperienceLaunchDarklyGetTargeting],
  );
};

export const getAdminExperienceLaunchDarklyGetTargetingQueryKey = (experienceId: string) => {
  return [`/admin/experiences/${experienceId}/launchdarkly/targeting`] as const;
};

export const useAdminExperienceLaunchDarklyGetTargetingQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperienceLaunchDarklyGetTargetingHook>>>,
  TError = unknown,
>(
  experienceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperienceLaunchDarklyGetTargetingHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminExperienceLaunchDarklyGetTargetingQueryKey(experienceId);

  const adminExperienceLaunchDarklyGetTargeting = useAdminExperienceLaunchDarklyGetTargetingHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminExperienceLaunchDarklyGetTargetingHook>>>> = ({
    signal,
  }) => adminExperienceLaunchDarklyGetTargeting(experienceId, signal);

  return { queryKey, queryFn, enabled: !!experienceId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminExperienceLaunchDarklyGetTargetingHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminExperienceLaunchDarklyGetTargetingQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminExperienceLaunchDarklyGetTargetingHook>>>
>;
export type AdminExperienceLaunchDarklyGetTargetingQueryError = unknown;

export function useAdminExperienceLaunchDarklyGetTargeting<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperienceLaunchDarklyGetTargetingHook>>>,
  TError = unknown,
>(
  experienceId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperienceLaunchDarklyGetTargetingHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminExperienceLaunchDarklyGetTargetingHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminExperienceLaunchDarklyGetTargetingHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminExperienceLaunchDarklyGetTargeting<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperienceLaunchDarklyGetTargetingHook>>>,
  TError = unknown,
>(
  experienceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperienceLaunchDarklyGetTargetingHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminExperienceLaunchDarklyGetTargetingHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminExperienceLaunchDarklyGetTargetingHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminExperienceLaunchDarklyGetTargeting<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperienceLaunchDarklyGetTargetingHook>>>,
  TError = unknown,
>(
  experienceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperienceLaunchDarklyGetTargetingHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Read the segment / individual-user → variation targeting for this experience
 */

export function useAdminExperienceLaunchDarklyGetTargeting<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminExperienceLaunchDarklyGetTargetingHook>>>,
  TError = unknown,
>(
  experienceId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminExperienceLaunchDarklyGetTargetingHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminExperienceLaunchDarklyGetTargetingQueryOptions(experienceId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Replace the full segment / individual-user → variation targeting (idempotent)
 */
export const useAdminExperienceLaunchDarklyPutTargetingHook = () => {
  const adminExperienceLaunchDarklyPutTargeting = useCustomInstance<TargetingResponseDto>();

  return useCallback(
    (experienceId: string, putTargetingDto: PutTargetingDto) => {
      return adminExperienceLaunchDarklyPutTargeting({
        url: `/admin/experiences/${experienceId}/launchdarkly/targeting`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: putTargetingDto,
      });
    },
    [adminExperienceLaunchDarklyPutTargeting],
  );
};

export const useAdminExperienceLaunchDarklyPutTargetingMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminExperienceLaunchDarklyPutTargetingHook>>>,
    TError,
    { experienceId: string; data: PutTargetingDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminExperienceLaunchDarklyPutTargetingHook>>>,
  TError,
  { experienceId: string; data: PutTargetingDto },
  TContext
> => {
  const mutationKey = ['adminExperienceLaunchDarklyPutTargeting'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminExperienceLaunchDarklyPutTargeting = useAdminExperienceLaunchDarklyPutTargetingHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminExperienceLaunchDarklyPutTargetingHook>>>,
    { experienceId: string; data: PutTargetingDto }
  > = (props) => {
    const { experienceId, data } = props ?? {};

    return adminExperienceLaunchDarklyPutTargeting(experienceId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminExperienceLaunchDarklyPutTargetingMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminExperienceLaunchDarklyPutTargetingHook>>>
>;
export type AdminExperienceLaunchDarklyPutTargetingMutationBody = PutTargetingDto;
export type AdminExperienceLaunchDarklyPutTargetingMutationError = unknown;

/**
 * @summary Replace the full segment / individual-user → variation targeting (idempotent)
 */
export const useAdminExperienceLaunchDarklyPutTargeting = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminExperienceLaunchDarklyPutTargetingHook>>>,
      TError,
      { experienceId: string; data: PutTargetingDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminExperienceLaunchDarklyPutTargetingHook>>>,
  TError,
  { experienceId: string; data: PutTargetingDto },
  TContext
> => {
  const mutationOptions = useAdminExperienceLaunchDarklyPutTargetingMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Return the current player's cash-back balance and active lots
 */
export const useCashBackGetMineHook = () => {
  const cashBackGetMine = useCustomInstance<CashBackSummaryDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return cashBackGetMine({ url: `/me/cash-back`, method: 'GET', signal });
    },
    [cashBackGetMine],
  );
};

export const getCashBackGetMineQueryKey = () => {
  return [`/me/cash-back`] as const;
};

export const useCashBackGetMineQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useCashBackGetMineHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCashBackGetMineHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCashBackGetMineQueryKey();

  const cashBackGetMine = useCashBackGetMineHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useCashBackGetMineHook>>>> = ({ signal }) =>
    cashBackGetMine(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useCashBackGetMineHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CashBackGetMineQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCashBackGetMineHook>>>>;
export type CashBackGetMineQueryError = unknown;

export function useCashBackGetMine<TData = Awaited<ReturnType<ReturnType<typeof useCashBackGetMineHook>>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCashBackGetMineHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useCashBackGetMineHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useCashBackGetMineHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCashBackGetMine<TData = Awaited<ReturnType<ReturnType<typeof useCashBackGetMineHook>>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCashBackGetMineHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useCashBackGetMineHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useCashBackGetMineHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCashBackGetMine<TData = Awaited<ReturnType<ReturnType<typeof useCashBackGetMineHook>>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCashBackGetMineHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Return the current player's cash-back balance and active lots
 */

export function useCashBackGetMine<TData = Awaited<ReturnType<ReturnType<typeof useCashBackGetMineHook>>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCashBackGetMineHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useCashBackGetMineQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List segments in the configured environment.
 */
export const useAdminLaunchDarklySegmentsListHook = () => {
  const adminLaunchDarklySegmentsList = useCustomInstance<SegmentSummaryResponseDto[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminLaunchDarklySegmentsList({ url: `/admin/launchdarkly/segments`, method: 'GET', signal });
    },
    [adminLaunchDarklySegmentsList],
  );
};

export const getAdminLaunchDarklySegmentsListQueryKey = () => {
  return [`/admin/launchdarkly/segments`] as const;
};

export const useAdminLaunchDarklySegmentsListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsListHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsListHook>>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminLaunchDarklySegmentsListQueryKey();

  const adminLaunchDarklySegmentsList = useAdminLaunchDarklySegmentsListHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsListHook>>>> = ({
    signal,
  }) => adminLaunchDarklySegmentsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsListHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminLaunchDarklySegmentsListQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsListHook>>>
>;
export type AdminLaunchDarklySegmentsListQueryError = unknown;

export function useAdminLaunchDarklySegmentsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsListHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsListHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminLaunchDarklySegmentsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsListHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsListHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminLaunchDarklySegmentsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsListHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsListHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List segments in the configured environment.
 */

export function useAdminLaunchDarklySegmentsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsListHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsListHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminLaunchDarklySegmentsListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a new segment.
 */
export const useAdminLaunchDarklySegmentsCreateHook = () => {
  const adminLaunchDarklySegmentsCreate = useCustomInstance<SegmentResponseDto>();

  return useCallback(
    (createSegmentDto: CreateSegmentDto, signal?: AbortSignal) => {
      return adminLaunchDarklySegmentsCreate({
        url: `/admin/launchdarkly/segments`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createSegmentDto,
        signal,
      });
    },
    [adminLaunchDarklySegmentsCreate],
  );
};

export const useAdminLaunchDarklySegmentsCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsCreateHook>>>,
    TError,
    { data: CreateSegmentDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsCreateHook>>>,
  TError,
  { data: CreateSegmentDto },
  TContext
> => {
  const mutationKey = ['adminLaunchDarklySegmentsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminLaunchDarklySegmentsCreate = useAdminLaunchDarklySegmentsCreateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsCreateHook>>>,
    { data: CreateSegmentDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminLaunchDarklySegmentsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminLaunchDarklySegmentsCreateMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsCreateHook>>>
>;
export type AdminLaunchDarklySegmentsCreateMutationBody = CreateSegmentDto;
export type AdminLaunchDarklySegmentsCreateMutationError = unknown;

/**
 * @summary Create a new segment.
 */
export const useAdminLaunchDarklySegmentsCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsCreateHook>>>,
      TError,
      { data: CreateSegmentDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsCreateHook>>>,
  TError,
  { data: CreateSegmentDto },
  TContext
> => {
  const mutationOptions = useAdminLaunchDarklySegmentsCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Read a single segment with full member lists.
 */
export const useAdminLaunchDarklySegmentsGetHook = () => {
  const adminLaunchDarklySegmentsGet = useCustomInstance<SegmentResponseDto>();

  return useCallback(
    (key: string, signal?: AbortSignal) => {
      return adminLaunchDarklySegmentsGet({ url: `/admin/launchdarkly/segments/${key}`, method: 'GET', signal });
    },
    [adminLaunchDarklySegmentsGet],
  );
};

export const getAdminLaunchDarklySegmentsGetQueryKey = (key: string) => {
  return [`/admin/launchdarkly/segments/${key}`] as const;
};

export const useAdminLaunchDarklySegmentsGetQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsGetHook>>>,
  TError = unknown,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsGetHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminLaunchDarklySegmentsGetQueryKey(key);

  const adminLaunchDarklySegmentsGet = useAdminLaunchDarklySegmentsGetHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsGetHook>>>> = ({ signal }) =>
    adminLaunchDarklySegmentsGet(key, signal);

  return { queryKey, queryFn, enabled: !!key, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsGetHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminLaunchDarklySegmentsGetQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsGetHook>>>
>;
export type AdminLaunchDarklySegmentsGetQueryError = unknown;

export function useAdminLaunchDarklySegmentsGet<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsGetHook>>>,
  TError = unknown,
>(
  key: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsGetHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsGetHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsGetHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminLaunchDarklySegmentsGet<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsGetHook>>>,
  TError = unknown,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsGetHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsGetHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsGetHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminLaunchDarklySegmentsGet<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsGetHook>>>,
  TError = unknown,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsGetHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Read a single segment with full member lists.
 */

export function useAdminLaunchDarklySegmentsGet<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsGetHook>>>,
  TError = unknown,
>(
  key: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsGetHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminLaunchDarklySegmentsGetQueryOptions(key, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete a segment. Refused by LD if any flag rule references it.
 */
export const useAdminLaunchDarklySegmentsDeleteHook = () => {
  const adminLaunchDarklySegmentsDelete = useCustomInstance<void>();

  return useCallback(
    (key: string) => {
      return adminLaunchDarklySegmentsDelete({ url: `/admin/launchdarkly/segments/${key}`, method: 'DELETE' });
    },
    [adminLaunchDarklySegmentsDelete],
  );
};

export const useAdminLaunchDarklySegmentsDeleteMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsDeleteHook>>>,
    TError,
    { key: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsDeleteHook>>>,
  TError,
  { key: string },
  TContext
> => {
  const mutationKey = ['adminLaunchDarklySegmentsDelete'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminLaunchDarklySegmentsDelete = useAdminLaunchDarklySegmentsDeleteHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsDeleteHook>>>,
    { key: string }
  > = (props) => {
    const { key } = props ?? {};

    return adminLaunchDarklySegmentsDelete(key);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminLaunchDarklySegmentsDeleteMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsDeleteHook>>>
>;

export type AdminLaunchDarklySegmentsDeleteMutationError = unknown;

/**
 * @summary Delete a segment. Refused by LD if any flag rule references it.
 */
export const useAdminLaunchDarklySegmentsDelete = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsDeleteHook>>>,
      TError,
      { key: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsDeleteHook>>>,
  TError,
  { key: string },
  TContext
> => {
  const mutationOptions = useAdminLaunchDarklySegmentsDeleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Add users to the included or excluded list.
 */
export const useAdminLaunchDarklySegmentsAddMembersHook = () => {
  const adminLaunchDarklySegmentsAddMembers = useCustomInstance<SegmentResponseDto>();

  return useCallback(
    (key: string, segmentMembersDto: SegmentMembersDto, signal?: AbortSignal) => {
      return adminLaunchDarklySegmentsAddMembers({
        url: `/admin/launchdarkly/segments/${key}/members`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: segmentMembersDto,
        signal,
      });
    },
    [adminLaunchDarklySegmentsAddMembers],
  );
};

export const useAdminLaunchDarklySegmentsAddMembersMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsAddMembersHook>>>,
    TError,
    { key: string; data: SegmentMembersDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsAddMembersHook>>>,
  TError,
  { key: string; data: SegmentMembersDto },
  TContext
> => {
  const mutationKey = ['adminLaunchDarklySegmentsAddMembers'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminLaunchDarklySegmentsAddMembers = useAdminLaunchDarklySegmentsAddMembersHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsAddMembersHook>>>,
    { key: string; data: SegmentMembersDto }
  > = (props) => {
    const { key, data } = props ?? {};

    return adminLaunchDarklySegmentsAddMembers(key, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminLaunchDarklySegmentsAddMembersMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsAddMembersHook>>>
>;
export type AdminLaunchDarklySegmentsAddMembersMutationBody = SegmentMembersDto;
export type AdminLaunchDarklySegmentsAddMembersMutationError = unknown;

/**
 * @summary Add users to the included or excluded list.
 */
export const useAdminLaunchDarklySegmentsAddMembers = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsAddMembersHook>>>,
      TError,
      { key: string; data: SegmentMembersDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsAddMembersHook>>>,
  TError,
  { key: string; data: SegmentMembersDto },
  TContext
> => {
  const mutationOptions = useAdminLaunchDarklySegmentsAddMembersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Remove users from the included or excluded list.
 */
export const useAdminLaunchDarklySegmentsRemoveMembersHook = () => {
  const adminLaunchDarklySegmentsRemoveMembers = useCustomInstance<SegmentResponseDto>();

  return useCallback(
    (key: string, segmentMembersDto: SegmentMembersDto) => {
      return adminLaunchDarklySegmentsRemoveMembers({
        url: `/admin/launchdarkly/segments/${key}/members`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: segmentMembersDto,
      });
    },
    [adminLaunchDarklySegmentsRemoveMembers],
  );
};

export const useAdminLaunchDarklySegmentsRemoveMembersMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsRemoveMembersHook>>>,
    TError,
    { key: string; data: SegmentMembersDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsRemoveMembersHook>>>,
  TError,
  { key: string; data: SegmentMembersDto },
  TContext
> => {
  const mutationKey = ['adminLaunchDarklySegmentsRemoveMembers'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminLaunchDarklySegmentsRemoveMembers = useAdminLaunchDarklySegmentsRemoveMembersHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsRemoveMembersHook>>>,
    { key: string; data: SegmentMembersDto }
  > = (props) => {
    const { key, data } = props ?? {};

    return adminLaunchDarklySegmentsRemoveMembers(key, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminLaunchDarklySegmentsRemoveMembersMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsRemoveMembersHook>>>
>;
export type AdminLaunchDarklySegmentsRemoveMembersMutationBody = SegmentMembersDto;
export type AdminLaunchDarklySegmentsRemoveMembersMutationError = unknown;

/**
 * @summary Remove users from the included or excluded list.
 */
export const useAdminLaunchDarklySegmentsRemoveMembers = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsRemoveMembersHook>>>,
      TError,
      { key: string; data: SegmentMembersDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminLaunchDarklySegmentsRemoveMembersHook>>>,
  TError,
  { key: string; data: SegmentMembersDto },
  TContext
> => {
  const mutationOptions = useAdminLaunchDarklySegmentsRemoveMembersMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List markets with pagination and filters
 */
export const useAdminMarketsGetListHook = () => {
  const adminMarketsGetList = useCustomInstance<AdminMarketListResponseDto>();

  return useCallback(
    (params: AdminMarketsGetListParams, signal?: AbortSignal) => {
      return adminMarketsGetList({ url: `/admin/markets`, method: 'GET', params, signal });
    },
    [adminMarketsGetList],
  );
};

export const getAdminMarketsGetListQueryKey = (params: AdminMarketsGetListParams) => {
  return [`/admin/markets`, ...(params ? [params] : [])] as const;
};

export const useAdminMarketsGetListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetListHook>>>,
  TError = unknown,
>(
  params: AdminMarketsGetListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetListHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminMarketsGetListQueryKey(params);

  const adminMarketsGetList = useAdminMarketsGetListHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetListHook>>>> = ({ signal }) =>
    adminMarketsGetList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetListHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminMarketsGetListQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetListHook>>>>;
export type AdminMarketsGetListQueryError = unknown;

export function useAdminMarketsGetList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetListHook>>>,
  TError = unknown,
>(
  params: AdminMarketsGetListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetListHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminMarketsGetList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetListHook>>>,
  TError = unknown,
>(
  params: AdminMarketsGetListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetListHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminMarketsGetList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetListHook>>>,
  TError = unknown,
>(
  params: AdminMarketsGetListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List markets with pagination and filters
 */

export function useAdminMarketsGetList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetListHook>>>,
  TError = unknown,
>(
  params: AdminMarketsGetListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminMarketsGetListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get a single market by id
 */
export const useAdminMarketsGetOneHook = () => {
  const adminMarketsGetOne = useCustomInstance<AdminMarketResponseDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminMarketsGetOne({ url: `/admin/markets/${id}`, method: 'GET', signal });
    },
    [adminMarketsGetOne],
  );
};

export const getAdminMarketsGetOneQueryKey = (id: string) => {
  return [`/admin/markets/${id}`] as const;
};

export const useAdminMarketsGetOneQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetOneHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminMarketsGetOneQueryKey(id);

  const adminMarketsGetOne = useAdminMarketsGetOneHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetOneHook>>>> = ({ signal }) =>
    adminMarketsGetOne(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetOneHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminMarketsGetOneQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetOneHook>>>>;
export type AdminMarketsGetOneQueryError = unknown;

export function useAdminMarketsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetOneHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminMarketsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetOneHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminMarketsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetOneHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a single market by id
 */

export function useAdminMarketsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMarketsGetOneHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminMarketsGetOneQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Toggle whether a market is visible to players
 */
export const useAdminMarketsSetVisibilityHook = () => {
  const adminMarketsSetVisibility = useCustomInstance<AdminMarketResponseDto>();

  return useCallback(
    (id: string, updateMarketVisibilityDto: UpdateMarketVisibilityDto) => {
      return adminMarketsSetVisibility({
        url: `/admin/markets/${id}/visibility`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateMarketVisibilityDto,
      });
    },
    [adminMarketsSetVisibility],
  );
};

export const useAdminMarketsSetVisibilityMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminMarketsSetVisibilityHook>>>,
    TError,
    { id: string; data: UpdateMarketVisibilityDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminMarketsSetVisibilityHook>>>,
  TError,
  { id: string; data: UpdateMarketVisibilityDto },
  TContext
> => {
  const mutationKey = ['adminMarketsSetVisibility'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminMarketsSetVisibility = useAdminMarketsSetVisibilityHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminMarketsSetVisibilityHook>>>,
    { id: string; data: UpdateMarketVisibilityDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminMarketsSetVisibility(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminMarketsSetVisibilityMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminMarketsSetVisibilityHook>>>
>;
export type AdminMarketsSetVisibilityMutationBody = UpdateMarketVisibilityDto;
export type AdminMarketsSetVisibilityMutationError = unknown;

/**
 * @summary Toggle whether a market is visible to players
 */
export const useAdminMarketsSetVisibility = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminMarketsSetVisibilityHook>>>,
      TError,
      { id: string; data: UpdateMarketVisibilityDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminMarketsSetVisibilityHook>>>,
  TError,
  { id: string; data: UpdateMarketVisibilityDto },
  TContext
> => {
  const mutationOptions = useAdminMarketsSetVisibilityMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List market-page sections in display order
 */
export const useAdminEventsMarketsGetSectionsHook = () => {
  const adminEventsMarketsGetSections = useCustomInstance<AdminSectionResponseDto[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminEventsMarketsGetSections({ url: `/admin/events-markets/sections`, method: 'GET', signal });
    },
    [adminEventsMarketsGetSections],
  );
};

export const getAdminEventsMarketsGetSectionsQueryKey = () => {
  return [`/admin/events-markets/sections`] as const;
};

export const useAdminEventsMarketsGetSectionsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetSectionsHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetSectionsHook>>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminEventsMarketsGetSectionsQueryKey();

  const adminEventsMarketsGetSections = useAdminEventsMarketsGetSectionsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetSectionsHook>>>> = ({
    signal,
  }) => adminEventsMarketsGetSections(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetSectionsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminEventsMarketsGetSectionsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetSectionsHook>>>
>;
export type AdminEventsMarketsGetSectionsQueryError = unknown;

export function useAdminEventsMarketsGetSections<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetSectionsHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetSectionsHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetSectionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetSectionsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminEventsMarketsGetSections<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetSectionsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetSectionsHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetSectionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetSectionsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminEventsMarketsGetSections<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetSectionsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetSectionsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List market-page sections in display order
 */

export function useAdminEventsMarketsGetSections<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetSectionsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetSectionsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminEventsMarketsGetSectionsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Replace the market-page section order and default state
 */
export const useAdminEventsMarketsUpdateSectionsHook = () => {
  const adminEventsMarketsUpdateSections = useCustomInstance<AdminSectionResponseDto[]>();

  return useCallback(
    (updateSectionsDto: UpdateSectionsDto) => {
      return adminEventsMarketsUpdateSections({
        url: `/admin/events-markets/sections`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: updateSectionsDto,
      });
    },
    [adminEventsMarketsUpdateSections],
  );
};

export const useAdminEventsMarketsUpdateSectionsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsUpdateSectionsHook>>>,
    TError,
    { data: UpdateSectionsDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsUpdateSectionsHook>>>,
  TError,
  { data: UpdateSectionsDto },
  TContext
> => {
  const mutationKey = ['adminEventsMarketsUpdateSections'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminEventsMarketsUpdateSections = useAdminEventsMarketsUpdateSectionsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsUpdateSectionsHook>>>,
    { data: UpdateSectionsDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminEventsMarketsUpdateSections(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminEventsMarketsUpdateSectionsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsUpdateSectionsHook>>>
>;
export type AdminEventsMarketsUpdateSectionsMutationBody = UpdateSectionsDto;
export type AdminEventsMarketsUpdateSectionsMutationError = unknown;

/**
 * @summary Replace the market-page section order and default state
 */
export const useAdminEventsMarketsUpdateSections = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsUpdateSectionsHook>>>,
      TError,
      { data: UpdateSectionsDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsUpdateSectionsHook>>>,
  TError,
  { data: UpdateSectionsDto },
  TContext
> => {
  const mutationOptions = useAdminEventsMarketsUpdateSectionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get the lobby visible-market count
 */
export const useAdminEventsMarketsGetLobbyConfigHook = () => {
  const adminEventsMarketsGetLobbyConfig = useCustomInstance<LobbyConfigResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminEventsMarketsGetLobbyConfig({ url: `/admin/events-markets/lobby-config`, method: 'GET', signal });
    },
    [adminEventsMarketsGetLobbyConfig],
  );
};

export const getAdminEventsMarketsGetLobbyConfigQueryKey = () => {
  return [`/admin/events-markets/lobby-config`] as const;
};

export const useAdminEventsMarketsGetLobbyConfigQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetLobbyConfigHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetLobbyConfigHook>>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminEventsMarketsGetLobbyConfigQueryKey();

  const adminEventsMarketsGetLobbyConfig = useAdminEventsMarketsGetLobbyConfigHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetLobbyConfigHook>>>> = ({
    signal,
  }) => adminEventsMarketsGetLobbyConfig(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetLobbyConfigHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminEventsMarketsGetLobbyConfigQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetLobbyConfigHook>>>
>;
export type AdminEventsMarketsGetLobbyConfigQueryError = unknown;

export function useAdminEventsMarketsGetLobbyConfig<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetLobbyConfigHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetLobbyConfigHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetLobbyConfigHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetLobbyConfigHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminEventsMarketsGetLobbyConfig<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetLobbyConfigHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetLobbyConfigHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetLobbyConfigHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetLobbyConfigHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminEventsMarketsGetLobbyConfig<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetLobbyConfigHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetLobbyConfigHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the lobby visible-market count
 */

export function useAdminEventsMarketsGetLobbyConfig<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetLobbyConfigHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetLobbyConfigHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminEventsMarketsGetLobbyConfigQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Set the lobby visible-market count
 */
export const useAdminEventsMarketsUpdateLobbyConfigHook = () => {
  const adminEventsMarketsUpdateLobbyConfig = useCustomInstance<LobbyConfigResponseDto>();

  return useCallback(
    (updateLobbyConfigDto: UpdateLobbyConfigDto) => {
      return adminEventsMarketsUpdateLobbyConfig({
        url: `/admin/events-markets/lobby-config`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: updateLobbyConfigDto,
      });
    },
    [adminEventsMarketsUpdateLobbyConfig],
  );
};

export const useAdminEventsMarketsUpdateLobbyConfigMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsUpdateLobbyConfigHook>>>,
    TError,
    { data: UpdateLobbyConfigDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsUpdateLobbyConfigHook>>>,
  TError,
  { data: UpdateLobbyConfigDto },
  TContext
> => {
  const mutationKey = ['adminEventsMarketsUpdateLobbyConfig'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminEventsMarketsUpdateLobbyConfig = useAdminEventsMarketsUpdateLobbyConfigHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsUpdateLobbyConfigHook>>>,
    { data: UpdateLobbyConfigDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminEventsMarketsUpdateLobbyConfig(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminEventsMarketsUpdateLobbyConfigMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsUpdateLobbyConfigHook>>>
>;
export type AdminEventsMarketsUpdateLobbyConfigMutationBody = UpdateLobbyConfigDto;
export type AdminEventsMarketsUpdateLobbyConfigMutationError = unknown;

/**
 * @summary Set the lobby visible-market count
 */
export const useAdminEventsMarketsUpdateLobbyConfig = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsUpdateLobbyConfigHook>>>,
      TError,
      { data: UpdateLobbyConfigDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsUpdateLobbyConfigHook>>>,
  TError,
  { data: UpdateLobbyConfigDto },
  TContext
> => {
  const mutationOptions = useAdminEventsMarketsUpdateLobbyConfigMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get the trending ("People Are Also Trading") semantic toggle and top-X cap
 */
export const useAdminEventsMarketsGetTrendingConfigHook = () => {
  const adminEventsMarketsGetTrendingConfig = useCustomInstance<TrendingConfigResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminEventsMarketsGetTrendingConfig({ url: `/admin/events-markets/trending-config`, method: 'GET', signal });
    },
    [adminEventsMarketsGetTrendingConfig],
  );
};

export const getAdminEventsMarketsGetTrendingConfigQueryKey = () => {
  return [`/admin/events-markets/trending-config`] as const;
};

export const useAdminEventsMarketsGetTrendingConfigQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetTrendingConfigHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetTrendingConfigHook>>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminEventsMarketsGetTrendingConfigQueryKey();

  const adminEventsMarketsGetTrendingConfig = useAdminEventsMarketsGetTrendingConfigHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetTrendingConfigHook>>>> = ({
    signal,
  }) => adminEventsMarketsGetTrendingConfig(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetTrendingConfigHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminEventsMarketsGetTrendingConfigQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetTrendingConfigHook>>>
>;
export type AdminEventsMarketsGetTrendingConfigQueryError = unknown;

export function useAdminEventsMarketsGetTrendingConfig<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetTrendingConfigHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetTrendingConfigHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetTrendingConfigHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetTrendingConfigHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminEventsMarketsGetTrendingConfig<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetTrendingConfigHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetTrendingConfigHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetTrendingConfigHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetTrendingConfigHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminEventsMarketsGetTrendingConfig<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetTrendingConfigHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetTrendingConfigHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the trending ("People Are Also Trading") semantic toggle and top-X cap
 */

export function useAdminEventsMarketsGetTrendingConfig<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetTrendingConfigHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsGetTrendingConfigHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminEventsMarketsGetTrendingConfigQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Set the trending semantic toggle and top-X cap
 */
export const useAdminEventsMarketsUpdateTrendingConfigHook = () => {
  const adminEventsMarketsUpdateTrendingConfig = useCustomInstance<TrendingConfigResponseDto>();

  return useCallback(
    (updateTrendingConfigDto: UpdateTrendingConfigDto) => {
      return adminEventsMarketsUpdateTrendingConfig({
        url: `/admin/events-markets/trending-config`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: updateTrendingConfigDto,
      });
    },
    [adminEventsMarketsUpdateTrendingConfig],
  );
};

export const useAdminEventsMarketsUpdateTrendingConfigMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsUpdateTrendingConfigHook>>>,
    TError,
    { data: UpdateTrendingConfigDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsUpdateTrendingConfigHook>>>,
  TError,
  { data: UpdateTrendingConfigDto },
  TContext
> => {
  const mutationKey = ['adminEventsMarketsUpdateTrendingConfig'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminEventsMarketsUpdateTrendingConfig = useAdminEventsMarketsUpdateTrendingConfigHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsUpdateTrendingConfigHook>>>,
    { data: UpdateTrendingConfigDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminEventsMarketsUpdateTrendingConfig(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminEventsMarketsUpdateTrendingConfigMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsUpdateTrendingConfigHook>>>
>;
export type AdminEventsMarketsUpdateTrendingConfigMutationBody = UpdateTrendingConfigDto;
export type AdminEventsMarketsUpdateTrendingConfigMutationError = unknown;

/**
 * @summary Set the trending semantic toggle and top-X cap
 */
export const useAdminEventsMarketsUpdateTrendingConfig = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsUpdateTrendingConfigHook>>>,
      TError,
      { data: UpdateTrendingConfigDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsUpdateTrendingConfigHook>>>,
  TError,
  { data: UpdateTrendingConfigDto },
  TContext
> => {
  const mutationOptions = useAdminEventsMarketsUpdateTrendingConfigMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List price-cube rules, optionally filtered by format
 */
export const useAdminEventsMarketsListPriceCubesHook = () => {
  const adminEventsMarketsListPriceCubes = useCustomInstance<PriceCubeResponseDto[]>();

  return useCallback(
    (params?: AdminEventsMarketsListPriceCubesParams, signal?: AbortSignal) => {
      return adminEventsMarketsListPriceCubes({ url: `/admin/events-markets/price-cubes`, method: 'GET', params, signal });
    },
    [adminEventsMarketsListPriceCubes],
  );
};

export const getAdminEventsMarketsListPriceCubesQueryKey = (params?: AdminEventsMarketsListPriceCubesParams) => {
  return [`/admin/events-markets/price-cubes`, ...(params ? [params] : [])] as const;
};

export const useAdminEventsMarketsListPriceCubesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsListPriceCubesHook>>>,
  TError = unknown,
>(
  params?: AdminEventsMarketsListPriceCubesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsListPriceCubesHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminEventsMarketsListPriceCubesQueryKey(params);

  const adminEventsMarketsListPriceCubes = useAdminEventsMarketsListPriceCubesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsListPriceCubesHook>>>> = ({
    signal,
  }) => adminEventsMarketsListPriceCubes(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsListPriceCubesHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminEventsMarketsListPriceCubesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsListPriceCubesHook>>>
>;
export type AdminEventsMarketsListPriceCubesQueryError = unknown;

export function useAdminEventsMarketsListPriceCubes<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsListPriceCubesHook>>>,
  TError = unknown,
>(
  params: undefined | AdminEventsMarketsListPriceCubesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsListPriceCubesHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsListPriceCubesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsListPriceCubesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminEventsMarketsListPriceCubes<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsListPriceCubesHook>>>,
  TError = unknown,
>(
  params?: AdminEventsMarketsListPriceCubesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsListPriceCubesHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsListPriceCubesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsListPriceCubesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminEventsMarketsListPriceCubes<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsListPriceCubesHook>>>,
  TError = unknown,
>(
  params?: AdminEventsMarketsListPriceCubesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsListPriceCubesHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List price-cube rules, optionally filtered by format
 */

export function useAdminEventsMarketsListPriceCubes<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsListPriceCubesHook>>>,
  TError = unknown,
>(
  params?: AdminEventsMarketsListPriceCubesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsListPriceCubesHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminEventsMarketsListPriceCubesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a price-cube rule
 */
export const useAdminEventsMarketsCreatePriceCubeHook = () => {
  const adminEventsMarketsCreatePriceCube = useCustomInstance<PriceCubeResponseDto>();

  return useCallback(
    (createPriceCubeDto: CreatePriceCubeDto, signal?: AbortSignal) => {
      return adminEventsMarketsCreatePriceCube({
        url: `/admin/events-markets/price-cubes`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createPriceCubeDto,
        signal,
      });
    },
    [adminEventsMarketsCreatePriceCube],
  );
};

export const useAdminEventsMarketsCreatePriceCubeMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsCreatePriceCubeHook>>>,
    TError,
    { data: CreatePriceCubeDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsCreatePriceCubeHook>>>,
  TError,
  { data: CreatePriceCubeDto },
  TContext
> => {
  const mutationKey = ['adminEventsMarketsCreatePriceCube'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminEventsMarketsCreatePriceCube = useAdminEventsMarketsCreatePriceCubeHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsCreatePriceCubeHook>>>,
    { data: CreatePriceCubeDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminEventsMarketsCreatePriceCube(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminEventsMarketsCreatePriceCubeMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsCreatePriceCubeHook>>>
>;
export type AdminEventsMarketsCreatePriceCubeMutationBody = CreatePriceCubeDto;
export type AdminEventsMarketsCreatePriceCubeMutationError = unknown;

/**
 * @summary Create a price-cube rule
 */
export const useAdminEventsMarketsCreatePriceCube = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsCreatePriceCubeHook>>>,
      TError,
      { data: CreatePriceCubeDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsCreatePriceCubeHook>>>,
  TError,
  { data: CreatePriceCubeDto },
  TContext
> => {
  const mutationOptions = useAdminEventsMarketsCreatePriceCubeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Update a price-cube rule
 */
export const useAdminEventsMarketsUpdatePriceCubeHook = () => {
  const adminEventsMarketsUpdatePriceCube = useCustomInstance<PriceCubeResponseDto>();

  return useCallback(
    (id: string, updatePriceCubeDto: UpdatePriceCubeDto) => {
      return adminEventsMarketsUpdatePriceCube({
        url: `/admin/events-markets/price-cubes/${id}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updatePriceCubeDto,
      });
    },
    [adminEventsMarketsUpdatePriceCube],
  );
};

export const useAdminEventsMarketsUpdatePriceCubeMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsUpdatePriceCubeHook>>>,
    TError,
    { id: string; data: UpdatePriceCubeDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsUpdatePriceCubeHook>>>,
  TError,
  { id: string; data: UpdatePriceCubeDto },
  TContext
> => {
  const mutationKey = ['adminEventsMarketsUpdatePriceCube'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminEventsMarketsUpdatePriceCube = useAdminEventsMarketsUpdatePriceCubeHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsUpdatePriceCubeHook>>>,
    { id: string; data: UpdatePriceCubeDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminEventsMarketsUpdatePriceCube(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminEventsMarketsUpdatePriceCubeMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsUpdatePriceCubeHook>>>
>;
export type AdminEventsMarketsUpdatePriceCubeMutationBody = UpdatePriceCubeDto;
export type AdminEventsMarketsUpdatePriceCubeMutationError = unknown;

/**
 * @summary Update a price-cube rule
 */
export const useAdminEventsMarketsUpdatePriceCube = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsUpdatePriceCubeHook>>>,
      TError,
      { id: string; data: UpdatePriceCubeDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsUpdatePriceCubeHook>>>,
  TError,
  { id: string; data: UpdatePriceCubeDto },
  TContext
> => {
  const mutationOptions = useAdminEventsMarketsUpdatePriceCubeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Delete a price-cube rule
 */
export const useAdminEventsMarketsDeletePriceCubeHook = () => {
  const adminEventsMarketsDeletePriceCube = useCustomInstance<PriceCubeDeleteResponseDto>();

  return useCallback(
    (id: string) => {
      return adminEventsMarketsDeletePriceCube({ url: `/admin/events-markets/price-cubes/${id}`, method: 'DELETE' });
    },
    [adminEventsMarketsDeletePriceCube],
  );
};

export const useAdminEventsMarketsDeletePriceCubeMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsDeletePriceCubeHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsDeletePriceCubeHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminEventsMarketsDeletePriceCube'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminEventsMarketsDeletePriceCube = useAdminEventsMarketsDeletePriceCubeHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsDeletePriceCubeHook>>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminEventsMarketsDeletePriceCube(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminEventsMarketsDeletePriceCubeMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsDeletePriceCubeHook>>>
>;

export type AdminEventsMarketsDeletePriceCubeMutationError = unknown;

/**
 * @summary Delete a price-cube rule
 */
export const useAdminEventsMarketsDeletePriceCube = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsDeletePriceCubeHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminEventsMarketsDeletePriceCubeHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useAdminEventsMarketsDeletePriceCubeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List snake currency config rows
 */
export const useAdminSnakeMarketsListCurrenciesHook = () => {
  const adminSnakeMarketsListCurrencies = useCustomInstance<CurrencyConfigResponseDto[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminSnakeMarketsListCurrencies({ url: `/admin/snake-markets/currencies`, method: 'GET', signal });
    },
    [adminSnakeMarketsListCurrencies],
  );
};

export const getAdminSnakeMarketsListCurrenciesQueryKey = () => {
  return [`/admin/snake-markets/currencies`] as const;
};

export const useAdminSnakeMarketsListCurrenciesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListCurrenciesHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListCurrenciesHook>>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminSnakeMarketsListCurrenciesQueryKey();

  const adminSnakeMarketsListCurrencies = useAdminSnakeMarketsListCurrenciesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListCurrenciesHook>>>> = ({
    signal,
  }) => adminSnakeMarketsListCurrencies(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListCurrenciesHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminSnakeMarketsListCurrenciesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListCurrenciesHook>>>
>;
export type AdminSnakeMarketsListCurrenciesQueryError = unknown;

export function useAdminSnakeMarketsListCurrencies<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListCurrenciesHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListCurrenciesHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListCurrenciesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListCurrenciesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminSnakeMarketsListCurrencies<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListCurrenciesHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListCurrenciesHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListCurrenciesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListCurrenciesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminSnakeMarketsListCurrencies<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListCurrenciesHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListCurrenciesHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List snake currency config rows
 */

export function useAdminSnakeMarketsListCurrencies<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListCurrenciesHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListCurrenciesHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminSnakeMarketsListCurrenciesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Add a snake currency config row
 */
export const useAdminSnakeMarketsCreateCurrencyHook = () => {
  const adminSnakeMarketsCreateCurrency = useCustomInstance<CurrencyConfigResponseDto>();

  return useCallback(
    (createCurrencyConfigDto: CreateCurrencyConfigDto, signal?: AbortSignal) => {
      return adminSnakeMarketsCreateCurrency({
        url: `/admin/snake-markets/currencies`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createCurrencyConfigDto,
        signal,
      });
    },
    [adminSnakeMarketsCreateCurrency],
  );
};

export const useAdminSnakeMarketsCreateCurrencyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsCreateCurrencyHook>>>,
    TError,
    { data: CreateCurrencyConfigDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsCreateCurrencyHook>>>,
  TError,
  { data: CreateCurrencyConfigDto },
  TContext
> => {
  const mutationKey = ['adminSnakeMarketsCreateCurrency'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminSnakeMarketsCreateCurrency = useAdminSnakeMarketsCreateCurrencyHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsCreateCurrencyHook>>>,
    { data: CreateCurrencyConfigDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminSnakeMarketsCreateCurrency(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSnakeMarketsCreateCurrencyMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsCreateCurrencyHook>>>
>;
export type AdminSnakeMarketsCreateCurrencyMutationBody = CreateCurrencyConfigDto;
export type AdminSnakeMarketsCreateCurrencyMutationError = unknown;

/**
 * @summary Add a snake currency config row
 */
export const useAdminSnakeMarketsCreateCurrency = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsCreateCurrencyHook>>>,
      TError,
      { data: CreateCurrencyConfigDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsCreateCurrencyHook>>>,
  TError,
  { data: CreateCurrencyConfigDto },
  TContext
> => {
  const mutationOptions = useAdminSnakeMarketsCreateCurrencyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List distinct crypto instruments synced from recurring snake markets
 */
export const useAdminSnakeMarketsListAvailableCurrenciesHook = () => {
  const adminSnakeMarketsListAvailableCurrencies = useCustomInstance<AvailableCurrencyDto[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminSnakeMarketsListAvailableCurrencies({
        url: `/admin/snake-markets/currencies/available`,
        method: 'GET',
        signal,
      });
    },
    [adminSnakeMarketsListAvailableCurrencies],
  );
};

export const getAdminSnakeMarketsListAvailableCurrenciesQueryKey = () => {
  return [`/admin/snake-markets/currencies/available`] as const;
};

export const useAdminSnakeMarketsListAvailableCurrenciesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListAvailableCurrenciesHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListAvailableCurrenciesHook>>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminSnakeMarketsListAvailableCurrenciesQueryKey();

  const adminSnakeMarketsListAvailableCurrencies = useAdminSnakeMarketsListAvailableCurrenciesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListAvailableCurrenciesHook>>>> = ({
    signal,
  }) => adminSnakeMarketsListAvailableCurrencies(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListAvailableCurrenciesHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminSnakeMarketsListAvailableCurrenciesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListAvailableCurrenciesHook>>>
>;
export type AdminSnakeMarketsListAvailableCurrenciesQueryError = unknown;

export function useAdminSnakeMarketsListAvailableCurrencies<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListAvailableCurrenciesHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListAvailableCurrenciesHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListAvailableCurrenciesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListAvailableCurrenciesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminSnakeMarketsListAvailableCurrencies<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListAvailableCurrenciesHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListAvailableCurrenciesHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListAvailableCurrenciesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListAvailableCurrenciesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminSnakeMarketsListAvailableCurrencies<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListAvailableCurrenciesHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListAvailableCurrenciesHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List distinct crypto instruments synced from recurring snake markets
 */

export function useAdminSnakeMarketsListAvailableCurrencies<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListAvailableCurrenciesHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListAvailableCurrenciesHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminSnakeMarketsListAvailableCurrenciesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update a snake currency config row
 */
export const useAdminSnakeMarketsUpdateCurrencyHook = () => {
  const adminSnakeMarketsUpdateCurrency = useCustomInstance<CurrencyConfigResponseDto>();

  return useCallback(
    (id: string, updateCurrencyConfigDto: UpdateCurrencyConfigDto) => {
      return adminSnakeMarketsUpdateCurrency({
        url: `/admin/snake-markets/currencies/${id}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateCurrencyConfigDto,
      });
    },
    [adminSnakeMarketsUpdateCurrency],
  );
};

export const useAdminSnakeMarketsUpdateCurrencyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsUpdateCurrencyHook>>>,
    TError,
    { id: string; data: UpdateCurrencyConfigDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsUpdateCurrencyHook>>>,
  TError,
  { id: string; data: UpdateCurrencyConfigDto },
  TContext
> => {
  const mutationKey = ['adminSnakeMarketsUpdateCurrency'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminSnakeMarketsUpdateCurrency = useAdminSnakeMarketsUpdateCurrencyHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsUpdateCurrencyHook>>>,
    { id: string; data: UpdateCurrencyConfigDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminSnakeMarketsUpdateCurrency(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSnakeMarketsUpdateCurrencyMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsUpdateCurrencyHook>>>
>;
export type AdminSnakeMarketsUpdateCurrencyMutationBody = UpdateCurrencyConfigDto;
export type AdminSnakeMarketsUpdateCurrencyMutationError = unknown;

/**
 * @summary Update a snake currency config row
 */
export const useAdminSnakeMarketsUpdateCurrency = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsUpdateCurrencyHook>>>,
      TError,
      { id: string; data: UpdateCurrencyConfigDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsUpdateCurrencyHook>>>,
  TError,
  { id: string; data: UpdateCurrencyConfigDto },
  TContext
> => {
  const mutationOptions = useAdminSnakeMarketsUpdateCurrencyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Delete a snake currency config row
 */
export const useAdminSnakeMarketsDeleteCurrencyHook = () => {
  const adminSnakeMarketsDeleteCurrency = useCustomInstance<CurrencyConfigDeleteResponseDto>();

  return useCallback(
    (id: string) => {
      return adminSnakeMarketsDeleteCurrency({ url: `/admin/snake-markets/currencies/${id}`, method: 'DELETE' });
    },
    [adminSnakeMarketsDeleteCurrency],
  );
};

export const useAdminSnakeMarketsDeleteCurrencyMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsDeleteCurrencyHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsDeleteCurrencyHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminSnakeMarketsDeleteCurrency'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminSnakeMarketsDeleteCurrency = useAdminSnakeMarketsDeleteCurrencyHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsDeleteCurrencyHook>>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminSnakeMarketsDeleteCurrency(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSnakeMarketsDeleteCurrencyMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsDeleteCurrencyHook>>>
>;

export type AdminSnakeMarketsDeleteCurrencyMutationError = unknown;

/**
 * @summary Delete a snake currency config row
 */
export const useAdminSnakeMarketsDeleteCurrency = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsDeleteCurrencyHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsDeleteCurrencyHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useAdminSnakeMarketsDeleteCurrencyMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List snake resolution config rows
 */
export const useAdminSnakeMarketsListResolutionsHook = () => {
  const adminSnakeMarketsListResolutions = useCustomInstance<ResolutionConfigResponseDto[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminSnakeMarketsListResolutions({ url: `/admin/snake-markets/resolutions`, method: 'GET', signal });
    },
    [adminSnakeMarketsListResolutions],
  );
};

export const getAdminSnakeMarketsListResolutionsQueryKey = () => {
  return [`/admin/snake-markets/resolutions`] as const;
};

export const useAdminSnakeMarketsListResolutionsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListResolutionsHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListResolutionsHook>>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminSnakeMarketsListResolutionsQueryKey();

  const adminSnakeMarketsListResolutions = useAdminSnakeMarketsListResolutionsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListResolutionsHook>>>> = ({
    signal,
  }) => adminSnakeMarketsListResolutions(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListResolutionsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminSnakeMarketsListResolutionsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListResolutionsHook>>>
>;
export type AdminSnakeMarketsListResolutionsQueryError = unknown;

export function useAdminSnakeMarketsListResolutions<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListResolutionsHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListResolutionsHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListResolutionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListResolutionsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminSnakeMarketsListResolutions<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListResolutionsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListResolutionsHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListResolutionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListResolutionsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminSnakeMarketsListResolutions<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListResolutionsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListResolutionsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List snake resolution config rows
 */

export function useAdminSnakeMarketsListResolutions<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListResolutionsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListResolutionsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminSnakeMarketsListResolutionsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Add a snake resolution config row
 */
export const useAdminSnakeMarketsCreateResolutionHook = () => {
  const adminSnakeMarketsCreateResolution = useCustomInstance<ResolutionConfigResponseDto>();

  return useCallback(
    (createResolutionConfigDto: CreateResolutionConfigDto, signal?: AbortSignal) => {
      return adminSnakeMarketsCreateResolution({
        url: `/admin/snake-markets/resolutions`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createResolutionConfigDto,
        signal,
      });
    },
    [adminSnakeMarketsCreateResolution],
  );
};

export const useAdminSnakeMarketsCreateResolutionMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsCreateResolutionHook>>>,
    TError,
    { data: CreateResolutionConfigDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsCreateResolutionHook>>>,
  TError,
  { data: CreateResolutionConfigDto },
  TContext
> => {
  const mutationKey = ['adminSnakeMarketsCreateResolution'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminSnakeMarketsCreateResolution = useAdminSnakeMarketsCreateResolutionHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsCreateResolutionHook>>>,
    { data: CreateResolutionConfigDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminSnakeMarketsCreateResolution(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSnakeMarketsCreateResolutionMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsCreateResolutionHook>>>
>;
export type AdminSnakeMarketsCreateResolutionMutationBody = CreateResolutionConfigDto;
export type AdminSnakeMarketsCreateResolutionMutationError = unknown;

/**
 * @summary Add a snake resolution config row
 */
export const useAdminSnakeMarketsCreateResolution = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsCreateResolutionHook>>>,
      TError,
      { data: CreateResolutionConfigDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsCreateResolutionHook>>>,
  TError,
  { data: CreateResolutionConfigDto },
  TContext
> => {
  const mutationOptions = useAdminSnakeMarketsCreateResolutionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Update a snake resolution config row
 */
export const useAdminSnakeMarketsUpdateResolutionHook = () => {
  const adminSnakeMarketsUpdateResolution = useCustomInstance<ResolutionConfigResponseDto>();

  return useCallback(
    (id: string, updateResolutionConfigDto: UpdateResolutionConfigDto) => {
      return adminSnakeMarketsUpdateResolution({
        url: `/admin/snake-markets/resolutions/${id}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateResolutionConfigDto,
      });
    },
    [adminSnakeMarketsUpdateResolution],
  );
};

export const useAdminSnakeMarketsUpdateResolutionMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsUpdateResolutionHook>>>,
    TError,
    { id: string; data: UpdateResolutionConfigDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsUpdateResolutionHook>>>,
  TError,
  { id: string; data: UpdateResolutionConfigDto },
  TContext
> => {
  const mutationKey = ['adminSnakeMarketsUpdateResolution'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminSnakeMarketsUpdateResolution = useAdminSnakeMarketsUpdateResolutionHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsUpdateResolutionHook>>>,
    { id: string; data: UpdateResolutionConfigDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminSnakeMarketsUpdateResolution(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSnakeMarketsUpdateResolutionMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsUpdateResolutionHook>>>
>;
export type AdminSnakeMarketsUpdateResolutionMutationBody = UpdateResolutionConfigDto;
export type AdminSnakeMarketsUpdateResolutionMutationError = unknown;

/**
 * @summary Update a snake resolution config row
 */
export const useAdminSnakeMarketsUpdateResolution = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsUpdateResolutionHook>>>,
      TError,
      { id: string; data: UpdateResolutionConfigDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsUpdateResolutionHook>>>,
  TError,
  { id: string; data: UpdateResolutionConfigDto },
  TContext
> => {
  const mutationOptions = useAdminSnakeMarketsUpdateResolutionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Delete a snake resolution config row
 */
export const useAdminSnakeMarketsDeleteResolutionHook = () => {
  const adminSnakeMarketsDeleteResolution = useCustomInstance<ResolutionConfigDeleteResponseDto>();

  return useCallback(
    (id: string) => {
      return adminSnakeMarketsDeleteResolution({ url: `/admin/snake-markets/resolutions/${id}`, method: 'DELETE' });
    },
    [adminSnakeMarketsDeleteResolution],
  );
};

export const useAdminSnakeMarketsDeleteResolutionMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsDeleteResolutionHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsDeleteResolutionHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminSnakeMarketsDeleteResolution'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminSnakeMarketsDeleteResolution = useAdminSnakeMarketsDeleteResolutionHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsDeleteResolutionHook>>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminSnakeMarketsDeleteResolution(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSnakeMarketsDeleteResolutionMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsDeleteResolutionHook>>>
>;

export type AdminSnakeMarketsDeleteResolutionMutationError = unknown;

/**
 * @summary Delete a snake resolution config row
 */
export const useAdminSnakeMarketsDeleteResolution = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsDeleteResolutionHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsDeleteResolutionHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useAdminSnakeMarketsDeleteResolutionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List snake page sections with default open state
 */
export const useAdminSnakeMarketsGetSectionsHook = () => {
  const adminSnakeMarketsGetSections = useCustomInstance<SnakeSectionResponseDto[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminSnakeMarketsGetSections({ url: `/admin/snake-markets/sections`, method: 'GET', signal });
    },
    [adminSnakeMarketsGetSections],
  );
};

export const getAdminSnakeMarketsGetSectionsQueryKey = () => {
  return [`/admin/snake-markets/sections`] as const;
};

export const useAdminSnakeMarketsGetSectionsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsGetSectionsHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsGetSectionsHook>>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminSnakeMarketsGetSectionsQueryKey();

  const adminSnakeMarketsGetSections = useAdminSnakeMarketsGetSectionsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsGetSectionsHook>>>> = ({ signal }) =>
    adminSnakeMarketsGetSections(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsGetSectionsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminSnakeMarketsGetSectionsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsGetSectionsHook>>>
>;
export type AdminSnakeMarketsGetSectionsQueryError = unknown;

export function useAdminSnakeMarketsGetSections<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsGetSectionsHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsGetSectionsHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsGetSectionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsGetSectionsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminSnakeMarketsGetSections<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsGetSectionsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsGetSectionsHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsGetSectionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsGetSectionsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminSnakeMarketsGetSections<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsGetSectionsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsGetSectionsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List snake page sections with default open state
 */

export function useAdminSnakeMarketsGetSections<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsGetSectionsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsGetSectionsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminSnakeMarketsGetSectionsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Replace the snake page section default-open state
 */
export const useAdminSnakeMarketsUpdateSectionsHook = () => {
  const adminSnakeMarketsUpdateSections = useCustomInstance<SnakeSectionResponseDto[]>();

  return useCallback(
    (updateSnakeSectionsDto: UpdateSnakeSectionsDto) => {
      return adminSnakeMarketsUpdateSections({
        url: `/admin/snake-markets/sections`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: updateSnakeSectionsDto,
      });
    },
    [adminSnakeMarketsUpdateSections],
  );
};

export const useAdminSnakeMarketsUpdateSectionsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsUpdateSectionsHook>>>,
    TError,
    { data: UpdateSnakeSectionsDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsUpdateSectionsHook>>>,
  TError,
  { data: UpdateSnakeSectionsDto },
  TContext
> => {
  const mutationKey = ['adminSnakeMarketsUpdateSections'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminSnakeMarketsUpdateSections = useAdminSnakeMarketsUpdateSectionsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsUpdateSectionsHook>>>,
    { data: UpdateSnakeSectionsDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminSnakeMarketsUpdateSections(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSnakeMarketsUpdateSectionsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsUpdateSectionsHook>>>
>;
export type AdminSnakeMarketsUpdateSectionsMutationBody = UpdateSnakeSectionsDto;
export type AdminSnakeMarketsUpdateSectionsMutationError = unknown;

/**
 * @summary Replace the snake page section default-open state
 */
export const useAdminSnakeMarketsUpdateSections = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsUpdateSectionsHook>>>,
      TError,
      { data: UpdateSnakeSectionsDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsUpdateSectionsHook>>>,
  TError,
  { data: UpdateSnakeSectionsDto },
  TContext
> => {
  const mutationOptions = useAdminSnakeMarketsUpdateSectionsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Update one snake page section default-open state
 */
export const useAdminSnakeMarketsUpdateSectionHook = () => {
  const adminSnakeMarketsUpdateSection = useCustomInstance<SnakeSectionResponseDto>();

  return useCallback(
    (
      section: 'ORDER_BOOK' | 'MARKET_RULES' | 'TIMELINE_PAYOUT' | 'PEOPLE_ALSO_TRADING' | 'PEOPLE_SAYING',
      updateSnakeSectionDto: UpdateSnakeSectionDto,
    ) => {
      return adminSnakeMarketsUpdateSection({
        url: `/admin/snake-markets/sections/${section}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateSnakeSectionDto,
      });
    },
    [adminSnakeMarketsUpdateSection],
  );
};

export const useAdminSnakeMarketsUpdateSectionMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsUpdateSectionHook>>>,
    TError,
    {
      section: 'ORDER_BOOK' | 'MARKET_RULES' | 'TIMELINE_PAYOUT' | 'PEOPLE_ALSO_TRADING' | 'PEOPLE_SAYING';
      data: UpdateSnakeSectionDto;
    },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsUpdateSectionHook>>>,
  TError,
  {
    section: 'ORDER_BOOK' | 'MARKET_RULES' | 'TIMELINE_PAYOUT' | 'PEOPLE_ALSO_TRADING' | 'PEOPLE_SAYING';
    data: UpdateSnakeSectionDto;
  },
  TContext
> => {
  const mutationKey = ['adminSnakeMarketsUpdateSection'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminSnakeMarketsUpdateSection = useAdminSnakeMarketsUpdateSectionHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsUpdateSectionHook>>>,
    {
      section: 'ORDER_BOOK' | 'MARKET_RULES' | 'TIMELINE_PAYOUT' | 'PEOPLE_ALSO_TRADING' | 'PEOPLE_SAYING';
      data: UpdateSnakeSectionDto;
    }
  > = (props) => {
    const { section, data } = props ?? {};

    return adminSnakeMarketsUpdateSection(section, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSnakeMarketsUpdateSectionMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsUpdateSectionHook>>>
>;
export type AdminSnakeMarketsUpdateSectionMutationBody = UpdateSnakeSectionDto;
export type AdminSnakeMarketsUpdateSectionMutationError = unknown;

/**
 * @summary Update one snake page section default-open state
 */
export const useAdminSnakeMarketsUpdateSection = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsUpdateSectionHook>>>,
      TError,
      {
        section: 'ORDER_BOOK' | 'MARKET_RULES' | 'TIMELINE_PAYOUT' | 'PEOPLE_ALSO_TRADING' | 'PEOPLE_SAYING';
        data: UpdateSnakeSectionDto;
      },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsUpdateSectionHook>>>,
  TError,
  {
    section: 'ORDER_BOOK' | 'MARKET_RULES' | 'TIMELINE_PAYOUT' | 'PEOPLE_ALSO_TRADING' | 'PEOPLE_SAYING';
    data: UpdateSnakeSectionDto;
  },
  TContext
> => {
  const mutationOptions = useAdminSnakeMarketsUpdateSectionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List snake price-cube rules, optionally filtered by format
 */
export const useAdminSnakeMarketsListPriceCubesHook = () => {
  const adminSnakeMarketsListPriceCubes = useCustomInstance<SnakePriceCubeResponseDto[]>();

  return useCallback(
    (params?: AdminSnakeMarketsListPriceCubesParams, signal?: AbortSignal) => {
      return adminSnakeMarketsListPriceCubes({ url: `/admin/snake-markets/price-cubes`, method: 'GET', params, signal });
    },
    [adminSnakeMarketsListPriceCubes],
  );
};

export const getAdminSnakeMarketsListPriceCubesQueryKey = (params?: AdminSnakeMarketsListPriceCubesParams) => {
  return [`/admin/snake-markets/price-cubes`, ...(params ? [params] : [])] as const;
};

export const useAdminSnakeMarketsListPriceCubesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListPriceCubesHook>>>,
  TError = unknown,
>(
  params?: AdminSnakeMarketsListPriceCubesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListPriceCubesHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminSnakeMarketsListPriceCubesQueryKey(params);

  const adminSnakeMarketsListPriceCubes = useAdminSnakeMarketsListPriceCubesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListPriceCubesHook>>>> = ({
    signal,
  }) => adminSnakeMarketsListPriceCubes(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListPriceCubesHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminSnakeMarketsListPriceCubesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListPriceCubesHook>>>
>;
export type AdminSnakeMarketsListPriceCubesQueryError = unknown;

export function useAdminSnakeMarketsListPriceCubes<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListPriceCubesHook>>>,
  TError = unknown,
>(
  params: undefined | AdminSnakeMarketsListPriceCubesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListPriceCubesHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListPriceCubesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListPriceCubesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminSnakeMarketsListPriceCubes<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListPriceCubesHook>>>,
  TError = unknown,
>(
  params?: AdminSnakeMarketsListPriceCubesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListPriceCubesHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListPriceCubesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListPriceCubesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminSnakeMarketsListPriceCubes<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListPriceCubesHook>>>,
  TError = unknown,
>(
  params?: AdminSnakeMarketsListPriceCubesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListPriceCubesHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List snake price-cube rules, optionally filtered by format
 */

export function useAdminSnakeMarketsListPriceCubes<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListPriceCubesHook>>>,
  TError = unknown,
>(
  params?: AdminSnakeMarketsListPriceCubesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsListPriceCubesHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminSnakeMarketsListPriceCubesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a snake price-cube rule
 */
export const useAdminSnakeMarketsCreatePriceCubeHook = () => {
  const adminSnakeMarketsCreatePriceCube = useCustomInstance<SnakePriceCubeResponseDto>();

  return useCallback(
    (createSnakePriceCubeDto: CreateSnakePriceCubeDto, signal?: AbortSignal) => {
      return adminSnakeMarketsCreatePriceCube({
        url: `/admin/snake-markets/price-cubes`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createSnakePriceCubeDto,
        signal,
      });
    },
    [adminSnakeMarketsCreatePriceCube],
  );
};

export const useAdminSnakeMarketsCreatePriceCubeMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsCreatePriceCubeHook>>>,
    TError,
    { data: CreateSnakePriceCubeDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsCreatePriceCubeHook>>>,
  TError,
  { data: CreateSnakePriceCubeDto },
  TContext
> => {
  const mutationKey = ['adminSnakeMarketsCreatePriceCube'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminSnakeMarketsCreatePriceCube = useAdminSnakeMarketsCreatePriceCubeHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsCreatePriceCubeHook>>>,
    { data: CreateSnakePriceCubeDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminSnakeMarketsCreatePriceCube(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSnakeMarketsCreatePriceCubeMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsCreatePriceCubeHook>>>
>;
export type AdminSnakeMarketsCreatePriceCubeMutationBody = CreateSnakePriceCubeDto;
export type AdminSnakeMarketsCreatePriceCubeMutationError = unknown;

/**
 * @summary Create a snake price-cube rule
 */
export const useAdminSnakeMarketsCreatePriceCube = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsCreatePriceCubeHook>>>,
      TError,
      { data: CreateSnakePriceCubeDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsCreatePriceCubeHook>>>,
  TError,
  { data: CreateSnakePriceCubeDto },
  TContext
> => {
  const mutationOptions = useAdminSnakeMarketsCreatePriceCubeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Update a snake price-cube rule
 */
export const useAdminSnakeMarketsUpdatePriceCubeHook = () => {
  const adminSnakeMarketsUpdatePriceCube = useCustomInstance<SnakePriceCubeResponseDto>();

  return useCallback(
    (id: string, updateSnakePriceCubeDto: UpdateSnakePriceCubeDto) => {
      return adminSnakeMarketsUpdatePriceCube({
        url: `/admin/snake-markets/price-cubes/${id}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateSnakePriceCubeDto,
      });
    },
    [adminSnakeMarketsUpdatePriceCube],
  );
};

export const useAdminSnakeMarketsUpdatePriceCubeMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsUpdatePriceCubeHook>>>,
    TError,
    { id: string; data: UpdateSnakePriceCubeDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsUpdatePriceCubeHook>>>,
  TError,
  { id: string; data: UpdateSnakePriceCubeDto },
  TContext
> => {
  const mutationKey = ['adminSnakeMarketsUpdatePriceCube'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminSnakeMarketsUpdatePriceCube = useAdminSnakeMarketsUpdatePriceCubeHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsUpdatePriceCubeHook>>>,
    { id: string; data: UpdateSnakePriceCubeDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminSnakeMarketsUpdatePriceCube(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSnakeMarketsUpdatePriceCubeMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsUpdatePriceCubeHook>>>
>;
export type AdminSnakeMarketsUpdatePriceCubeMutationBody = UpdateSnakePriceCubeDto;
export type AdminSnakeMarketsUpdatePriceCubeMutationError = unknown;

/**
 * @summary Update a snake price-cube rule
 */
export const useAdminSnakeMarketsUpdatePriceCube = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsUpdatePriceCubeHook>>>,
      TError,
      { id: string; data: UpdateSnakePriceCubeDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsUpdatePriceCubeHook>>>,
  TError,
  { id: string; data: UpdateSnakePriceCubeDto },
  TContext
> => {
  const mutationOptions = useAdminSnakeMarketsUpdatePriceCubeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Delete a snake price-cube rule
 */
export const useAdminSnakeMarketsDeletePriceCubeHook = () => {
  const adminSnakeMarketsDeletePriceCube = useCustomInstance<SnakePriceCubeDeleteResponseDto>();

  return useCallback(
    (id: string) => {
      return adminSnakeMarketsDeletePriceCube({ url: `/admin/snake-markets/price-cubes/${id}`, method: 'DELETE' });
    },
    [adminSnakeMarketsDeletePriceCube],
  );
};

export const useAdminSnakeMarketsDeletePriceCubeMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsDeletePriceCubeHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsDeletePriceCubeHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminSnakeMarketsDeletePriceCube'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminSnakeMarketsDeletePriceCube = useAdminSnakeMarketsDeletePriceCubeHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsDeletePriceCubeHook>>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminSnakeMarketsDeletePriceCube(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminSnakeMarketsDeletePriceCubeMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsDeletePriceCubeHook>>>
>;

export type AdminSnakeMarketsDeletePriceCubeMutationError = unknown;

/**
 * @summary Delete a snake price-cube rule
 */
export const useAdminSnakeMarketsDeletePriceCube = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsDeletePriceCubeHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminSnakeMarketsDeletePriceCubeHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useAdminSnakeMarketsDeletePriceCubeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List the unified ledger (USD wallet + cash-back) with filters. Use userId to scope to a single user; transactionType to scope to deposits / withdrawals / settlements / CASHBACK_MINT etc.; ledger=WALLET|CASHBACK to scope to one ledger. Cash-back rows carry currency=CASHBACK and link to the offer that produced them.
 */
export const useAdminTransactionsListHook = () => {
  const adminTransactionsList = useCustomInstance<AdminTransactionListResponseDto>();

  return useCallback(
    (params?: AdminTransactionsListParams, signal?: AbortSignal) => {
      return adminTransactionsList({ url: `/admin/transactions`, method: 'GET', params, signal });
    },
    [adminTransactionsList],
  );
};

export const getAdminTransactionsListQueryKey = (params?: AdminTransactionsListParams) => {
  return [`/admin/transactions`, ...(params ? [params] : [])] as const;
};

export const useAdminTransactionsListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTransactionsListHook>>>,
  TError = unknown,
>(
  params?: AdminTransactionsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsListHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminTransactionsListQueryKey(params);

  const adminTransactionsList = useAdminTransactionsListHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsListHook>>>> = ({ signal }) =>
    adminTransactionsList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminTransactionsListHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminTransactionsListQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminTransactionsListHook>>>
>;
export type AdminTransactionsListQueryError = unknown;

export function useAdminTransactionsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTransactionsListHook>>>,
  TError = unknown,
>(
  params: undefined | AdminTransactionsListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsListHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminTransactionsListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminTransactionsListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminTransactionsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTransactionsListHook>>>,
  TError = unknown,
>(
  params?: AdminTransactionsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsListHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminTransactionsListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminTransactionsListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminTransactionsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTransactionsListHook>>>,
  TError = unknown,
>(
  params?: AdminTransactionsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List the unified ledger (USD wallet + cash-back) with filters. Use userId to scope to a single user; transactionType to scope to deposits / withdrawals / settlements / CASHBACK_MINT etc.; ledger=WALLET|CASHBACK to scope to one ledger. Cash-back rows carry currency=CASHBACK and link to the offer that produced them.
 */

export function useAdminTransactionsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTransactionsListHook>>>,
  TError = unknown,
>(
  params?: AdminTransactionsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminTransactionsListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary A user's current cash-back balance (spendable + lifetime minted/burned, in cents) — the stat shown beside the wallet balance.
 */
export const useAdminTransactionsCashBackBalanceHook = () => {
  const adminTransactionsCashBackBalance = useCustomInstance<CashBackBalanceDto>();

  return useCallback(
    (params: AdminTransactionsCashBackBalanceParams, signal?: AbortSignal) => {
      return adminTransactionsCashBackBalance({
        url: `/admin/transactions/cashback-balance`,
        method: 'GET',
        params,
        signal,
      });
    },
    [adminTransactionsCashBackBalance],
  );
};

export const getAdminTransactionsCashBackBalanceQueryKey = (params: AdminTransactionsCashBackBalanceParams) => {
  return [`/admin/transactions/cashback-balance`, ...(params ? [params] : [])] as const;
};

export const useAdminTransactionsCashBackBalanceQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBalanceHook>>>,
  TError = unknown,
>(
  params: AdminTransactionsCashBackBalanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBalanceHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminTransactionsCashBackBalanceQueryKey(params);

  const adminTransactionsCashBackBalance = useAdminTransactionsCashBackBalanceHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBalanceHook>>>> = ({
    signal,
  }) => adminTransactionsCashBackBalance(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBalanceHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminTransactionsCashBackBalanceQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBalanceHook>>>
>;
export type AdminTransactionsCashBackBalanceQueryError = unknown;

export function useAdminTransactionsCashBackBalance<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBalanceHook>>>,
  TError = unknown,
>(
  params: AdminTransactionsCashBackBalanceParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBalanceHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBalanceHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBalanceHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminTransactionsCashBackBalance<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBalanceHook>>>,
  TError = unknown,
>(
  params: AdminTransactionsCashBackBalanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBalanceHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBalanceHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBalanceHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminTransactionsCashBackBalance<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBalanceHook>>>,
  TError = unknown,
>(
  params: AdminTransactionsCashBackBalanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBalanceHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A user's current cash-back balance (spendable + lifetime minted/burned, in cents) — the stat shown beside the wallet balance.
 */

export function useAdminTransactionsCashBackBalance<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBalanceHook>>>,
  TError = unknown,
>(
  params: AdminTransactionsCashBackBalanceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBalanceHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminTransactionsCashBackBalanceQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary A user's active cash-back broken down by scope limit (category / sub-category / event / all) — the composition behind the balance, shown under the cash-back balance. Lots sharing a scope are merged into one group: remaining summed, distinct sources collected, soonest expiry and lot count surfaced.
 */
export const useAdminTransactionsCashBackBreakdownHook = () => {
  const adminTransactionsCashBackBreakdown = useCustomInstance<AdminCashBackGroupDto[]>();

  return useCallback(
    (params: AdminTransactionsCashBackBreakdownParams, signal?: AbortSignal) => {
      return adminTransactionsCashBackBreakdown({ url: `/admin/transactions/cashback-lots`, method: 'GET', params, signal });
    },
    [adminTransactionsCashBackBreakdown],
  );
};

export const getAdminTransactionsCashBackBreakdownQueryKey = (params: AdminTransactionsCashBackBreakdownParams) => {
  return [`/admin/transactions/cashback-lots`, ...(params ? [params] : [])] as const;
};

export const useAdminTransactionsCashBackBreakdownQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBreakdownHook>>>,
  TError = unknown,
>(
  params: AdminTransactionsCashBackBreakdownParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBreakdownHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminTransactionsCashBackBreakdownQueryKey(params);

  const adminTransactionsCashBackBreakdown = useAdminTransactionsCashBackBreakdownHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBreakdownHook>>>> = ({
    signal,
  }) => adminTransactionsCashBackBreakdown(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBreakdownHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminTransactionsCashBackBreakdownQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBreakdownHook>>>
>;
export type AdminTransactionsCashBackBreakdownQueryError = unknown;

export function useAdminTransactionsCashBackBreakdown<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBreakdownHook>>>,
  TError = unknown,
>(
  params: AdminTransactionsCashBackBreakdownParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBreakdownHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBreakdownHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBreakdownHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminTransactionsCashBackBreakdown<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBreakdownHook>>>,
  TError = unknown,
>(
  params: AdminTransactionsCashBackBreakdownParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBreakdownHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBreakdownHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBreakdownHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminTransactionsCashBackBreakdown<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBreakdownHook>>>,
  TError = unknown,
>(
  params: AdminTransactionsCashBackBreakdownParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBreakdownHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A user's active cash-back broken down by scope limit (category / sub-category / event / all) — the composition behind the balance, shown under the cash-back balance. Lots sharing a scope are merged into one group: remaining summed, distinct sources collected, soonest expiry and lot count surfaced.
 */

export function useAdminTransactionsCashBackBreakdown<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBreakdownHook>>>,
  TError = unknown,
>(
  params: AdminTransactionsCashBackBreakdownParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsCashBackBreakdownHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminTransactionsCashBackBreakdownQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Time-windowed, downsampled balance-over-time series for a single user (closing available + locked balance per bucket) — the data behind the user wallet balance chart.
 */
export const useAdminTransactionsBalanceHistoryHook = () => {
  const adminTransactionsBalanceHistory = useCustomInstance<BalanceHistoryDto>();

  return useCallback(
    (params: AdminTransactionsBalanceHistoryParams, signal?: AbortSignal) => {
      return adminTransactionsBalanceHistory({ url: `/admin/transactions/balance-history`, method: 'GET', params, signal });
    },
    [adminTransactionsBalanceHistory],
  );
};

export const getAdminTransactionsBalanceHistoryQueryKey = (params: AdminTransactionsBalanceHistoryParams) => {
  return [`/admin/transactions/balance-history`, ...(params ? [params] : [])] as const;
};

export const useAdminTransactionsBalanceHistoryQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTransactionsBalanceHistoryHook>>>,
  TError = unknown,
>(
  params: AdminTransactionsBalanceHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsBalanceHistoryHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminTransactionsBalanceHistoryQueryKey(params);

  const adminTransactionsBalanceHistory = useAdminTransactionsBalanceHistoryHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsBalanceHistoryHook>>>> = ({
    signal,
  }) => adminTransactionsBalanceHistory(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminTransactionsBalanceHistoryHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminTransactionsBalanceHistoryQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminTransactionsBalanceHistoryHook>>>
>;
export type AdminTransactionsBalanceHistoryQueryError = unknown;

export function useAdminTransactionsBalanceHistory<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTransactionsBalanceHistoryHook>>>,
  TError = unknown,
>(
  params: AdminTransactionsBalanceHistoryParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsBalanceHistoryHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminTransactionsBalanceHistoryHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminTransactionsBalanceHistoryHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminTransactionsBalanceHistory<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTransactionsBalanceHistoryHook>>>,
  TError = unknown,
>(
  params: AdminTransactionsBalanceHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsBalanceHistoryHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminTransactionsBalanceHistoryHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminTransactionsBalanceHistoryHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminTransactionsBalanceHistory<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTransactionsBalanceHistoryHook>>>,
  TError = unknown,
>(
  params: AdminTransactionsBalanceHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsBalanceHistoryHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Time-windowed, downsampled balance-over-time series for a single user (closing available + locked balance per bucket) — the data behind the user wallet balance chart.
 */

export function useAdminTransactionsBalanceHistory<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTransactionsBalanceHistoryHook>>>,
  TError = unknown,
>(
  params: AdminTransactionsBalanceHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsBalanceHistoryHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminTransactionsBalanceHistoryQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary CSV export of the wallet ledger (USD wallet_transactions) for the current filters — the full filtered set, not a page. Bulk financial data, so the route is audited. Excludes QA mock users. Sets X-Export-Truncated: true when the row cap is hit (narrow the filters).
 */
export const useAdminTransactionsExportTransactionsHook = () => {
  const adminTransactionsExportTransactions = useCustomInstance<string>();

  return useCallback(
    (params?: AdminTransactionsExportTransactionsParams, signal?: AbortSignal) => {
      return adminTransactionsExportTransactions({ url: `/admin/transactions/export`, method: 'GET', params, signal });
    },
    [adminTransactionsExportTransactions],
  );
};

export const getAdminTransactionsExportTransactionsQueryKey = (params?: AdminTransactionsExportTransactionsParams) => {
  return [`/admin/transactions/export`, ...(params ? [params] : [])] as const;
};

export const useAdminTransactionsExportTransactionsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTransactionsExportTransactionsHook>>>,
  TError = unknown,
>(
  params?: AdminTransactionsExportTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsExportTransactionsHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminTransactionsExportTransactionsQueryKey(params);

  const adminTransactionsExportTransactions = useAdminTransactionsExportTransactionsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsExportTransactionsHook>>>> = ({
    signal,
  }) => adminTransactionsExportTransactions(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminTransactionsExportTransactionsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminTransactionsExportTransactionsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminTransactionsExportTransactionsHook>>>
>;
export type AdminTransactionsExportTransactionsQueryError = unknown;

export function useAdminTransactionsExportTransactions<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTransactionsExportTransactionsHook>>>,
  TError = unknown,
>(
  params: undefined | AdminTransactionsExportTransactionsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsExportTransactionsHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminTransactionsExportTransactionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminTransactionsExportTransactionsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminTransactionsExportTransactions<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTransactionsExportTransactionsHook>>>,
  TError = unknown,
>(
  params?: AdminTransactionsExportTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsExportTransactionsHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminTransactionsExportTransactionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminTransactionsExportTransactionsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminTransactionsExportTransactions<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTransactionsExportTransactionsHook>>>,
  TError = unknown,
>(
  params?: AdminTransactionsExportTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsExportTransactionsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary CSV export of the wallet ledger (USD wallet_transactions) for the current filters — the full filtered set, not a page. Bulk financial data, so the route is audited. Excludes QA mock users. Sets X-Export-Truncated: true when the row cap is hit (narrow the filters).
 */

export function useAdminTransactionsExportTransactions<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTransactionsExportTransactionsHook>>>,
  TError = unknown,
>(
  params?: AdminTransactionsExportTransactionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsExportTransactionsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminTransactionsExportTransactionsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get a single transaction by ledger row id. Includes the full responsePayload plus the linked Pay.com deposit intent (with inbound webhook events) or payout when resolvable from referenceId.
 */
export const useAdminTransactionsGetOneHook = () => {
  const adminTransactionsGetOne = useCustomInstance<AdminTransactionDetailDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminTransactionsGetOne({ url: `/admin/transactions/${id}`, method: 'GET', signal });
    },
    [adminTransactionsGetOne],
  );
};

export const getAdminTransactionsGetOneQueryKey = (id: string) => {
  return [`/admin/transactions/${id}`] as const;
};

export const useAdminTransactionsGetOneQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTransactionsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsGetOneHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminTransactionsGetOneQueryKey(id);

  const adminTransactionsGetOne = useAdminTransactionsGetOneHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsGetOneHook>>>> = ({ signal }) =>
    adminTransactionsGetOne(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminTransactionsGetOneHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminTransactionsGetOneQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminTransactionsGetOneHook>>>
>;
export type AdminTransactionsGetOneQueryError = unknown;

export function useAdminTransactionsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTransactionsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsGetOneHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminTransactionsGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminTransactionsGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminTransactionsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTransactionsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsGetOneHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminTransactionsGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminTransactionsGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminTransactionsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTransactionsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsGetOneHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a single transaction by ledger row id. Includes the full responsePayload plus the linked Pay.com deposit intent (with inbound webhook events) or payout when resolvable from referenceId.
 */

export function useAdminTransactionsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTransactionsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTransactionsGetOneHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminTransactionsGetOneQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List all kill switches with their current LaunchDarkly state.
 */
export const useAdminKillSwitchListHook = () => {
  const adminKillSwitchList = useCustomInstance<AdminKillSwitchDto[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminKillSwitchList({ url: `/admin/kill-switches`, method: 'GET', signal });
    },
    [adminKillSwitchList],
  );
};

export const getAdminKillSwitchListQueryKey = () => {
  return [`/admin/kill-switches`] as const;
};

export const useAdminKillSwitchListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKillSwitchListHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKillSwitchListHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminKillSwitchListQueryKey();

  const adminKillSwitchList = useAdminKillSwitchListHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminKillSwitchListHook>>>> = ({ signal }) =>
    adminKillSwitchList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminKillSwitchListHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminKillSwitchListQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminKillSwitchListHook>>>>;
export type AdminKillSwitchListQueryError = unknown;

export function useAdminKillSwitchList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKillSwitchListHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKillSwitchListHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminKillSwitchListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminKillSwitchListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminKillSwitchList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKillSwitchListHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKillSwitchListHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminKillSwitchListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminKillSwitchListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminKillSwitchList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKillSwitchListHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKillSwitchListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List all kill switches with their current LaunchDarkly state.
 */

export function useAdminKillSwitchList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKillSwitchListHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKillSwitchListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminKillSwitchListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Enable (live) or kill a capability by flipping the flag fallthrough.
 */
export const useAdminKillSwitchToggleHook = () => {
  const adminKillSwitchToggle = useCustomInstance<AdminKillSwitchDto>();

  return useCallback(
    (key: string, toggleKillSwitchDto: ToggleKillSwitchDto) => {
      return adminKillSwitchToggle({
        url: `/admin/kill-switches/${key}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: toggleKillSwitchDto,
      });
    },
    [adminKillSwitchToggle],
  );
};

export const useAdminKillSwitchToggleMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminKillSwitchToggleHook>>>,
    TError,
    { key: string; data: ToggleKillSwitchDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminKillSwitchToggleHook>>>,
  TError,
  { key: string; data: ToggleKillSwitchDto },
  TContext
> => {
  const mutationKey = ['adminKillSwitchToggle'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminKillSwitchToggle = useAdminKillSwitchToggleHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminKillSwitchToggleHook>>>,
    { key: string; data: ToggleKillSwitchDto }
  > = (props) => {
    const { key, data } = props ?? {};

    return adminKillSwitchToggle(key, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminKillSwitchToggleMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminKillSwitchToggleHook>>>
>;
export type AdminKillSwitchToggleMutationBody = ToggleKillSwitchDto;
export type AdminKillSwitchToggleMutationError = unknown;

/**
 * @summary Enable (live) or kill a capability by flipping the flag fallthrough.
 */
export const useAdminKillSwitchToggle = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminKillSwitchToggleHook>>>,
      TError,
      { key: string; data: ToggleKillSwitchDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminKillSwitchToggleHook>>>,
  TError,
  { key: string; data: ToggleKillSwitchDto },
  TContext
> => {
  const mutationOptions = useAdminKillSwitchToggleMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Add or remove individual user keys from the internal-tester bypass.
 */
export const useAdminKillSwitchSetTargetsHook = () => {
  const adminKillSwitchSetTargets = useCustomInstance<AdminKillSwitchDto>();

  return useCallback(
    (key: string, killSwitchTargetsDto: KillSwitchTargetsDto) => {
      return adminKillSwitchSetTargets({
        url: `/admin/kill-switches/${key}/targets`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: killSwitchTargetsDto,
      });
    },
    [adminKillSwitchSetTargets],
  );
};

export const useAdminKillSwitchSetTargetsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminKillSwitchSetTargetsHook>>>,
    TError,
    { key: string; data: KillSwitchTargetsDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminKillSwitchSetTargetsHook>>>,
  TError,
  { key: string; data: KillSwitchTargetsDto },
  TContext
> => {
  const mutationKey = ['adminKillSwitchSetTargets'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminKillSwitchSetTargets = useAdminKillSwitchSetTargetsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminKillSwitchSetTargetsHook>>>,
    { key: string; data: KillSwitchTargetsDto }
  > = (props) => {
    const { key, data } = props ?? {};

    return adminKillSwitchSetTargets(key, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminKillSwitchSetTargetsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminKillSwitchSetTargetsHook>>>
>;
export type AdminKillSwitchSetTargetsMutationBody = KillSwitchTargetsDto;
export type AdminKillSwitchSetTargetsMutationError = unknown;

/**
 * @summary Add or remove individual user keys from the internal-tester bypass.
 */
export const useAdminKillSwitchSetTargets = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminKillSwitchSetTargetsHook>>>,
      TError,
      { key: string; data: KillSwitchTargetsDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminKillSwitchSetTargetsHook>>>,
  TError,
  { key: string; data: KillSwitchTargetsDto },
  TContext
> => {
  const mutationOptions = useAdminKillSwitchSetTargetsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List deposit intents with pagination and filters. Unlike /admin/transactions (which only shows succeeded deposits, since the wallet is credited on SUCCEEDED), this surfaces the full funnel: AWAITING_PAYMENT / REQUIRES_ACTION / PROCESSING / SUCCEEDED / FAILED / CANCELLED. Filter by status or userId.
 */
export const useAdminDepositsGetListHook = () => {
  const adminDepositsGetList = useCustomInstance<AdminDepositListResponseDto>();

  return useCallback(
    (params?: AdminDepositsGetListParams, signal?: AbortSignal) => {
      return adminDepositsGetList({ url: `/admin/deposits`, method: 'GET', params, signal });
    },
    [adminDepositsGetList],
  );
};

export const getAdminDepositsGetListQueryKey = (params?: AdminDepositsGetListParams) => {
  return [`/admin/deposits`, ...(params ? [params] : [])] as const;
};

export const useAdminDepositsGetListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetListHook>>>,
  TError = unknown,
>(
  params?: AdminDepositsGetListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetListHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminDepositsGetListQueryKey(params);

  const adminDepositsGetList = useAdminDepositsGetListHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetListHook>>>> = ({ signal }) =>
    adminDepositsGetList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetListHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminDepositsGetListQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetListHook>>>
>;
export type AdminDepositsGetListQueryError = unknown;

export function useAdminDepositsGetList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetListHook>>>,
  TError = unknown,
>(
  params: undefined | AdminDepositsGetListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetListHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminDepositsGetList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetListHook>>>,
  TError = unknown,
>(
  params?: AdminDepositsGetListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetListHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminDepositsGetList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetListHook>>>,
  TError = unknown,
>(
  params?: AdminDepositsGetListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List deposit intents with pagination and filters. Unlike /admin/transactions (which only shows succeeded deposits, since the wallet is credited on SUCCEEDED), this surfaces the full funnel: AWAITING_PAYMENT / REQUIRES_ACTION / PROCESSING / SUCCEEDED / FAILED / CANCELLED. Filter by status or userId.
 */

export function useAdminDepositsGetList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetListHook>>>,
  TError = unknown,
>(
  params?: AdminDepositsGetListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminDepositsGetListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get a single deposit intent by id, including its inbound Pay.com webhook events (full round-trip).
 */
export const useAdminDepositsGetOneHook = () => {
  const adminDepositsGetOne = useCustomInstance<AdminDepositResponseDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminDepositsGetOne({ url: `/admin/deposits/${id}`, method: 'GET', signal });
    },
    [adminDepositsGetOne],
  );
};

export const getAdminDepositsGetOneQueryKey = (id: string) => {
  return [`/admin/deposits/${id}`] as const;
};

export const useAdminDepositsGetOneQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetOneHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminDepositsGetOneQueryKey(id);

  const adminDepositsGetOne = useAdminDepositsGetOneHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetOneHook>>>> = ({ signal }) =>
    adminDepositsGetOne(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetOneHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminDepositsGetOneQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetOneHook>>>>;
export type AdminDepositsGetOneQueryError = unknown;

export function useAdminDepositsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetOneHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminDepositsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetOneHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminDepositsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetOneHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a single deposit intent by id, including its inbound Pay.com webhook events (full round-trip).
 */

export function useAdminDepositsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDepositsGetOneHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminDepositsGetOneQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List/search events — free-text over name/slug, volume-ordered (the Live-page pin picker)
 */
export const useAdminEventsListEventsHook = () => {
  const adminEventsListEvents = useCustomInstance<AdminEventListResponseDto>();

  return useCallback(
    (params?: AdminEventsListEventsParams, signal?: AbortSignal) => {
      return adminEventsListEvents({ url: `/admin/events`, method: 'GET', params, signal });
    },
    [adminEventsListEvents],
  );
};

export const getAdminEventsListEventsQueryKey = (params?: AdminEventsListEventsParams) => {
  return [`/admin/events`, ...(params ? [params] : [])] as const;
};

export const useAdminEventsListEventsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminEventsListEventsHook>>>,
  TError = unknown,
>(
  params?: AdminEventsListEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminEventsListEventsHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminEventsListEventsQueryKey(params);

  const adminEventsListEvents = useAdminEventsListEventsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminEventsListEventsHook>>>> = ({ signal }) =>
    adminEventsListEvents(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminEventsListEventsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminEventsListEventsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminEventsListEventsHook>>>
>;
export type AdminEventsListEventsQueryError = unknown;

export function useAdminEventsListEvents<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminEventsListEventsHook>>>,
  TError = unknown,
>(
  params: undefined | AdminEventsListEventsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminEventsListEventsHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminEventsListEventsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminEventsListEventsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminEventsListEvents<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminEventsListEventsHook>>>,
  TError = unknown,
>(
  params?: AdminEventsListEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminEventsListEventsHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminEventsListEventsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminEventsListEventsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminEventsListEvents<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminEventsListEventsHook>>>,
  TError = unknown,
>(
  params?: AdminEventsListEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminEventsListEventsHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List/search events — free-text over name/slug, volume-ordered (the Live-page pin picker)
 */

export function useAdminEventsListEvents<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminEventsListEventsHook>>>,
  TError = unknown,
>(
  params?: AdminEventsListEventsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminEventsListEventsHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminEventsListEventsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Queue a Plaee reconciliation sync. Pulls /brand-events and updates existing local markets/outcomes — new rows are left to the webhook pipeline. Categories are refreshed at the start. The settlement sweep runs at the tail.
 */
export const useAdminEventsSyncEventsHook = () => {
  const adminEventsSyncEvents = useCustomInstance<SyncEventsResponseDto>();

  return useCallback(
    (syncEventsDto: SyncEventsDto, signal?: AbortSignal) => {
      return adminEventsSyncEvents({
        url: `/admin/sync-events`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: syncEventsDto,
        signal,
      });
    },
    [adminEventsSyncEvents],
  );
};

export const useAdminEventsSyncEventsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminEventsSyncEventsHook>>>,
    TError,
    { data: SyncEventsDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminEventsSyncEventsHook>>>,
  TError,
  { data: SyncEventsDto },
  TContext
> => {
  const mutationKey = ['adminEventsSyncEvents'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminEventsSyncEvents = useAdminEventsSyncEventsHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminEventsSyncEventsHook>>>,
    { data: SyncEventsDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminEventsSyncEvents(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminEventsSyncEventsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminEventsSyncEventsHook>>>
>;
export type AdminEventsSyncEventsMutationBody = SyncEventsDto;
export type AdminEventsSyncEventsMutationError = unknown;

/**
 * @summary Queue a Plaee reconciliation sync. Pulls /brand-events and updates existing local markets/outcomes — new rows are left to the webhook pipeline. Categories are refreshed at the start. The settlement sweep runs at the tail.
 */
export const useAdminEventsSyncEvents = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminEventsSyncEventsHook>>>,
      TError,
      { data: SyncEventsDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminEventsSyncEventsHook>>>,
  TError,
  { data: SyncEventsDto },
  TContext
> => {
  const mutationOptions = useAdminEventsSyncEventsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get the current admin principal (role + permissions)
 */
export const useAdminMeMeHook = () => {
  const adminMeMe = useCustomInstance<AdminMeResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminMeMe({ url: `/admin/me`, method: 'GET', signal });
    },
    [adminMeMe],
  );
};

export const getAdminMeMeQueryKey = () => {
  return [`/admin/me`] as const;
};

export const useAdminMeMeQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMeMeHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMeMeHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminMeMeQueryKey();

  const adminMeMe = useAdminMeMeHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminMeMeHook>>>> = ({ signal }) => adminMeMe(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminMeMeHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminMeMeQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminMeMeHook>>>>;
export type AdminMeMeQueryError = unknown;

export function useAdminMeMe<TData = Awaited<ReturnType<ReturnType<typeof useAdminMeMeHook>>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMeMeHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminMeMeHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminMeMeHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminMeMe<TData = Awaited<ReturnType<ReturnType<typeof useAdminMeMeHook>>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMeMeHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminMeMeHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminMeMeHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminMeMe<TData = Awaited<ReturnType<ReturnType<typeof useAdminMeMeHook>>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMeMeHook>>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the current admin principal (role + permissions)
 */

export function useAdminMeMe<TData = Awaited<ReturnType<ReturnType<typeof useAdminMeMeHook>>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMeMeHook>>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminMeMeQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List all admins (active + disabled)
 */
export const useAdminAdminsListHook = () => {
  const adminAdminsList = useCustomInstance<AdminListResponseDto>();

  return useCallback(
    (params?: AdminAdminsListParams, signal?: AbortSignal) => {
      return adminAdminsList({ url: `/admin/admins`, method: 'GET', params, signal });
    },
    [adminAdminsList],
  );
};

export const getAdminAdminsListQueryKey = (params?: AdminAdminsListParams) => {
  return [`/admin/admins`, ...(params ? [params] : [])] as const;
};

export const useAdminAdminsListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminAdminsListHook>>>,
  TError = unknown,
>(
  params?: AdminAdminsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminAdminsListHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminAdminsListQueryKey(params);

  const adminAdminsList = useAdminAdminsListHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminAdminsListHook>>>> = ({ signal }) =>
    adminAdminsList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminAdminsListHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminAdminsListQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminAdminsListHook>>>>;
export type AdminAdminsListQueryError = unknown;

export function useAdminAdminsList<TData = Awaited<ReturnType<ReturnType<typeof useAdminAdminsListHook>>>, TError = unknown>(
  params: undefined | AdminAdminsListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminAdminsListHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminAdminsListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminAdminsListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminAdminsList<TData = Awaited<ReturnType<ReturnType<typeof useAdminAdminsListHook>>>, TError = unknown>(
  params?: AdminAdminsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminAdminsListHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminAdminsListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminAdminsListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminAdminsList<TData = Awaited<ReturnType<ReturnType<typeof useAdminAdminsListHook>>>, TError = unknown>(
  params?: AdminAdminsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminAdminsListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List all admins (active + disabled)
 */

export function useAdminAdminsList<TData = Awaited<ReturnType<ReturnType<typeof useAdminAdminsListHook>>>, TError = unknown>(
  params?: AdminAdminsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminAdminsListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminAdminsListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a new admin (allowlist entry)
 */
export const useAdminAdminsCreateHook = () => {
  const adminAdminsCreate = useCustomInstance<AdminResponseDto>();

  return useCallback(
    (createAdminDto: CreateAdminDto, signal?: AbortSignal) => {
      return adminAdminsCreate({
        url: `/admin/admins`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createAdminDto,
        signal,
      });
    },
    [adminAdminsCreate],
  );
};

export const useAdminAdminsCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminAdminsCreateHook>>>,
    TError,
    { data: CreateAdminDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminAdminsCreateHook>>>,
  TError,
  { data: CreateAdminDto },
  TContext
> => {
  const mutationKey = ['adminAdminsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminAdminsCreate = useAdminAdminsCreateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminAdminsCreateHook>>>,
    { data: CreateAdminDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminAdminsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminAdminsCreateMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminAdminsCreateHook>>>>;
export type AdminAdminsCreateMutationBody = CreateAdminDto;
export type AdminAdminsCreateMutationError = unknown;

/**
 * @summary Create a new admin (allowlist entry)
 */
export const useAdminAdminsCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminAdminsCreateHook>>>,
      TError,
      { data: CreateAdminDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminAdminsCreateHook>>>,
  TError,
  { data: CreateAdminDto },
  TContext
> => {
  const mutationOptions = useAdminAdminsCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get one admin by id
 */
export const useAdminAdminsGetOneHook = () => {
  const adminAdminsGetOne = useCustomInstance<AdminResponseDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminAdminsGetOne({ url: `/admin/admins/${id}`, method: 'GET', signal });
    },
    [adminAdminsGetOne],
  );
};

export const getAdminAdminsGetOneQueryKey = (id: string) => {
  return [`/admin/admins/${id}`] as const;
};

export const useAdminAdminsGetOneQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminAdminsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminAdminsGetOneHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminAdminsGetOneQueryKey(id);

  const adminAdminsGetOne = useAdminAdminsGetOneHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminAdminsGetOneHook>>>> = ({ signal }) =>
    adminAdminsGetOne(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminAdminsGetOneHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminAdminsGetOneQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminAdminsGetOneHook>>>>;
export type AdminAdminsGetOneQueryError = unknown;

export function useAdminAdminsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminAdminsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminAdminsGetOneHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminAdminsGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminAdminsGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminAdminsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminAdminsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminAdminsGetOneHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminAdminsGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminAdminsGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminAdminsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminAdminsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminAdminsGetOneHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get one admin by id
 */

export function useAdminAdminsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminAdminsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminAdminsGetOneHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminAdminsGetOneQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Change an admin role
 */
export const useAdminAdminsUpdateRoleHook = () => {
  const adminAdminsUpdateRole = useCustomInstance<AdminResponseDto>();

  return useCallback(
    (id: string, updateAdminRoleDto: UpdateAdminRoleDto) => {
      return adminAdminsUpdateRole({
        url: `/admin/admins/${id}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateAdminRoleDto,
      });
    },
    [adminAdminsUpdateRole],
  );
};

export const useAdminAdminsUpdateRoleMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminAdminsUpdateRoleHook>>>,
    TError,
    { id: string; data: UpdateAdminRoleDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminAdminsUpdateRoleHook>>>,
  TError,
  { id: string; data: UpdateAdminRoleDto },
  TContext
> => {
  const mutationKey = ['adminAdminsUpdateRole'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminAdminsUpdateRole = useAdminAdminsUpdateRoleHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminAdminsUpdateRoleHook>>>,
    { id: string; data: UpdateAdminRoleDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminAdminsUpdateRole(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminAdminsUpdateRoleMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminAdminsUpdateRoleHook>>>
>;
export type AdminAdminsUpdateRoleMutationBody = UpdateAdminRoleDto;
export type AdminAdminsUpdateRoleMutationError = unknown;

/**
 * @summary Change an admin role
 */
export const useAdminAdminsUpdateRole = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminAdminsUpdateRoleHook>>>,
      TError,
      { id: string; data: UpdateAdminRoleDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminAdminsUpdateRoleHook>>>,
  TError,
  { id: string; data: UpdateAdminRoleDto },
  TContext
> => {
  const mutationOptions = useAdminAdminsUpdateRoleMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Soft-disable an admin
 */
export const useAdminAdminsDisableHook = () => {
  const adminAdminsDisable = useCustomInstance<AdminResponseDto>();

  return useCallback(
    (id: string) => {
      return adminAdminsDisable({ url: `/admin/admins/${id}`, method: 'DELETE' });
    },
    [adminAdminsDisable],
  );
};

export const useAdminAdminsDisableMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminAdminsDisableHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminAdminsDisableHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminAdminsDisable'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminAdminsDisable = useAdminAdminsDisableHook();

  const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useAdminAdminsDisableHook>>>, { id: string }> = (
    props,
  ) => {
    const { id } = props ?? {};

    return adminAdminsDisable(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminAdminsDisableMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminAdminsDisableHook>>>
>;

export type AdminAdminsDisableMutationError = unknown;

/**
 * @summary Soft-disable an admin
 */
export const useAdminAdminsDisable = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminAdminsDisableHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminAdminsDisableHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useAdminAdminsDisableMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List all roles with their permissions
 */
export const useAdminRolesListHook = () => {
  const adminRolesList = useCustomInstance<RoleListResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminRolesList({ url: `/admin/roles`, method: 'GET', signal });
    },
    [adminRolesList],
  );
};

export const getAdminRolesListQueryKey = () => {
  return [`/admin/roles`] as const;
};

export const useAdminRolesListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminRolesListHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminRolesListHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminRolesListQueryKey();

  const adminRolesList = useAdminRolesListHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminRolesListHook>>>> = ({ signal }) =>
    adminRolesList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminRolesListHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminRolesListQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminRolesListHook>>>>;
export type AdminRolesListQueryError = unknown;

export function useAdminRolesList<TData = Awaited<ReturnType<ReturnType<typeof useAdminRolesListHook>>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminRolesListHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminRolesListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminRolesListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminRolesList<TData = Awaited<ReturnType<ReturnType<typeof useAdminRolesListHook>>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminRolesListHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminRolesListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminRolesListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminRolesList<TData = Awaited<ReturnType<ReturnType<typeof useAdminRolesListHook>>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminRolesListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List all roles with their permissions
 */

export function useAdminRolesList<TData = Awaited<ReturnType<ReturnType<typeof useAdminRolesListHook>>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminRolesListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminRolesListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a new role with the given permission set
 */
export const useAdminRolesCreateHook = () => {
  const adminRolesCreate = useCustomInstance<RoleWithPermissionsResponseDto>();

  return useCallback(
    (createRoleDto: CreateRoleDto, signal?: AbortSignal) => {
      return adminRolesCreate({
        url: `/admin/roles`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createRoleDto,
        signal,
      });
    },
    [adminRolesCreate],
  );
};

export const useAdminRolesCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminRolesCreateHook>>>,
    TError,
    { data: CreateRoleDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminRolesCreateHook>>>,
  TError,
  { data: CreateRoleDto },
  TContext
> => {
  const mutationKey = ['adminRolesCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminRolesCreate = useAdminRolesCreateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminRolesCreateHook>>>,
    { data: CreateRoleDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminRolesCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminRolesCreateMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminRolesCreateHook>>>>;
export type AdminRolesCreateMutationBody = CreateRoleDto;
export type AdminRolesCreateMutationError = unknown;

/**
 * @summary Create a new role with the given permission set
 */
export const useAdminRolesCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminRolesCreateHook>>>,
      TError,
      { data: CreateRoleDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminRolesCreateHook>>>,
  TError,
  { data: CreateRoleDto },
  TContext
> => {
  const mutationOptions = useAdminRolesCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get one role by id with permissions
 */
export const useAdminRolesGetOneHook = () => {
  const adminRolesGetOne = useCustomInstance<RoleResponseDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminRolesGetOne({ url: `/admin/roles/${id}`, method: 'GET', signal });
    },
    [adminRolesGetOne],
  );
};

export const getAdminRolesGetOneQueryKey = (id: string) => {
  return [`/admin/roles/${id}`] as const;
};

export const useAdminRolesGetOneQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminRolesGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminRolesGetOneHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminRolesGetOneQueryKey(id);

  const adminRolesGetOne = useAdminRolesGetOneHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminRolesGetOneHook>>>> = ({ signal }) =>
    adminRolesGetOne(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminRolesGetOneHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminRolesGetOneQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminRolesGetOneHook>>>>;
export type AdminRolesGetOneQueryError = unknown;

export function useAdminRolesGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminRolesGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminRolesGetOneHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminRolesGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminRolesGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminRolesGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminRolesGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminRolesGetOneHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminRolesGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminRolesGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminRolesGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminRolesGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminRolesGetOneHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get one role by id with permissions
 */

export function useAdminRolesGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminRolesGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminRolesGetOneHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminRolesGetOneQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update label and/or replace the full permission set
 */
export const useAdminRolesUpdateHook = () => {
  const adminRolesUpdate = useCustomInstance<RoleWithPermissionsResponseDto>();

  return useCallback(
    (id: string, updateRoleDto: UpdateRoleDto) => {
      return adminRolesUpdate({
        url: `/admin/roles/${id}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateRoleDto,
      });
    },
    [adminRolesUpdate],
  );
};

export const useAdminRolesUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminRolesUpdateHook>>>,
    TError,
    { id: string; data: UpdateRoleDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminRolesUpdateHook>>>,
  TError,
  { id: string; data: UpdateRoleDto },
  TContext
> => {
  const mutationKey = ['adminRolesUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminRolesUpdate = useAdminRolesUpdateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminRolesUpdateHook>>>,
    { id: string; data: UpdateRoleDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminRolesUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminRolesUpdateMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminRolesUpdateHook>>>>;
export type AdminRolesUpdateMutationBody = UpdateRoleDto;
export type AdminRolesUpdateMutationError = unknown;

/**
 * @summary Update label and/or replace the full permission set
 */
export const useAdminRolesUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminRolesUpdateHook>>>,
      TError,
      { id: string; data: UpdateRoleDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminRolesUpdateHook>>>,
  TError,
  { id: string; data: UpdateRoleDto },
  TContext
> => {
  const mutationOptions = useAdminRolesUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Delete a non-system role (only if no admin is assigned)
 */
export const useAdminRolesDeleteHook = () => {
  const adminRolesDelete = useCustomInstance<void>();

  return useCallback(
    (id: string) => {
      return adminRolesDelete({ url: `/admin/roles/${id}`, method: 'DELETE' });
    },
    [adminRolesDelete],
  );
};

export const useAdminRolesDeleteMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminRolesDeleteHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminRolesDeleteHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminRolesDelete'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminRolesDelete = useAdminRolesDeleteHook();

  const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useAdminRolesDeleteHook>>>, { id: string }> = (
    props,
  ) => {
    const { id } = props ?? {};

    return adminRolesDelete(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminRolesDeleteMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminRolesDeleteHook>>>>;

export type AdminRolesDeleteMutationError = unknown;

/**
 * @summary Delete a non-system role (only if no admin is assigned)
 */
export const useAdminRolesDelete = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminRolesDeleteHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useAdminRolesDeleteHook>>>, TError, { id: string }, TContext> => {
  const mutationOptions = useAdminRolesDeleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List all permission scopes
 */
export const useAdminPermissionsListHook = () => {
  const adminPermissionsList = useCustomInstance<PermissionListResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminPermissionsList({ url: `/admin/permissions`, method: 'GET', signal });
    },
    [adminPermissionsList],
  );
};

export const getAdminPermissionsListQueryKey = () => {
  return [`/admin/permissions`] as const;
};

export const useAdminPermissionsListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminPermissionsListHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminPermissionsListHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminPermissionsListQueryKey();

  const adminPermissionsList = useAdminPermissionsListHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminPermissionsListHook>>>> = ({ signal }) =>
    adminPermissionsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminPermissionsListHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPermissionsListQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminPermissionsListHook>>>
>;
export type AdminPermissionsListQueryError = unknown;

export function useAdminPermissionsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminPermissionsListHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminPermissionsListHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminPermissionsListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminPermissionsListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPermissionsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminPermissionsListHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminPermissionsListHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminPermissionsListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminPermissionsListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPermissionsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminPermissionsListHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminPermissionsListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List all permission scopes
 */

export function useAdminPermissionsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminPermissionsListHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminPermissionsListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminPermissionsListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a new permission scope
 */
export const useAdminPermissionsCreateHook = () => {
  const adminPermissionsCreate = useCustomInstance<PermissionResponseDto>();

  return useCallback(
    (createPermissionDto: CreatePermissionDto, signal?: AbortSignal) => {
      return adminPermissionsCreate({
        url: `/admin/permissions`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createPermissionDto,
        signal,
      });
    },
    [adminPermissionsCreate],
  );
};

export const useAdminPermissionsCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminPermissionsCreateHook>>>,
    TError,
    { data: CreatePermissionDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminPermissionsCreateHook>>>,
  TError,
  { data: CreatePermissionDto },
  TContext
> => {
  const mutationKey = ['adminPermissionsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminPermissionsCreate = useAdminPermissionsCreateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminPermissionsCreateHook>>>,
    { data: CreatePermissionDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminPermissionsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminPermissionsCreateMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminPermissionsCreateHook>>>
>;
export type AdminPermissionsCreateMutationBody = CreatePermissionDto;
export type AdminPermissionsCreateMutationError = unknown;

/**
 * @summary Create a new permission scope
 */
export const useAdminPermissionsCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminPermissionsCreateHook>>>,
      TError,
      { data: CreatePermissionDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminPermissionsCreateHook>>>,
  TError,
  { data: CreatePermissionDto },
  TContext
> => {
  const mutationOptions = useAdminPermissionsCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get one permission by id
 */
export const useAdminPermissionsGetOneHook = () => {
  const adminPermissionsGetOne = useCustomInstance<PermissionDetailResponseDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminPermissionsGetOne({ url: `/admin/permissions/${id}`, method: 'GET', signal });
    },
    [adminPermissionsGetOne],
  );
};

export const getAdminPermissionsGetOneQueryKey = (id: string) => {
  return [`/admin/permissions/${id}`] as const;
};

export const useAdminPermissionsGetOneQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminPermissionsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminPermissionsGetOneHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminPermissionsGetOneQueryKey(id);

  const adminPermissionsGetOne = useAdminPermissionsGetOneHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminPermissionsGetOneHook>>>> = ({ signal }) =>
    adminPermissionsGetOne(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminPermissionsGetOneHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminPermissionsGetOneQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminPermissionsGetOneHook>>>
>;
export type AdminPermissionsGetOneQueryError = unknown;

export function useAdminPermissionsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminPermissionsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminPermissionsGetOneHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminPermissionsGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminPermissionsGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPermissionsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminPermissionsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminPermissionsGetOneHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminPermissionsGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminPermissionsGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminPermissionsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminPermissionsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminPermissionsGetOneHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get one permission by id
 */

export function useAdminPermissionsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminPermissionsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminPermissionsGetOneHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminPermissionsGetOneQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update permission label
 */
export const useAdminPermissionsUpdateHook = () => {
  const adminPermissionsUpdate = useCustomInstance<PermissionResponseDto>();

  return useCallback(
    (id: string, updatePermissionDto: UpdatePermissionDto) => {
      return adminPermissionsUpdate({
        url: `/admin/permissions/${id}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updatePermissionDto,
      });
    },
    [adminPermissionsUpdate],
  );
};

export const useAdminPermissionsUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminPermissionsUpdateHook>>>,
    TError,
    { id: string; data: UpdatePermissionDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminPermissionsUpdateHook>>>,
  TError,
  { id: string; data: UpdatePermissionDto },
  TContext
> => {
  const mutationKey = ['adminPermissionsUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminPermissionsUpdate = useAdminPermissionsUpdateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminPermissionsUpdateHook>>>,
    { id: string; data: UpdatePermissionDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminPermissionsUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminPermissionsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminPermissionsUpdateHook>>>
>;
export type AdminPermissionsUpdateMutationBody = UpdatePermissionDto;
export type AdminPermissionsUpdateMutationError = unknown;

/**
 * @summary Update permission label
 */
export const useAdminPermissionsUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminPermissionsUpdateHook>>>,
      TError,
      { id: string; data: UpdatePermissionDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminPermissionsUpdateHook>>>,
  TError,
  { id: string; data: UpdatePermissionDto },
  TContext
> => {
  const mutationOptions = useAdminPermissionsUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Delete a permission (only if no role references it)
 */
export const useAdminPermissionsDeleteHook = () => {
  const adminPermissionsDelete = useCustomInstance<void>();

  return useCallback(
    (id: string) => {
      return adminPermissionsDelete({ url: `/admin/permissions/${id}`, method: 'DELETE' });
    },
    [adminPermissionsDelete],
  );
};

export const useAdminPermissionsDeleteMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminPermissionsDeleteHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminPermissionsDeleteHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminPermissionsDelete'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminPermissionsDelete = useAdminPermissionsDeleteHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminPermissionsDeleteHook>>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminPermissionsDelete(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminPermissionsDeleteMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminPermissionsDeleteHook>>>
>;

export type AdminPermissionsDeleteMutationError = unknown;

/**
 * @summary Delete a permission (only if no role references it)
 */
export const useAdminPermissionsDelete = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminPermissionsDeleteHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminPermissionsDeleteHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useAdminPermissionsDeleteMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List admin audit log entries with filters and pagination
 */
export const useAdminAuditLogListHook = () => {
  const adminAuditLogList = useCustomInstance<AdminAuditLogListResponseDto>();

  return useCallback(
    (params?: AdminAuditLogListParams, signal?: AbortSignal) => {
      return adminAuditLogList({ url: `/admin/audit-log`, method: 'GET', params, signal });
    },
    [adminAuditLogList],
  );
};

export const getAdminAuditLogListQueryKey = (params?: AdminAuditLogListParams) => {
  return [`/admin/audit-log`, ...(params ? [params] : [])] as const;
};

export const useAdminAuditLogListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminAuditLogListHook>>>,
  TError = unknown,
>(
  params?: AdminAuditLogListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminAuditLogListHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminAuditLogListQueryKey(params);

  const adminAuditLogList = useAdminAuditLogListHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminAuditLogListHook>>>> = ({ signal }) =>
    adminAuditLogList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminAuditLogListHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminAuditLogListQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminAuditLogListHook>>>>;
export type AdminAuditLogListQueryError = unknown;

export function useAdminAuditLogList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminAuditLogListHook>>>,
  TError = unknown,
>(
  params: undefined | AdminAuditLogListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminAuditLogListHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminAuditLogListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminAuditLogListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminAuditLogList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminAuditLogListHook>>>,
  TError = unknown,
>(
  params?: AdminAuditLogListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminAuditLogListHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminAuditLogListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminAuditLogListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminAuditLogList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminAuditLogListHook>>>,
  TError = unknown,
>(
  params?: AdminAuditLogListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminAuditLogListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List admin audit log entries with filters and pagination
 */

export function useAdminAuditLogList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminAuditLogListHook>>>,
  TError = unknown,
>(
  params?: AdminAuditLogListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminAuditLogListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminAuditLogListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get a single admin audit log entry by id
 */
export const useAdminAuditLogShowHook = () => {
  const adminAuditLogShow = useCustomInstance<AdminAuditLogEntryDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminAuditLogShow({ url: `/admin/audit-log/${id}`, method: 'GET', signal });
    },
    [adminAuditLogShow],
  );
};

export const getAdminAuditLogShowQueryKey = (id: string) => {
  return [`/admin/audit-log/${id}`] as const;
};

export const useAdminAuditLogShowQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminAuditLogShowHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminAuditLogShowHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminAuditLogShowQueryKey(id);

  const adminAuditLogShow = useAdminAuditLogShowHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminAuditLogShowHook>>>> = ({ signal }) =>
    adminAuditLogShow(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminAuditLogShowHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminAuditLogShowQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminAuditLogShowHook>>>>;
export type AdminAuditLogShowQueryError = unknown;

export function useAdminAuditLogShow<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminAuditLogShowHook>>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminAuditLogShowHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminAuditLogShowHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminAuditLogShowHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminAuditLogShow<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminAuditLogShowHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminAuditLogShowHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminAuditLogShowHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminAuditLogShowHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminAuditLogShow<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminAuditLogShowHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminAuditLogShowHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a single admin audit log entry by id
 */

export function useAdminAuditLogShow<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminAuditLogShowHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminAuditLogShowHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminAuditLogShowQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List all legal document definitions
 */
export const useAdminDocumentsListHook = () => {
  const adminDocumentsList = useCustomInstance<DocumentResponseDto[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminDocumentsList({ url: `/admin/documents`, method: 'GET', signal });
    },
    [adminDocumentsList],
  );
};

export const getAdminDocumentsListQueryKey = () => {
  return [`/admin/documents`] as const;
};

export const useAdminDocumentsListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminDocumentsListQueryKey();

  const adminDocumentsList = useAdminDocumentsListHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListHook>>>> = ({ signal }) =>
    adminDocumentsList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminDocumentsListQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListHook>>>>;
export type AdminDocumentsListQueryError = unknown;

export function useAdminDocumentsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminDocumentsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminDocumentsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List all legal document definitions
 */

export function useAdminDocumentsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminDocumentsListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a new document definition
 */
export const useAdminDocumentsCreateHook = () => {
  const adminDocumentsCreate = useCustomInstance<DocumentResponseDto>();

  return useCallback(
    (createDocumentDto: CreateDocumentDto, signal?: AbortSignal) => {
      return adminDocumentsCreate({
        url: `/admin/documents`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createDocumentDto,
        signal,
      });
    },
    [adminDocumentsCreate],
  );
};

export const useAdminDocumentsCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminDocumentsCreateHook>>>,
    TError,
    { data: CreateDocumentDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminDocumentsCreateHook>>>,
  TError,
  { data: CreateDocumentDto },
  TContext
> => {
  const mutationKey = ['adminDocumentsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminDocumentsCreate = useAdminDocumentsCreateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminDocumentsCreateHook>>>,
    { data: CreateDocumentDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminDocumentsCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDocumentsCreateMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminDocumentsCreateHook>>>
>;
export type AdminDocumentsCreateMutationBody = CreateDocumentDto;
export type AdminDocumentsCreateMutationError = unknown;

/**
 * @summary Create a new document definition
 */
export const useAdminDocumentsCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminDocumentsCreateHook>>>,
      TError,
      { data: CreateDocumentDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminDocumentsCreateHook>>>,
  TError,
  { data: CreateDocumentDto },
  TContext
> => {
  const mutationOptions = useAdminDocumentsCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get a document with its full version history
 */
export const useAdminDocumentsGetOneHook = () => {
  const adminDocumentsGetOne = useCustomInstance<DocumentResponseDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminDocumentsGetOne({ url: `/admin/documents/${id}`, method: 'GET', signal });
    },
    [adminDocumentsGetOne],
  );
};

export const getAdminDocumentsGetOneQueryKey = (id: string) => {
  return [`/admin/documents/${id}`] as const;
};

export const useAdminDocumentsGetOneQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDocumentsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDocumentsGetOneHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminDocumentsGetOneQueryKey(id);

  const adminDocumentsGetOne = useAdminDocumentsGetOneHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminDocumentsGetOneHook>>>> = ({ signal }) =>
    adminDocumentsGetOne(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminDocumentsGetOneHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminDocumentsGetOneQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminDocumentsGetOneHook>>>
>;
export type AdminDocumentsGetOneQueryError = unknown;

export function useAdminDocumentsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDocumentsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDocumentsGetOneHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminDocumentsGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminDocumentsGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminDocumentsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDocumentsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDocumentsGetOneHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminDocumentsGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminDocumentsGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminDocumentsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDocumentsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDocumentsGetOneHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a document with its full version history
 */

export function useAdminDocumentsGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDocumentsGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDocumentsGetOneHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminDocumentsGetOneQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update document metadata or archive/unarchive it
 */
export const useAdminDocumentsUpdateHook = () => {
  const adminDocumentsUpdate = useCustomInstance<DocumentResponseDto>();

  return useCallback(
    (id: string, updateDocumentDto: UpdateDocumentDto) => {
      return adminDocumentsUpdate({
        url: `/admin/documents/${id}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateDocumentDto,
      });
    },
    [adminDocumentsUpdate],
  );
};

export const useAdminDocumentsUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminDocumentsUpdateHook>>>,
    TError,
    { id: string; data: UpdateDocumentDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminDocumentsUpdateHook>>>,
  TError,
  { id: string; data: UpdateDocumentDto },
  TContext
> => {
  const mutationKey = ['adminDocumentsUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminDocumentsUpdate = useAdminDocumentsUpdateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminDocumentsUpdateHook>>>,
    { id: string; data: UpdateDocumentDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminDocumentsUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDocumentsUpdateMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminDocumentsUpdateHook>>>
>;
export type AdminDocumentsUpdateMutationBody = UpdateDocumentDto;
export type AdminDocumentsUpdateMutationError = unknown;

/**
 * @summary Update document metadata or archive/unarchive it
 */
export const useAdminDocumentsUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminDocumentsUpdateHook>>>,
      TError,
      { id: string; data: UpdateDocumentDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminDocumentsUpdateHook>>>,
  TError,
  { id: string; data: UpdateDocumentDto },
  TContext
> => {
  const mutationOptions = useAdminDocumentsUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List versions of a document
 */
export const useAdminDocumentsListVersionsHook = () => {
  const adminDocumentsListVersions = useCustomInstance<DocumentVersionResponseDto[]>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminDocumentsListVersions({ url: `/admin/documents/${id}/versions`, method: 'GET', signal });
    },
    [adminDocumentsListVersions],
  );
};

export const getAdminDocumentsListVersionsQueryKey = (id: string) => {
  return [`/admin/documents/${id}/versions`] as const;
};

export const useAdminDocumentsListVersionsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListVersionsHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListVersionsHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminDocumentsListVersionsQueryKey(id);

  const adminDocumentsListVersions = useAdminDocumentsListVersionsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListVersionsHook>>>> = ({ signal }) =>
    adminDocumentsListVersions(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListVersionsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminDocumentsListVersionsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListVersionsHook>>>
>;
export type AdminDocumentsListVersionsQueryError = unknown;

export function useAdminDocumentsListVersions<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListVersionsHook>>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListVersionsHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListVersionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListVersionsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminDocumentsListVersions<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListVersionsHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListVersionsHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListVersionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListVersionsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminDocumentsListVersions<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListVersionsHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListVersionsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List versions of a document
 */

export function useAdminDocumentsListVersions<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListVersionsHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDocumentsListVersionsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminDocumentsListVersionsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a new DRAFT version
 */
export const useAdminDocumentsCreateVersionHook = () => {
  const adminDocumentsCreateVersion = useCustomInstance<DocumentVersionResponseDto>();

  return useCallback(
    (id: string, createVersionDto: CreateVersionDto, signal?: AbortSignal) => {
      return adminDocumentsCreateVersion({
        url: `/admin/documents/${id}/versions`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createVersionDto,
        signal,
      });
    },
    [adminDocumentsCreateVersion],
  );
};

export const useAdminDocumentsCreateVersionMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminDocumentsCreateVersionHook>>>,
    TError,
    { id: string; data: CreateVersionDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminDocumentsCreateVersionHook>>>,
  TError,
  { id: string; data: CreateVersionDto },
  TContext
> => {
  const mutationKey = ['adminDocumentsCreateVersion'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminDocumentsCreateVersion = useAdminDocumentsCreateVersionHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminDocumentsCreateVersionHook>>>,
    { id: string; data: CreateVersionDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminDocumentsCreateVersion(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDocumentsCreateVersionMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminDocumentsCreateVersionHook>>>
>;
export type AdminDocumentsCreateVersionMutationBody = CreateVersionDto;
export type AdminDocumentsCreateVersionMutationError = unknown;

/**
 * @summary Create a new DRAFT version
 */
export const useAdminDocumentsCreateVersion = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminDocumentsCreateVersionHook>>>,
      TError,
      { id: string; data: CreateVersionDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminDocumentsCreateVersionHook>>>,
  TError,
  { id: string; data: CreateVersionDto },
  TContext
> => {
  const mutationOptions = useAdminDocumentsCreateVersionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Edit a DRAFT version (published versions are immutable)
 */
export const useAdminDocumentsUpdateVersionHook = () => {
  const adminDocumentsUpdateVersion = useCustomInstance<DocumentVersionResponseDto>();

  return useCallback(
    (id: string, versionId: string, updateVersionDto: UpdateVersionDto) => {
      return adminDocumentsUpdateVersion({
        url: `/admin/documents/${id}/versions/${versionId}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateVersionDto,
      });
    },
    [adminDocumentsUpdateVersion],
  );
};

export const useAdminDocumentsUpdateVersionMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminDocumentsUpdateVersionHook>>>,
    TError,
    { id: string; versionId: string; data: UpdateVersionDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminDocumentsUpdateVersionHook>>>,
  TError,
  { id: string; versionId: string; data: UpdateVersionDto },
  TContext
> => {
  const mutationKey = ['adminDocumentsUpdateVersion'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminDocumentsUpdateVersion = useAdminDocumentsUpdateVersionHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminDocumentsUpdateVersionHook>>>,
    { id: string; versionId: string; data: UpdateVersionDto }
  > = (props) => {
    const { id, versionId, data } = props ?? {};

    return adminDocumentsUpdateVersion(id, versionId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDocumentsUpdateVersionMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminDocumentsUpdateVersionHook>>>
>;
export type AdminDocumentsUpdateVersionMutationBody = UpdateVersionDto;
export type AdminDocumentsUpdateVersionMutationError = unknown;

/**
 * @summary Edit a DRAFT version (published versions are immutable)
 */
export const useAdminDocumentsUpdateVersion = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminDocumentsUpdateVersionHook>>>,
      TError,
      { id: string; versionId: string; data: UpdateVersionDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminDocumentsUpdateVersionHook>>>,
  TError,
  { id: string; versionId: string; data: UpdateVersionDto },
  TContext
> => {
  const mutationOptions = useAdminDocumentsUpdateVersionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Delete a DRAFT version
 */
export const useAdminDocumentsDeleteVersionHook = () => {
  const adminDocumentsDeleteVersion = useCustomInstance<void>();

  return useCallback(
    (id: string, versionId: string) => {
      return adminDocumentsDeleteVersion({ url: `/admin/documents/${id}/versions/${versionId}`, method: 'DELETE' });
    },
    [adminDocumentsDeleteVersion],
  );
};

export const useAdminDocumentsDeleteVersionMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminDocumentsDeleteVersionHook>>>,
    TError,
    { id: string; versionId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminDocumentsDeleteVersionHook>>>,
  TError,
  { id: string; versionId: string },
  TContext
> => {
  const mutationKey = ['adminDocumentsDeleteVersion'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminDocumentsDeleteVersion = useAdminDocumentsDeleteVersionHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminDocumentsDeleteVersionHook>>>,
    { id: string; versionId: string }
  > = (props) => {
    const { id, versionId } = props ?? {};

    return adminDocumentsDeleteVersion(id, versionId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDocumentsDeleteVersionMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminDocumentsDeleteVersionHook>>>
>;

export type AdminDocumentsDeleteVersionMutationError = unknown;

/**
 * @summary Delete a DRAFT version
 */
export const useAdminDocumentsDeleteVersion = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminDocumentsDeleteVersionHook>>>,
      TError,
      { id: string; versionId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminDocumentsDeleteVersionHook>>>,
  TError,
  { id: string; versionId: string },
  TContext
> => {
  const mutationOptions = useAdminDocumentsDeleteVersionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Publish (or schedule) a version with its enforcement + re-acceptance config
 */
export const useAdminDocumentsPublishHook = () => {
  const adminDocumentsPublish = useCustomInstance<DocumentVersionResponseDto>();

  return useCallback(
    (id: string, versionId: string, publishVersionDto: PublishVersionDto, signal?: AbortSignal) => {
      return adminDocumentsPublish({
        url: `/admin/documents/${id}/versions/${versionId}/publish`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: publishVersionDto,
        signal,
      });
    },
    [adminDocumentsPublish],
  );
};

export const useAdminDocumentsPublishMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminDocumentsPublishHook>>>,
    TError,
    { id: string; versionId: string; data: PublishVersionDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminDocumentsPublishHook>>>,
  TError,
  { id: string; versionId: string; data: PublishVersionDto },
  TContext
> => {
  const mutationKey = ['adminDocumentsPublish'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminDocumentsPublish = useAdminDocumentsPublishHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminDocumentsPublishHook>>>,
    { id: string; versionId: string; data: PublishVersionDto }
  > = (props) => {
    const { id, versionId, data } = props ?? {};

    return adminDocumentsPublish(id, versionId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminDocumentsPublishMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminDocumentsPublishHook>>>
>;
export type AdminDocumentsPublishMutationBody = PublishVersionDto;
export type AdminDocumentsPublishMutationError = unknown;

/**
 * @summary Publish (or schedule) a version with its enforcement + re-acceptance config
 */
export const useAdminDocumentsPublish = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminDocumentsPublishHook>>>,
      TError,
      { id: string; versionId: string; data: PublishVersionDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminDocumentsPublishHook>>>,
  TError,
  { id: string; versionId: string; data: PublishVersionDto },
  TContext
> => {
  const mutationOptions = useAdminDocumentsPublishMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Acceptance counts for a document
 */
export const useAdminDocumentsAcceptanceStatsHook = () => {
  const adminDocumentsAcceptanceStats = useCustomInstance<AcceptanceStatsResponseDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminDocumentsAcceptanceStats({ url: `/admin/documents/${id}/acceptance-stats`, method: 'GET', signal });
    },
    [adminDocumentsAcceptanceStats],
  );
};

export const getAdminDocumentsAcceptanceStatsQueryKey = (id: string) => {
  return [`/admin/documents/${id}/acceptance-stats`] as const;
};

export const useAdminDocumentsAcceptanceStatsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDocumentsAcceptanceStatsHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDocumentsAcceptanceStatsHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminDocumentsAcceptanceStatsQueryKey(id);

  const adminDocumentsAcceptanceStats = useAdminDocumentsAcceptanceStatsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminDocumentsAcceptanceStatsHook>>>> = ({
    signal,
  }) => adminDocumentsAcceptanceStats(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminDocumentsAcceptanceStatsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminDocumentsAcceptanceStatsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminDocumentsAcceptanceStatsHook>>>
>;
export type AdminDocumentsAcceptanceStatsQueryError = unknown;

export function useAdminDocumentsAcceptanceStats<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDocumentsAcceptanceStatsHook>>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDocumentsAcceptanceStatsHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminDocumentsAcceptanceStatsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminDocumentsAcceptanceStatsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminDocumentsAcceptanceStats<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDocumentsAcceptanceStatsHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDocumentsAcceptanceStatsHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminDocumentsAcceptanceStatsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminDocumentsAcceptanceStatsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminDocumentsAcceptanceStats<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDocumentsAcceptanceStatsHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDocumentsAcceptanceStatsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Acceptance counts for a document
 */

export function useAdminDocumentsAcceptanceStats<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDocumentsAcceptanceStatsHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDocumentsAcceptanceStatsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminDocumentsAcceptanceStatsQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary CSV export of the acceptance ledger (PII — audited)
 */
export const useAdminDocumentsExportAcceptancesHook = () => {
  const adminDocumentsExportAcceptances = useCustomInstance<string>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminDocumentsExportAcceptances({ url: `/admin/documents/${id}/acceptances/export`, method: 'GET', signal });
    },
    [adminDocumentsExportAcceptances],
  );
};

export const getAdminDocumentsExportAcceptancesQueryKey = (id: string) => {
  return [`/admin/documents/${id}/acceptances/export`] as const;
};

export const useAdminDocumentsExportAcceptancesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDocumentsExportAcceptancesHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDocumentsExportAcceptancesHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminDocumentsExportAcceptancesQueryKey(id);

  const adminDocumentsExportAcceptances = useAdminDocumentsExportAcceptancesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminDocumentsExportAcceptancesHook>>>> = ({
    signal,
  }) => adminDocumentsExportAcceptances(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminDocumentsExportAcceptancesHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminDocumentsExportAcceptancesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminDocumentsExportAcceptancesHook>>>
>;
export type AdminDocumentsExportAcceptancesQueryError = unknown;

export function useAdminDocumentsExportAcceptances<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDocumentsExportAcceptancesHook>>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDocumentsExportAcceptancesHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminDocumentsExportAcceptancesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminDocumentsExportAcceptancesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminDocumentsExportAcceptances<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDocumentsExportAcceptancesHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDocumentsExportAcceptancesHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminDocumentsExportAcceptancesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminDocumentsExportAcceptancesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminDocumentsExportAcceptances<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDocumentsExportAcceptancesHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDocumentsExportAcceptancesHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary CSV export of the acceptance ledger (PII — audited)
 */

export function useAdminDocumentsExportAcceptances<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDocumentsExportAcceptancesHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDocumentsExportAcceptancesHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminDocumentsExportAcceptancesQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List all footers (Default first)
 */
export const useAdminFootersListHook = () => {
  const adminFootersList = useCustomInstance<FooterResponseDto[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminFootersList({ url: `/admin/footers`, method: 'GET', signal });
    },
    [adminFootersList],
  );
};

export const getAdminFootersListQueryKey = () => {
  return [`/admin/footers`] as const;
};

export const useAdminFootersListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminFootersListHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminFootersListHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminFootersListQueryKey();

  const adminFootersList = useAdminFootersListHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminFootersListHook>>>> = ({ signal }) =>
    adminFootersList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminFootersListHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminFootersListQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminFootersListHook>>>>;
export type AdminFootersListQueryError = unknown;

export function useAdminFootersList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminFootersListHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminFootersListHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminFootersListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminFootersListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminFootersList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminFootersListHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminFootersListHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminFootersListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminFootersListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminFootersList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminFootersListHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminFootersListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List all footers (Default first)
 */

export function useAdminFootersList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminFootersListHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminFootersListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminFootersListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Add a country-specific footer
 */
export const useAdminFootersCreateHook = () => {
  const adminFootersCreate = useCustomInstance<FooterResponseDto>();

  return useCallback(
    (createFooterDto: CreateFooterDto, signal?: AbortSignal) => {
      return adminFootersCreate({
        url: `/admin/footers`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createFooterDto,
        signal,
      });
    },
    [adminFootersCreate],
  );
};

export const useAdminFootersCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminFootersCreateHook>>>,
    TError,
    { data: CreateFooterDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminFootersCreateHook>>>,
  TError,
  { data: CreateFooterDto },
  TContext
> => {
  const mutationKey = ['adminFootersCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminFootersCreate = useAdminFootersCreateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminFootersCreateHook>>>,
    { data: CreateFooterDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminFootersCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminFootersCreateMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminFootersCreateHook>>>
>;
export type AdminFootersCreateMutationBody = CreateFooterDto;
export type AdminFootersCreateMutationError = unknown;

/**
 * @summary Add a country-specific footer
 */
export const useAdminFootersCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminFootersCreateHook>>>,
      TError,
      { data: CreateFooterDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminFootersCreateHook>>>,
  TError,
  { data: CreateFooterDto },
  TContext
> => {
  const mutationOptions = useAdminFootersCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get a single footer with its published + draft content
 */
export const useAdminFootersGetOneHook = () => {
  const adminFootersGetOne = useCustomInstance<FooterResponseDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminFootersGetOne({ url: `/admin/footers/${id}`, method: 'GET', signal });
    },
    [adminFootersGetOne],
  );
};

export const getAdminFootersGetOneQueryKey = (id: string) => {
  return [`/admin/footers/${id}`] as const;
};

export const useAdminFootersGetOneQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminFootersGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminFootersGetOneHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminFootersGetOneQueryKey(id);

  const adminFootersGetOne = useAdminFootersGetOneHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminFootersGetOneHook>>>> = ({ signal }) =>
    adminFootersGetOne(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminFootersGetOneHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminFootersGetOneQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminFootersGetOneHook>>>>;
export type AdminFootersGetOneQueryError = unknown;

export function useAdminFootersGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminFootersGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminFootersGetOneHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminFootersGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminFootersGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminFootersGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminFootersGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminFootersGetOneHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminFootersGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminFootersGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminFootersGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminFootersGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminFootersGetOneHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a single footer with its published + draft content
 */

export function useAdminFootersGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminFootersGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminFootersGetOneHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminFootersGetOneQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete a country-specific footer (the Default cannot be deleted)
 */
export const useAdminFootersRemoveHook = () => {
  const adminFootersRemove = useCustomInstance<void>();

  return useCallback(
    (id: string) => {
      return adminFootersRemove({ url: `/admin/footers/${id}`, method: 'DELETE' });
    },
    [adminFootersRemove],
  );
};

export const useAdminFootersRemoveMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminFootersRemoveHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminFootersRemoveHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminFootersRemove'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminFootersRemove = useAdminFootersRemoveHook();

  const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useAdminFootersRemoveHook>>>, { id: string }> = (
    props,
  ) => {
    const { id } = props ?? {};

    return adminFootersRemove(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminFootersRemoveMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminFootersRemoveHook>>>
>;

export type AdminFootersRemoveMutationError = void;

/**
 * @summary Delete a country-specific footer (the Default cannot be deleted)
 */
export const useAdminFootersRemove = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminFootersRemoveHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminFootersRemoveHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useAdminFootersRemoveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Save the footer's draft content
 */
export const useAdminFootersSaveDraftHook = () => {
  const adminFootersSaveDraft = useCustomInstance<FooterResponseDto>();

  return useCallback(
    (id: string, updateFooterDraftDto: UpdateFooterDraftDto) => {
      return adminFootersSaveDraft({
        url: `/admin/footers/${id}/draft`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateFooterDraftDto,
      });
    },
    [adminFootersSaveDraft],
  );
};

export const useAdminFootersSaveDraftMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminFootersSaveDraftHook>>>,
    TError,
    { id: string; data: UpdateFooterDraftDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminFootersSaveDraftHook>>>,
  TError,
  { id: string; data: UpdateFooterDraftDto },
  TContext
> => {
  const mutationKey = ['adminFootersSaveDraft'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminFootersSaveDraft = useAdminFootersSaveDraftHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminFootersSaveDraftHook>>>,
    { id: string; data: UpdateFooterDraftDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminFootersSaveDraft(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminFootersSaveDraftMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminFootersSaveDraftHook>>>
>;
export type AdminFootersSaveDraftMutationBody = UpdateFooterDraftDto;
export type AdminFootersSaveDraftMutationError = unknown;

/**
 * @summary Save the footer's draft content
 */
export const useAdminFootersSaveDraft = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminFootersSaveDraftHook>>>,
      TError,
      { id: string; data: UpdateFooterDraftDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminFootersSaveDraftHook>>>,
  TError,
  { id: string; data: UpdateFooterDraftDto },
  TContext
> => {
  const mutationOptions = useAdminFootersSaveDraftMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Publish the draft (goes live immediately)
 */
export const useAdminFootersPublishHook = () => {
  const adminFootersPublish = useCustomInstance<FooterResponseDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminFootersPublish({ url: `/admin/footers/${id}/publish`, method: 'POST', signal });
    },
    [adminFootersPublish],
  );
};

export const useAdminFootersPublishMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminFootersPublishHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminFootersPublishHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminFootersPublish'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminFootersPublish = useAdminFootersPublishHook();

  const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useAdminFootersPublishHook>>>, { id: string }> = (
    props,
  ) => {
    const { id } = props ?? {};

    return adminFootersPublish(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminFootersPublishMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminFootersPublishHook>>>
>;

export type AdminFootersPublishMutationError = void;

/**
 * @summary Publish the draft (goes live immediately)
 */
export const useAdminFootersPublish = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminFootersPublishHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminFootersPublishHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useAdminFootersPublishMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Discard the draft, reverting to the published content
 */
export const useAdminFootersDiscardDraftHook = () => {
  const adminFootersDiscardDraft = useCustomInstance<FooterResponseDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminFootersDiscardDraft({ url: `/admin/footers/${id}/discard-draft`, method: 'POST', signal });
    },
    [adminFootersDiscardDraft],
  );
};

export const useAdminFootersDiscardDraftMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminFootersDiscardDraftHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminFootersDiscardDraftHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminFootersDiscardDraft'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminFootersDiscardDraft = useAdminFootersDiscardDraftHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminFootersDiscardDraftHook>>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminFootersDiscardDraft(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminFootersDiscardDraftMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminFootersDiscardDraftHook>>>
>;

export type AdminFootersDiscardDraftMutationError = unknown;

/**
 * @summary Discard the draft, reverting to the published content
 */
export const useAdminFootersDiscardDraft = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminFootersDiscardDraftHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminFootersDiscardDraftHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useAdminFootersDiscardDraftMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List all Buy In footers (Default first)
 */
export const useAdminBuyInFootersListHook = () => {
  const adminBuyInFootersList = useCustomInstance<FooterResponseDto[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminBuyInFootersList({ url: `/admin/buy-in-footers`, method: 'GET', signal });
    },
    [adminBuyInFootersList],
  );
};

export const getAdminBuyInFootersListQueryKey = () => {
  return [`/admin/buy-in-footers`] as const;
};

export const useAdminBuyInFootersListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersListHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersListHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminBuyInFootersListQueryKey();

  const adminBuyInFootersList = useAdminBuyInFootersListHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersListHook>>>> = ({ signal }) =>
    adminBuyInFootersList(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersListHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminBuyInFootersListQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersListHook>>>
>;
export type AdminBuyInFootersListQueryError = unknown;

export function useAdminBuyInFootersList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersListHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersListHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminBuyInFootersList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersListHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersListHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminBuyInFootersList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersListHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List all Buy In footers (Default first)
 */

export function useAdminBuyInFootersList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersListHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminBuyInFootersListQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Add a country-specific Buy In footer
 */
export const useAdminBuyInFootersCreateHook = () => {
  const adminBuyInFootersCreate = useCustomInstance<FooterResponseDto>();

  return useCallback(
    (createFooterDto: CreateFooterDto, signal?: AbortSignal) => {
      return adminBuyInFootersCreate({
        url: `/admin/buy-in-footers`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createFooterDto,
        signal,
      });
    },
    [adminBuyInFootersCreate],
  );
};

export const useAdminBuyInFootersCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersCreateHook>>>,
    TError,
    { data: CreateFooterDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersCreateHook>>>,
  TError,
  { data: CreateFooterDto },
  TContext
> => {
  const mutationKey = ['adminBuyInFootersCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminBuyInFootersCreate = useAdminBuyInFootersCreateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersCreateHook>>>,
    { data: CreateFooterDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminBuyInFootersCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminBuyInFootersCreateMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersCreateHook>>>
>;
export type AdminBuyInFootersCreateMutationBody = CreateFooterDto;
export type AdminBuyInFootersCreateMutationError = unknown;

/**
 * @summary Add a country-specific Buy In footer
 */
export const useAdminBuyInFootersCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersCreateHook>>>,
      TError,
      { data: CreateFooterDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersCreateHook>>>,
  TError,
  { data: CreateFooterDto },
  TContext
> => {
  const mutationOptions = useAdminBuyInFootersCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get a single Buy In footer with its published + draft content
 */
export const useAdminBuyInFootersGetOneHook = () => {
  const adminBuyInFootersGetOne = useCustomInstance<FooterResponseDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminBuyInFootersGetOne({ url: `/admin/buy-in-footers/${id}`, method: 'GET', signal });
    },
    [adminBuyInFootersGetOne],
  );
};

export const getAdminBuyInFootersGetOneQueryKey = (id: string) => {
  return [`/admin/buy-in-footers/${id}`] as const;
};

export const useAdminBuyInFootersGetOneQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersGetOneHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminBuyInFootersGetOneQueryKey(id);

  const adminBuyInFootersGetOne = useAdminBuyInFootersGetOneHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersGetOneHook>>>> = ({ signal }) =>
    adminBuyInFootersGetOne(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersGetOneHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminBuyInFootersGetOneQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersGetOneHook>>>
>;
export type AdminBuyInFootersGetOneQueryError = unknown;

export function useAdminBuyInFootersGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersGetOneHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminBuyInFootersGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersGetOneHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminBuyInFootersGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersGetOneHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a single Buy In footer with its published + draft content
 */

export function useAdminBuyInFootersGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersGetOneHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminBuyInFootersGetOneQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete a country-specific Buy In footer (the Default cannot be deleted)
 */
export const useAdminBuyInFootersRemoveHook = () => {
  const adminBuyInFootersRemove = useCustomInstance<void>();

  return useCallback(
    (id: string) => {
      return adminBuyInFootersRemove({ url: `/admin/buy-in-footers/${id}`, method: 'DELETE' });
    },
    [adminBuyInFootersRemove],
  );
};

export const useAdminBuyInFootersRemoveMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersRemoveHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersRemoveHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminBuyInFootersRemove'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminBuyInFootersRemove = useAdminBuyInFootersRemoveHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersRemoveHook>>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminBuyInFootersRemove(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminBuyInFootersRemoveMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersRemoveHook>>>
>;

export type AdminBuyInFootersRemoveMutationError = void;

/**
 * @summary Delete a country-specific Buy In footer (the Default cannot be deleted)
 */
export const useAdminBuyInFootersRemove = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersRemoveHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersRemoveHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useAdminBuyInFootersRemoveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Save the Buy In footer's draft content
 */
export const useAdminBuyInFootersSaveDraftHook = () => {
  const adminBuyInFootersSaveDraft = useCustomInstance<FooterResponseDto>();

  return useCallback(
    (id: string, updateFooterDraftDto: UpdateFooterDraftDto) => {
      return adminBuyInFootersSaveDraft({
        url: `/admin/buy-in-footers/${id}/draft`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateFooterDraftDto,
      });
    },
    [adminBuyInFootersSaveDraft],
  );
};

export const useAdminBuyInFootersSaveDraftMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersSaveDraftHook>>>,
    TError,
    { id: string; data: UpdateFooterDraftDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersSaveDraftHook>>>,
  TError,
  { id: string; data: UpdateFooterDraftDto },
  TContext
> => {
  const mutationKey = ['adminBuyInFootersSaveDraft'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminBuyInFootersSaveDraft = useAdminBuyInFootersSaveDraftHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersSaveDraftHook>>>,
    { id: string; data: UpdateFooterDraftDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminBuyInFootersSaveDraft(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminBuyInFootersSaveDraftMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersSaveDraftHook>>>
>;
export type AdminBuyInFootersSaveDraftMutationBody = UpdateFooterDraftDto;
export type AdminBuyInFootersSaveDraftMutationError = unknown;

/**
 * @summary Save the Buy In footer's draft content
 */
export const useAdminBuyInFootersSaveDraft = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersSaveDraftHook>>>,
      TError,
      { id: string; data: UpdateFooterDraftDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersSaveDraftHook>>>,
  TError,
  { id: string; data: UpdateFooterDraftDto },
  TContext
> => {
  const mutationOptions = useAdminBuyInFootersSaveDraftMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Publish the draft (goes live immediately)
 */
export const useAdminBuyInFootersPublishHook = () => {
  const adminBuyInFootersPublish = useCustomInstance<FooterResponseDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminBuyInFootersPublish({ url: `/admin/buy-in-footers/${id}/publish`, method: 'POST', signal });
    },
    [adminBuyInFootersPublish],
  );
};

export const useAdminBuyInFootersPublishMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersPublishHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersPublishHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminBuyInFootersPublish'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminBuyInFootersPublish = useAdminBuyInFootersPublishHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersPublishHook>>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminBuyInFootersPublish(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminBuyInFootersPublishMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersPublishHook>>>
>;

export type AdminBuyInFootersPublishMutationError = void;

/**
 * @summary Publish the draft (goes live immediately)
 */
export const useAdminBuyInFootersPublish = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersPublishHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersPublishHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useAdminBuyInFootersPublishMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Discard the draft, reverting to the published content
 */
export const useAdminBuyInFootersDiscardDraftHook = () => {
  const adminBuyInFootersDiscardDraft = useCustomInstance<FooterResponseDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminBuyInFootersDiscardDraft({ url: `/admin/buy-in-footers/${id}/discard-draft`, method: 'POST', signal });
    },
    [adminBuyInFootersDiscardDraft],
  );
};

export const useAdminBuyInFootersDiscardDraftMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersDiscardDraftHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersDiscardDraftHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminBuyInFootersDiscardDraft'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminBuyInFootersDiscardDraft = useAdminBuyInFootersDiscardDraftHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersDiscardDraftHook>>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminBuyInFootersDiscardDraft(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminBuyInFootersDiscardDraftMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersDiscardDraftHook>>>
>;

export type AdminBuyInFootersDiscardDraftMutationError = unknown;

/**
 * @summary Discard the draft, reverting to the published content
 */
export const useAdminBuyInFootersDiscardDraft = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersDiscardDraftHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminBuyInFootersDiscardDraftHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useAdminBuyInFootersDiscardDraftMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List a user's identity verification(s)
 */
export const useAdminKycGetUserKycHook = () => {
  const adminKycGetUserKyc = useCustomInstance<AdminUserKycResponseDto>();

  return useCallback(
    (userId: string, signal?: AbortSignal) => {
      return adminKycGetUserKyc({ url: `/admin/users/${userId}/kyc`, method: 'GET', signal });
    },
    [adminKycGetUserKyc],
  );
};

export const getAdminKycGetUserKycQueryKey = (userId: string) => {
  return [`/admin/users/${userId}/kyc`] as const;
};

export const useAdminKycGetUserKycQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminKycGetUserKycQueryKey(userId);

  const adminKycGetUserKyc = useAdminKycGetUserKycHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycHook>>>> = ({ signal }) =>
    adminKycGetUserKyc(userId, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminKycGetUserKycQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycHook>>>>;
export type AdminKycGetUserKycQueryError = unknown;

export function useAdminKycGetUserKyc<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycHook>>>,
  TError = unknown,
>(
  userId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminKycGetUserKyc<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminKycGetUserKyc<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List a user's identity verification(s)
 */

export function useAdminKycGetUserKyc<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminKycGetUserKycQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List a user's inbound Sumsub webhook events (ingestion audit)
 */
export const useAdminKycGetUserKycWebhookEventsHook = () => {
  const adminKycGetUserKycWebhookEvents = useCustomInstance<KycWebhookEventsResponseDto>();

  return useCallback(
    (userId: string, signal?: AbortSignal) => {
      return adminKycGetUserKycWebhookEvents({ url: `/admin/users/${userId}/kyc/webhook-events`, method: 'GET', signal });
    },
    [adminKycGetUserKycWebhookEvents],
  );
};

export const getAdminKycGetUserKycWebhookEventsQueryKey = (userId: string) => {
  return [`/admin/users/${userId}/kyc/webhook-events`] as const;
};

export const useAdminKycGetUserKycWebhookEventsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycWebhookEventsHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycWebhookEventsHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminKycGetUserKycWebhookEventsQueryKey(userId);

  const adminKycGetUserKycWebhookEvents = useAdminKycGetUserKycWebhookEventsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycWebhookEventsHook>>>> = ({
    signal,
  }) => adminKycGetUserKycWebhookEvents(userId, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycWebhookEventsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminKycGetUserKycWebhookEventsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycWebhookEventsHook>>>
>;
export type AdminKycGetUserKycWebhookEventsQueryError = unknown;

export function useAdminKycGetUserKycWebhookEvents<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycWebhookEventsHook>>>,
  TError = unknown,
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycWebhookEventsHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycWebhookEventsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycWebhookEventsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminKycGetUserKycWebhookEvents<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycWebhookEventsHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycWebhookEventsHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycWebhookEventsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycWebhookEventsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminKycGetUserKycWebhookEvents<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycWebhookEventsHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycWebhookEventsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List a user's inbound Sumsub webhook events (ingestion audit)
 */

export function useAdminKycGetUserKycWebhookEvents<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycWebhookEventsHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserKycWebhookEventsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminKycGetUserKycWebhookEventsQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Trigger identity KYC for a user (at the geo-resolved level)
 */
export const useAdminKycTriggerHook = () => {
  const adminKycTrigger = useCustomInstance<KycTriggerResponseDto>();

  return useCallback(
    (userId: string, signal?: AbortSignal) => {
      return adminKycTrigger({ url: `/admin/users/${userId}/kyc/trigger`, method: 'POST', signal });
    },
    [adminKycTrigger],
  );
};

export const useAdminKycTriggerMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminKycTriggerHook>>>,
    TError,
    { userId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminKycTriggerHook>>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationKey = ['adminKycTrigger'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminKycTrigger = useAdminKycTriggerHook();

  const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useAdminKycTriggerHook>>>, { userId: string }> = (
    props,
  ) => {
    const { userId } = props ?? {};

    return adminKycTrigger(userId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminKycTriggerMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminKycTriggerHook>>>>;

export type AdminKycTriggerMutationError = unknown;

/**
 * @summary Trigger identity KYC for a user (at the geo-resolved level)
 */
export const useAdminKycTrigger = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminKycTriggerHook>>>,
      TError,
      { userId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminKycTriggerHook>>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationOptions = useAdminKycTriggerMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Reset a user's identity verification so they can re-run it
 */
export const useAdminKycResetHook = () => {
  const adminKycReset = useCustomInstance<KycResetResponseDto>();

  return useCallback(
    (userId: string, signal?: AbortSignal) => {
      return adminKycReset({ url: `/admin/users/${userId}/kyc/reset`, method: 'POST', signal });
    },
    [adminKycReset],
  );
};

export const useAdminKycResetMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminKycResetHook>>>,
    TError,
    { userId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminKycResetHook>>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationKey = ['adminKycReset'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminKycReset = useAdminKycResetHook();

  const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useAdminKycResetHook>>>, { userId: string }> = (
    props,
  ) => {
    const { userId } = props ?? {};

    return adminKycReset(userId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminKycResetMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminKycResetHook>>>>;

export type AdminKycResetMutationError = unknown;

/**
 * @summary Reset a user's identity verification so they can re-run it
 */
export const useAdminKycReset = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminKycResetHook>>>,
      TError,
      { userId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useAdminKycResetHook>>>, TError, { userId: string }, TContext> => {
  const mutationOptions = useAdminKycResetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Force a user's identity verification status (compliance override)
 */
export const useAdminKycOverrideHook = () => {
  const adminKycOverride = useCustomInstance<KycOverrideStatusResponseDto>();

  return useCallback(
    (userId: string, overrideKycDto: OverrideKycDto, signal?: AbortSignal) => {
      return adminKycOverride({
        url: `/admin/users/${userId}/kyc/override`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: overrideKycDto,
        signal,
      });
    },
    [adminKycOverride],
  );
};

export const useAdminKycOverrideMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminKycOverrideHook>>>,
    TError,
    { userId: string; data: OverrideKycDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminKycOverrideHook>>>,
  TError,
  { userId: string; data: OverrideKycDto },
  TContext
> => {
  const mutationKey = ['adminKycOverride'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminKycOverride = useAdminKycOverrideHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminKycOverrideHook>>>,
    { userId: string; data: OverrideKycDto }
  > = (props) => {
    const { userId, data } = props ?? {};

    return adminKycOverride(userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminKycOverrideMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminKycOverrideHook>>>>;
export type AdminKycOverrideMutationBody = OverrideKycDto;
export type AdminKycOverrideMutationError = unknown;

/**
 * @summary Force a user's identity verification status (compliance override)
 */
export const useAdminKycOverride = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminKycOverrideHook>>>,
      TError,
      { userId: string; data: OverrideKycDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminKycOverrideHook>>>,
  TError,
  { userId: string; data: OverrideKycDto },
  TContext
> => {
  const mutationOptions = useAdminKycOverrideMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Live Sumsub applicant snapshot — personal data, address, review, document list (PII)
 */
export const useAdminKycGetApplicantPreviewHook = () => {
  const adminKycGetApplicantPreview = useCustomInstance<KycApplicantPreviewResponseDto>();

  return useCallback(
    (userId: string, signal?: AbortSignal) => {
      return adminKycGetApplicantPreview({ url: `/admin/users/${userId}/kyc/applicant`, method: 'GET', signal });
    },
    [adminKycGetApplicantPreview],
  );
};

export const getAdminKycGetApplicantPreviewQueryKey = (userId: string) => {
  return [`/admin/users/${userId}/kyc/applicant`] as const;
};

export const useAdminKycGetApplicantPreviewQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantPreviewHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantPreviewHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminKycGetApplicantPreviewQueryKey(userId);

  const adminKycGetApplicantPreview = useAdminKycGetApplicantPreviewHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantPreviewHook>>>> = ({ signal }) =>
    adminKycGetApplicantPreview(userId, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantPreviewHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminKycGetApplicantPreviewQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantPreviewHook>>>
>;
export type AdminKycGetApplicantPreviewQueryError = unknown;

export function useAdminKycGetApplicantPreview<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantPreviewHook>>>,
  TError = unknown,
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantPreviewHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantPreviewHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantPreviewHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminKycGetApplicantPreview<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantPreviewHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantPreviewHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantPreviewHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantPreviewHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminKycGetApplicantPreview<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantPreviewHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantPreviewHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Live Sumsub applicant snapshot — personal data, address, review, document list (PII)
 */

export function useAdminKycGetApplicantPreview<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantPreviewHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantPreviewHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminKycGetApplicantPreviewQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Proxy a single Sumsub document/selfie image's bytes (PII)
 */
export const useAdminKycGetApplicantImageHook = () => {
  const adminKycGetApplicantImage = useCustomInstance<Blob>();

  return useCallback(
    (userId: string, imageId: string, signal?: AbortSignal) => {
      return adminKycGetApplicantImage({
        url: `/admin/users/${userId}/kyc/applicant/images/${imageId}`,
        method: 'GET',
        responseType: 'blob',
        signal,
      });
    },
    [adminKycGetApplicantImage],
  );
};

export const getAdminKycGetApplicantImageQueryKey = (userId: string, imageId: string) => {
  return [`/admin/users/${userId}/kyc/applicant/images/${imageId}`] as const;
};

export const useAdminKycGetApplicantImageQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantImageHook>>>,
  TError = unknown,
>(
  userId: string,
  imageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantImageHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminKycGetApplicantImageQueryKey(userId, imageId);

  const adminKycGetApplicantImage = useAdminKycGetApplicantImageHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantImageHook>>>> = ({ signal }) =>
    adminKycGetApplicantImage(userId, imageId, signal);

  return { queryKey, queryFn, enabled: !!(userId && imageId), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantImageHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminKycGetApplicantImageQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantImageHook>>>
>;
export type AdminKycGetApplicantImageQueryError = unknown;

export function useAdminKycGetApplicantImage<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantImageHook>>>,
  TError = unknown,
>(
  userId: string,
  imageId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantImageHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantImageHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantImageHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminKycGetApplicantImage<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantImageHook>>>,
  TError = unknown,
>(
  userId: string,
  imageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantImageHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantImageHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantImageHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminKycGetApplicantImage<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantImageHook>>>,
  TError = unknown,
>(
  userId: string,
  imageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantImageHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Proxy a single Sumsub document/selfie image's bytes (PII)
 */

export function useAdminKycGetApplicantImage<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantImageHook>>>,
  TError = unknown,
>(
  userId: string,
  imageId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycGetApplicantImageHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminKycGetApplicantImageQueryOptions(userId, imageId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List a user's action-verification history
 */
export const useAdminKycGetUserActionsHook = () => {
  const adminKycGetUserActions = useCustomInstance<AdminUserKycActionsResponseDto>();

  return useCallback(
    (userId: string, signal?: AbortSignal) => {
      return adminKycGetUserActions({ url: `/admin/users/${userId}/kyc/actions`, method: 'GET', signal });
    },
    [adminKycGetUserActions],
  );
};

export const getAdminKycGetUserActionsQueryKey = (userId: string) => {
  return [`/admin/users/${userId}/kyc/actions`] as const;
};

export const useAdminKycGetUserActionsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserActionsHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserActionsHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminKycGetUserActionsQueryKey(userId);

  const adminKycGetUserActions = useAdminKycGetUserActionsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserActionsHook>>>> = ({ signal }) =>
    adminKycGetUserActions(userId, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserActionsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminKycGetUserActionsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserActionsHook>>>
>;
export type AdminKycGetUserActionsQueryError = unknown;

export function useAdminKycGetUserActions<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserActionsHook>>>,
  TError = unknown,
>(
  userId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserActionsHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserActionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserActionsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminKycGetUserActions<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserActionsHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserActionsHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserActionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserActionsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminKycGetUserActions<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserActionsHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserActionsHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List a user's action-verification history
 */

export function useAdminKycGetUserActions<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserActionsHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycGetUserActionsHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminKycGetUserActionsQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Trigger an action check for a user at a synced ACTION level
 */
export const useAdminKycTriggerActionHook = () => {
  const adminKycTriggerAction = useCustomInstance<KycActionTriggerResponseDto>();

  return useCallback(
    (userId: string, triggerActionDto: TriggerActionDto, signal?: AbortSignal) => {
      return adminKycTriggerAction({
        url: `/admin/users/${userId}/kyc/actions/trigger`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: triggerActionDto,
        signal,
      });
    },
    [adminKycTriggerAction],
  );
};

export const useAdminKycTriggerActionMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminKycTriggerActionHook>>>,
    TError,
    { userId: string; data: TriggerActionDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminKycTriggerActionHook>>>,
  TError,
  { userId: string; data: TriggerActionDto },
  TContext
> => {
  const mutationKey = ['adminKycTriggerAction'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminKycTriggerAction = useAdminKycTriggerActionHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminKycTriggerActionHook>>>,
    { userId: string; data: TriggerActionDto }
  > = (props) => {
    const { userId, data } = props ?? {};

    return adminKycTriggerAction(userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminKycTriggerActionMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminKycTriggerActionHook>>>
>;
export type AdminKycTriggerActionMutationBody = TriggerActionDto;
export type AdminKycTriggerActionMutationError = unknown;

/**
 * @summary Trigger an action check for a user at a synced ACTION level
 */
export const useAdminKycTriggerAction = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminKycTriggerActionHook>>>,
      TError,
      { userId: string; data: TriggerActionDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminKycTriggerActionHook>>>,
  TError,
  { userId: string; data: TriggerActionDto },
  TContext
> => {
  const mutationOptions = useAdminKycTriggerActionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Force a single action verification status (compliance override)
 */
export const useAdminKycOverrideActionHook = () => {
  const adminKycOverrideAction = useCustomInstance<KycOverrideStatusResponseDto>();

  return useCallback(
    (userId: string, externalActionId: string, overrideActionDto: OverrideActionDto, signal?: AbortSignal) => {
      return adminKycOverrideAction({
        url: `/admin/users/${userId}/kyc/actions/${externalActionId}/override`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: overrideActionDto,
        signal,
      });
    },
    [adminKycOverrideAction],
  );
};

export const useAdminKycOverrideActionMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminKycOverrideActionHook>>>,
    TError,
    { userId: string; externalActionId: string; data: OverrideActionDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminKycOverrideActionHook>>>,
  TError,
  { userId: string; externalActionId: string; data: OverrideActionDto },
  TContext
> => {
  const mutationKey = ['adminKycOverrideAction'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminKycOverrideAction = useAdminKycOverrideActionHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminKycOverrideActionHook>>>,
    { userId: string; externalActionId: string; data: OverrideActionDto }
  > = (props) => {
    const { userId, externalActionId, data } = props ?? {};

    return adminKycOverrideAction(userId, externalActionId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminKycOverrideActionMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminKycOverrideActionHook>>>
>;
export type AdminKycOverrideActionMutationBody = OverrideActionDto;
export type AdminKycOverrideActionMutationError = unknown;

/**
 * @summary Force a single action verification status (compliance override)
 */
export const useAdminKycOverrideAction = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminKycOverrideActionHook>>>,
      TError,
      { userId: string; externalActionId: string; data: OverrideActionDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminKycOverrideActionHook>>>,
  TError,
  { userId: string; externalActionId: string; data: OverrideActionDto },
  TContext
> => {
  const mutationOptions = useAdminKycOverrideActionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List the synced Sumsub level catalog (optionally filter by kind)
 */
export const useAdminKycListSumsubLevelsHook = () => {
  const adminKycListSumsubLevels = useCustomInstance<SumsubLevelsResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminKycListSumsubLevels({ url: `/admin/kyc/sumsub-levels`, method: 'GET', signal });
    },
    [adminKycListSumsubLevels],
  );
};

export const getAdminKycListSumsubLevelsQueryKey = () => {
  return [`/admin/kyc/sumsub-levels`] as const;
};

export const useAdminKycListSumsubLevelsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycListSumsubLevelsHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycListSumsubLevelsHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminKycListSumsubLevelsQueryKey();

  const adminKycListSumsubLevels = useAdminKycListSumsubLevelsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminKycListSumsubLevelsHook>>>> = ({ signal }) =>
    adminKycListSumsubLevels(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminKycListSumsubLevelsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminKycListSumsubLevelsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminKycListSumsubLevelsHook>>>
>;
export type AdminKycListSumsubLevelsQueryError = unknown;

export function useAdminKycListSumsubLevels<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycListSumsubLevelsHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycListSumsubLevelsHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminKycListSumsubLevelsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminKycListSumsubLevelsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminKycListSumsubLevels<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycListSumsubLevelsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycListSumsubLevelsHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminKycListSumsubLevelsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminKycListSumsubLevelsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminKycListSumsubLevels<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycListSumsubLevelsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycListSumsubLevelsHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List the synced Sumsub level catalog (optionally filter by kind)
 */

export function useAdminKycListSumsubLevels<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycListSumsubLevelsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycListSumsubLevelsHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminKycListSumsubLevelsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Sync verification levels from the Sumsub dashboard into the catalog
 */
export const useAdminKycSyncSumsubLevelsHook = () => {
  const adminKycSyncSumsubLevels = useCustomInstance<SumsubLevelSyncResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminKycSyncSumsubLevels({ url: `/admin/kyc/sumsub-levels/sync`, method: 'POST', signal });
    },
    [adminKycSyncSumsubLevels],
  );
};

export const useAdminKycSyncSumsubLevelsMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminKycSyncSumsubLevelsHook>>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycSyncSumsubLevelsHook>>>, TError, void, TContext> => {
  const mutationKey = ['adminKycSyncSumsubLevels'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminKycSyncSumsubLevels = useAdminKycSyncSumsubLevelsHook();

  const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useAdminKycSyncSumsubLevelsHook>>>, void> = () => {
    return adminKycSyncSumsubLevels();
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminKycSyncSumsubLevelsMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminKycSyncSumsubLevelsHook>>>
>;

export type AdminKycSyncSumsubLevelsMutationError = unknown;

/**
 * @summary Sync verification levels from the Sumsub dashboard into the catalog
 */
export const useAdminKycSyncSumsubLevels = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminKycSyncSumsubLevelsHook>>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useAdminKycSyncSumsubLevelsHook>>>, TError, void, TContext> => {
  const mutationOptions = useAdminKycSyncSumsubLevelsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Edit the friendly name on a synced Sumsub level
 */
export const useAdminKycUpdateSumsubLevelHook = () => {
  const adminKycUpdateSumsubLevel = useCustomInstance<SumsubLevelDto>();

  return useCallback(
    (id: string, updateSumsubLevelDto: UpdateSumsubLevelDto) => {
      return adminKycUpdateSumsubLevel({
        url: `/admin/kyc/sumsub-levels/${id}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateSumsubLevelDto,
      });
    },
    [adminKycUpdateSumsubLevel],
  );
};

export const useAdminKycUpdateSumsubLevelMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminKycUpdateSumsubLevelHook>>>,
    TError,
    { id: string; data: UpdateSumsubLevelDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminKycUpdateSumsubLevelHook>>>,
  TError,
  { id: string; data: UpdateSumsubLevelDto },
  TContext
> => {
  const mutationKey = ['adminKycUpdateSumsubLevel'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminKycUpdateSumsubLevel = useAdminKycUpdateSumsubLevelHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminKycUpdateSumsubLevelHook>>>,
    { id: string; data: UpdateSumsubLevelDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminKycUpdateSumsubLevel(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminKycUpdateSumsubLevelMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminKycUpdateSumsubLevelHook>>>
>;
export type AdminKycUpdateSumsubLevelMutationBody = UpdateSumsubLevelDto;
export type AdminKycUpdateSumsubLevelMutationError = unknown;

/**
 * @summary Edit the friendly name on a synced Sumsub level
 */
export const useAdminKycUpdateSumsubLevel = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminKycUpdateSumsubLevelHook>>>,
      TError,
      { id: string; data: UpdateSumsubLevelDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminKycUpdateSumsubLevelHook>>>,
  TError,
  { id: string; data: UpdateSumsubLevelDto },
  TContext
> => {
  const mutationOptions = useAdminKycUpdateSumsubLevelMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List geo identity-level rules in evaluation order (top first; first match wins)
 */
export const useAdminKycListIdentityLevelRulesHook = () => {
  const adminKycListIdentityLevelRules = useCustomInstance<IdentityLevelRulesResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminKycListIdentityLevelRules({ url: `/admin/kyc/identity-level-rules`, method: 'GET', signal });
    },
    [adminKycListIdentityLevelRules],
  );
};

export const getAdminKycListIdentityLevelRulesQueryKey = () => {
  return [`/admin/kyc/identity-level-rules`] as const;
};

export const useAdminKycListIdentityLevelRulesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycListIdentityLevelRulesHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycListIdentityLevelRulesHook>>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminKycListIdentityLevelRulesQueryKey();

  const adminKycListIdentityLevelRules = useAdminKycListIdentityLevelRulesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminKycListIdentityLevelRulesHook>>>> = ({
    signal,
  }) => adminKycListIdentityLevelRules(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminKycListIdentityLevelRulesHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminKycListIdentityLevelRulesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminKycListIdentityLevelRulesHook>>>
>;
export type AdminKycListIdentityLevelRulesQueryError = unknown;

export function useAdminKycListIdentityLevelRules<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycListIdentityLevelRulesHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycListIdentityLevelRulesHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminKycListIdentityLevelRulesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminKycListIdentityLevelRulesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminKycListIdentityLevelRules<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycListIdentityLevelRulesHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycListIdentityLevelRulesHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminKycListIdentityLevelRulesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminKycListIdentityLevelRulesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminKycListIdentityLevelRules<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycListIdentityLevelRulesHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycListIdentityLevelRulesHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List geo identity-level rules in evaluation order (top first; first match wins)
 */

export function useAdminKycListIdentityLevelRules<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminKycListIdentityLevelRulesHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminKycListIdentityLevelRulesHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminKycListIdentityLevelRulesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a geo identity-level rule (appended to the bottom of the list)
 */
export const useAdminKycCreateIdentityLevelRuleHook = () => {
  const adminKycCreateIdentityLevelRule = useCustomInstance<IdentityLevelRuleDto>();

  return useCallback(
    (createIdentityLevelRuleDto: CreateIdentityLevelRuleDto, signal?: AbortSignal) => {
      return adminKycCreateIdentityLevelRule({
        url: `/admin/kyc/identity-level-rules`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createIdentityLevelRuleDto,
        signal,
      });
    },
    [adminKycCreateIdentityLevelRule],
  );
};

export const useAdminKycCreateIdentityLevelRuleMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminKycCreateIdentityLevelRuleHook>>>,
    TError,
    { data: CreateIdentityLevelRuleDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminKycCreateIdentityLevelRuleHook>>>,
  TError,
  { data: CreateIdentityLevelRuleDto },
  TContext
> => {
  const mutationKey = ['adminKycCreateIdentityLevelRule'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminKycCreateIdentityLevelRule = useAdminKycCreateIdentityLevelRuleHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminKycCreateIdentityLevelRuleHook>>>,
    { data: CreateIdentityLevelRuleDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminKycCreateIdentityLevelRule(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminKycCreateIdentityLevelRuleMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminKycCreateIdentityLevelRuleHook>>>
>;
export type AdminKycCreateIdentityLevelRuleMutationBody = CreateIdentityLevelRuleDto;
export type AdminKycCreateIdentityLevelRuleMutationError = unknown;

/**
 * @summary Create a geo identity-level rule (appended to the bottom of the list)
 */
export const useAdminKycCreateIdentityLevelRule = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminKycCreateIdentityLevelRuleHook>>>,
      TError,
      { data: CreateIdentityLevelRuleDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminKycCreateIdentityLevelRuleHook>>>,
  TError,
  { data: CreateIdentityLevelRuleDto },
  TContext
> => {
  const mutationOptions = useAdminKycCreateIdentityLevelRuleMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Reorder the identity-level rules (index = precedence; 0 = top, wins first)
 */
export const useAdminKycReorderIdentityLevelRulesHook = () => {
  const adminKycReorderIdentityLevelRules = useCustomInstance<IdentityLevelRulesResponseDto>();

  return useCallback(
    (reorderIdentityLevelRulesDto: ReorderIdentityLevelRulesDto) => {
      return adminKycReorderIdentityLevelRules({
        url: `/admin/kyc/identity-level-rules/order`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: reorderIdentityLevelRulesDto,
      });
    },
    [adminKycReorderIdentityLevelRules],
  );
};

export const useAdminKycReorderIdentityLevelRulesMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminKycReorderIdentityLevelRulesHook>>>,
    TError,
    { data: ReorderIdentityLevelRulesDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminKycReorderIdentityLevelRulesHook>>>,
  TError,
  { data: ReorderIdentityLevelRulesDto },
  TContext
> => {
  const mutationKey = ['adminKycReorderIdentityLevelRules'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminKycReorderIdentityLevelRules = useAdminKycReorderIdentityLevelRulesHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminKycReorderIdentityLevelRulesHook>>>,
    { data: ReorderIdentityLevelRulesDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminKycReorderIdentityLevelRules(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminKycReorderIdentityLevelRulesMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminKycReorderIdentityLevelRulesHook>>>
>;
export type AdminKycReorderIdentityLevelRulesMutationBody = ReorderIdentityLevelRulesDto;
export type AdminKycReorderIdentityLevelRulesMutationError = unknown;

/**
 * @summary Reorder the identity-level rules (index = precedence; 0 = top, wins first)
 */
export const useAdminKycReorderIdentityLevelRules = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminKycReorderIdentityLevelRulesHook>>>,
      TError,
      { data: ReorderIdentityLevelRulesDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminKycReorderIdentityLevelRulesHook>>>,
  TError,
  { data: ReorderIdentityLevelRulesDto },
  TContext
> => {
  const mutationOptions = useAdminKycReorderIdentityLevelRulesMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Update a geo identity-level rule
 */
export const useAdminKycUpdateIdentityLevelRuleHook = () => {
  const adminKycUpdateIdentityLevelRule = useCustomInstance<IdentityLevelRuleDto>();

  return useCallback(
    (id: string, updateIdentityLevelRuleDto: UpdateIdentityLevelRuleDto) => {
      return adminKycUpdateIdentityLevelRule({
        url: `/admin/kyc/identity-level-rules/${id}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateIdentityLevelRuleDto,
      });
    },
    [adminKycUpdateIdentityLevelRule],
  );
};

export const useAdminKycUpdateIdentityLevelRuleMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminKycUpdateIdentityLevelRuleHook>>>,
    TError,
    { id: string; data: UpdateIdentityLevelRuleDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminKycUpdateIdentityLevelRuleHook>>>,
  TError,
  { id: string; data: UpdateIdentityLevelRuleDto },
  TContext
> => {
  const mutationKey = ['adminKycUpdateIdentityLevelRule'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminKycUpdateIdentityLevelRule = useAdminKycUpdateIdentityLevelRuleHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminKycUpdateIdentityLevelRuleHook>>>,
    { id: string; data: UpdateIdentityLevelRuleDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminKycUpdateIdentityLevelRule(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminKycUpdateIdentityLevelRuleMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminKycUpdateIdentityLevelRuleHook>>>
>;
export type AdminKycUpdateIdentityLevelRuleMutationBody = UpdateIdentityLevelRuleDto;
export type AdminKycUpdateIdentityLevelRuleMutationError = unknown;

/**
 * @summary Update a geo identity-level rule
 */
export const useAdminKycUpdateIdentityLevelRule = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminKycUpdateIdentityLevelRuleHook>>>,
      TError,
      { id: string; data: UpdateIdentityLevelRuleDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminKycUpdateIdentityLevelRuleHook>>>,
  TError,
  { id: string; data: UpdateIdentityLevelRuleDto },
  TContext
> => {
  const mutationOptions = useAdminKycUpdateIdentityLevelRuleMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Delete a geo identity-level rule
 */
export const useAdminKycDeleteIdentityLevelRuleHook = () => {
  const adminKycDeleteIdentityLevelRule = useCustomInstance<IdentityLevelRuleDeleteResponseDto>();

  return useCallback(
    (id: string) => {
      return adminKycDeleteIdentityLevelRule({ url: `/admin/kyc/identity-level-rules/${id}`, method: 'DELETE' });
    },
    [adminKycDeleteIdentityLevelRule],
  );
};

export const useAdminKycDeleteIdentityLevelRuleMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminKycDeleteIdentityLevelRuleHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminKycDeleteIdentityLevelRuleHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminKycDeleteIdentityLevelRule'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminKycDeleteIdentityLevelRule = useAdminKycDeleteIdentityLevelRuleHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminKycDeleteIdentityLevelRuleHook>>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminKycDeleteIdentityLevelRule(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminKycDeleteIdentityLevelRuleMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminKycDeleteIdentityLevelRuleHook>>>
>;

export type AdminKycDeleteIdentityLevelRuleMutationError = unknown;

/**
 * @summary Delete a geo identity-level rule
 */
export const useAdminKycDeleteIdentityLevelRule = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminKycDeleteIdentityLevelRuleHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminKycDeleteIdentityLevelRuleHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useAdminKycDeleteIdentityLevelRuleMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Mint a Sumsub WebSDK access token for identity verification
 */
export const useKycCreateAccessTokenHook = () => {
  const kycCreateAccessToken = useCustomInstance<AccessTokenResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return kycCreateAccessToken({ url: `/kyc/access-token`, method: 'POST', signal });
    },
    [kycCreateAccessToken],
  );
};

export const useKycCreateAccessTokenMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useKycCreateAccessTokenHook>>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useKycCreateAccessTokenHook>>>, TError, void, TContext> => {
  const mutationKey = ['kycCreateAccessToken'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const kycCreateAccessToken = useKycCreateAccessTokenHook();

  const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useKycCreateAccessTokenHook>>>, void> = () => {
    return kycCreateAccessToken();
  };

  return { mutationFn, ...mutationOptions };
};

export type KycCreateAccessTokenMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useKycCreateAccessTokenHook>>>
>;

export type KycCreateAccessTokenMutationError = unknown;

/**
 * @summary Mint a Sumsub WebSDK access token for identity verification
 */
export const useKycCreateAccessToken = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useKycCreateAccessTokenHook>>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useKycCreateAccessTokenHook>>>, TError, void, TContext> => {
  const mutationOptions = useKycCreateAccessTokenMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Mint a WebSDK token to complete one of the user's pending action checks
 */
export const useKycCreateActionTokenHook = () => {
  const kycCreateActionToken = useCustomInstance<AccessTokenResponseDto>();

  return useCallback(
    (externalActionId: string, signal?: AbortSignal) => {
      return kycCreateActionToken({ url: `/kyc/actions/${externalActionId}/token`, method: 'POST', signal });
    },
    [kycCreateActionToken],
  );
};

export const useKycCreateActionTokenMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useKycCreateActionTokenHook>>>,
    TError,
    { externalActionId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useKycCreateActionTokenHook>>>,
  TError,
  { externalActionId: string },
  TContext
> => {
  const mutationKey = ['kycCreateActionToken'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const kycCreateActionToken = useKycCreateActionTokenHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useKycCreateActionTokenHook>>>,
    { externalActionId: string }
  > = (props) => {
    const { externalActionId } = props ?? {};

    return kycCreateActionToken(externalActionId);
  };

  return { mutationFn, ...mutationOptions };
};

export type KycCreateActionTokenMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useKycCreateActionTokenHook>>>
>;

export type KycCreateActionTokenMutationError = unknown;

/**
 * @summary Mint a WebSDK token to complete one of the user's pending action checks
 */
export const useKycCreateActionToken = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useKycCreateActionTokenHook>>>,
      TError,
      { externalActionId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useKycCreateActionTokenHook>>>,
  TError,
  { externalActionId: string },
  TContext
> => {
  const mutationOptions = useKycCreateActionTokenMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary The current user's KYC verifications and their statuses
 */
export const useKycGetStatusHook = () => {
  const kycGetStatus = useCustomInstance<KycStatusResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return kycGetStatus({ url: `/kyc/status`, method: 'GET', signal });
    },
    [kycGetStatus],
  );
};

export const getKycGetStatusQueryKey = () => {
  return [`/kyc/status`] as const;
};

export const useKycGetStatusQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useKycGetStatusHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useKycGetStatusHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getKycGetStatusQueryKey();

  const kycGetStatus = useKycGetStatusHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useKycGetStatusHook>>>> = ({ signal }) =>
    kycGetStatus(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useKycGetStatusHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type KycGetStatusQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useKycGetStatusHook>>>>;
export type KycGetStatusQueryError = unknown;

export function useKycGetStatus<TData = Awaited<ReturnType<ReturnType<typeof useKycGetStatusHook>>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useKycGetStatusHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useKycGetStatusHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useKycGetStatusHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useKycGetStatus<TData = Awaited<ReturnType<ReturnType<typeof useKycGetStatusHook>>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useKycGetStatusHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useKycGetStatusHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useKycGetStatusHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useKycGetStatus<TData = Awaited<ReturnType<ReturnType<typeof useKycGetStatusHook>>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useKycGetStatusHook>>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The current user's KYC verifications and their statuses
 */

export function useKycGetStatus<TData = Awaited<ReturnType<ReturnType<typeof useKycGetStatusHook>>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useKycGetStatusHook>>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useKycGetStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List opened countries (paginated)
 */
export const useAdminTerritoryCountriesListHook = () => {
  const adminTerritoryCountriesList = useCustomInstance<TerritoryCountryResponseDto[]>();

  return useCallback(
    (params?: AdminTerritoryCountriesListParams, signal?: AbortSignal) => {
      return adminTerritoryCountriesList({ url: `/admin/territories/countries`, method: 'GET', params, signal });
    },
    [adminTerritoryCountriesList],
  );
};

export const getAdminTerritoryCountriesListQueryKey = (params?: AdminTerritoryCountriesListParams) => {
  return [`/admin/territories/countries`, ...(params ? [params] : [])] as const;
};

export const useAdminTerritoryCountriesListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesListHook>>>,
  TError = unknown,
>(
  params?: AdminTerritoryCountriesListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesListHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminTerritoryCountriesListQueryKey(params);

  const adminTerritoryCountriesList = useAdminTerritoryCountriesListHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesListHook>>>> = ({ signal }) =>
    adminTerritoryCountriesList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesListHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminTerritoryCountriesListQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesListHook>>>
>;
export type AdminTerritoryCountriesListQueryError = unknown;

export function useAdminTerritoryCountriesList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesListHook>>>,
  TError = unknown,
>(
  params: undefined | AdminTerritoryCountriesListParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesListHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminTerritoryCountriesList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesListHook>>>,
  TError = unknown,
>(
  params?: AdminTerritoryCountriesListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesListHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminTerritoryCountriesList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesListHook>>>,
  TError = unknown,
>(
  params?: AdminTerritoryCountriesListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesListHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List opened countries (paginated)
 */

export function useAdminTerritoryCountriesList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesListHook>>>,
  TError = unknown,
>(
  params?: AdminTerritoryCountriesListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesListHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminTerritoryCountriesListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Open a new country (defaults to inactive)
 */
export const useAdminTerritoryCountriesCreateHook = () => {
  const adminTerritoryCountriesCreate = useCustomInstance<TerritoryCountryResponseDto>();

  return useCallback(
    (createCountryDto: CreateCountryDto, signal?: AbortSignal) => {
      return adminTerritoryCountriesCreate({
        url: `/admin/territories/countries`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createCountryDto,
        signal,
      });
    },
    [adminTerritoryCountriesCreate],
  );
};

export const useAdminTerritoryCountriesCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesCreateHook>>>,
    TError,
    { data: CreateCountryDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesCreateHook>>>,
  TError,
  { data: CreateCountryDto },
  TContext
> => {
  const mutationKey = ['adminTerritoryCountriesCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminTerritoryCountriesCreate = useAdminTerritoryCountriesCreateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesCreateHook>>>,
    { data: CreateCountryDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminTerritoryCountriesCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminTerritoryCountriesCreateMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesCreateHook>>>
>;
export type AdminTerritoryCountriesCreateMutationBody = CreateCountryDto;
export type AdminTerritoryCountriesCreateMutationError = unknown;

/**
 * @summary Open a new country (defaults to inactive)
 */
export const useAdminTerritoryCountriesCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesCreateHook>>>,
      TError,
      { data: CreateCountryDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesCreateHook>>>,
  TError,
  { data: CreateCountryDto },
  TContext
> => {
  const mutationOptions = useAdminTerritoryCountriesCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get a single country
 */
export const useAdminTerritoryCountriesGetOneHook = () => {
  const adminTerritoryCountriesGetOne = useCustomInstance<TerritoryCountryResponseDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminTerritoryCountriesGetOne({ url: `/admin/territories/countries/${id}`, method: 'GET', signal });
    },
    [adminTerritoryCountriesGetOne],
  );
};

export const getAdminTerritoryCountriesGetOneQueryKey = (id: string) => {
  return [`/admin/territories/countries/${id}`] as const;
};

export const useAdminTerritoryCountriesGetOneQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesGetOneHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminTerritoryCountriesGetOneQueryKey(id);

  const adminTerritoryCountriesGetOne = useAdminTerritoryCountriesGetOneHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesGetOneHook>>>> = ({
    signal,
  }) => adminTerritoryCountriesGetOne(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesGetOneHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminTerritoryCountriesGetOneQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesGetOneHook>>>
>;
export type AdminTerritoryCountriesGetOneQueryError = unknown;

export function useAdminTerritoryCountriesGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesGetOneHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminTerritoryCountriesGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesGetOneHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminTerritoryCountriesGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesGetOneHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a single country
 */

export function useAdminTerritoryCountriesGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesGetOneHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminTerritoryCountriesGetOneQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Edit any country field
 */
export const useAdminTerritoryCountriesUpdateHook = () => {
  const adminTerritoryCountriesUpdate = useCustomInstance<TerritoryCountryResponseDto>();

  return useCallback(
    (id: string, updateCountryDto: UpdateCountryDto) => {
      return adminTerritoryCountriesUpdate({
        url: `/admin/territories/countries/${id}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateCountryDto,
      });
    },
    [adminTerritoryCountriesUpdate],
  );
};

export const useAdminTerritoryCountriesUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesUpdateHook>>>,
    TError,
    { id: string; data: UpdateCountryDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesUpdateHook>>>,
  TError,
  { id: string; data: UpdateCountryDto },
  TContext
> => {
  const mutationKey = ['adminTerritoryCountriesUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminTerritoryCountriesUpdate = useAdminTerritoryCountriesUpdateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesUpdateHook>>>,
    { id: string; data: UpdateCountryDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminTerritoryCountriesUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminTerritoryCountriesUpdateMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesUpdateHook>>>
>;
export type AdminTerritoryCountriesUpdateMutationBody = UpdateCountryDto;
export type AdminTerritoryCountriesUpdateMutationError = unknown;

/**
 * @summary Edit any country field
 */
export const useAdminTerritoryCountriesUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesUpdateHook>>>,
      TError,
      { id: string; data: UpdateCountryDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesUpdateHook>>>,
  TError,
  { id: string; data: UpdateCountryDto },
  TContext
> => {
  const mutationOptions = useAdminTerritoryCountriesUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Activate a country
 */
export const useAdminTerritoryCountriesActivateHook = () => {
  const adminTerritoryCountriesActivate = useCustomInstance<TerritoryCountryResponseDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminTerritoryCountriesActivate({ url: `/admin/territories/countries/${id}/activate`, method: 'POST', signal });
    },
    [adminTerritoryCountriesActivate],
  );
};

export const useAdminTerritoryCountriesActivateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesActivateHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesActivateHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminTerritoryCountriesActivate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminTerritoryCountriesActivate = useAdminTerritoryCountriesActivateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesActivateHook>>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminTerritoryCountriesActivate(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminTerritoryCountriesActivateMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesActivateHook>>>
>;

export type AdminTerritoryCountriesActivateMutationError = unknown;

/**
 * @summary Activate a country
 */
export const useAdminTerritoryCountriesActivate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesActivateHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesActivateHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useAdminTerritoryCountriesActivateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Deactivate a country (blocks all its users + states)
 */
export const useAdminTerritoryCountriesDeactivateHook = () => {
  const adminTerritoryCountriesDeactivate = useCustomInstance<TerritoryCountryResponseDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminTerritoryCountriesDeactivate({
        url: `/admin/territories/countries/${id}/deactivate`,
        method: 'POST',
        signal,
      });
    },
    [adminTerritoryCountriesDeactivate],
  );
};

export const useAdminTerritoryCountriesDeactivateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesDeactivateHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesDeactivateHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminTerritoryCountriesDeactivate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminTerritoryCountriesDeactivate = useAdminTerritoryCountriesDeactivateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesDeactivateHook>>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminTerritoryCountriesDeactivate(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminTerritoryCountriesDeactivateMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesDeactivateHook>>>
>;

export type AdminTerritoryCountriesDeactivateMutationError = unknown;

/**
 * @summary Deactivate a country (blocks all its users + states)
 */
export const useAdminTerritoryCountriesDeactivate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesDeactivateHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminTerritoryCountriesDeactivateHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useAdminTerritoryCountriesDeactivateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List state restrictions (only states that carry a restriction)
 */
export const useAdminTerritoryStatesListHook = () => {
  const adminTerritoryStatesList = useCustomInstance<TerritoryStateResponseDto[]>();

  return useCallback(
    (params?: AdminTerritoryStatesListParams, signal?: AbortSignal) => {
      return adminTerritoryStatesList({ url: `/admin/territories/states`, method: 'GET', params, signal });
    },
    [adminTerritoryStatesList],
  );
};

export const getAdminTerritoryStatesListQueryKey = (params?: AdminTerritoryStatesListParams) => {
  return [`/admin/territories/states`, ...(params ? [params] : [])] as const;
};

export const useAdminTerritoryStatesListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesListHook>>>,
  TError = unknown,
>(
  params?: AdminTerritoryStatesListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesListHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminTerritoryStatesListQueryKey(params);

  const adminTerritoryStatesList = useAdminTerritoryStatesListHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesListHook>>>> = ({ signal }) =>
    adminTerritoryStatesList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesListHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminTerritoryStatesListQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesListHook>>>
>;
export type AdminTerritoryStatesListQueryError = unknown;

export function useAdminTerritoryStatesList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesListHook>>>,
  TError = unknown,
>(
  params: undefined | AdminTerritoryStatesListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesListHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminTerritoryStatesList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesListHook>>>,
  TError = unknown,
>(
  params?: AdminTerritoryStatesListParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesListHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminTerritoryStatesList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesListHook>>>,
  TError = unknown,
>(
  params?: AdminTerritoryStatesListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List state restrictions (only states that carry a restriction)
 */

export function useAdminTerritoryStatesList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesListHook>>>,
  TError = unknown,
>(
  params?: AdminTerritoryStatesListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminTerritoryStatesListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Add a state restriction under an active country
 */
export const useAdminTerritoryStatesCreateHook = () => {
  const adminTerritoryStatesCreate = useCustomInstance<TerritoryStateResponseDto>();

  return useCallback(
    (createStateDto: CreateStateDto, signal?: AbortSignal) => {
      return adminTerritoryStatesCreate({
        url: `/admin/territories/states`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createStateDto,
        signal,
      });
    },
    [adminTerritoryStatesCreate],
  );
};

export const useAdminTerritoryStatesCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesCreateHook>>>,
    TError,
    { data: CreateStateDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesCreateHook>>>,
  TError,
  { data: CreateStateDto },
  TContext
> => {
  const mutationKey = ['adminTerritoryStatesCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminTerritoryStatesCreate = useAdminTerritoryStatesCreateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesCreateHook>>>,
    { data: CreateStateDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminTerritoryStatesCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminTerritoryStatesCreateMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesCreateHook>>>
>;
export type AdminTerritoryStatesCreateMutationBody = CreateStateDto;
export type AdminTerritoryStatesCreateMutationError = unknown;

/**
 * @summary Add a state restriction under an active country
 */
export const useAdminTerritoryStatesCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesCreateHook>>>,
      TError,
      { data: CreateStateDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesCreateHook>>>,
  TError,
  { data: CreateStateDto },
  TContext
> => {
  const mutationOptions = useAdminTerritoryStatesCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get a single state restriction
 */
export const useAdminTerritoryStatesGetOneHook = () => {
  const adminTerritoryStatesGetOne = useCustomInstance<TerritoryStateResponseDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return adminTerritoryStatesGetOne({ url: `/admin/territories/states/${id}`, method: 'GET', signal });
    },
    [adminTerritoryStatesGetOne],
  );
};

export const getAdminTerritoryStatesGetOneQueryKey = (id: string) => {
  return [`/admin/territories/states/${id}`] as const;
};

export const useAdminTerritoryStatesGetOneQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesGetOneHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminTerritoryStatesGetOneQueryKey(id);

  const adminTerritoryStatesGetOne = useAdminTerritoryStatesGetOneHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesGetOneHook>>>> = ({ signal }) =>
    adminTerritoryStatesGetOne(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesGetOneHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminTerritoryStatesGetOneQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesGetOneHook>>>
>;
export type AdminTerritoryStatesGetOneQueryError = unknown;

export function useAdminTerritoryStatesGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesGetOneHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminTerritoryStatesGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesGetOneHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminTerritoryStatesGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesGetOneHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a single state restriction
 */

export function useAdminTerritoryStatesGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesGetOneHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesGetOneHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminTerritoryStatesGetOneQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Edit a state restriction
 */
export const useAdminTerritoryStatesUpdateHook = () => {
  const adminTerritoryStatesUpdate = useCustomInstance<TerritoryStateResponseDto>();

  return useCallback(
    (id: string, updateStateDto: UpdateStateDto) => {
      return adminTerritoryStatesUpdate({
        url: `/admin/territories/states/${id}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateStateDto,
      });
    },
    [adminTerritoryStatesUpdate],
  );
};

export const useAdminTerritoryStatesUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesUpdateHook>>>,
    TError,
    { id: string; data: UpdateStateDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesUpdateHook>>>,
  TError,
  { id: string; data: UpdateStateDto },
  TContext
> => {
  const mutationKey = ['adminTerritoryStatesUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminTerritoryStatesUpdate = useAdminTerritoryStatesUpdateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesUpdateHook>>>,
    { id: string; data: UpdateStateDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return adminTerritoryStatesUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminTerritoryStatesUpdateMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesUpdateHook>>>
>;
export type AdminTerritoryStatesUpdateMutationBody = UpdateStateDto;
export type AdminTerritoryStatesUpdateMutationError = unknown;

/**
 * @summary Edit a state restriction
 */
export const useAdminTerritoryStatesUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesUpdateHook>>>,
      TError,
      { id: string; data: UpdateStateDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesUpdateHook>>>,
  TError,
  { id: string; data: UpdateStateDto },
  TContext
> => {
  const mutationOptions = useAdminTerritoryStatesUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Remove a state restriction (the state returns to fully open)
 */
export const useAdminTerritoryStatesRemoveHook = () => {
  const adminTerritoryStatesRemove = useCustomInstance<TerritoryStateResponseDto>();

  return useCallback(
    (id: string) => {
      return adminTerritoryStatesRemove({ url: `/admin/territories/states/${id}`, method: 'DELETE' });
    },
    [adminTerritoryStatesRemove],
  );
};

export const useAdminTerritoryStatesRemoveMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesRemoveHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesRemoveHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminTerritoryStatesRemove'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminTerritoryStatesRemove = useAdminTerritoryStatesRemoveHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesRemoveHook>>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminTerritoryStatesRemove(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminTerritoryStatesRemoveMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesRemoveHook>>>
>;

export type AdminTerritoryStatesRemoveMutationError = unknown;

/**
 * @summary Remove a state restriction (the state returns to fully open)
 */
export const useAdminTerritoryStatesRemove = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesRemoveHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminTerritoryStatesRemoveHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useAdminTerritoryStatesRemoveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Create N mock users (Firebase-free) + register them as Plaee customers
 */
export const useAdminMockUsersCreateHook = () => {
  const adminMockUsersCreate = useCustomInstance<CreateMockUsersResponseDto>();

  return useCallback(
    (createMockUsersDto: CreateMockUsersDto, signal?: AbortSignal) => {
      return adminMockUsersCreate({
        url: `/admin/mock-users`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createMockUsersDto,
        signal,
      });
    },
    [adminMockUsersCreate],
  );
};

export const useAdminMockUsersCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminMockUsersCreateHook>>>,
    TError,
    { data: CreateMockUsersDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminMockUsersCreateHook>>>,
  TError,
  { data: CreateMockUsersDto },
  TContext
> => {
  const mutationKey = ['adminMockUsersCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminMockUsersCreate = useAdminMockUsersCreateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminMockUsersCreateHook>>>,
    { data: CreateMockUsersDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminMockUsersCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminMockUsersCreateMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminMockUsersCreateHook>>>
>;
export type AdminMockUsersCreateMutationBody = CreateMockUsersDto;
export type AdminMockUsersCreateMutationError = unknown;

/**
 * @summary Create N mock users (Firebase-free) + register them as Plaee customers
 */
export const useAdminMockUsersCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminMockUsersCreateHook>>>,
      TError,
      { data: CreateMockUsersDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminMockUsersCreateHook>>>,
  TError,
  { data: CreateMockUsersDto },
  TContext
> => {
  const mutationOptions = useAdminMockUsersCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List mock users with wallet balances
 */
export const useAdminMockUsersListHook = () => {
  const adminMockUsersList = useCustomInstance<MockUserListResponseDto>();

  return useCallback(
    (params?: AdminMockUsersListParams, signal?: AbortSignal) => {
      return adminMockUsersList({ url: `/admin/mock-users`, method: 'GET', params, signal });
    },
    [adminMockUsersList],
  );
};

export const getAdminMockUsersListQueryKey = (params?: AdminMockUsersListParams) => {
  return [`/admin/mock-users`, ...(params ? [params] : [])] as const;
};

export const useAdminMockUsersListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMockUsersListHook>>>,
  TError = unknown,
>(
  params?: AdminMockUsersListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMockUsersListHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminMockUsersListQueryKey(params);

  const adminMockUsersList = useAdminMockUsersListHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminMockUsersListHook>>>> = ({ signal }) =>
    adminMockUsersList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminMockUsersListHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminMockUsersListQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminMockUsersListHook>>>>;
export type AdminMockUsersListQueryError = unknown;

export function useAdminMockUsersList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMockUsersListHook>>>,
  TError = unknown,
>(
  params: undefined | AdminMockUsersListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMockUsersListHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminMockUsersListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminMockUsersListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminMockUsersList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMockUsersListHook>>>,
  TError = unknown,
>(
  params?: AdminMockUsersListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMockUsersListHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminMockUsersListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminMockUsersListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminMockUsersList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMockUsersListHook>>>,
  TError = unknown,
>(
  params?: AdminMockUsersListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMockUsersListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List mock users with wallet balances
 */

export function useAdminMockUsersList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMockUsersListHook>>>,
  TError = unknown,
>(
  params?: AdminMockUsersListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMockUsersListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminMockUsersListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Run a batch scenario: create + fund N mock users and place orders across both sides
 */
export const useAdminMockUsersScenarioHook = () => {
  const adminMockUsersScenario = useCustomInstance<ScenarioResultDto>();

  return useCallback(
    (runScenarioDto: RunScenarioDto, signal?: AbortSignal) => {
      return adminMockUsersScenario({
        url: `/admin/mock-users/scenario`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: runScenarioDto,
        signal,
      });
    },
    [adminMockUsersScenario],
  );
};

export const useAdminMockUsersScenarioMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminMockUsersScenarioHook>>>,
    TError,
    { data: RunScenarioDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminMockUsersScenarioHook>>>,
  TError,
  { data: RunScenarioDto },
  TContext
> => {
  const mutationKey = ['adminMockUsersScenario'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminMockUsersScenario = useAdminMockUsersScenarioHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminMockUsersScenarioHook>>>,
    { data: RunScenarioDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminMockUsersScenario(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminMockUsersScenarioMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminMockUsersScenarioHook>>>
>;
export type AdminMockUsersScenarioMutationBody = RunScenarioDto;
export type AdminMockUsersScenarioMutationError = unknown;

/**
 * @summary Run a batch scenario: create + fund N mock users and place orders across both sides
 */
export const useAdminMockUsersScenario = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminMockUsersScenarioHook>>>,
      TError,
      { data: RunScenarioDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminMockUsersScenarioHook>>>,
  TError,
  { data: RunScenarioDto },
  TContext
> => {
  const mutationOptions = useAdminMockUsersScenarioMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get one mock user: wallet balance + live Plaee positions and open orders
 */
export const useAdminMockUsersGetOneHook = () => {
  const adminMockUsersGetOne = useCustomInstance<MockUserDetailDto>();

  return useCallback(
    (userId: string, signal?: AbortSignal) => {
      return adminMockUsersGetOne({ url: `/admin/mock-users/${userId}`, method: 'GET', signal });
    },
    [adminMockUsersGetOne],
  );
};

export const getAdminMockUsersGetOneQueryKey = (userId: string) => {
  return [`/admin/mock-users/${userId}`] as const;
};

export const useAdminMockUsersGetOneQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMockUsersGetOneHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMockUsersGetOneHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminMockUsersGetOneQueryKey(userId);

  const adminMockUsersGetOne = useAdminMockUsersGetOneHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminMockUsersGetOneHook>>>> = ({ signal }) =>
    adminMockUsersGetOne(userId, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminMockUsersGetOneHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminMockUsersGetOneQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminMockUsersGetOneHook>>>
>;
export type AdminMockUsersGetOneQueryError = unknown;

export function useAdminMockUsersGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMockUsersGetOneHook>>>,
  TError = unknown,
>(
  userId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMockUsersGetOneHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminMockUsersGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminMockUsersGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminMockUsersGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMockUsersGetOneHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMockUsersGetOneHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminMockUsersGetOneHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminMockUsersGetOneHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminMockUsersGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMockUsersGetOneHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMockUsersGetOneHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get one mock user: wallet balance + live Plaee positions and open orders
 */

export function useAdminMockUsersGetOne<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMockUsersGetOneHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMockUsersGetOneHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminMockUsersGetOneQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Hard-delete a mock user and its wallet/Plaee rows
 */
export const useAdminMockUsersRemoveHook = () => {
  const adminMockUsersRemove = useCustomInstance<DeleteMockUserResponseDto>();

  return useCallback(
    (userId: string) => {
      return adminMockUsersRemove({ url: `/admin/mock-users/${userId}`, method: 'DELETE' });
    },
    [adminMockUsersRemove],
  );
};

export const useAdminMockUsersRemoveMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminMockUsersRemoveHook>>>,
    TError,
    { userId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminMockUsersRemoveHook>>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationKey = ['adminMockUsersRemove'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminMockUsersRemove = useAdminMockUsersRemoveHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminMockUsersRemoveHook>>>,
    { userId: string }
  > = (props) => {
    const { userId } = props ?? {};

    return adminMockUsersRemove(userId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminMockUsersRemoveMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminMockUsersRemoveHook>>>
>;

export type AdminMockUsersRemoveMutationError = unknown;

/**
 * @summary Hard-delete a mock user and its wallet/Plaee rows
 */
export const useAdminMockUsersRemove = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminMockUsersRemoveHook>>>,
      TError,
      { userId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminMockUsersRemoveHook>>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationOptions = useAdminMockUsersRemoveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Set a mock user wallet to a target balance via ADMIN_ADJUSTMENT (locked ledger)
 */
export const useAdminMockUsersFundHook = () => {
  const adminMockUsersFund = useCustomInstance<FundMockUserResponseDto>();

  return useCallback(
    (userId: string, fundMockUserDto: FundMockUserDto) => {
      return adminMockUsersFund({
        url: `/admin/mock-users/${userId}/wallet`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: fundMockUserDto,
      });
    },
    [adminMockUsersFund],
  );
};

export const useAdminMockUsersFundMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminMockUsersFundHook>>>,
    TError,
    { userId: string; data: FundMockUserDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminMockUsersFundHook>>>,
  TError,
  { userId: string; data: FundMockUserDto },
  TContext
> => {
  const mutationKey = ['adminMockUsersFund'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminMockUsersFund = useAdminMockUsersFundHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminMockUsersFundHook>>>,
    { userId: string; data: FundMockUserDto }
  > = (props) => {
    const { userId, data } = props ?? {};

    return adminMockUsersFund(userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminMockUsersFundMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminMockUsersFundHook>>>
>;
export type AdminMockUsersFundMutationBody = FundMockUserDto;
export type AdminMockUsersFundMutationError = unknown;

/**
 * @summary Set a mock user wallet to a target balance via ADMIN_ADJUSTMENT (locked ledger)
 */
export const useAdminMockUsersFund = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminMockUsersFundHook>>>,
      TError,
      { userId: string; data: FundMockUserDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminMockUsersFundHook>>>,
  TError,
  { userId: string; data: FundMockUserDto },
  TContext
> => {
  const mutationOptions = useAdminMockUsersFundMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Place a buy/sell (YES/NO) order for a mock user via PlaeeOrderService.placeOrder
 */
export const useAdminMockUsersPlaceOrderHook = () => {
  const adminMockUsersPlaceOrder = useCustomInstance<MockOrderResultDto>();

  return useCallback(
    (userId: string, placeMockOrderDto: PlaceMockOrderDto, signal?: AbortSignal) => {
      return adminMockUsersPlaceOrder({
        url: `/admin/mock-users/${userId}/orders`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: placeMockOrderDto,
        signal,
      });
    },
    [adminMockUsersPlaceOrder],
  );
};

export const useAdminMockUsersPlaceOrderMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminMockUsersPlaceOrderHook>>>,
    TError,
    { userId: string; data: PlaceMockOrderDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminMockUsersPlaceOrderHook>>>,
  TError,
  { userId: string; data: PlaceMockOrderDto },
  TContext
> => {
  const mutationKey = ['adminMockUsersPlaceOrder'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminMockUsersPlaceOrder = useAdminMockUsersPlaceOrderHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminMockUsersPlaceOrderHook>>>,
    { userId: string; data: PlaceMockOrderDto }
  > = (props) => {
    const { userId, data } = props ?? {};

    return adminMockUsersPlaceOrder(userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminMockUsersPlaceOrderMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminMockUsersPlaceOrderHook>>>
>;
export type AdminMockUsersPlaceOrderMutationBody = PlaceMockOrderDto;
export type AdminMockUsersPlaceOrderMutationError = unknown;

/**
 * @summary Place a buy/sell (YES/NO) order for a mock user via PlaeeOrderService.placeOrder
 */
export const useAdminMockUsersPlaceOrder = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminMockUsersPlaceOrderHook>>>,
      TError,
      { userId: string; data: PlaceMockOrderDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminMockUsersPlaceOrderHook>>>,
  TError,
  { userId: string; data: PlaceMockOrderDto },
  TContext
> => {
  const mutationOptions = useAdminMockUsersPlaceOrderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Ledger-safe reset: cancel open orders and zero the wallet, keep the user
 */
export const useAdminMockUsersResetHook = () => {
  const adminMockUsersReset = useCustomInstance<MockUserDetailDto>();

  return useCallback(
    (userId: string, signal?: AbortSignal) => {
      return adminMockUsersReset({ url: `/admin/mock-users/${userId}/reset`, method: 'POST', signal });
    },
    [adminMockUsersReset],
  );
};

export const useAdminMockUsersResetMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminMockUsersResetHook>>>,
    TError,
    { userId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminMockUsersResetHook>>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationKey = ['adminMockUsersReset'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminMockUsersReset = useAdminMockUsersResetHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminMockUsersResetHook>>>,
    { userId: string }
  > = (props) => {
    const { userId } = props ?? {};

    return adminMockUsersReset(userId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminMockUsersResetMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminMockUsersResetHook>>>
>;

export type AdminMockUsersResetMutationError = unknown;

/**
 * @summary Ledger-safe reset: cancel open orders and zero the wallet, keep the user
 */
export const useAdminMockUsersReset = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminMockUsersResetHook>>>,
      TError,
      { userId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminMockUsersResetHook>>>,
  TError,
  { userId: string },
  TContext
> => {
  const mutationOptions = useAdminMockUsersResetMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get the current random trading session config + live status
 */
export const useMockTradingSessionGetStatusHook = () => {
  const mockTradingSessionGetStatus = useCustomInstance<TradingSessionStatusDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return mockTradingSessionGetStatus({ url: `/admin/mock-users/trading-session`, method: 'GET', signal });
    },
    [mockTradingSessionGetStatus],
  );
};

export const getMockTradingSessionGetStatusQueryKey = () => {
  return [`/admin/mock-users/trading-session`] as const;
};

export const useMockTradingSessionGetStatusQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useMockTradingSessionGetStatusHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMockTradingSessionGetStatusHook>>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMockTradingSessionGetStatusQueryKey();

  const mockTradingSessionGetStatus = useMockTradingSessionGetStatusHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useMockTradingSessionGetStatusHook>>>> = ({ signal }) =>
    mockTradingSessionGetStatus(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useMockTradingSessionGetStatusHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type MockTradingSessionGetStatusQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useMockTradingSessionGetStatusHook>>>
>;
export type MockTradingSessionGetStatusQueryError = unknown;

export function useMockTradingSessionGetStatus<
  TData = Awaited<ReturnType<ReturnType<typeof useMockTradingSessionGetStatusHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMockTradingSessionGetStatusHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useMockTradingSessionGetStatusHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useMockTradingSessionGetStatusHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMockTradingSessionGetStatus<
  TData = Awaited<ReturnType<ReturnType<typeof useMockTradingSessionGetStatusHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMockTradingSessionGetStatusHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useMockTradingSessionGetStatusHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useMockTradingSessionGetStatusHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMockTradingSessionGetStatus<
  TData = Awaited<ReturnType<ReturnType<typeof useMockTradingSessionGetStatusHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMockTradingSessionGetStatusHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the current random trading session config + live status
 */

export function useMockTradingSessionGetStatus<
  TData = Awaited<ReturnType<ReturnType<typeof useMockTradingSessionGetStatusHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMockTradingSessionGetStatusHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useMockTradingSessionGetStatusQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Count of active, tradeable market outcomes the engine would auto-trade
 */
export const useMockTradingSessionActiveOutcomesHook = () => {
  const mockTradingSessionActiveOutcomes = useCustomInstance<ActiveOutcomesDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return mockTradingSessionActiveOutcomes({
        url: `/admin/mock-users/trading-session/active-outcomes`,
        method: 'GET',
        signal,
      });
    },
    [mockTradingSessionActiveOutcomes],
  );
};

export const getMockTradingSessionActiveOutcomesQueryKey = () => {
  return [`/admin/mock-users/trading-session/active-outcomes`] as const;
};

export const useMockTradingSessionActiveOutcomesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useMockTradingSessionActiveOutcomesHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMockTradingSessionActiveOutcomesHook>>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMockTradingSessionActiveOutcomesQueryKey();

  const mockTradingSessionActiveOutcomes = useMockTradingSessionActiveOutcomesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useMockTradingSessionActiveOutcomesHook>>>> = ({
    signal,
  }) => mockTradingSessionActiveOutcomes(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useMockTradingSessionActiveOutcomesHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type MockTradingSessionActiveOutcomesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useMockTradingSessionActiveOutcomesHook>>>
>;
export type MockTradingSessionActiveOutcomesQueryError = unknown;

export function useMockTradingSessionActiveOutcomes<
  TData = Awaited<ReturnType<ReturnType<typeof useMockTradingSessionActiveOutcomesHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMockTradingSessionActiveOutcomesHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useMockTradingSessionActiveOutcomesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useMockTradingSessionActiveOutcomesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMockTradingSessionActiveOutcomes<
  TData = Awaited<ReturnType<ReturnType<typeof useMockTradingSessionActiveOutcomesHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMockTradingSessionActiveOutcomesHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useMockTradingSessionActiveOutcomesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useMockTradingSessionActiveOutcomesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMockTradingSessionActiveOutcomes<
  TData = Awaited<ReturnType<ReturnType<typeof useMockTradingSessionActiveOutcomesHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMockTradingSessionActiveOutcomesHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Count of active, tradeable market outcomes the engine would auto-trade
 */

export function useMockTradingSessionActiveOutcomes<
  TData = Awaited<ReturnType<ReturnType<typeof useMockTradingSessionActiveOutcomesHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMockTradingSessionActiveOutcomesHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useMockTradingSessionActiveOutcomesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary The live snake series snake mode would trade right now (spot vs price-to-beat per series)
 */
export const useMockTradingSessionSnakeTargetsHook = () => {
  const mockTradingSessionSnakeTargets = useCustomInstance<SnakeTargetsDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return mockTradingSessionSnakeTargets({
        url: `/admin/mock-users/trading-session/snake-targets`,
        method: 'GET',
        signal,
      });
    },
    [mockTradingSessionSnakeTargets],
  );
};

export const getMockTradingSessionSnakeTargetsQueryKey = () => {
  return [`/admin/mock-users/trading-session/snake-targets`] as const;
};

export const useMockTradingSessionSnakeTargetsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useMockTradingSessionSnakeTargetsHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMockTradingSessionSnakeTargetsHook>>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMockTradingSessionSnakeTargetsQueryKey();

  const mockTradingSessionSnakeTargets = useMockTradingSessionSnakeTargetsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useMockTradingSessionSnakeTargetsHook>>>> = ({
    signal,
  }) => mockTradingSessionSnakeTargets(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useMockTradingSessionSnakeTargetsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type MockTradingSessionSnakeTargetsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useMockTradingSessionSnakeTargetsHook>>>
>;
export type MockTradingSessionSnakeTargetsQueryError = unknown;

export function useMockTradingSessionSnakeTargets<
  TData = Awaited<ReturnType<ReturnType<typeof useMockTradingSessionSnakeTargetsHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMockTradingSessionSnakeTargetsHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useMockTradingSessionSnakeTargetsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useMockTradingSessionSnakeTargetsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMockTradingSessionSnakeTargets<
  TData = Awaited<ReturnType<ReturnType<typeof useMockTradingSessionSnakeTargetsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMockTradingSessionSnakeTargetsHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useMockTradingSessionSnakeTargetsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useMockTradingSessionSnakeTargetsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMockTradingSessionSnakeTargets<
  TData = Awaited<ReturnType<ReturnType<typeof useMockTradingSessionSnakeTargetsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMockTradingSessionSnakeTargetsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary The live snake series snake mode would trade right now (spot vs price-to-beat per series)
 */

export function useMockTradingSessionSnakeTargets<
  TData = Awaited<ReturnType<ReturnType<typeof useMockTradingSessionSnakeTargetsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMockTradingSessionSnakeTargetsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useMockTradingSessionSnakeTargetsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Start a continuous random trading session across a mock-user cohort
 */
export const useMockTradingSessionStartHook = () => {
  const mockTradingSessionStart = useCustomInstance<TradingSessionStatusDto>();

  return useCallback(
    (startTradingSessionDto: StartTradingSessionDto, signal?: AbortSignal) => {
      return mockTradingSessionStart({
        url: `/admin/mock-users/trading-session/start`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: startTradingSessionDto,
        signal,
      });
    },
    [mockTradingSessionStart],
  );
};

export const useMockTradingSessionStartMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useMockTradingSessionStartHook>>>,
    TError,
    { data: StartTradingSessionDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useMockTradingSessionStartHook>>>,
  TError,
  { data: StartTradingSessionDto },
  TContext
> => {
  const mutationKey = ['mockTradingSessionStart'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mockTradingSessionStart = useMockTradingSessionStartHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useMockTradingSessionStartHook>>>,
    { data: StartTradingSessionDto }
  > = (props) => {
    const { data } = props ?? {};

    return mockTradingSessionStart(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type MockTradingSessionStartMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useMockTradingSessionStartHook>>>
>;
export type MockTradingSessionStartMutationBody = StartTradingSessionDto;
export type MockTradingSessionStartMutationError = unknown;

/**
 * @summary Start a continuous random trading session across a mock-user cohort
 */
export const useMockTradingSessionStart = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useMockTradingSessionStartHook>>>,
      TError,
      { data: StartTradingSessionDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useMockTradingSessionStartHook>>>,
  TError,
  { data: StartTradingSessionDto },
  TContext
> => {
  const mutationOptions = useMockTradingSessionStartMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Stop the running session (optionally cancel participants’ open orders)
 */
export const useMockTradingSessionStopHook = () => {
  const mockTradingSessionStop = useCustomInstance<TradingSessionStatusDto>();

  return useCallback(
    (stopTradingSessionDto: StopTradingSessionDto, signal?: AbortSignal) => {
      return mockTradingSessionStop({
        url: `/admin/mock-users/trading-session/stop`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: stopTradingSessionDto,
        signal,
      });
    },
    [mockTradingSessionStop],
  );
};

export const useMockTradingSessionStopMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useMockTradingSessionStopHook>>>,
    TError,
    { data: StopTradingSessionDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useMockTradingSessionStopHook>>>,
  TError,
  { data: StopTradingSessionDto },
  TContext
> => {
  const mutationKey = ['mockTradingSessionStop'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mockTradingSessionStop = useMockTradingSessionStopHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useMockTradingSessionStopHook>>>,
    { data: StopTradingSessionDto }
  > = (props) => {
    const { data } = props ?? {};

    return mockTradingSessionStop(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type MockTradingSessionStopMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useMockTradingSessionStopHook>>>
>;
export type MockTradingSessionStopMutationBody = StopTradingSessionDto;
export type MockTradingSessionStopMutationError = unknown;

/**
 * @summary Stop the running session (optionally cancel participants’ open orders)
 */
export const useMockTradingSessionStop = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useMockTradingSessionStopHook>>>,
      TError,
      { data: StopTradingSessionDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useMockTradingSessionStopHook>>>,
  TError,
  { data: StopTradingSessionDto },
  TContext
> => {
  const mutationOptions = useMockTradingSessionStopMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Available snake currencies — distinct crypto instruments with visible+active snake markets and their resolution periods (closest-first)
 */
export const useSnakeMarketsFindCurrenciesHook = () => {
  const snakeMarketsFindCurrencies = useCustomInstance<SnakeCurrenciesResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return snakeMarketsFindCurrencies({ url: `/prediction-market/snake/currencies`, method: 'GET', signal });
    },
    [snakeMarketsFindCurrencies],
  );
};

export const getSnakeMarketsFindCurrenciesQueryKey = () => {
  return [`/prediction-market/snake/currencies`] as const;
};

export const useSnakeMarketsFindCurrenciesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindCurrenciesHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindCurrenciesHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSnakeMarketsFindCurrenciesQueryKey();

  const snakeMarketsFindCurrencies = useSnakeMarketsFindCurrenciesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindCurrenciesHook>>>> = ({ signal }) =>
    snakeMarketsFindCurrencies(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindCurrenciesHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SnakeMarketsFindCurrenciesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindCurrenciesHook>>>
>;
export type SnakeMarketsFindCurrenciesQueryError = unknown;

export function useSnakeMarketsFindCurrencies<
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindCurrenciesHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindCurrenciesHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindCurrenciesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindCurrenciesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSnakeMarketsFindCurrencies<
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindCurrenciesHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindCurrenciesHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindCurrenciesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindCurrenciesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSnakeMarketsFindCurrencies<
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindCurrenciesHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindCurrenciesHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Available snake currencies — distinct crypto instruments with visible+active snake markets and their resolution periods (closest-first)
 */

export function useSnakeMarketsFindCurrencies<
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindCurrenciesHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindCurrenciesHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useSnakeMarketsFindCurrenciesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Current "price to beat" market for a series — the active instance whose strike is closest to the prior resolution
 */
export const useSnakeMarketsFindSeriesHook = () => {
  const snakeMarketsFindSeries = useCustomInstance<SnakeSeriesResponseDto>();

  return useCallback(
    (params: SnakeMarketsFindSeriesParams, signal?: AbortSignal) => {
      return snakeMarketsFindSeries({ url: `/prediction-market/snake/series`, method: 'GET', params, signal });
    },
    [snakeMarketsFindSeries],
  );
};

export const getSnakeMarketsFindSeriesQueryKey = (params: SnakeMarketsFindSeriesParams) => {
  return [`/prediction-market/snake/series`, ...(params ? [params] : [])] as const;
};

export const useSnakeMarketsFindSeriesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHook>>>,
  TError = unknown,
>(
  params: SnakeMarketsFindSeriesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSnakeMarketsFindSeriesQueryKey(params);

  const snakeMarketsFindSeries = useSnakeMarketsFindSeriesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHook>>>> = ({ signal }) =>
    snakeMarketsFindSeries(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SnakeMarketsFindSeriesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHook>>>
>;
export type SnakeMarketsFindSeriesQueryError = unknown;

export function useSnakeMarketsFindSeries<
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHook>>>,
  TError = unknown,
>(
  params: SnakeMarketsFindSeriesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSnakeMarketsFindSeries<
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHook>>>,
  TError = unknown,
>(
  params: SnakeMarketsFindSeriesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSnakeMarketsFindSeries<
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHook>>>,
  TError = unknown,
>(
  params: SnakeMarketsFindSeriesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Current "price to beat" market for a series — the active instance whose strike is closest to the prior resolution
 */

export function useSnakeMarketsFindSeries<
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHook>>>,
  TError = unknown,
>(
  params: SnakeMarketsFindSeriesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useSnakeMarketsFindSeriesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Series timeline — recent settled instances (newest-first) plus the current/upcoming instance summary
 */
export const useSnakeMarketsFindSeriesHistoryHook = () => {
  const snakeMarketsFindSeriesHistory = useCustomInstance<SnakeSeriesHistoryResponseDto>();

  return useCallback(
    (params: SnakeMarketsFindSeriesHistoryParams, signal?: AbortSignal) => {
      return snakeMarketsFindSeriesHistory({
        url: `/prediction-market/snake/series/history`,
        method: 'GET',
        params,
        signal,
      });
    },
    [snakeMarketsFindSeriesHistory],
  );
};

export const getSnakeMarketsFindSeriesHistoryQueryKey = (params: SnakeMarketsFindSeriesHistoryParams) => {
  return [`/prediction-market/snake/series/history`, ...(params ? [params] : [])] as const;
};

export const useSnakeMarketsFindSeriesHistoryQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHistoryHook>>>,
  TError = unknown,
>(
  params: SnakeMarketsFindSeriesHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHistoryHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSnakeMarketsFindSeriesHistoryQueryKey(params);

  const snakeMarketsFindSeriesHistory = useSnakeMarketsFindSeriesHistoryHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHistoryHook>>>> = ({
    signal,
  }) => snakeMarketsFindSeriesHistory(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHistoryHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SnakeMarketsFindSeriesHistoryQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHistoryHook>>>
>;
export type SnakeMarketsFindSeriesHistoryQueryError = unknown;

export function useSnakeMarketsFindSeriesHistory<
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHistoryHook>>>,
  TError = unknown,
>(
  params: SnakeMarketsFindSeriesHistoryParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHistoryHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHistoryHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHistoryHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSnakeMarketsFindSeriesHistory<
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHistoryHook>>>,
  TError = unknown,
>(
  params: SnakeMarketsFindSeriesHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHistoryHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHistoryHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHistoryHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSnakeMarketsFindSeriesHistory<
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHistoryHook>>>,
  TError = unknown,
>(
  params: SnakeMarketsFindSeriesHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHistoryHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Series timeline — recent settled instances (newest-first) plus the current/upcoming instance summary
 */

export function useSnakeMarketsFindSeriesHistory<
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHistoryHook>>>,
  TError = unknown,
>(
  params: SnakeMarketsFindSeriesHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindSeriesHistoryHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useSnakeMarketsFindSeriesHistoryQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Price history for the series' current instance strike outcome (proxied from Plaee)
 */
export const useSnakeMarketsGetSeriesPriceHistoryHook = () => {
  const snakeMarketsGetSeriesPriceHistory = useCustomInstance<PriceHistoryResponseDto>();

  return useCallback(
    (params: SnakeMarketsGetSeriesPriceHistoryParams, signal?: AbortSignal) => {
      return snakeMarketsGetSeriesPriceHistory({
        url: `/prediction-market/snake/series/price-history`,
        method: 'GET',
        params,
        signal,
      });
    },
    [snakeMarketsGetSeriesPriceHistory],
  );
};

export const getSnakeMarketsGetSeriesPriceHistoryQueryKey = (params: SnakeMarketsGetSeriesPriceHistoryParams) => {
  return [`/prediction-market/snake/series/price-history`, ...(params ? [params] : [])] as const;
};

export const useSnakeMarketsGetSeriesPriceHistoryQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetSeriesPriceHistoryHook>>>,
  TError = unknown,
>(
  params: SnakeMarketsGetSeriesPriceHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetSeriesPriceHistoryHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSnakeMarketsGetSeriesPriceHistoryQueryKey(params);

  const snakeMarketsGetSeriesPriceHistory = useSnakeMarketsGetSeriesPriceHistoryHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetSeriesPriceHistoryHook>>>> = ({
    signal,
  }) => snakeMarketsGetSeriesPriceHistory(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetSeriesPriceHistoryHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SnakeMarketsGetSeriesPriceHistoryQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetSeriesPriceHistoryHook>>>
>;
export type SnakeMarketsGetSeriesPriceHistoryQueryError = unknown;

export function useSnakeMarketsGetSeriesPriceHistory<
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetSeriesPriceHistoryHook>>>,
  TError = unknown,
>(
  params: SnakeMarketsGetSeriesPriceHistoryParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetSeriesPriceHistoryHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetSeriesPriceHistoryHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetSeriesPriceHistoryHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSnakeMarketsGetSeriesPriceHistory<
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetSeriesPriceHistoryHook>>>,
  TError = unknown,
>(
  params: SnakeMarketsGetSeriesPriceHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetSeriesPriceHistoryHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetSeriesPriceHistoryHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetSeriesPriceHistoryHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSnakeMarketsGetSeriesPriceHistory<
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetSeriesPriceHistoryHook>>>,
  TError = unknown,
>(
  params: SnakeMarketsGetSeriesPriceHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetSeriesPriceHistoryHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Price history for the series' current instance strike outcome (proxied from Plaee)
 */

export function useSnakeMarketsGetSeriesPriceHistory<
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetSeriesPriceHistoryHook>>>,
  TError = unknown,
>(
  params: SnakeMarketsGetSeriesPriceHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetSeriesPriceHistoryHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useSnakeMarketsGetSeriesPriceHistoryQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Frozen past view of a settled snake market — strike, settled price, result, and the underlying dollar candles for the window
 */
export const useSnakeMarketsFindPastMarketHook = () => {
  const snakeMarketsFindPastMarket = useCustomInstance<SnakePastMarketResponseDto>();

  return useCallback(
    (marketId: string, signal?: AbortSignal) => {
      return snakeMarketsFindPastMarket({ url: `/prediction-market/snake/past-market/${marketId}`, method: 'GET', signal });
    },
    [snakeMarketsFindPastMarket],
  );
};

export const getSnakeMarketsFindPastMarketQueryKey = (marketId: string) => {
  return [`/prediction-market/snake/past-market/${marketId}`] as const;
};

export const useSnakeMarketsFindPastMarketQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindPastMarketHook>>>,
  TError = unknown,
>(
  marketId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindPastMarketHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSnakeMarketsFindPastMarketQueryKey(marketId);

  const snakeMarketsFindPastMarket = useSnakeMarketsFindPastMarketHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindPastMarketHook>>>> = ({ signal }) =>
    snakeMarketsFindPastMarket(marketId, signal);

  return { queryKey, queryFn, enabled: !!marketId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindPastMarketHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SnakeMarketsFindPastMarketQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindPastMarketHook>>>
>;
export type SnakeMarketsFindPastMarketQueryError = unknown;

export function useSnakeMarketsFindPastMarket<
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindPastMarketHook>>>,
  TError = unknown,
>(
  marketId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindPastMarketHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindPastMarketHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindPastMarketHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSnakeMarketsFindPastMarket<
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindPastMarketHook>>>,
  TError = unknown,
>(
  marketId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindPastMarketHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindPastMarketHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindPastMarketHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSnakeMarketsFindPastMarket<
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindPastMarketHook>>>,
  TError = unknown,
>(
  marketId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindPastMarketHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Frozen past view of a settled snake market — strike, settled price, result, and the underlying dollar candles for the window
 */

export function useSnakeMarketsFindPastMarket<
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindPastMarketHook>>>,
  TError = unknown,
>(
  marketId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsFindPastMarketHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useSnakeMarketsFindPastMarketQueryOptions(marketId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Snake market-page info tabs in fixed order with their default open/closed state
 */
export const useSnakeMarketsGetTabsHook = () => {
  const snakeMarketsGetTabs = useCustomInstance<SnakeTabResponseDto[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return snakeMarketsGetTabs({ url: `/prediction-market/snake/config/tabs`, method: 'GET', signal });
    },
    [snakeMarketsGetTabs],
  );
};

export const getSnakeMarketsGetTabsQueryKey = () => {
  return [`/prediction-market/snake/config/tabs`] as const;
};

export const useSnakeMarketsGetTabsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetTabsHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetTabsHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSnakeMarketsGetTabsQueryKey();

  const snakeMarketsGetTabs = useSnakeMarketsGetTabsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetTabsHook>>>> = ({ signal }) =>
    snakeMarketsGetTabs(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetTabsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SnakeMarketsGetTabsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetTabsHook>>>>;
export type SnakeMarketsGetTabsQueryError = unknown;

export function useSnakeMarketsGetTabs<
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetTabsHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetTabsHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetTabsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetTabsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSnakeMarketsGetTabs<
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetTabsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetTabsHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetTabsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetTabsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSnakeMarketsGetTabs<
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetTabsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetTabsHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Snake market-page info tabs in fixed order with their default open/closed state
 */

export function useSnakeMarketsGetTabs<
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetTabsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsGetTabsHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useSnakeMarketsGetTabsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Resolve the snake buy-in price-cube values for the current user
 */
export const useSnakeMarketsResolvePriceCubeHook = () => {
  const snakeMarketsResolvePriceCube = useCustomInstance<PriceCubeResolvedDto>();

  return useCallback(
    (params?: SnakeMarketsResolvePriceCubeParams, signal?: AbortSignal) => {
      return snakeMarketsResolvePriceCube({ url: `/prediction-market/snake/price-cubes`, method: 'GET', params, signal });
    },
    [snakeMarketsResolvePriceCube],
  );
};

export const getSnakeMarketsResolvePriceCubeQueryKey = (params?: SnakeMarketsResolvePriceCubeParams) => {
  return [`/prediction-market/snake/price-cubes`, ...(params ? [params] : [])] as const;
};

export const useSnakeMarketsResolvePriceCubeQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsResolvePriceCubeHook>>>,
  TError = unknown,
>(
  params?: SnakeMarketsResolvePriceCubeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsResolvePriceCubeHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSnakeMarketsResolvePriceCubeQueryKey(params);

  const snakeMarketsResolvePriceCube = useSnakeMarketsResolvePriceCubeHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsResolvePriceCubeHook>>>> = ({ signal }) =>
    snakeMarketsResolvePriceCube(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useSnakeMarketsResolvePriceCubeHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SnakeMarketsResolvePriceCubeQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useSnakeMarketsResolvePriceCubeHook>>>
>;
export type SnakeMarketsResolvePriceCubeQueryError = unknown;

export function useSnakeMarketsResolvePriceCube<
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsResolvePriceCubeHook>>>,
  TError = unknown,
>(
  params: undefined | SnakeMarketsResolvePriceCubeParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsResolvePriceCubeHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useSnakeMarketsResolvePriceCubeHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useSnakeMarketsResolvePriceCubeHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSnakeMarketsResolvePriceCube<
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsResolvePriceCubeHook>>>,
  TError = unknown,
>(
  params?: SnakeMarketsResolvePriceCubeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsResolvePriceCubeHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useSnakeMarketsResolvePriceCubeHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useSnakeMarketsResolvePriceCubeHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSnakeMarketsResolvePriceCube<
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsResolvePriceCubeHook>>>,
  TError = unknown,
>(
  params?: SnakeMarketsResolvePriceCubeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsResolvePriceCubeHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Resolve the snake buy-in price-cube values for the current user
 */

export function useSnakeMarketsResolvePriceCube<
  TData = Awaited<ReturnType<ReturnType<typeof useSnakeMarketsResolvePriceCubeHook>>>,
  TError = unknown,
>(
  params?: SnakeMarketsResolvePriceCubeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useSnakeMarketsResolvePriceCubeHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useSnakeMarketsResolvePriceCubeQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get the market-page sections in display order
 */
export const usePredictionMarketConfigGetSectionsHook = () => {
  const predictionMarketConfigGetSections = useCustomInstance<SectionResponseDto[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return predictionMarketConfigGetSections({ url: `/prediction-market/config/sections`, method: 'GET', signal });
    },
    [predictionMarketConfigGetSections],
  );
};

export const getPredictionMarketConfigGetSectionsQueryKey = () => {
  return [`/prediction-market/config/sections`] as const;
};

export const usePredictionMarketConfigGetSectionsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigGetSectionsHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigGetSectionsHook>>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPredictionMarketConfigGetSectionsQueryKey();

  const predictionMarketConfigGetSections = usePredictionMarketConfigGetSectionsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigGetSectionsHook>>>> = ({
    signal,
  }) => predictionMarketConfigGetSections(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigGetSectionsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PredictionMarketConfigGetSectionsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigGetSectionsHook>>>
>;
export type PredictionMarketConfigGetSectionsQueryError = unknown;

export function usePredictionMarketConfigGetSections<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigGetSectionsHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigGetSectionsHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigGetSectionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigGetSectionsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePredictionMarketConfigGetSections<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigGetSectionsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigGetSectionsHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigGetSectionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigGetSectionsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePredictionMarketConfigGetSections<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigGetSectionsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigGetSectionsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the market-page sections in display order
 */

export function usePredictionMarketConfigGetSections<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigGetSectionsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigGetSectionsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = usePredictionMarketConfigGetSectionsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Resolve the buy-in price-cube values for the current user
 */
export const usePredictionMarketConfigResolvePriceCubeHook = () => {
  const predictionMarketConfigResolvePriceCube = useCustomInstance<PriceCubeResolvedDto>();

  return useCallback(
    (params: PredictionMarketConfigResolvePriceCubeParams, signal?: AbortSignal) => {
      return predictionMarketConfigResolvePriceCube({
        url: `/prediction-market/price-cubes`,
        method: 'GET',
        params,
        signal,
      });
    },
    [predictionMarketConfigResolvePriceCube],
  );
};

export const getPredictionMarketConfigResolvePriceCubeQueryKey = (params: PredictionMarketConfigResolvePriceCubeParams) => {
  return [`/prediction-market/price-cubes`, ...(params ? [params] : [])] as const;
};

export const usePredictionMarketConfigResolvePriceCubeQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigResolvePriceCubeHook>>>,
  TError = unknown,
>(
  params: PredictionMarketConfigResolvePriceCubeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigResolvePriceCubeHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPredictionMarketConfigResolvePriceCubeQueryKey(params);

  const predictionMarketConfigResolvePriceCube = usePredictionMarketConfigResolvePriceCubeHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigResolvePriceCubeHook>>>> = ({
    signal,
  }) => predictionMarketConfigResolvePriceCube(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigResolvePriceCubeHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PredictionMarketConfigResolvePriceCubeQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigResolvePriceCubeHook>>>
>;
export type PredictionMarketConfigResolvePriceCubeQueryError = unknown;

export function usePredictionMarketConfigResolvePriceCube<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigResolvePriceCubeHook>>>,
  TError = unknown,
>(
  params: PredictionMarketConfigResolvePriceCubeParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigResolvePriceCubeHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigResolvePriceCubeHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigResolvePriceCubeHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePredictionMarketConfigResolvePriceCube<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigResolvePriceCubeHook>>>,
  TError = unknown,
>(
  params: PredictionMarketConfigResolvePriceCubeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigResolvePriceCubeHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigResolvePriceCubeHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigResolvePriceCubeHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePredictionMarketConfigResolvePriceCube<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigResolvePriceCubeHook>>>,
  TError = unknown,
>(
  params: PredictionMarketConfigResolvePriceCubeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigResolvePriceCubeHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Resolve the buy-in price-cube values for the current user
 */

export function usePredictionMarketConfigResolvePriceCube<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigResolvePriceCubeHook>>>,
  TError = unknown,
>(
  params: PredictionMarketConfigResolvePriceCubeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketConfigResolvePriceCubeHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = usePredictionMarketConfigResolvePriceCubeQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Supported instruments available for trading (proxied from Plaee)
 */
export const usePredictionMarketInstrumentsListInstrumentsHook = () => {
  const predictionMarketInstrumentsListInstruments = useCustomInstance<InstrumentListResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return predictionMarketInstrumentsListInstruments({ url: `/prediction-market/instruments`, method: 'GET', signal });
    },
    [predictionMarketInstrumentsListInstruments],
  );
};

export const getPredictionMarketInstrumentsListInstrumentsQueryKey = () => {
  return [`/prediction-market/instruments`] as const;
};

export const usePredictionMarketInstrumentsListInstrumentsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsListInstrumentsHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsListInstrumentsHook>>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPredictionMarketInstrumentsListInstrumentsQueryKey();

  const predictionMarketInstrumentsListInstruments = usePredictionMarketInstrumentsListInstrumentsHook();

  const queryFn: QueryFunction<
    Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsListInstrumentsHook>>>
  > = ({ signal }) => predictionMarketInstrumentsListInstruments(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsListInstrumentsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PredictionMarketInstrumentsListInstrumentsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsListInstrumentsHook>>>
>;
export type PredictionMarketInstrumentsListInstrumentsQueryError = unknown;

export function usePredictionMarketInstrumentsListInstruments<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsListInstrumentsHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsListInstrumentsHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsListInstrumentsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsListInstrumentsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePredictionMarketInstrumentsListInstruments<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsListInstrumentsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsListInstrumentsHook>>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsListInstrumentsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsListInstrumentsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePredictionMarketInstrumentsListInstruments<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsListInstrumentsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsListInstrumentsHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Supported instruments available for trading (proxied from Plaee)
 */

export function usePredictionMarketInstrumentsListInstruments<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsListInstrumentsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsListInstrumentsHook>>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = usePredictionMarketInstrumentsListInstrumentsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Latest price snapshots for an instrument (proxied from Plaee)
 */
export const usePredictionMarketInstrumentsGetSnapshotsHook = () => {
  const predictionMarketInstrumentsGetSnapshots = useCustomInstance<InstrumentSnapshotsResponseDto>();

  return useCallback(
    (instrument: string, params?: PredictionMarketInstrumentsGetSnapshotsParams, signal?: AbortSignal) => {
      return predictionMarketInstrumentsGetSnapshots({
        url: `/prediction-market/instruments/${instrument}`,
        method: 'GET',
        params,
        signal,
      });
    },
    [predictionMarketInstrumentsGetSnapshots],
  );
};

export const getPredictionMarketInstrumentsGetSnapshotsQueryKey = (
  instrument: string,
  params?: PredictionMarketInstrumentsGetSnapshotsParams,
) => {
  return [`/prediction-market/instruments/${instrument}`, ...(params ? [params] : [])] as const;
};

export const usePredictionMarketInstrumentsGetSnapshotsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsGetSnapshotsHook>>>,
  TError = unknown,
>(
  instrument: string,
  params?: PredictionMarketInstrumentsGetSnapshotsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsGetSnapshotsHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPredictionMarketInstrumentsGetSnapshotsQueryKey(instrument, params);

  const predictionMarketInstrumentsGetSnapshots = usePredictionMarketInstrumentsGetSnapshotsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsGetSnapshotsHook>>>> = ({
    signal,
  }) => predictionMarketInstrumentsGetSnapshots(instrument, params, signal);

  return { queryKey, queryFn, enabled: !!instrument, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsGetSnapshotsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PredictionMarketInstrumentsGetSnapshotsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsGetSnapshotsHook>>>
>;
export type PredictionMarketInstrumentsGetSnapshotsQueryError = unknown;

export function usePredictionMarketInstrumentsGetSnapshots<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsGetSnapshotsHook>>>,
  TError = unknown,
>(
  instrument: string,
  params: undefined | PredictionMarketInstrumentsGetSnapshotsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsGetSnapshotsHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsGetSnapshotsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsGetSnapshotsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePredictionMarketInstrumentsGetSnapshots<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsGetSnapshotsHook>>>,
  TError = unknown,
>(
  instrument: string,
  params?: PredictionMarketInstrumentsGetSnapshotsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsGetSnapshotsHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsGetSnapshotsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsGetSnapshotsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePredictionMarketInstrumentsGetSnapshots<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsGetSnapshotsHook>>>,
  TError = unknown,
>(
  instrument: string,
  params?: PredictionMarketInstrumentsGetSnapshotsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsGetSnapshotsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Latest price snapshots for an instrument (proxied from Plaee)
 */

export function usePredictionMarketInstrumentsGetSnapshots<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsGetSnapshotsHook>>>,
  TError = unknown,
>(
  instrument: string,
  params?: PredictionMarketInstrumentsGetSnapshotsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketInstrumentsGetSnapshotsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = usePredictionMarketInstrumentsGetSnapshotsQueryOptions(instrument, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Per-type delivery + read aggregation (received / recipients / read / read-rate / last sent)
 */
export const useAdminNotificationsAggregationsHook = () => {
  const adminNotificationsAggregations = useCustomInstance<NotificationStatsResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminNotificationsAggregations({ url: `/admin/notifications/stats`, method: 'GET', signal });
    },
    [adminNotificationsAggregations],
  );
};

export const getAdminNotificationsAggregationsQueryKey = () => {
  return [`/admin/notifications/stats`] as const;
};

export const useAdminNotificationsAggregationsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminNotificationsAggregationsHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminNotificationsAggregationsHook>>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminNotificationsAggregationsQueryKey();

  const adminNotificationsAggregations = useAdminNotificationsAggregationsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminNotificationsAggregationsHook>>>> = ({
    signal,
  }) => adminNotificationsAggregations(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminNotificationsAggregationsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminNotificationsAggregationsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminNotificationsAggregationsHook>>>
>;
export type AdminNotificationsAggregationsQueryError = unknown;

export function useAdminNotificationsAggregations<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminNotificationsAggregationsHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminNotificationsAggregationsHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminNotificationsAggregationsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminNotificationsAggregationsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminNotificationsAggregations<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminNotificationsAggregationsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminNotificationsAggregationsHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminNotificationsAggregationsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminNotificationsAggregationsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminNotificationsAggregations<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminNotificationsAggregationsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminNotificationsAggregationsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Per-type delivery + read aggregation (received / recipients / read / read-rate / last sent)
 */

export function useAdminNotificationsAggregations<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminNotificationsAggregationsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminNotificationsAggregationsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminNotificationsAggregationsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary A single user’s recent notifications + per-type received/read/unread counts
 */
export const useAdminNotificationsForUserHook = () => {
  const adminNotificationsForUser = useCustomInstance<AdminUserNotificationsResponseDto>();

  return useCallback(
    (userId: string, signal?: AbortSignal) => {
      return adminNotificationsForUser({ url: `/admin/notifications/users/${userId}`, method: 'GET', signal });
    },
    [adminNotificationsForUser],
  );
};

export const getAdminNotificationsForUserQueryKey = (userId: string) => {
  return [`/admin/notifications/users/${userId}`] as const;
};

export const useAdminNotificationsForUserQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminNotificationsForUserHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminNotificationsForUserHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminNotificationsForUserQueryKey(userId);

  const adminNotificationsForUser = useAdminNotificationsForUserHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminNotificationsForUserHook>>>> = ({ signal }) =>
    adminNotificationsForUser(userId, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminNotificationsForUserHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminNotificationsForUserQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminNotificationsForUserHook>>>
>;
export type AdminNotificationsForUserQueryError = unknown;

export function useAdminNotificationsForUser<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminNotificationsForUserHook>>>,
  TError = unknown,
>(
  userId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminNotificationsForUserHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminNotificationsForUserHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminNotificationsForUserHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminNotificationsForUser<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminNotificationsForUserHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminNotificationsForUserHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminNotificationsForUserHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminNotificationsForUserHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminNotificationsForUser<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminNotificationsForUserHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminNotificationsForUserHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A single user’s recent notifications + per-type received/read/unread counts
 */

export function useAdminNotificationsForUser<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminNotificationsForUserHook>>>,
  TError = unknown,
>(
  userId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminNotificationsForUserHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminNotificationsForUserQueryOptions(userId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Send a personal message to one player (admin-broadcast)
 */
export const useAdminNotificationsSendToUserHook = () => {
  const adminNotificationsSendToUser = useCustomInstance<NotificationResponseDto>();

  return useCallback(
    (userId: string, sendUserNotificationDto: SendUserNotificationDto, signal?: AbortSignal) => {
      return adminNotificationsSendToUser({
        url: `/admin/notifications/users/${userId}`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: sendUserNotificationDto,
        signal,
      });
    },
    [adminNotificationsSendToUser],
  );
};

export const useAdminNotificationsSendToUserMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminNotificationsSendToUserHook>>>,
    TError,
    { userId: string; data: SendUserNotificationDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminNotificationsSendToUserHook>>>,
  TError,
  { userId: string; data: SendUserNotificationDto },
  TContext
> => {
  const mutationKey = ['adminNotificationsSendToUser'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminNotificationsSendToUser = useAdminNotificationsSendToUserHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminNotificationsSendToUserHook>>>,
    { userId: string; data: SendUserNotificationDto }
  > = (props) => {
    const { userId, data } = props ?? {};

    return adminNotificationsSendToUser(userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminNotificationsSendToUserMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminNotificationsSendToUserHook>>>
>;
export type AdminNotificationsSendToUserMutationBody = SendUserNotificationDto;
export type AdminNotificationsSendToUserMutationError = unknown;

/**
 * @summary Send a personal message to one player (admin-broadcast)
 */
export const useAdminNotificationsSendToUser = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminNotificationsSendToUserHook>>>,
      TError,
      { userId: string; data: SendUserNotificationDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminNotificationsSendToUserHook>>>,
  TError,
  { userId: string; data: SendUserNotificationDto },
  TContext
> => {
  const mutationOptions = useAdminNotificationsSendToUserMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get the singleton cross-type notification settings (general cooldown)
 */
export const useAdminNotificationsGetGlobalConfigHook = () => {
  const adminNotificationsGetGlobalConfig = useCustomInstance<NotificationGlobalConfigResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminNotificationsGetGlobalConfig({ url: `/admin/notifications/global-config`, method: 'GET', signal });
    },
    [adminNotificationsGetGlobalConfig],
  );
};

export const getAdminNotificationsGetGlobalConfigQueryKey = () => {
  return [`/admin/notifications/global-config`] as const;
};

export const useAdminNotificationsGetGlobalConfigQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminNotificationsGetGlobalConfigHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminNotificationsGetGlobalConfigHook>>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminNotificationsGetGlobalConfigQueryKey();

  const adminNotificationsGetGlobalConfig = useAdminNotificationsGetGlobalConfigHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminNotificationsGetGlobalConfigHook>>>> = ({
    signal,
  }) => adminNotificationsGetGlobalConfig(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminNotificationsGetGlobalConfigHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminNotificationsGetGlobalConfigQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminNotificationsGetGlobalConfigHook>>>
>;
export type AdminNotificationsGetGlobalConfigQueryError = unknown;

export function useAdminNotificationsGetGlobalConfig<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminNotificationsGetGlobalConfigHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminNotificationsGetGlobalConfigHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminNotificationsGetGlobalConfigHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminNotificationsGetGlobalConfigHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminNotificationsGetGlobalConfig<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminNotificationsGetGlobalConfigHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminNotificationsGetGlobalConfigHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminNotificationsGetGlobalConfigHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminNotificationsGetGlobalConfigHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminNotificationsGetGlobalConfig<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminNotificationsGetGlobalConfigHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminNotificationsGetGlobalConfigHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the singleton cross-type notification settings (general cooldown)
 */

export function useAdminNotificationsGetGlobalConfig<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminNotificationsGetGlobalConfigHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminNotificationsGetGlobalConfigHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminNotificationsGetGlobalConfigQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update the singleton cross-type notification settings (general cooldown)
 */
export const useAdminNotificationsUpdateGlobalConfigHook = () => {
  const adminNotificationsUpdateGlobalConfig = useCustomInstance<NotificationGlobalConfigResponseDto>();

  return useCallback(
    (updateNotificationGlobalConfigDto: UpdateNotificationGlobalConfigDto) => {
      return adminNotificationsUpdateGlobalConfig({
        url: `/admin/notifications/global-config`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateNotificationGlobalConfigDto,
      });
    },
    [adminNotificationsUpdateGlobalConfig],
  );
};

export const useAdminNotificationsUpdateGlobalConfigMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminNotificationsUpdateGlobalConfigHook>>>,
    TError,
    { data: UpdateNotificationGlobalConfigDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminNotificationsUpdateGlobalConfigHook>>>,
  TError,
  { data: UpdateNotificationGlobalConfigDto },
  TContext
> => {
  const mutationKey = ['adminNotificationsUpdateGlobalConfig'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminNotificationsUpdateGlobalConfig = useAdminNotificationsUpdateGlobalConfigHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminNotificationsUpdateGlobalConfigHook>>>,
    { data: UpdateNotificationGlobalConfigDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminNotificationsUpdateGlobalConfig(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminNotificationsUpdateGlobalConfigMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminNotificationsUpdateGlobalConfigHook>>>
>;
export type AdminNotificationsUpdateGlobalConfigMutationBody = UpdateNotificationGlobalConfigDto;
export type AdminNotificationsUpdateGlobalConfigMutationError = unknown;

/**
 * @summary Update the singleton cross-type notification settings (general cooldown)
 */
export const useAdminNotificationsUpdateGlobalConfig = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminNotificationsUpdateGlobalConfigHook>>>,
      TError,
      { data: UpdateNotificationGlobalConfigDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminNotificationsUpdateGlobalConfigHook>>>,
  TError,
  { data: UpdateNotificationGlobalConfigDto },
  TContext
> => {
  const mutationOptions = useAdminNotificationsUpdateGlobalConfigMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List the global config for every notification type
 */
export const useAdminNotificationsListConfigsHook = () => {
  const adminNotificationsListConfigs = useCustomInstance<NotificationConfigResponseDto[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminNotificationsListConfigs({ url: `/admin/notifications/configs`, method: 'GET', signal });
    },
    [adminNotificationsListConfigs],
  );
};

export const getAdminNotificationsListConfigsQueryKey = () => {
  return [`/admin/notifications/configs`] as const;
};

export const useAdminNotificationsListConfigsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminNotificationsListConfigsHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminNotificationsListConfigsHook>>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminNotificationsListConfigsQueryKey();

  const adminNotificationsListConfigs = useAdminNotificationsListConfigsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminNotificationsListConfigsHook>>>> = ({
    signal,
  }) => adminNotificationsListConfigs(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminNotificationsListConfigsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminNotificationsListConfigsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminNotificationsListConfigsHook>>>
>;
export type AdminNotificationsListConfigsQueryError = unknown;

export function useAdminNotificationsListConfigs<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminNotificationsListConfigsHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminNotificationsListConfigsHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminNotificationsListConfigsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminNotificationsListConfigsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminNotificationsListConfigs<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminNotificationsListConfigsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminNotificationsListConfigsHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminNotificationsListConfigsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminNotificationsListConfigsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminNotificationsListConfigs<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminNotificationsListConfigsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminNotificationsListConfigsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List the global config for every notification type
 */

export function useAdminNotificationsListConfigs<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminNotificationsListConfigsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminNotificationsListConfigsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminNotificationsListConfigsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Enable/disable a notification type or edit its params (global, all users)
 */
export const useAdminNotificationsUpdateConfigHook = () => {
  const adminNotificationsUpdateConfig = useCustomInstance<NotificationConfigResponseDto>();

  return useCallback(
    (type: string, updateNotificationConfigDto: UpdateNotificationConfigDto) => {
      return adminNotificationsUpdateConfig({
        url: `/admin/notifications/configs/${type}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateNotificationConfigDto,
      });
    },
    [adminNotificationsUpdateConfig],
  );
};

export const useAdminNotificationsUpdateConfigMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminNotificationsUpdateConfigHook>>>,
    TError,
    { type: string; data: UpdateNotificationConfigDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminNotificationsUpdateConfigHook>>>,
  TError,
  { type: string; data: UpdateNotificationConfigDto },
  TContext
> => {
  const mutationKey = ['adminNotificationsUpdateConfig'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminNotificationsUpdateConfig = useAdminNotificationsUpdateConfigHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminNotificationsUpdateConfigHook>>>,
    { type: string; data: UpdateNotificationConfigDto }
  > = (props) => {
    const { type, data } = props ?? {};

    return adminNotificationsUpdateConfig(type, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminNotificationsUpdateConfigMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminNotificationsUpdateConfigHook>>>
>;
export type AdminNotificationsUpdateConfigMutationBody = UpdateNotificationConfigDto;
export type AdminNotificationsUpdateConfigMutationError = unknown;

/**
 * @summary Enable/disable a notification type or edit its params (global, all users)
 */
export const useAdminNotificationsUpdateConfig = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminNotificationsUpdateConfigHook>>>,
      TError,
      { type: string; data: UpdateNotificationConfigDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminNotificationsUpdateConfigHook>>>,
  TError,
  { type: string; data: UpdateNotificationConfigDto },
  TContext
> => {
  const mutationOptions = useAdminNotificationsUpdateConfigMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Whether the notification feature is enabled for the caller (the UI hides the bell when off)
 */
export const useNotificationsFeatureStateHook = () => {
  const notificationsFeatureState = useCustomInstance<NotificationFeatureResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return notificationsFeatureState({ url: `/notifications/feature`, method: 'GET', signal });
    },
    [notificationsFeatureState],
  );
};

export const getNotificationsFeatureStateQueryKey = () => {
  return [`/notifications/feature`] as const;
};

export const useNotificationsFeatureStateQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useNotificationsFeatureStateHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useNotificationsFeatureStateHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getNotificationsFeatureStateQueryKey();

  const notificationsFeatureState = useNotificationsFeatureStateHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useNotificationsFeatureStateHook>>>> = ({ signal }) =>
    notificationsFeatureState(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useNotificationsFeatureStateHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type NotificationsFeatureStateQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useNotificationsFeatureStateHook>>>
>;
export type NotificationsFeatureStateQueryError = unknown;

export function useNotificationsFeatureState<
  TData = Awaited<ReturnType<ReturnType<typeof useNotificationsFeatureStateHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useNotificationsFeatureStateHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useNotificationsFeatureStateHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useNotificationsFeatureStateHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useNotificationsFeatureState<
  TData = Awaited<ReturnType<ReturnType<typeof useNotificationsFeatureStateHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useNotificationsFeatureStateHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useNotificationsFeatureStateHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useNotificationsFeatureStateHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useNotificationsFeatureState<
  TData = Awaited<ReturnType<ReturnType<typeof useNotificationsFeatureStateHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useNotificationsFeatureStateHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Whether the notification feature is enabled for the caller (the UI hides the bell when off)
 */

export function useNotificationsFeatureState<
  TData = Awaited<ReturnType<ReturnType<typeof useNotificationsFeatureStateHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useNotificationsFeatureStateHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useNotificationsFeatureStateQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List the caller’s notifications, newest first (cursor-paginated)
 */
export const useNotificationsListHook = () => {
  const notificationsList = useCustomInstance<NotificationListResponseDto>();

  return useCallback(
    (params?: NotificationsListParams, signal?: AbortSignal) => {
      return notificationsList({ url: `/notifications`, method: 'GET', params, signal });
    },
    [notificationsList],
  );
};

export const getNotificationsListQueryKey = (params?: NotificationsListParams) => {
  return [`/notifications`, ...(params ? [params] : [])] as const;
};

export const useNotificationsListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useNotificationsListHook>>>,
  TError = unknown,
>(
  params?: NotificationsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useNotificationsListHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getNotificationsListQueryKey(params);

  const notificationsList = useNotificationsListHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useNotificationsListHook>>>> = ({ signal }) =>
    notificationsList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useNotificationsListHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type NotificationsListQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useNotificationsListHook>>>>;
export type NotificationsListQueryError = unknown;

export function useNotificationsList<
  TData = Awaited<ReturnType<ReturnType<typeof useNotificationsListHook>>>,
  TError = unknown,
>(
  params: undefined | NotificationsListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useNotificationsListHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useNotificationsListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useNotificationsListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useNotificationsList<
  TData = Awaited<ReturnType<ReturnType<typeof useNotificationsListHook>>>,
  TError = unknown,
>(
  params?: NotificationsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useNotificationsListHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useNotificationsListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useNotificationsListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useNotificationsList<
  TData = Awaited<ReturnType<ReturnType<typeof useNotificationsListHook>>>,
  TError = unknown,
>(
  params?: NotificationsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useNotificationsListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List the caller’s notifications, newest first (cursor-paginated)
 */

export function useNotificationsList<
  TData = Awaited<ReturnType<ReturnType<typeof useNotificationsListHook>>>,
  TError = unknown,
>(
  params?: NotificationsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useNotificationsListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useNotificationsListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Unread notification count (optionally scoped to a tab) for the badge
 */
export const useNotificationsUnreadCountHook = () => {
  const notificationsUnreadCount = useCustomInstance<UnreadCountResponseDto>();

  return useCallback(
    (params?: NotificationsUnreadCountParams, signal?: AbortSignal) => {
      return notificationsUnreadCount({ url: `/notifications/unread-count`, method: 'GET', params, signal });
    },
    [notificationsUnreadCount],
  );
};

export const getNotificationsUnreadCountQueryKey = (params?: NotificationsUnreadCountParams) => {
  return [`/notifications/unread-count`, ...(params ? [params] : [])] as const;
};

export const useNotificationsUnreadCountQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountHook>>>,
  TError = unknown,
>(
  params?: NotificationsUnreadCountParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getNotificationsUnreadCountQueryKey(params);

  const notificationsUnreadCount = useNotificationsUnreadCountHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountHook>>>> = ({ signal }) =>
    notificationsUnreadCount(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type NotificationsUnreadCountQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountHook>>>
>;
export type NotificationsUnreadCountQueryError = unknown;

export function useNotificationsUnreadCount<
  TData = Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountHook>>>,
  TError = unknown,
>(
  params: undefined | NotificationsUnreadCountParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useNotificationsUnreadCount<
  TData = Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountHook>>>,
  TError = unknown,
>(
  params?: NotificationsUnreadCountParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useNotificationsUnreadCount<
  TData = Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountHook>>>,
  TError = unknown,
>(
  params?: NotificationsUnreadCountParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Unread notification count (optionally scoped to a tab) for the badge
 */

export function useNotificationsUnreadCount<
  TData = Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountHook>>>,
  TError = unknown,
>(
  params?: NotificationsUnreadCountParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useNotificationsUnreadCountQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Per-tab unread counts for the drawer pills + bell badge
 */
export const useNotificationsUnreadCountsHook = () => {
  const notificationsUnreadCounts = useCustomInstance<UnreadCountsResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return notificationsUnreadCounts({ url: `/notifications/unread-counts`, method: 'GET', signal });
    },
    [notificationsUnreadCounts],
  );
};

export const getNotificationsUnreadCountsQueryKey = () => {
  return [`/notifications/unread-counts`] as const;
};

export const useNotificationsUnreadCountsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountsHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountsHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getNotificationsUnreadCountsQueryKey();

  const notificationsUnreadCounts = useNotificationsUnreadCountsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountsHook>>>> = ({ signal }) =>
    notificationsUnreadCounts(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type NotificationsUnreadCountsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountsHook>>>
>;
export type NotificationsUnreadCountsQueryError = unknown;

export function useNotificationsUnreadCounts<
  TData = Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountsHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountsHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useNotificationsUnreadCounts<
  TData = Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountsHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useNotificationsUnreadCounts<
  TData = Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Per-tab unread counts for the drawer pills + bell badge
 */

export function useNotificationsUnreadCounts<
  TData = Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useNotificationsUnreadCountsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useNotificationsUnreadCountsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Mark one notification read (removes its unread dot)
 */
export const useNotificationsMarkReadHook = () => {
  const notificationsMarkRead = useCustomInstance<NotificationResponseDto>();

  return useCallback(
    (id: string) => {
      return notificationsMarkRead({ url: `/notifications/${id}/read`, method: 'PATCH' });
    },
    [notificationsMarkRead],
  );
};

export const useNotificationsMarkReadMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useNotificationsMarkReadHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useNotificationsMarkReadHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['notificationsMarkRead'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const notificationsMarkRead = useNotificationsMarkReadHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useNotificationsMarkReadHook>>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return notificationsMarkRead(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type NotificationsMarkReadMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useNotificationsMarkReadHook>>>
>;

export type NotificationsMarkReadMutationError = unknown;

/**
 * @summary Mark one notification read (removes its unread dot)
 */
export const useNotificationsMarkRead = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useNotificationsMarkReadHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useNotificationsMarkReadHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useNotificationsMarkReadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Mark the caller’s notifications read (optionally scoped to the active tab)
 */
export const useNotificationsMarkAllReadHook = () => {
  const notificationsMarkAllRead = useCustomInstance<MarkAllReadResponseDto>();

  return useCallback(
    (params?: NotificationsMarkAllReadParams, signal?: AbortSignal) => {
      return notificationsMarkAllRead({ url: `/notifications/read-all`, method: 'POST', params, signal });
    },
    [notificationsMarkAllRead],
  );
};

export const useNotificationsMarkAllReadMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useNotificationsMarkAllReadHook>>>,
    TError,
    { params?: NotificationsMarkAllReadParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useNotificationsMarkAllReadHook>>>,
  TError,
  { params?: NotificationsMarkAllReadParams },
  TContext
> => {
  const mutationKey = ['notificationsMarkAllRead'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const notificationsMarkAllRead = useNotificationsMarkAllReadHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useNotificationsMarkAllReadHook>>>,
    { params?: NotificationsMarkAllReadParams }
  > = (props) => {
    const { params } = props ?? {};

    return notificationsMarkAllRead(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type NotificationsMarkAllReadMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useNotificationsMarkAllReadHook>>>
>;

export type NotificationsMarkAllReadMutationError = unknown;

/**
 * @summary Mark the caller’s notifications read (optionally scoped to the active tab)
 */
export const useNotificationsMarkAllRead = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useNotificationsMarkAllReadHook>>>,
      TError,
      { params?: NotificationsMarkAllReadParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useNotificationsMarkAllReadHook>>>,
  TError,
  { params?: NotificationsMarkAllReadParams },
  TContext
> => {
  const mutationOptions = useNotificationsMarkAllReadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Ingest a notification event (gate → dedupe → persist → realtime).
 */
export const useNotificationWebhookIngestHook = () => {
  const notificationWebhookIngest = useCustomInstance<IngestNotificationAckDto>();

  return useCallback(
    (ingestNotificationDto: IngestNotificationDto, signal?: AbortSignal) => {
      return notificationWebhookIngest({
        url: `/webhooks/notifications`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: ingestNotificationDto,
        signal,
      });
    },
    [notificationWebhookIngest],
  );
};

export const useNotificationWebhookIngestMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useNotificationWebhookIngestHook>>>,
    TError,
    { data: IngestNotificationDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useNotificationWebhookIngestHook>>>,
  TError,
  { data: IngestNotificationDto },
  TContext
> => {
  const mutationKey = ['notificationWebhookIngest'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const notificationWebhookIngest = useNotificationWebhookIngestHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useNotificationWebhookIngestHook>>>,
    { data: IngestNotificationDto }
  > = (props) => {
    const { data } = props ?? {};

    return notificationWebhookIngest(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type NotificationWebhookIngestMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useNotificationWebhookIngestHook>>>
>;
export type NotificationWebhookIngestMutationBody = IngestNotificationDto;
export type NotificationWebhookIngestMutationError = unknown;

/**
 * @summary Ingest a notification event (gate → dedupe → persist → realtime).
 */
export const useNotificationWebhookIngest = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useNotificationWebhookIngestHook>>>,
      TError,
      { data: IngestNotificationDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useNotificationWebhookIngestHook>>>,
  TError,
  { data: IngestNotificationDto },
  TContext
> => {
  const mutationOptions = useNotificationWebhookIngestMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List comments for moderation with filters (eventId, userId, status, hasOpenReports, free-text over body).
 */
export const useAdminCommentsListHook = () => {
  const adminCommentsList = useCustomInstance<AdminCommentListResponseDto>();

  return useCallback(
    (params?: AdminCommentsListParams, signal?: AbortSignal) => {
      return adminCommentsList({ url: `/admin/comments`, method: 'GET', params, signal });
    },
    [adminCommentsList],
  );
};

export const getAdminCommentsListQueryKey = (params?: AdminCommentsListParams) => {
  return [`/admin/comments`, ...(params ? [params] : [])] as const;
};

export const useAdminCommentsListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminCommentsListHook>>>,
  TError = unknown,
>(
  params?: AdminCommentsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminCommentsListHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminCommentsListQueryKey(params);

  const adminCommentsList = useAdminCommentsListHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminCommentsListHook>>>> = ({ signal }) =>
    adminCommentsList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminCommentsListHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminCommentsListQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminCommentsListHook>>>>;
export type AdminCommentsListQueryError = unknown;

export function useAdminCommentsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminCommentsListHook>>>,
  TError = unknown,
>(
  params: undefined | AdminCommentsListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminCommentsListHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminCommentsListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminCommentsListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminCommentsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminCommentsListHook>>>,
  TError = unknown,
>(
  params?: AdminCommentsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminCommentsListHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminCommentsListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminCommentsListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminCommentsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminCommentsListHook>>>,
  TError = unknown,
>(
  params?: AdminCommentsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminCommentsListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List comments for moderation with filters (eventId, userId, status, hasOpenReports, free-text over body).
 */

export function useAdminCommentsList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminCommentsListHook>>>,
  TError = unknown,
>(
  params?: AdminCommentsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminCommentsListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminCommentsListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Hide a comment (reversible). Auto-resolves its open reports.
 */
export const useAdminCommentsHideHook = () => {
  const adminCommentsHide = useCustomInstance<void>();

  return useCallback(
    (id: string) => {
      return adminCommentsHide({ url: `/admin/comments/${id}/hide`, method: 'PATCH' });
    },
    [adminCommentsHide],
  );
};

export const useAdminCommentsHideMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminCommentsHideHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminCommentsHideHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminCommentsHide'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminCommentsHide = useAdminCommentsHideHook();

  const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useAdminCommentsHideHook>>>, { id: string }> = (
    props,
  ) => {
    const { id } = props ?? {};

    return adminCommentsHide(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCommentsHideMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminCommentsHideHook>>>>;

export type AdminCommentsHideMutationError = unknown;

/**
 * @summary Hide a comment (reversible). Auto-resolves its open reports.
 */
export const useAdminCommentsHide = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminCommentsHideHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useAdminCommentsHideHook>>>, TError, { id: string }, TContext> => {
  const mutationOptions = useAdminCommentsHideMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Restore a hidden comment.
 */
export const useAdminCommentsRestoreHook = () => {
  const adminCommentsRestore = useCustomInstance<void>();

  return useCallback(
    (id: string) => {
      return adminCommentsRestore({ url: `/admin/comments/${id}/restore`, method: 'PATCH' });
    },
    [adminCommentsRestore],
  );
};

export const useAdminCommentsRestoreMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminCommentsRestoreHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminCommentsRestoreHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminCommentsRestore'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminCommentsRestore = useAdminCommentsRestoreHook();

  const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useAdminCommentsRestoreHook>>>, { id: string }> = (
    props,
  ) => {
    const { id } = props ?? {};

    return adminCommentsRestore(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCommentsRestoreMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminCommentsRestoreHook>>>
>;

export type AdminCommentsRestoreMutationError = unknown;

/**
 * @summary Restore a hidden comment.
 */
export const useAdminCommentsRestore = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminCommentsRestoreHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminCommentsRestoreHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useAdminCommentsRestoreMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Remove a comment (terminal). Auto-resolves its open reports.
 */
export const useAdminCommentsRemoveHook = () => {
  const adminCommentsRemove = useCustomInstance<void>();

  return useCallback(
    (id: string) => {
      return adminCommentsRemove({ url: `/admin/comments/${id}/remove`, method: 'PATCH' });
    },
    [adminCommentsRemove],
  );
};

export const useAdminCommentsRemoveMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminCommentsRemoveHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminCommentsRemoveHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminCommentsRemove'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminCommentsRemove = useAdminCommentsRemoveHook();

  const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useAdminCommentsRemoveHook>>>, { id: string }> = (
    props,
  ) => {
    const { id } = props ?? {};

    return adminCommentsRemove(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCommentsRemoveMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminCommentsRemoveHook>>>
>;

export type AdminCommentsRemoveMutationError = unknown;

/**
 * @summary Remove a comment (terminal). Auto-resolves its open reports.
 */
export const useAdminCommentsRemove = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminCommentsRemoveHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminCommentsRemoveHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useAdminCommentsRemoveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Moderation reports queue (defaults to OPEN).
 */
export const useAdminCommentsListReportsHook = () => {
  const adminCommentsListReports = useCustomInstance<AdminCommentReportListResponseDto>();

  return useCallback(
    (params?: AdminCommentsListReportsParams, signal?: AbortSignal) => {
      return adminCommentsListReports({ url: `/admin/comment-reports`, method: 'GET', params, signal });
    },
    [adminCommentsListReports],
  );
};

export const getAdminCommentsListReportsQueryKey = (params?: AdminCommentsListReportsParams) => {
  return [`/admin/comment-reports`, ...(params ? [params] : [])] as const;
};

export const useAdminCommentsListReportsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminCommentsListReportsHook>>>,
  TError = unknown,
>(
  params?: AdminCommentsListReportsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminCommentsListReportsHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminCommentsListReportsQueryKey(params);

  const adminCommentsListReports = useAdminCommentsListReportsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminCommentsListReportsHook>>>> = ({ signal }) =>
    adminCommentsListReports(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminCommentsListReportsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminCommentsListReportsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminCommentsListReportsHook>>>
>;
export type AdminCommentsListReportsQueryError = unknown;

export function useAdminCommentsListReports<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminCommentsListReportsHook>>>,
  TError = unknown,
>(
  params: undefined | AdminCommentsListReportsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminCommentsListReportsHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminCommentsListReportsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminCommentsListReportsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminCommentsListReports<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminCommentsListReportsHook>>>,
  TError = unknown,
>(
  params?: AdminCommentsListReportsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminCommentsListReportsHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminCommentsListReportsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminCommentsListReportsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminCommentsListReports<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminCommentsListReportsHook>>>,
  TError = unknown,
>(
  params?: AdminCommentsListReportsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminCommentsListReportsHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Moderation reports queue (defaults to OPEN).
 */

export function useAdminCommentsListReports<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminCommentsListReportsHook>>>,
  TError = unknown,
>(
  params?: AdminCommentsListReportsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminCommentsListReportsHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminCommentsListReportsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Dismiss an open report without acting on the comment.
 */
export const useAdminCommentsDismissReportHook = () => {
  const adminCommentsDismissReport = useCustomInstance<void>();

  return useCallback(
    (id: string) => {
      return adminCommentsDismissReport({ url: `/admin/comment-reports/${id}/dismiss`, method: 'PATCH' });
    },
    [adminCommentsDismissReport],
  );
};

export const useAdminCommentsDismissReportMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminCommentsDismissReportHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminCommentsDismissReportHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['adminCommentsDismissReport'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminCommentsDismissReport = useAdminCommentsDismissReportHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminCommentsDismissReportHook>>>,
    { id: string }
  > = (props) => {
    const { id } = props ?? {};

    return adminCommentsDismissReport(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCommentsDismissReportMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminCommentsDismissReportHook>>>
>;

export type AdminCommentsDismissReportMutationError = unknown;

/**
 * @summary Dismiss an open report without acting on the comment.
 */
export const useAdminCommentsDismissReport = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminCommentsDismissReportHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminCommentsDismissReportHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useAdminCommentsDismissReportMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Set / lift a comment ban on a user (TIMED, PERMANENT or LIFT; reason audited).
 */
export const useAdminCommentsCommentBanHook = () => {
  const adminCommentsCommentBan = useCustomInstance<CommentBanResponseDto>();

  return useCallback(
    (userId: string, commentBanDto: CommentBanDto) => {
      return adminCommentsCommentBan({
        url: `/admin/users/${userId}/comment-ban`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: commentBanDto,
      });
    },
    [adminCommentsCommentBan],
  );
};

export const useAdminCommentsCommentBanMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminCommentsCommentBanHook>>>,
    TError,
    { userId: string; data: CommentBanDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminCommentsCommentBanHook>>>,
  TError,
  { userId: string; data: CommentBanDto },
  TContext
> => {
  const mutationKey = ['adminCommentsCommentBan'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminCommentsCommentBan = useAdminCommentsCommentBanHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminCommentsCommentBanHook>>>,
    { userId: string; data: CommentBanDto }
  > = (props) => {
    const { userId, data } = props ?? {};

    return adminCommentsCommentBan(userId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminCommentsCommentBanMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminCommentsCommentBanHook>>>
>;
export type AdminCommentsCommentBanMutationBody = CommentBanDto;
export type AdminCommentsCommentBanMutationError = unknown;

/**
 * @summary Set / lift a comment ban on a user (TIMED, PERMANENT or LIFT; reason audited).
 */
export const useAdminCommentsCommentBan = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminCommentsCommentBanHook>>>,
      TError,
      { userId: string; data: CommentBanDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminCommentsCommentBanHook>>>,
  TError,
  { userId: string; data: CommentBanDto },
  TContext
> => {
  const mutationOptions = useAdminCommentsCommentBanMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get the Live-page group thresholds
 */
export const useAdminLivePageGetConfigHook = () => {
  const adminLivePageGetConfig = useCustomInstance<LivePageConfigResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminLivePageGetConfig({ url: `/admin/live-page/config`, method: 'GET', signal });
    },
    [adminLivePageGetConfig],
  );
};

export const getAdminLivePageGetConfigQueryKey = () => {
  return [`/admin/live-page/config`] as const;
};

export const useAdminLivePageGetConfigQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminLivePageGetConfigHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminLivePageGetConfigHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminLivePageGetConfigQueryKey();

  const adminLivePageGetConfig = useAdminLivePageGetConfigHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminLivePageGetConfigHook>>>> = ({ signal }) =>
    adminLivePageGetConfig(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminLivePageGetConfigHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminLivePageGetConfigQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminLivePageGetConfigHook>>>
>;
export type AdminLivePageGetConfigQueryError = unknown;

export function useAdminLivePageGetConfig<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminLivePageGetConfigHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminLivePageGetConfigHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminLivePageGetConfigHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminLivePageGetConfigHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminLivePageGetConfig<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminLivePageGetConfigHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminLivePageGetConfigHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminLivePageGetConfigHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminLivePageGetConfigHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminLivePageGetConfig<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminLivePageGetConfigHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminLivePageGetConfigHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the Live-page group thresholds
 */

export function useAdminLivePageGetConfig<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminLivePageGetConfigHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminLivePageGetConfigHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminLivePageGetConfigQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Set the Live-page group thresholds (closing-soon < today < eligibility, or 400)
 */
export const useAdminLivePageUpdateConfigHook = () => {
  const adminLivePageUpdateConfig = useCustomInstance<LivePageConfigResponseDto>();

  return useCallback(
    (updateLivePageConfigDto: UpdateLivePageConfigDto) => {
      return adminLivePageUpdateConfig({
        url: `/admin/live-page/config`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: updateLivePageConfigDto,
      });
    },
    [adminLivePageUpdateConfig],
  );
};

export const useAdminLivePageUpdateConfigMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminLivePageUpdateConfigHook>>>,
    TError,
    { data: UpdateLivePageConfigDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminLivePageUpdateConfigHook>>>,
  TError,
  { data: UpdateLivePageConfigDto },
  TContext
> => {
  const mutationKey = ['adminLivePageUpdateConfig'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminLivePageUpdateConfig = useAdminLivePageUpdateConfigHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminLivePageUpdateConfigHook>>>,
    { data: UpdateLivePageConfigDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminLivePageUpdateConfig(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminLivePageUpdateConfigMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminLivePageUpdateConfigHook>>>
>;
export type AdminLivePageUpdateConfigMutationBody = UpdateLivePageConfigDto;
export type AdminLivePageUpdateConfigMutationError = unknown;

/**
 * @summary Set the Live-page group thresholds (closing-soon < today < eligibility, or 400)
 */
export const useAdminLivePageUpdateConfig = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminLivePageUpdateConfigHook>>>,
      TError,
      { data: UpdateLivePageConfigDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminLivePageUpdateConfigHook>>>,
  TError,
  { data: UpdateLivePageConfigDto },
  TContext
> => {
  const mutationOptions = useAdminLivePageUpdateConfigMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List Live-page pinned events (including resolved/ineligible ones, until unpinned)
 */
export const useAdminLivePageListPinnedEventsHook = () => {
  const adminLivePageListPinnedEvents = useCustomInstance<PinnedEventResponseDto[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminLivePageListPinnedEvents({ url: `/admin/live-page/pinned-events`, method: 'GET', signal });
    },
    [adminLivePageListPinnedEvents],
  );
};

export const getAdminLivePageListPinnedEventsQueryKey = () => {
  return [`/admin/live-page/pinned-events`] as const;
};

export const useAdminLivePageListPinnedEventsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminLivePageListPinnedEventsHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminLivePageListPinnedEventsHook>>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminLivePageListPinnedEventsQueryKey();

  const adminLivePageListPinnedEvents = useAdminLivePageListPinnedEventsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminLivePageListPinnedEventsHook>>>> = ({
    signal,
  }) => adminLivePageListPinnedEvents(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminLivePageListPinnedEventsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminLivePageListPinnedEventsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminLivePageListPinnedEventsHook>>>
>;
export type AdminLivePageListPinnedEventsQueryError = unknown;

export function useAdminLivePageListPinnedEvents<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminLivePageListPinnedEventsHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminLivePageListPinnedEventsHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminLivePageListPinnedEventsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminLivePageListPinnedEventsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminLivePageListPinnedEvents<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminLivePageListPinnedEventsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminLivePageListPinnedEventsHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminLivePageListPinnedEventsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminLivePageListPinnedEventsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminLivePageListPinnedEvents<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminLivePageListPinnedEventsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminLivePageListPinnedEventsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List Live-page pinned events (including resolved/ineligible ones, until unpinned)
 */

export function useAdminLivePageListPinnedEvents<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminLivePageListPinnedEventsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminLivePageListPinnedEventsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminLivePageListPinnedEventsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Pin an event to the top of its Live-page time group (409 when already pinned)
 */
export const useAdminLivePagePinEventHook = () => {
  const adminLivePagePinEvent = useCustomInstance<PinnedEventResponseDto>();

  return useCallback(
    (pinEventDto: PinEventDto, signal?: AbortSignal) => {
      return adminLivePagePinEvent({
        url: `/admin/live-page/pinned-events`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: pinEventDto,
        signal,
      });
    },
    [adminLivePagePinEvent],
  );
};

export const useAdminLivePagePinEventMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminLivePagePinEventHook>>>,
    TError,
    { data: PinEventDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminLivePagePinEventHook>>>,
  TError,
  { data: PinEventDto },
  TContext
> => {
  const mutationKey = ['adminLivePagePinEvent'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminLivePagePinEvent = useAdminLivePagePinEventHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminLivePagePinEventHook>>>,
    { data: PinEventDto }
  > = (props) => {
    const { data } = props ?? {};

    return adminLivePagePinEvent(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminLivePagePinEventMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminLivePagePinEventHook>>>
>;
export type AdminLivePagePinEventMutationBody = PinEventDto;
export type AdminLivePagePinEventMutationError = unknown;

/**
 * @summary Pin an event to the top of its Live-page time group (409 when already pinned)
 */
export const useAdminLivePagePinEvent = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminLivePagePinEventHook>>>,
      TError,
      { data: PinEventDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminLivePagePinEventHook>>>,
  TError,
  { data: PinEventDto },
  TContext
> => {
  const mutationOptions = useAdminLivePagePinEventMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Unpin an event from the Live page
 */
export const useAdminLivePageUnpinEventHook = () => {
  const adminLivePageUnpinEvent = useCustomInstance<UnpinEventResponseDto>();

  return useCallback(
    (eventId: string) => {
      return adminLivePageUnpinEvent({ url: `/admin/live-page/pinned-events/${eventId}`, method: 'DELETE' });
    },
    [adminLivePageUnpinEvent],
  );
};

export const useAdminLivePageUnpinEventMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminLivePageUnpinEventHook>>>,
    TError,
    { eventId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminLivePageUnpinEventHook>>>,
  TError,
  { eventId: string },
  TContext
> => {
  const mutationKey = ['adminLivePageUnpinEvent'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminLivePageUnpinEvent = useAdminLivePageUnpinEventHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminLivePageUnpinEventHook>>>,
    { eventId: string }
  > = (props) => {
    const { eventId } = props ?? {};

    return adminLivePageUnpinEvent(eventId);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminLivePageUnpinEventMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminLivePageUnpinEventHook>>>
>;

export type AdminLivePageUnpinEventMutationError = unknown;

/**
 * @summary Unpin an event from the Live page
 */
export const useAdminLivePageUnpinEvent = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminLivePageUnpinEventHook>>>,
      TError,
      { eventId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminLivePageUnpinEventHook>>>,
  TError,
  { eventId: string },
  TContext
> => {
  const mutationOptions = useAdminLivePageUnpinEventMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Per-experience funnel (impressions / actions / dismisses / assignments / claims + claim-rate)
 */
export const useAdminMonetizationAnalyticsExperienceHook = () => {
  const adminMonetizationAnalyticsExperience = useCustomInstance<ExperienceAnalyticsResponseDto>();

  return useCallback(
    (id: string, params?: AdminMonetizationAnalyticsExperienceParams, signal?: AbortSignal) => {
      return adminMonetizationAnalyticsExperience({
        url: `/admin/monetization/analytics/experiences/${id}`,
        method: 'GET',
        params,
        signal,
      });
    },
    [adminMonetizationAnalyticsExperience],
  );
};

export const getAdminMonetizationAnalyticsExperienceQueryKey = (
  id: string,
  params?: AdminMonetizationAnalyticsExperienceParams,
) => {
  return [`/admin/monetization/analytics/experiences/${id}`, ...(params ? [params] : [])] as const;
};

export const useAdminMonetizationAnalyticsExperienceQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsExperienceHook>>>,
  TError = unknown,
>(
  id: string,
  params?: AdminMonetizationAnalyticsExperienceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsExperienceHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminMonetizationAnalyticsExperienceQueryKey(id, params);

  const adminMonetizationAnalyticsExperience = useAdminMonetizationAnalyticsExperienceHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsExperienceHook>>>> = ({
    signal,
  }) => adminMonetizationAnalyticsExperience(id, params, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsExperienceHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminMonetizationAnalyticsExperienceQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsExperienceHook>>>
>;
export type AdminMonetizationAnalyticsExperienceQueryError = unknown;

export function useAdminMonetizationAnalyticsExperience<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsExperienceHook>>>,
  TError = unknown,
>(
  id: string,
  params: undefined | AdminMonetizationAnalyticsExperienceParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsExperienceHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsExperienceHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsExperienceHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminMonetizationAnalyticsExperience<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsExperienceHook>>>,
  TError = unknown,
>(
  id: string,
  params?: AdminMonetizationAnalyticsExperienceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsExperienceHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsExperienceHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsExperienceHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminMonetizationAnalyticsExperience<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsExperienceHook>>>,
  TError = unknown,
>(
  id: string,
  params?: AdminMonetizationAnalyticsExperienceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsExperienceHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Per-experience funnel (impressions / actions / dismisses / assignments / claims + claim-rate)
 */

export function useAdminMonetizationAnalyticsExperience<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsExperienceHook>>>,
  TError = unknown,
>(
  id: string,
  params?: AdminMonetizationAnalyticsExperienceParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsExperienceHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminMonetizationAnalyticsExperienceQueryOptions(id, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Minted cash-back over a window: total + grouped by source (GIFT / OFFER / ADMIN)
 */
export const useAdminMonetizationAnalyticsMintVolumeHook = () => {
  const adminMonetizationAnalyticsMintVolume = useCustomInstance<MintVolumeResponseDto>();

  return useCallback(
    (params?: AdminMonetizationAnalyticsMintVolumeParams, signal?: AbortSignal) => {
      return adminMonetizationAnalyticsMintVolume({
        url: `/admin/monetization/analytics/mint-volume`,
        method: 'GET',
        params,
        signal,
      });
    },
    [adminMonetizationAnalyticsMintVolume],
  );
};

export const getAdminMonetizationAnalyticsMintVolumeQueryKey = (params?: AdminMonetizationAnalyticsMintVolumeParams) => {
  return [`/admin/monetization/analytics/mint-volume`, ...(params ? [params] : [])] as const;
};

export const useAdminMonetizationAnalyticsMintVolumeQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsMintVolumeHook>>>,
  TError = unknown,
>(
  params?: AdminMonetizationAnalyticsMintVolumeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsMintVolumeHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminMonetizationAnalyticsMintVolumeQueryKey(params);

  const adminMonetizationAnalyticsMintVolume = useAdminMonetizationAnalyticsMintVolumeHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsMintVolumeHook>>>> = ({
    signal,
  }) => adminMonetizationAnalyticsMintVolume(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsMintVolumeHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminMonetizationAnalyticsMintVolumeQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsMintVolumeHook>>>
>;
export type AdminMonetizationAnalyticsMintVolumeQueryError = unknown;

export function useAdminMonetizationAnalyticsMintVolume<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsMintVolumeHook>>>,
  TError = unknown,
>(
  params: undefined | AdminMonetizationAnalyticsMintVolumeParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsMintVolumeHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsMintVolumeHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsMintVolumeHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminMonetizationAnalyticsMintVolume<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsMintVolumeHook>>>,
  TError = unknown,
>(
  params?: AdminMonetizationAnalyticsMintVolumeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsMintVolumeHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsMintVolumeHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsMintVolumeHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminMonetizationAnalyticsMintVolume<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsMintVolumeHook>>>,
  TError = unknown,
>(
  params?: AdminMonetizationAnalyticsMintVolumeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsMintVolumeHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Minted cash-back over a window: total + grouped by source (GIFT / OFFER / ADMIN)
 */

export function useAdminMonetizationAnalyticsMintVolume<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsMintVolumeHook>>>,
  TError = unknown,
>(
  params?: AdminMonetizationAnalyticsMintVolumeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsMintVolumeHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminMonetizationAnalyticsMintVolumeQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary A user’s merged monetization timeline (events + grant claims), newest first, capped
 */
export const useAdminMonetizationAnalyticsUserTimelineHook = () => {
  const adminMonetizationAnalyticsUserTimeline = useCustomInstance<UserTimelineResponseDto>();

  return useCallback(
    (userId: string, params?: AdminMonetizationAnalyticsUserTimelineParams, signal?: AbortSignal) => {
      return adminMonetizationAnalyticsUserTimeline({
        url: `/admin/monetization/analytics/users/${userId}/timeline`,
        method: 'GET',
        params,
        signal,
      });
    },
    [adminMonetizationAnalyticsUserTimeline],
  );
};

export const getAdminMonetizationAnalyticsUserTimelineQueryKey = (
  userId: string,
  params?: AdminMonetizationAnalyticsUserTimelineParams,
) => {
  return [`/admin/monetization/analytics/users/${userId}/timeline`, ...(params ? [params] : [])] as const;
};

export const useAdminMonetizationAnalyticsUserTimelineQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsUserTimelineHook>>>,
  TError = unknown,
>(
  userId: string,
  params?: AdminMonetizationAnalyticsUserTimelineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsUserTimelineHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminMonetizationAnalyticsUserTimelineQueryKey(userId, params);

  const adminMonetizationAnalyticsUserTimeline = useAdminMonetizationAnalyticsUserTimelineHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsUserTimelineHook>>>> = ({
    signal,
  }) => adminMonetizationAnalyticsUserTimeline(userId, params, signal);

  return { queryKey, queryFn, enabled: !!userId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsUserTimelineHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminMonetizationAnalyticsUserTimelineQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsUserTimelineHook>>>
>;
export type AdminMonetizationAnalyticsUserTimelineQueryError = unknown;

export function useAdminMonetizationAnalyticsUserTimeline<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsUserTimelineHook>>>,
  TError = unknown,
>(
  userId: string,
  params: undefined | AdminMonetizationAnalyticsUserTimelineParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsUserTimelineHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsUserTimelineHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsUserTimelineHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminMonetizationAnalyticsUserTimeline<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsUserTimelineHook>>>,
  TError = unknown,
>(
  userId: string,
  params?: AdminMonetizationAnalyticsUserTimelineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsUserTimelineHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsUserTimelineHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsUserTimelineHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminMonetizationAnalyticsUserTimeline<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsUserTimelineHook>>>,
  TError = unknown,
>(
  userId: string,
  params?: AdminMonetizationAnalyticsUserTimelineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsUserTimelineHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary A user’s merged monetization timeline (events + grant claims), newest first, capped
 */

export function useAdminMonetizationAnalyticsUserTimeline<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsUserTimelineHook>>>,
  TError = unknown,
>(
  userId: string,
  params?: AdminMonetizationAnalyticsUserTimelineParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminMonetizationAnalyticsUserTimelineHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminMonetizationAnalyticsUserTimelineQueryOptions(userId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List the available gallery folders
 */
export const useAdminGalleryListDirectoriesHook = () => {
  const adminGalleryListDirectories = useCustomInstance<string[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminGalleryListDirectories({ url: `/admin/gallery/directories`, method: 'GET', signal });
    },
    [adminGalleryListDirectories],
  );
};

export const getAdminGalleryListDirectoriesQueryKey = () => {
  return [`/admin/gallery/directories`] as const;
};

export const useAdminGalleryListDirectoriesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminGalleryListDirectoriesHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminGalleryListDirectoriesHook>>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGalleryListDirectoriesQueryKey();

  const adminGalleryListDirectories = useAdminGalleryListDirectoriesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminGalleryListDirectoriesHook>>>> = ({ signal }) =>
    adminGalleryListDirectories(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminGalleryListDirectoriesHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminGalleryListDirectoriesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminGalleryListDirectoriesHook>>>
>;
export type AdminGalleryListDirectoriesQueryError = unknown;

export function useAdminGalleryListDirectories<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminGalleryListDirectoriesHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminGalleryListDirectoriesHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminGalleryListDirectoriesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminGalleryListDirectoriesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminGalleryListDirectories<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminGalleryListDirectoriesHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminGalleryListDirectoriesHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminGalleryListDirectoriesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminGalleryListDirectoriesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminGalleryListDirectories<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminGalleryListDirectoriesHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminGalleryListDirectoriesHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List the available gallery folders
 */

export function useAdminGalleryListDirectories<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminGalleryListDirectoriesHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminGalleryListDirectoriesHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminGalleryListDirectoriesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List images in a gallery folder
 */
export const useAdminGalleryListHook = () => {
  const adminGalleryList = useCustomInstance<GalleryImageDto[]>();

  return useCallback(
    (params?: AdminGalleryListParams, signal?: AbortSignal) => {
      return adminGalleryList({ url: `/admin/gallery`, method: 'GET', params, signal });
    },
    [adminGalleryList],
  );
};

export const getAdminGalleryListQueryKey = (params?: AdminGalleryListParams) => {
  return [`/admin/gallery`, ...(params ? [params] : [])] as const;
};

export const useAdminGalleryListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminGalleryListHook>>>,
  TError = unknown,
>(
  params?: AdminGalleryListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminGalleryListHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminGalleryListQueryKey(params);

  const adminGalleryList = useAdminGalleryListHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminGalleryListHook>>>> = ({ signal }) =>
    adminGalleryList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminGalleryListHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminGalleryListQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useAdminGalleryListHook>>>>;
export type AdminGalleryListQueryError = unknown;

export function useAdminGalleryList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminGalleryListHook>>>,
  TError = unknown,
>(
  params: undefined | AdminGalleryListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminGalleryListHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminGalleryListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminGalleryListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminGalleryList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminGalleryListHook>>>,
  TError = unknown,
>(
  params?: AdminGalleryListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminGalleryListHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminGalleryListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminGalleryListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminGalleryList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminGalleryListHook>>>,
  TError = unknown,
>(
  params?: AdminGalleryListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminGalleryListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List images in a gallery folder
 */

export function useAdminGalleryList<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminGalleryListHook>>>,
  TError = unknown,
>(
  params?: AdminGalleryListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminGalleryListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminGalleryListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Upload an image to a gallery folder (multipart field "file")
 */
export const useAdminGalleryUploadHook = () => {
  const adminGalleryUpload = useCustomInstance<GalleryImageDto>();

  return useCallback(
    (params?: AdminGalleryUploadParams, signal?: AbortSignal) => {
      return adminGalleryUpload({ url: `/admin/gallery`, method: 'POST', params, signal });
    },
    [adminGalleryUpload],
  );
};

export const useAdminGalleryUploadMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminGalleryUploadHook>>>,
    TError,
    { params?: AdminGalleryUploadParams },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useAdminGalleryUploadHook>>>,
  TError,
  { params?: AdminGalleryUploadParams },
  TContext
> => {
  const mutationKey = ['adminGalleryUpload'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const adminGalleryUpload = useAdminGalleryUploadHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useAdminGalleryUploadHook>>>,
    { params?: AdminGalleryUploadParams }
  > = (props) => {
    const { params } = props ?? {};

    return adminGalleryUpload(params);
  };

  return { mutationFn, ...mutationOptions };
};

export type AdminGalleryUploadMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminGalleryUploadHook>>>
>;

export type AdminGalleryUploadMutationError = unknown;

/**
 * @summary Upload an image to a gallery folder (multipart field "file")
 */
export const useAdminGalleryUpload = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useAdminGalleryUploadHook>>>,
      TError,
      { params?: AdminGalleryUploadParams },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useAdminGalleryUploadHook>>>,
  TError,
  { params?: AdminGalleryUploadParams },
  TContext
> => {
  const mutationOptions = useAdminGalleryUploadMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Full admin dashboard KPI bundle (summary counters, chart series, status breakdowns, activity feed). Aggregated server-side over the source tables and cached in Redis (short TTL).
 */
export const useAdminDashboardGetMetricsHook = () => {
  const adminDashboardGetMetrics = useCustomInstance<DashboardMetricsDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminDashboardGetMetrics({ url: `/admin/dashboard/metrics`, method: 'GET', signal });
    },
    [adminDashboardGetMetrics],
  );
};

export const getAdminDashboardGetMetricsQueryKey = () => {
  return [`/admin/dashboard/metrics`] as const;
};

export const useAdminDashboardGetMetricsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDashboardGetMetricsHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDashboardGetMetricsHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminDashboardGetMetricsQueryKey();

  const adminDashboardGetMetrics = useAdminDashboardGetMetricsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminDashboardGetMetricsHook>>>> = ({ signal }) =>
    adminDashboardGetMetrics(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminDashboardGetMetricsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminDashboardGetMetricsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminDashboardGetMetricsHook>>>
>;
export type AdminDashboardGetMetricsQueryError = unknown;

export function useAdminDashboardGetMetrics<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDashboardGetMetricsHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDashboardGetMetricsHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminDashboardGetMetricsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminDashboardGetMetricsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminDashboardGetMetrics<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDashboardGetMetricsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDashboardGetMetricsHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminDashboardGetMetricsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminDashboardGetMetricsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminDashboardGetMetrics<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDashboardGetMetricsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDashboardGetMetricsHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Full admin dashboard KPI bundle (summary counters, chart series, status breakdowns, activity feed). Aggregated server-side over the source tables and cached in Redis (short TTL).
 */

export function useAdminDashboardGetMetrics<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminDashboardGetMetricsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminDashboardGetMetricsHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminDashboardGetMetricsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Health of every external dependency (infra, OMS, payments, identity, comms, analytics, platform). Live-probed where a safe read exists, observed from telemetry for Plaee/LaunchDarkly, configured-state only where no safe probe exists. Cached in Redis (short TTL).
 */
export const useAdminServicesHealthGetHealthHook = () => {
  const adminServicesHealthGetHealth = useCustomInstance<ServicesHealthDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return adminServicesHealthGetHealth({ url: `/admin/services/health`, method: 'GET', signal });
    },
    [adminServicesHealthGetHealth],
  );
};

export const getAdminServicesHealthGetHealthQueryKey = () => {
  return [`/admin/services/health`] as const;
};

export const useAdminServicesHealthGetHealthQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useAdminServicesHealthGetHealthHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminServicesHealthGetHealthHook>>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getAdminServicesHealthGetHealthQueryKey();

  const adminServicesHealthGetHealth = useAdminServicesHealthGetHealthHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useAdminServicesHealthGetHealthHook>>>> = ({ signal }) =>
    adminServicesHealthGetHealth(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useAdminServicesHealthGetHealthHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type AdminServicesHealthGetHealthQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useAdminServicesHealthGetHealthHook>>>
>;
export type AdminServicesHealthGetHealthQueryError = unknown;

export function useAdminServicesHealthGetHealth<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminServicesHealthGetHealthHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminServicesHealthGetHealthHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminServicesHealthGetHealthHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminServicesHealthGetHealthHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminServicesHealthGetHealth<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminServicesHealthGetHealthHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminServicesHealthGetHealthHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useAdminServicesHealthGetHealthHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useAdminServicesHealthGetHealthHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useAdminServicesHealthGetHealth<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminServicesHealthGetHealthHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminServicesHealthGetHealthHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Health of every external dependency (infra, OMS, payments, identity, comms, analytics, platform). Live-probed where a safe read exists, observed from telemetry for Plaee/LaunchDarkly, configured-state only where no safe probe exists. Cached in Redis (short TTL).
 */

export function useAdminServicesHealthGetHealth<
  TData = Awaited<ReturnType<ReturnType<typeof useAdminServicesHealthGetHealthHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useAdminServicesHealthGetHealthHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useAdminServicesHealthGetHealthQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get the deposit store config (limits + suggested amounts) for the current viewer (guest or authed)
 */
export const useDepositGetStoreHook = () => {
  const depositGetStore = useCustomInstance<StoreConfigResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return depositGetStore({ url: `/deposit/store`, method: 'GET', signal });
    },
    [depositGetStore],
  );
};

export const getDepositGetStoreQueryKey = () => {
  return [`/deposit/store`] as const;
};

export const useDepositGetStoreQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useDepositGetStoreHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDepositGetStoreHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDepositGetStoreQueryKey();

  const depositGetStore = useDepositGetStoreHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useDepositGetStoreHook>>>> = ({ signal }) =>
    depositGetStore(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useDepositGetStoreHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DepositGetStoreQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDepositGetStoreHook>>>>;
export type DepositGetStoreQueryError = unknown;

export function useDepositGetStore<TData = Awaited<ReturnType<ReturnType<typeof useDepositGetStoreHook>>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDepositGetStoreHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDepositGetStoreHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDepositGetStoreHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDepositGetStore<TData = Awaited<ReturnType<ReturnType<typeof useDepositGetStoreHook>>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDepositGetStoreHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDepositGetStoreHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDepositGetStoreHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDepositGetStore<TData = Awaited<ReturnType<ReturnType<typeof useDepositGetStoreHook>>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDepositGetStoreHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the deposit store config (limits + suggested amounts) for the current viewer (guest or authed)
 */

export function useDepositGetStore<TData = Awaited<ReturnType<ReturnType<typeof useDepositGetStoreHook>>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDepositGetStoreHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useDepositGetStoreQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List the current user deposits, newest first. Without a status filter only real payment attempts (PROCESSING / SUCCEEDED / FAILED) are returned — pre-payment bootstrap intents are excluded.
 */
export const useDepositListHook = () => {
  const depositList = useCustomInstance<DepositListItemDto[]>();

  return useCallback(
    (params?: DepositListParams, signal?: AbortSignal) => {
      return depositList({ url: `/deposit`, method: 'GET', params, signal });
    },
    [depositList],
  );
};

export const getDepositListQueryKey = (params?: DepositListParams) => {
  return [`/deposit`, ...(params ? [params] : [])] as const;
};

export const useDepositListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useDepositListHook>>>,
  TError = unknown,
>(
  params?: DepositListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDepositListHook>>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDepositListQueryKey(params);

  const depositList = useDepositListHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useDepositListHook>>>> = ({ signal }) =>
    depositList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useDepositListHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DepositListQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDepositListHook>>>>;
export type DepositListQueryError = unknown;

export function useDepositList<TData = Awaited<ReturnType<ReturnType<typeof useDepositListHook>>>, TError = unknown>(
  params: undefined | DepositListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDepositListHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDepositListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDepositListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDepositList<TData = Awaited<ReturnType<ReturnType<typeof useDepositListHook>>>, TError = unknown>(
  params?: DepositListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDepositListHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDepositListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDepositListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDepositList<TData = Awaited<ReturnType<ReturnType<typeof useDepositListHook>>>, TError = unknown>(
  params?: DepositListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDepositListHook>>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List the current user deposits, newest first. Without a status filter only real payment attempts (PROCESSING / SUCCEEDED / FAILED) are returned — pre-payment bootstrap intents are excluded.
 */

export function useDepositList<TData = Awaited<ReturnType<ReturnType<typeof useDepositListHook>>>, TError = unknown>(
  params?: DepositListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDepositListHook>>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useDepositListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a deposit intent ready for the Pay.com SDK session flow
 */
export const useDepositInitiateHook = () => {
  const depositInitiate = useCustomInstance<InitiateDepositResponseDto>();

  return useCallback(
    (initiateDepositDto: InitiateDepositDto, signal?: AbortSignal) => {
      return depositInitiate({
        url: `/deposit/initiate`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: initiateDepositDto,
        signal,
      });
    },
    [depositInitiate],
  );
};

export const useDepositInitiateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDepositInitiateHook>>>,
    TError,
    { data: InitiateDepositDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useDepositInitiateHook>>>,
  TError,
  { data: InitiateDepositDto },
  TContext
> => {
  const mutationKey = ['depositInitiate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const depositInitiate = useDepositInitiateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useDepositInitiateHook>>>,
    { data: InitiateDepositDto }
  > = (props) => {
    const { data } = props ?? {};

    return depositInitiate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DepositInitiateMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDepositInitiateHook>>>>;
export type DepositInitiateMutationBody = InitiateDepositDto;
export type DepositInitiateMutationError = unknown;

/**
 * @summary Create a deposit intent ready for the Pay.com SDK session flow
 */
export const useDepositInitiate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useDepositInitiateHook>>>,
      TError,
      { data: InitiateDepositDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useDepositInitiateHook>>>,
  TError,
  { data: InitiateDepositDto },
  TContext
> => {
  const mutationOptions = useDepositInitiateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Re-point a live deposit intent at a new amount/offer, PATCHing the mounted Pay.com session in place. The UI calls checkout.resync() afterwards so the SDK picks up the new amount without a remount. The offer binding is replaced wholesale: omitting it clears any bound offer.
 */
export const useDepositUpdateHook = () => {
  const depositUpdate = useCustomInstance<InitiateDepositResponseDto>();

  return useCallback(
    (id: string, initiateDepositDto: InitiateDepositDto) => {
      return depositUpdate({
        url: `/deposit/${id}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: initiateDepositDto,
      });
    },
    [depositUpdate],
  );
};

export const useDepositUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDepositUpdateHook>>>,
    TError,
    { id: string; data: InitiateDepositDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useDepositUpdateHook>>>,
  TError,
  { id: string; data: InitiateDepositDto },
  TContext
> => {
  const mutationKey = ['depositUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const depositUpdate = useDepositUpdateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useDepositUpdateHook>>>,
    { id: string; data: InitiateDepositDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return depositUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type DepositUpdateMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDepositUpdateHook>>>>;
export type DepositUpdateMutationBody = InitiateDepositDto;
export type DepositUpdateMutationError = unknown;

/**
 * @summary Re-point a live deposit intent at a new amount/offer, PATCHing the mounted Pay.com session in place. The UI calls checkout.resync() afterwards so the SDK picks up the new amount without a remount. The offer binding is replaced wholesale: omitting it clears any bound offer.
 */
export const useDepositUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useDepositUpdateHook>>>,
      TError,
      { id: string; data: InitiateDepositDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useDepositUpdateHook>>>,
  TError,
  { id: string; data: InitiateDepositDto },
  TContext
> => {
  const mutationOptions = useDepositUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get the current state of a deposit. UI polls this while a session-mode SDK flow is in flight; the webhook handler transitions the row, so this is the source of truth.
 */
export const useDepositGetDepositHook = () => {
  const depositGetDeposit = useCustomInstance<DepositStatusResponseDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return depositGetDeposit({ url: `/deposit/${id}`, method: 'GET', signal });
    },
    [depositGetDeposit],
  );
};

export const getDepositGetDepositQueryKey = (id: string) => {
  return [`/deposit/${id}`] as const;
};

export const useDepositGetDepositQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useDepositGetDepositHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDepositGetDepositHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getDepositGetDepositQueryKey(id);

  const depositGetDeposit = useDepositGetDepositHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useDepositGetDepositHook>>>> = ({ signal }) =>
    depositGetDeposit(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useDepositGetDepositHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type DepositGetDepositQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDepositGetDepositHook>>>>;
export type DepositGetDepositQueryError = unknown;

export function useDepositGetDeposit<
  TData = Awaited<ReturnType<ReturnType<typeof useDepositGetDepositHook>>>,
  TError = unknown,
>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDepositGetDepositHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDepositGetDepositHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDepositGetDepositHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDepositGetDeposit<
  TData = Awaited<ReturnType<ReturnType<typeof useDepositGetDepositHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDepositGetDepositHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useDepositGetDepositHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useDepositGetDepositHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useDepositGetDeposit<
  TData = Awaited<ReturnType<ReturnType<typeof useDepositGetDepositHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDepositGetDepositHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the current state of a deposit. UI polls this while a session-mode SDK flow is in flight; the webhook handler transitions the row, so this is the source of truth.
 */

export function useDepositGetDeposit<
  TData = Awaited<ReturnType<ReturnType<typeof useDepositGetDepositHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useDepositGetDepositHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useDepositGetDepositQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Permanently remove one of the current user saved payment methods from the Pay.com vault. Idempotent; a payment method that does not belong to the caller 404s.
 */
export const useDepositDeletePaymentMethodHook = () => {
  const depositDeletePaymentMethod = useCustomInstance<void>();

  return useCallback(
    (paymentMethodId: string) => {
      return depositDeletePaymentMethod({ url: `/deposit/payment-methods/${paymentMethodId}`, method: 'DELETE' });
    },
    [depositDeletePaymentMethod],
  );
};

export const useDepositDeletePaymentMethodMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDepositDeletePaymentMethodHook>>>,
    TError,
    { paymentMethodId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useDepositDeletePaymentMethodHook>>>,
  TError,
  { paymentMethodId: string },
  TContext
> => {
  const mutationKey = ['depositDeletePaymentMethod'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const depositDeletePaymentMethod = useDepositDeletePaymentMethodHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useDepositDeletePaymentMethodHook>>>,
    { paymentMethodId: string }
  > = (props) => {
    const { paymentMethodId } = props ?? {};

    return depositDeletePaymentMethod(paymentMethodId);
  };

  return { mutationFn, ...mutationOptions };
};

export type DepositDeletePaymentMethodMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useDepositDeletePaymentMethodHook>>>
>;

export type DepositDeletePaymentMethodMutationError = unknown;

/**
 * @summary Permanently remove one of the current user saved payment methods from the Pay.com vault. Idempotent; a payment method that does not belong to the caller 404s.
 */
export const useDepositDeletePaymentMethod = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useDepositDeletePaymentMethodHook>>>,
      TError,
      { paymentMethodId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useDepositDeletePaymentMethodHook>>>,
  TError,
  { paymentMethodId: string },
  TContext
> => {
  const mutationOptions = useDepositDeletePaymentMethodMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Mint a Pay.com payment session for an existing deposit; UI uses the client_secret to mount the SDK
 */
export const useDepositCreateSessionHook = () => {
  const depositCreateSession = useCustomInstance<PaymentSessionResponseDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return depositCreateSession({ url: `/deposit/${id}/session`, method: 'POST', signal });
    },
    [depositCreateSession],
  );
};

export const useDepositCreateSessionMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useDepositCreateSessionHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useDepositCreateSessionHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['depositCreateSession'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const depositCreateSession = useDepositCreateSessionHook();

  const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDepositCreateSessionHook>>>, { id: string }> = (
    props,
  ) => {
    const { id } = props ?? {};

    return depositCreateSession(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DepositCreateSessionMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useDepositCreateSessionHook>>>
>;

export type DepositCreateSessionMutationError = unknown;

/**
 * @summary Mint a Pay.com payment session for an existing deposit; UI uses the client_secret to mount the SDK
 */
export const useDepositCreateSession = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useDepositCreateSessionHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useDepositCreateSessionHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationOptions = useDepositCreateSessionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Pay.com webhook ingress (HMAC-verified, idempotent)
 */
export const usePaycomWebhookIngestHook = () => {
  const paycomWebhookIngest = useCustomInstance<void>();

  return useCallback(
    (signal?: AbortSignal) => {
      return paycomWebhookIngest({ url: `/webhooks/paycom`, method: 'POST', signal });
    },
    [paycomWebhookIngest],
  );
};

export const usePaycomWebhookIngestMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePaycomWebhookIngestHook>>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof usePaycomWebhookIngestHook>>>, TError, void, TContext> => {
  const mutationKey = ['paycomWebhookIngest'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const paycomWebhookIngest = usePaycomWebhookIngestHook();

  const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof usePaycomWebhookIngestHook>>>, void> = () => {
    return paycomWebhookIngest();
  };

  return { mutationFn, ...mutationOptions };
};

export type PaycomWebhookIngestMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePaycomWebhookIngestHook>>>
>;

export type PaycomWebhookIngestMutationError = unknown;

/**
 * @summary Pay.com webhook ingress (HMAC-verified, idempotent)
 */
export const usePaycomWebhookIngest = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof usePaycomWebhookIngestHook>>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<ReturnType<typeof usePaycomWebhookIngestHook>>>, TError, void, TContext> => {
  const mutationOptions = usePaycomWebhookIngestMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get prediction market categories with subcategories
 */
export const usePredictionMarketCategoriesHook = () => {
  const predictionMarketCategories = useCustomInstance<CategoryResponseDto[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return predictionMarketCategories({ url: `/prediction-market/categories`, method: 'GET', signal });
    },
    [predictionMarketCategories],
  );
};

export const getPredictionMarketCategoriesQueryKey = () => {
  return [`/prediction-market/categories`] as const;
};

export const usePredictionMarketCategoriesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketCategoriesHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketCategoriesHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPredictionMarketCategoriesQueryKey();

  const predictionMarketCategories = usePredictionMarketCategoriesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof usePredictionMarketCategoriesHook>>>> = ({ signal }) =>
    predictionMarketCategories(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof usePredictionMarketCategoriesHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PredictionMarketCategoriesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePredictionMarketCategoriesHook>>>
>;
export type PredictionMarketCategoriesQueryError = unknown;

export function usePredictionMarketCategories<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketCategoriesHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketCategoriesHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketCategoriesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketCategoriesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePredictionMarketCategories<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketCategoriesHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketCategoriesHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketCategoriesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketCategoriesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePredictionMarketCategories<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketCategoriesHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketCategoriesHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get prediction market categories with subcategories
 */

export function usePredictionMarketCategories<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketCategoriesHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketCategoriesHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = usePredictionMarketCategoriesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Lobby feed — binary-question event cards (optionally scoped to a category / sub-category)
 */
export const usePredictionMarketEventsFindLobbyHook = () => {
  const predictionMarketEventsFindLobby = useCustomInstance<LobbyResponseDto>();

  return useCallback(
    (params?: PredictionMarketEventsFindLobbyParams, signal?: AbortSignal) => {
      return predictionMarketEventsFindLobby({ url: `/prediction-market/events`, method: 'GET', params, signal });
    },
    [predictionMarketEventsFindLobby],
  );
};

export const getPredictionMarketEventsFindLobbyQueryKey = (params?: PredictionMarketEventsFindLobbyParams) => {
  return [`/prediction-market/events`, ...(params ? [params] : [])] as const;
};

export const usePredictionMarketEventsFindLobbyQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindLobbyHook>>>,
  TError = unknown,
>(
  params?: PredictionMarketEventsFindLobbyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindLobbyHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPredictionMarketEventsFindLobbyQueryKey(params);

  const predictionMarketEventsFindLobby = usePredictionMarketEventsFindLobbyHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindLobbyHook>>>> = ({
    signal,
  }) => predictionMarketEventsFindLobby(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindLobbyHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PredictionMarketEventsFindLobbyQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindLobbyHook>>>
>;
export type PredictionMarketEventsFindLobbyQueryError = unknown;

export function usePredictionMarketEventsFindLobby<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindLobbyHook>>>,
  TError = unknown,
>(
  params: undefined | PredictionMarketEventsFindLobbyParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindLobbyHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindLobbyHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindLobbyHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePredictionMarketEventsFindLobby<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindLobbyHook>>>,
  TError = unknown,
>(
  params?: PredictionMarketEventsFindLobbyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindLobbyHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindLobbyHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindLobbyHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePredictionMarketEventsFindLobby<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindLobbyHook>>>,
  TError = unknown,
>(
  params?: PredictionMarketEventsFindLobbyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindLobbyHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Lobby feed — binary-question event cards (optionally scoped to a category / sub-category)
 */

export function usePredictionMarketEventsFindLobby<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindLobbyHook>>>,
  TError = unknown,
>(
  params?: PredictionMarketEventsFindLobbyParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindLobbyHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = usePredictionMarketEventsFindLobbyQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Trending (related) markets — top 7 in the same sub-category, parent-category fallback
 */
export const usePredictionMarketEventsFindTrendingHook = () => {
  const predictionMarketEventsFindTrending = useCustomInstance<TrendingResponseDto>();

  return useCallback(
    (eventId: string, signal?: AbortSignal) => {
      return predictionMarketEventsFindTrending({
        url: `/prediction-market/events/${eventId}/trending`,
        method: 'GET',
        signal,
      });
    },
    [predictionMarketEventsFindTrending],
  );
};

export const getPredictionMarketEventsFindTrendingQueryKey = (eventId: string) => {
  return [`/prediction-market/events/${eventId}/trending`] as const;
};

export const usePredictionMarketEventsFindTrendingQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindTrendingHook>>>,
  TError = unknown,
>(
  eventId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindTrendingHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPredictionMarketEventsFindTrendingQueryKey(eventId);

  const predictionMarketEventsFindTrending = usePredictionMarketEventsFindTrendingHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindTrendingHook>>>> = ({
    signal,
  }) => predictionMarketEventsFindTrending(eventId, signal);

  return { queryKey, queryFn, enabled: !!eventId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindTrendingHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PredictionMarketEventsFindTrendingQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindTrendingHook>>>
>;
export type PredictionMarketEventsFindTrendingQueryError = unknown;

export function usePredictionMarketEventsFindTrending<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindTrendingHook>>>,
  TError = unknown,
>(
  eventId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindTrendingHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindTrendingHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindTrendingHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePredictionMarketEventsFindTrending<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindTrendingHook>>>,
  TError = unknown,
>(
  eventId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindTrendingHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindTrendingHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindTrendingHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePredictionMarketEventsFindTrending<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindTrendingHook>>>,
  TError = unknown,
>(
  eventId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindTrendingHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Trending (related) markets — top 7 in the same sub-category, parent-category fallback
 */

export function usePredictionMarketEventsFindTrending<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindTrendingHook>>>,
  TError = unknown,
>(
  eventId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindTrendingHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = usePredictionMarketEventsFindTrendingQueryOptions(eventId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Binary-question page — event header + its markets (primary Yes/No + Market Rules)
 */
export const usePredictionMarketEventsFindByIdHook = () => {
  const predictionMarketEventsFindById = useCustomInstance<EventDetailDto>();

  return useCallback(
    (eventId: string, signal?: AbortSignal) => {
      return predictionMarketEventsFindById({ url: `/prediction-market/events/${eventId}`, method: 'GET', signal });
    },
    [predictionMarketEventsFindById],
  );
};

export const getPredictionMarketEventsFindByIdQueryKey = (eventId: string) => {
  return [`/prediction-market/events/${eventId}`] as const;
};

export const usePredictionMarketEventsFindByIdQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindByIdHook>>>,
  TError = unknown,
>(
  eventId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindByIdHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPredictionMarketEventsFindByIdQueryKey(eventId);

  const predictionMarketEventsFindById = usePredictionMarketEventsFindByIdHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindByIdHook>>>> = ({
    signal,
  }) => predictionMarketEventsFindById(eventId, signal);

  return { queryKey, queryFn, enabled: !!eventId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindByIdHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PredictionMarketEventsFindByIdQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindByIdHook>>>
>;
export type PredictionMarketEventsFindByIdQueryError = unknown;

export function usePredictionMarketEventsFindById<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindByIdHook>>>,
  TError = unknown,
>(
  eventId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindByIdHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindByIdHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindByIdHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePredictionMarketEventsFindById<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindByIdHook>>>,
  TError = unknown,
>(
  eventId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindByIdHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindByIdHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindByIdHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePredictionMarketEventsFindById<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindByIdHook>>>,
  TError = unknown,
>(
  eventId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindByIdHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Binary-question page — event header + its markets (primary Yes/No + Market Rules)
 */

export function usePredictionMarketEventsFindById<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindByIdHook>>>,
  TError = unknown,
>(
  eventId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsFindByIdHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = usePredictionMarketEventsFindByIdQueryOptions(eventId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Outcome price history for the page graph (proxied from Plaee)
 */
export const usePredictionMarketEventsGetPriceHistoryHook = () => {
  const predictionMarketEventsGetPriceHistory = useCustomInstance<PriceHistoryResponseDto>();

  return useCallback(
    (outcomeId: string, params: PredictionMarketEventsGetPriceHistoryParams, signal?: AbortSignal) => {
      return predictionMarketEventsGetPriceHistory({
        url: `/prediction-market/outcomes/${outcomeId}/history`,
        method: 'GET',
        params,
        signal,
      });
    },
    [predictionMarketEventsGetPriceHistory],
  );
};

export const getPredictionMarketEventsGetPriceHistoryQueryKey = (
  outcomeId: string,
  params: PredictionMarketEventsGetPriceHistoryParams,
) => {
  return [`/prediction-market/outcomes/${outcomeId}/history`, ...(params ? [params] : [])] as const;
};

export const usePredictionMarketEventsGetPriceHistoryQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsGetPriceHistoryHook>>>,
  TError = unknown,
>(
  outcomeId: string,
  params: PredictionMarketEventsGetPriceHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsGetPriceHistoryHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPredictionMarketEventsGetPriceHistoryQueryKey(outcomeId, params);

  const predictionMarketEventsGetPriceHistory = usePredictionMarketEventsGetPriceHistoryHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsGetPriceHistoryHook>>>> = ({
    signal,
  }) => predictionMarketEventsGetPriceHistory(outcomeId, params, signal);

  return { queryKey, queryFn, enabled: !!outcomeId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsGetPriceHistoryHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PredictionMarketEventsGetPriceHistoryQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsGetPriceHistoryHook>>>
>;
export type PredictionMarketEventsGetPriceHistoryQueryError = unknown;

export function usePredictionMarketEventsGetPriceHistory<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsGetPriceHistoryHook>>>,
  TError = unknown,
>(
  outcomeId: string,
  params: PredictionMarketEventsGetPriceHistoryParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsGetPriceHistoryHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsGetPriceHistoryHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsGetPriceHistoryHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePredictionMarketEventsGetPriceHistory<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsGetPriceHistoryHook>>>,
  TError = unknown,
>(
  outcomeId: string,
  params: PredictionMarketEventsGetPriceHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsGetPriceHistoryHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsGetPriceHistoryHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsGetPriceHistoryHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePredictionMarketEventsGetPriceHistory<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsGetPriceHistoryHook>>>,
  TError = unknown,
>(
  outcomeId: string,
  params: PredictionMarketEventsGetPriceHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsGetPriceHistoryHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Outcome price history for the page graph (proxied from Plaee)
 */

export function usePredictionMarketEventsGetPriceHistory<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsGetPriceHistoryHook>>>,
  TError = unknown,
>(
  outcomeId: string,
  params: PredictionMarketEventsGetPriceHistoryParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketEventsGetPriceHistoryHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = usePredictionMarketEventsGetPriceHistoryQueryOptions(outcomeId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Live page feed — eligible events grouped by time-to-resolution (Closing Soon / Today / This Week)
 */
export const useLivePageFindLiveHook = () => {
  const livePageFindLive = useCustomInstance<LivePageResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return livePageFindLive({ url: `/prediction-market/live`, method: 'GET', signal });
    },
    [livePageFindLive],
  );
};

export const getLivePageFindLiveQueryKey = () => {
  return [`/prediction-market/live`] as const;
};

export const useLivePageFindLiveQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useLivePageFindLiveHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLivePageFindLiveHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLivePageFindLiveQueryKey();

  const livePageFindLive = useLivePageFindLiveHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useLivePageFindLiveHook>>>> = ({ signal }) =>
    livePageFindLive(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useLivePageFindLiveHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LivePageFindLiveQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useLivePageFindLiveHook>>>>;
export type LivePageFindLiveQueryError = unknown;

export function useLivePageFindLive<
  TData = Awaited<ReturnType<ReturnType<typeof useLivePageFindLiveHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLivePageFindLiveHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useLivePageFindLiveHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useLivePageFindLiveHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLivePageFindLive<
  TData = Awaited<ReturnType<ReturnType<typeof useLivePageFindLiveHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLivePageFindLiveHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useLivePageFindLiveHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useLivePageFindLiveHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLivePageFindLive<
  TData = Awaited<ReturnType<ReturnType<typeof useLivePageFindLiveHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLivePageFindLiveHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Live page feed — eligible events grouped by time-to-resolution (Closing Soon / Today / This Week)
 */

export function useLivePageFindLive<
  TData = Awaited<ReturnType<ReturnType<typeof useLivePageFindLiveHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLivePageFindLiveHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useLivePageFindLiveQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Live event search — direct matches (event title > market title > description), volume tiebreak
 */
export const usePredictionMarketSearchHook = () => {
  const predictionMarketSearch = useCustomInstance<SearchResponseDto>();

  return useCallback(
    (params: PredictionMarketSearchParams, signal?: AbortSignal) => {
      return predictionMarketSearch({ url: `/prediction-market/search`, method: 'GET', params, signal });
    },
    [predictionMarketSearch],
  );
};

export const getPredictionMarketSearchQueryKey = (params: PredictionMarketSearchParams) => {
  return [`/prediction-market/search`, ...(params ? [params] : [])] as const;
};

export const usePredictionMarketSearchQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketSearchHook>>>,
  TError = unknown,
>(
  params: PredictionMarketSearchParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketSearchHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getPredictionMarketSearchQueryKey(params);

  const predictionMarketSearch = usePredictionMarketSearchHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof usePredictionMarketSearchHook>>>> = ({ signal }) =>
    predictionMarketSearch(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof usePredictionMarketSearchHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type PredictionMarketSearchQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof usePredictionMarketSearchHook>>>
>;
export type PredictionMarketSearchQueryError = unknown;

export function usePredictionMarketSearch<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketSearchHook>>>,
  TError = unknown,
>(
  params: PredictionMarketSearchParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketSearchHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketSearchHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketSearchHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePredictionMarketSearch<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketSearchHook>>>,
  TError = unknown,
>(
  params: PredictionMarketSearchParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketSearchHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketSearchHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof usePredictionMarketSearchHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function usePredictionMarketSearch<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketSearchHook>>>,
  TError = unknown,
>(
  params: PredictionMarketSearchParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketSearchHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Live event search — direct matches (event title > market title > description), volume tiebreak
 */

export function usePredictionMarketSearch<
  TData = Awaited<ReturnType<ReturnType<typeof usePredictionMarketSearchHook>>>,
  TError = unknown,
>(
  params: PredictionMarketSearchParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof usePredictionMarketSearchHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = usePredictionMarketSearchQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Proxies to Plaee `POST /external/v1/prediction-market/realtime/auth` using the cached Plaee customer JWT and returns the resulting Centrifugo token alongside the user's Plaee customer id. The FE uses this to open the direct path-B connection (channel `user:#<plaeeCustomerId>`).
 * @summary Mint a Plaee Centrifugo token for the authenticated user
 */
export const useRealtimeAuthHook = () => {
  const realtimeAuth = useCustomInstance<RealtimeAuthResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return realtimeAuth({ url: `/prediction-market/realtime/auth`, method: 'POST', signal });
    },
    [realtimeAuth],
  );
};

export const useRealtimeAuthMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useRealtimeAuthHook>>>, TError, void, TContext>;
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useRealtimeAuthHook>>>, TError, void, TContext> => {
  const mutationKey = ['realtimeAuth'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const realtimeAuth = useRealtimeAuthHook();

  const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useRealtimeAuthHook>>>, void> = () => {
    return realtimeAuth();
  };

  return { mutationFn, ...mutationOptions };
};

export type RealtimeAuthMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useRealtimeAuthHook>>>>;

export type RealtimeAuthMutationError = unknown;

/**
 * @summary Mint a Plaee Centrifugo token for the authenticated user
 */
export const useRealtimeAuth = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useRealtimeAuthHook>>>, TError, void, TContext>;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useRealtimeAuthHook>>>, TError, void, TContext> => {
  const mutationOptions = useRealtimeAuthMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List the authenticated customer's orders (local mirror)
 */
export const useTradingOrderListOrdersHook = () => {
  const tradingOrderListOrders = useCustomInstance<PlaeeOrderResponseDto[]>();

  return useCallback(
    (params?: TradingOrderListOrdersParams, signal?: AbortSignal) => {
      return tradingOrderListOrders({ url: `/plaee/orders`, method: 'GET', params, signal });
    },
    [tradingOrderListOrders],
  );
};

export const getTradingOrderListOrdersQueryKey = (params?: TradingOrderListOrdersParams) => {
  return [`/plaee/orders`, ...(params ? [params] : [])] as const;
};

export const useTradingOrderListOrdersQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useTradingOrderListOrdersHook>>>,
  TError = unknown,
>(
  params?: TradingOrderListOrdersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingOrderListOrdersHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTradingOrderListOrdersQueryKey(params);

  const tradingOrderListOrders = useTradingOrderListOrdersHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useTradingOrderListOrdersHook>>>> = ({ signal }) =>
    tradingOrderListOrders(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useTradingOrderListOrdersHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TradingOrderListOrdersQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useTradingOrderListOrdersHook>>>
>;
export type TradingOrderListOrdersQueryError = unknown;

export function useTradingOrderListOrders<
  TData = Awaited<ReturnType<ReturnType<typeof useTradingOrderListOrdersHook>>>,
  TError = unknown,
>(
  params: undefined | TradingOrderListOrdersParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingOrderListOrdersHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useTradingOrderListOrdersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useTradingOrderListOrdersHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTradingOrderListOrders<
  TData = Awaited<ReturnType<ReturnType<typeof useTradingOrderListOrdersHook>>>,
  TError = unknown,
>(
  params?: TradingOrderListOrdersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingOrderListOrdersHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useTradingOrderListOrdersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useTradingOrderListOrdersHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTradingOrderListOrders<
  TData = Awaited<ReturnType<ReturnType<typeof useTradingOrderListOrdersHook>>>,
  TError = unknown,
>(
  params?: TradingOrderListOrdersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingOrderListOrdersHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List the authenticated customer's orders (local mirror)
 */

export function useTradingOrderListOrders<
  TData = Awaited<ReturnType<ReturnType<typeof useTradingOrderListOrdersHook>>>,
  TError = unknown,
>(
  params?: TradingOrderListOrdersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingOrderListOrdersHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useTradingOrderListOrdersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Place a new order
 */
export const useTradingOrderPlaceOrderHook = () => {
  const tradingOrderPlaceOrder = useCustomInstance<PlaeeOrderExecutionResultDto>();

  return useCallback(
    (placeOrderDto: PlaceOrderDto, signal?: AbortSignal) => {
      return tradingOrderPlaceOrder({
        url: `/plaee/orders`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: placeOrderDto,
        signal,
      });
    },
    [tradingOrderPlaceOrder],
  );
};

export const useTradingOrderPlaceOrderMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useTradingOrderPlaceOrderHook>>>,
    TError,
    { data: PlaceOrderDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useTradingOrderPlaceOrderHook>>>,
  TError,
  { data: PlaceOrderDto },
  TContext
> => {
  const mutationKey = ['tradingOrderPlaceOrder'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const tradingOrderPlaceOrder = useTradingOrderPlaceOrderHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useTradingOrderPlaceOrderHook>>>,
    { data: PlaceOrderDto }
  > = (props) => {
    const { data } = props ?? {};

    return tradingOrderPlaceOrder(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TradingOrderPlaceOrderMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useTradingOrderPlaceOrderHook>>>
>;
export type TradingOrderPlaceOrderMutationBody = PlaceOrderDto;
export type TradingOrderPlaceOrderMutationError = unknown;

/**
 * @summary Place a new order
 */
export const useTradingOrderPlaceOrder = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useTradingOrderPlaceOrderHook>>>,
      TError,
      { data: PlaceOrderDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useTradingOrderPlaceOrderHook>>>,
  TError,
  { data: PlaceOrderDto },
  TContext
> => {
  const mutationOptions = useTradingOrderPlaceOrderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Per-bucket order counts for the portfolio tab badges (local mirror)
 */
export const useTradingOrderGetCountsHook = () => {
  const tradingOrderGetCounts = useCustomInstance<OrderCountsResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return tradingOrderGetCounts({ url: `/plaee/orders/counts`, method: 'GET', signal });
    },
    [tradingOrderGetCounts],
  );
};

export const getTradingOrderGetCountsQueryKey = () => {
  return [`/plaee/orders/counts`] as const;
};

export const useTradingOrderGetCountsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useTradingOrderGetCountsHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingOrderGetCountsHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTradingOrderGetCountsQueryKey();

  const tradingOrderGetCounts = useTradingOrderGetCountsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useTradingOrderGetCountsHook>>>> = ({ signal }) =>
    tradingOrderGetCounts(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useTradingOrderGetCountsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TradingOrderGetCountsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useTradingOrderGetCountsHook>>>
>;
export type TradingOrderGetCountsQueryError = unknown;

export function useTradingOrderGetCounts<
  TData = Awaited<ReturnType<ReturnType<typeof useTradingOrderGetCountsHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingOrderGetCountsHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useTradingOrderGetCountsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useTradingOrderGetCountsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTradingOrderGetCounts<
  TData = Awaited<ReturnType<ReturnType<typeof useTradingOrderGetCountsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingOrderGetCountsHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useTradingOrderGetCountsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useTradingOrderGetCountsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTradingOrderGetCounts<
  TData = Awaited<ReturnType<ReturnType<typeof useTradingOrderGetCountsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingOrderGetCountsHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Per-bucket order counts for the portfolio tab badges (local mirror)
 */

export function useTradingOrderGetCounts<
  TData = Awaited<ReturnType<ReturnType<typeof useTradingOrderGetCountsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingOrderGetCountsHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useTradingOrderGetCountsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get one of the authenticated customer's orders by id (local mirror)
 */
export const useTradingOrderGetOrderHook = () => {
  const tradingOrderGetOrder = useCustomInstance<PlaeeOrderResponseDto>();

  return useCallback(
    (orderId: string, signal?: AbortSignal) => {
      return tradingOrderGetOrder({ url: `/plaee/orders/${orderId}`, method: 'GET', signal });
    },
    [tradingOrderGetOrder],
  );
};

export const getTradingOrderGetOrderQueryKey = (orderId: string) => {
  return [`/plaee/orders/${orderId}`] as const;
};

export const useTradingOrderGetOrderQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useTradingOrderGetOrderHook>>>,
  TError = unknown,
>(
  orderId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingOrderGetOrderHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTradingOrderGetOrderQueryKey(orderId);

  const tradingOrderGetOrder = useTradingOrderGetOrderHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useTradingOrderGetOrderHook>>>> = ({ signal }) =>
    tradingOrderGetOrder(orderId, signal);

  return { queryKey, queryFn, enabled: !!orderId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useTradingOrderGetOrderHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TradingOrderGetOrderQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useTradingOrderGetOrderHook>>>
>;
export type TradingOrderGetOrderQueryError = unknown;

export function useTradingOrderGetOrder<
  TData = Awaited<ReturnType<ReturnType<typeof useTradingOrderGetOrderHook>>>,
  TError = unknown,
>(
  orderId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingOrderGetOrderHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useTradingOrderGetOrderHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useTradingOrderGetOrderHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTradingOrderGetOrder<
  TData = Awaited<ReturnType<ReturnType<typeof useTradingOrderGetOrderHook>>>,
  TError = unknown,
>(
  orderId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingOrderGetOrderHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useTradingOrderGetOrderHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useTradingOrderGetOrderHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTradingOrderGetOrder<
  TData = Awaited<ReturnType<ReturnType<typeof useTradingOrderGetOrderHook>>>,
  TError = unknown,
>(
  orderId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingOrderGetOrderHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get one of the authenticated customer's orders by id (local mirror)
 */

export function useTradingOrderGetOrder<
  TData = Awaited<ReturnType<ReturnType<typeof useTradingOrderGetOrderHook>>>,
  TError = unknown,
>(
  orderId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingOrderGetOrderHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useTradingOrderGetOrderQueryOptions(orderId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Amend an existing order
 */
export const useTradingOrderAmendOrderHook = () => {
  const tradingOrderAmendOrder = useCustomInstance<PlaeeOrderExecutionResultDto>();

  return useCallback(
    (orderId: string, amendOrderDto: AmendOrderDto) => {
      return tradingOrderAmendOrder({
        url: `/plaee/orders/${orderId}`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: amendOrderDto,
      });
    },
    [tradingOrderAmendOrder],
  );
};

export const useTradingOrderAmendOrderMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useTradingOrderAmendOrderHook>>>,
    TError,
    { orderId: string; data: AmendOrderDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useTradingOrderAmendOrderHook>>>,
  TError,
  { orderId: string; data: AmendOrderDto },
  TContext
> => {
  const mutationKey = ['tradingOrderAmendOrder'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const tradingOrderAmendOrder = useTradingOrderAmendOrderHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useTradingOrderAmendOrderHook>>>,
    { orderId: string; data: AmendOrderDto }
  > = (props) => {
    const { orderId, data } = props ?? {};

    return tradingOrderAmendOrder(orderId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TradingOrderAmendOrderMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useTradingOrderAmendOrderHook>>>
>;
export type TradingOrderAmendOrderMutationBody = AmendOrderDto;
export type TradingOrderAmendOrderMutationError = unknown;

/**
 * @summary Amend an existing order
 */
export const useTradingOrderAmendOrder = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useTradingOrderAmendOrderHook>>>,
      TError,
      { orderId: string; data: AmendOrderDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useTradingOrderAmendOrderHook>>>,
  TError,
  { orderId: string; data: AmendOrderDto },
  TContext
> => {
  const mutationOptions = useTradingOrderAmendOrderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Cancel an existing order
 */
export const useTradingOrderCancelOrderHook = () => {
  const tradingOrderCancelOrder = useCustomInstance<PlaeeOrderExecutionResultDto>();

  return useCallback(
    (orderId: string, cancelOrderDto: CancelOrderDto) => {
      return tradingOrderCancelOrder({
        url: `/plaee/orders/${orderId}`,
        method: 'DELETE',
        headers: { 'Content-Type': 'application/json' },
        data: cancelOrderDto,
      });
    },
    [tradingOrderCancelOrder],
  );
};

export const useTradingOrderCancelOrderMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useTradingOrderCancelOrderHook>>>,
    TError,
    { orderId: string; data: CancelOrderDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useTradingOrderCancelOrderHook>>>,
  TError,
  { orderId: string; data: CancelOrderDto },
  TContext
> => {
  const mutationKey = ['tradingOrderCancelOrder'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const tradingOrderCancelOrder = useTradingOrderCancelOrderHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useTradingOrderCancelOrderHook>>>,
    { orderId: string; data: CancelOrderDto }
  > = (props) => {
    const { orderId, data } = props ?? {};

    return tradingOrderCancelOrder(orderId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type TradingOrderCancelOrderMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useTradingOrderCancelOrderHook>>>
>;
export type TradingOrderCancelOrderMutationBody = CancelOrderDto;
export type TradingOrderCancelOrderMutationError = unknown;

/**
 * @summary Cancel an existing order
 */
export const useTradingOrderCancelOrder = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useTradingOrderCancelOrderHook>>>,
      TError,
      { orderId: string; data: CancelOrderDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useTradingOrderCancelOrderHook>>>,
  TError,
  { orderId: string; data: CancelOrderDto },
  TContext
> => {
  const mutationOptions = useTradingOrderCancelOrderMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List the authenticated customer's positions (local mirror)
 */
export const useTradingPositionListPositionsHook = () => {
  const tradingPositionListPositions = useCustomInstance<PlaeePositionResponseDto[]>();

  return useCallback(
    (params?: TradingPositionListPositionsParams, signal?: AbortSignal) => {
      return tradingPositionListPositions({ url: `/plaee/positions`, method: 'GET', params, signal });
    },
    [tradingPositionListPositions],
  );
};

export const getTradingPositionListPositionsQueryKey = (params?: TradingPositionListPositionsParams) => {
  return [`/plaee/positions`, ...(params ? [params] : [])] as const;
};

export const useTradingPositionListPositionsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useTradingPositionListPositionsHook>>>,
  TError = unknown,
>(
  params?: TradingPositionListPositionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingPositionListPositionsHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTradingPositionListPositionsQueryKey(params);

  const tradingPositionListPositions = useTradingPositionListPositionsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useTradingPositionListPositionsHook>>>> = ({ signal }) =>
    tradingPositionListPositions(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useTradingPositionListPositionsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TradingPositionListPositionsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useTradingPositionListPositionsHook>>>
>;
export type TradingPositionListPositionsQueryError = unknown;

export function useTradingPositionListPositions<
  TData = Awaited<ReturnType<ReturnType<typeof useTradingPositionListPositionsHook>>>,
  TError = unknown,
>(
  params: undefined | TradingPositionListPositionsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingPositionListPositionsHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useTradingPositionListPositionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useTradingPositionListPositionsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTradingPositionListPositions<
  TData = Awaited<ReturnType<ReturnType<typeof useTradingPositionListPositionsHook>>>,
  TError = unknown,
>(
  params?: TradingPositionListPositionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingPositionListPositionsHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useTradingPositionListPositionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useTradingPositionListPositionsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTradingPositionListPositions<
  TData = Awaited<ReturnType<ReturnType<typeof useTradingPositionListPositionsHook>>>,
  TError = unknown,
>(
  params?: TradingPositionListPositionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingPositionListPositionsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List the authenticated customer's positions (local mirror)
 */

export function useTradingPositionListPositions<
  TData = Awaited<ReturnType<ReturnType<typeof useTradingPositionListPositionsHook>>>,
  TError = unknown,
>(
  params?: TradingPositionListPositionsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingPositionListPositionsHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useTradingPositionListPositionsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Per-status position counts for the portfolio tab badges (local mirror)
 */
export const useTradingPositionGetCountsHook = () => {
  const tradingPositionGetCounts = useCustomInstance<PositionCountsResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return tradingPositionGetCounts({ url: `/plaee/positions/counts`, method: 'GET', signal });
    },
    [tradingPositionGetCounts],
  );
};

export const getTradingPositionGetCountsQueryKey = () => {
  return [`/plaee/positions/counts`] as const;
};

export const useTradingPositionGetCountsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useTradingPositionGetCountsHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingPositionGetCountsHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTradingPositionGetCountsQueryKey();

  const tradingPositionGetCounts = useTradingPositionGetCountsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useTradingPositionGetCountsHook>>>> = ({ signal }) =>
    tradingPositionGetCounts(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useTradingPositionGetCountsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TradingPositionGetCountsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useTradingPositionGetCountsHook>>>
>;
export type TradingPositionGetCountsQueryError = unknown;

export function useTradingPositionGetCounts<
  TData = Awaited<ReturnType<ReturnType<typeof useTradingPositionGetCountsHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingPositionGetCountsHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useTradingPositionGetCountsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useTradingPositionGetCountsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTradingPositionGetCounts<
  TData = Awaited<ReturnType<ReturnType<typeof useTradingPositionGetCountsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingPositionGetCountsHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useTradingPositionGetCountsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useTradingPositionGetCountsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTradingPositionGetCounts<
  TData = Awaited<ReturnType<ReturnType<typeof useTradingPositionGetCountsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingPositionGetCountsHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Per-status position counts for the portfolio tab badges (local mirror)
 */

export function useTradingPositionGetCounts<
  TData = Awaited<ReturnType<ReturnType<typeof useTradingPositionGetCountsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingPositionGetCountsHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useTradingPositionGetCountsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get the authenticated customer's portfolio summary (live)
 */
export const useTradingPositionGetPortfolioHook = () => {
  const tradingPositionGetPortfolio = useCustomInstance<PlaeePortfolioResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return tradingPositionGetPortfolio({ url: `/plaee/positions/portfolio`, method: 'GET', signal });
    },
    [tradingPositionGetPortfolio],
  );
};

export const getTradingPositionGetPortfolioQueryKey = () => {
  return [`/plaee/positions/portfolio`] as const;
};

export const useTradingPositionGetPortfolioQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPortfolioHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPortfolioHook>>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTradingPositionGetPortfolioQueryKey();

  const tradingPositionGetPortfolio = useTradingPositionGetPortfolioHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPortfolioHook>>>> = ({ signal }) =>
    tradingPositionGetPortfolio(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPortfolioHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TradingPositionGetPortfolioQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPortfolioHook>>>
>;
export type TradingPositionGetPortfolioQueryError = unknown;

export function useTradingPositionGetPortfolio<
  TData = Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPortfolioHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPortfolioHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPortfolioHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPortfolioHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTradingPositionGetPortfolio<
  TData = Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPortfolioHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPortfolioHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPortfolioHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPortfolioHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTradingPositionGetPortfolio<
  TData = Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPortfolioHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPortfolioHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the authenticated customer's portfolio summary (live)
 */

export function useTradingPositionGetPortfolio<
  TData = Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPortfolioHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPortfolioHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useTradingPositionGetPortfolioQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get the authenticated customer's realized-PnL history (live)
 */
export const useTradingPositionGetPnlHook = () => {
  const tradingPositionGetPnl = useCustomInstance<PlaeePnlDataPointDto[]>();

  return useCallback(
    (params?: TradingPositionGetPnlParams, signal?: AbortSignal) => {
      return tradingPositionGetPnl({ url: `/plaee/positions/pnl`, method: 'GET', params, signal });
    },
    [tradingPositionGetPnl],
  );
};

export const getTradingPositionGetPnlQueryKey = (params?: TradingPositionGetPnlParams) => {
  return [`/plaee/positions/pnl`, ...(params ? [params] : [])] as const;
};

export const useTradingPositionGetPnlQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPnlHook>>>,
  TError = unknown,
>(
  params?: TradingPositionGetPnlParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPnlHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTradingPositionGetPnlQueryKey(params);

  const tradingPositionGetPnl = useTradingPositionGetPnlHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPnlHook>>>> = ({ signal }) =>
    tradingPositionGetPnl(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPnlHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TradingPositionGetPnlQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPnlHook>>>
>;
export type TradingPositionGetPnlQueryError = unknown;

export function useTradingPositionGetPnl<
  TData = Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPnlHook>>>,
  TError = unknown,
>(
  params: undefined | TradingPositionGetPnlParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPnlHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPnlHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPnlHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTradingPositionGetPnl<
  TData = Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPnlHook>>>,
  TError = unknown,
>(
  params?: TradingPositionGetPnlParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPnlHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPnlHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPnlHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTradingPositionGetPnl<
  TData = Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPnlHook>>>,
  TError = unknown,
>(
  params?: TradingPositionGetPnlParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPnlHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the authenticated customer's realized-PnL history (live)
 */

export function useTradingPositionGetPnl<
  TData = Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPnlHook>>>,
  TError = unknown,
>(
  params?: TradingPositionGetPnlParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingPositionGetPnlHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useTradingPositionGetPnlQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List the authenticated customer's executed trades (live)
 */
export const useTradingTradeListTradesHook = () => {
  const tradingTradeListTrades = useCustomInstance<PlaeeTradeResponseDto[]>();

  return useCallback(
    (params?: TradingTradeListTradesParams, signal?: AbortSignal) => {
      return tradingTradeListTrades({ url: `/plaee/trades`, method: 'GET', params, signal });
    },
    [tradingTradeListTrades],
  );
};

export const getTradingTradeListTradesQueryKey = (params?: TradingTradeListTradesParams) => {
  return [`/plaee/trades`, ...(params ? [params] : [])] as const;
};

export const useTradingTradeListTradesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useTradingTradeListTradesHook>>>,
  TError = unknown,
>(
  params?: TradingTradeListTradesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingTradeListTradesHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getTradingTradeListTradesQueryKey(params);

  const tradingTradeListTrades = useTradingTradeListTradesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useTradingTradeListTradesHook>>>> = ({ signal }) =>
    tradingTradeListTrades(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useTradingTradeListTradesHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type TradingTradeListTradesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useTradingTradeListTradesHook>>>
>;
export type TradingTradeListTradesQueryError = unknown;

export function useTradingTradeListTrades<
  TData = Awaited<ReturnType<ReturnType<typeof useTradingTradeListTradesHook>>>,
  TError = unknown,
>(
  params: undefined | TradingTradeListTradesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingTradeListTradesHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useTradingTradeListTradesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useTradingTradeListTradesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTradingTradeListTrades<
  TData = Awaited<ReturnType<ReturnType<typeof useTradingTradeListTradesHook>>>,
  TError = unknown,
>(
  params?: TradingTradeListTradesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingTradeListTradesHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useTradingTradeListTradesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useTradingTradeListTradesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useTradingTradeListTrades<
  TData = Awaited<ReturnType<ReturnType<typeof useTradingTradeListTradesHook>>>,
  TError = unknown,
>(
  params?: TradingTradeListTradesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingTradeListTradesHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List the authenticated customer's executed trades (live)
 */

export function useTradingTradeListTrades<
  TData = Awaited<ReturnType<ReturnType<typeof useTradingTradeListTradesHook>>>,
  TError = unknown,
>(
  params?: TradingTradeListTradesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useTradingTradeListTradesHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useTradingTradeListTradesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get the current user profile
 */
export const useUsersGetMeHook = () => {
  const usersGetMe = useCustomInstance<UserProfileDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return usersGetMe({ url: `/users/me`, method: 'GET', signal });
    },
    [usersGetMe],
  );
};

export const getUsersGetMeQueryKey = () => {
  return [`/users/me`] as const;
};

export const useUsersGetMeQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useUsersGetMeHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useUsersGetMeHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUsersGetMeQueryKey();

  const usersGetMe = useUsersGetMeHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useUsersGetMeHook>>>> = ({ signal }) =>
    usersGetMe(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useUsersGetMeHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type UsersGetMeQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUsersGetMeHook>>>>;
export type UsersGetMeQueryError = unknown;

export function useUsersGetMe<TData = Awaited<ReturnType<ReturnType<typeof useUsersGetMeHook>>>, TError = unknown>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useUsersGetMeHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useUsersGetMeHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useUsersGetMeHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUsersGetMe<TData = Awaited<ReturnType<ReturnType<typeof useUsersGetMeHook>>>, TError = unknown>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useUsersGetMeHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useUsersGetMeHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useUsersGetMeHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useUsersGetMe<TData = Awaited<ReturnType<ReturnType<typeof useUsersGetMeHook>>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useUsersGetMeHook>>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the current user profile
 */

export function useUsersGetMe<TData = Awaited<ReturnType<ReturnType<typeof useUsersGetMeHook>>>, TError = unknown>(
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useUsersGetMeHook>>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useUsersGetMeQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update the current user friendly username
 */
export const useUsersUpdateMeHook = () => {
  const usersUpdateMe = useCustomInstance<UserProfileDto>();

  return useCallback(
    (updateUsernameDto: UpdateUsernameDto) => {
      return usersUpdateMe({
        url: `/users/me`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateUsernameDto,
      });
    },
    [usersUpdateMe],
  );
};

export const useUsersUpdateMeMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUsersUpdateMeHook>>>,
    TError,
    { data: UpdateUsernameDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUsersUpdateMeHook>>>,
  TError,
  { data: UpdateUsernameDto },
  TContext
> => {
  const mutationKey = ['usersUpdateMe'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const usersUpdateMe = useUsersUpdateMeHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUsersUpdateMeHook>>>,
    { data: UpdateUsernameDto }
  > = (props) => {
    const { data } = props ?? {};

    return usersUpdateMe(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersUpdateMeMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUsersUpdateMeHook>>>>;
export type UsersUpdateMeMutationBody = UpdateUsernameDto;
export type UsersUpdateMeMutationError = void;

/**
 * @summary Update the current user friendly username
 */
export const useUsersUpdateMe = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useUsersUpdateMeHook>>>,
      TError,
      { data: UpdateUsernameDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useUsersUpdateMeHook>>>,
  TError,
  { data: UpdateUsernameDto },
  TContext
> => {
  const mutationOptions = useUsersUpdateMeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Stamp that the FTUE was first shown (idempotent — first write wins)
 */
export const useUsersMarkFtueInitiatedHook = () => {
  const usersMarkFtueInitiated = useCustomInstance<UserProfileDto>();

  return useCallback(() => {
    return usersMarkFtueInitiated({ url: `/users/me/ftue-initiated`, method: 'PUT' });
  }, [usersMarkFtueInitiated]);
};

export const useUsersMarkFtueInitiatedMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUsersMarkFtueInitiatedHook>>>,
    TError,
    void,
    TContext
  >;
}): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUsersMarkFtueInitiatedHook>>>, TError, void, TContext> => {
  const mutationKey = ['usersMarkFtueInitiated'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const usersMarkFtueInitiated = useUsersMarkFtueInitiatedHook();

  const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUsersMarkFtueInitiatedHook>>>, void> = () => {
    return usersMarkFtueInitiated();
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersMarkFtueInitiatedMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useUsersMarkFtueInitiatedHook>>>
>;

export type UsersMarkFtueInitiatedMutationError = unknown;

/**
 * @summary Stamp that the FTUE was first shown (idempotent — first write wins)
 */
export const useUsersMarkFtueInitiated = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useUsersMarkFtueInitiatedHook>>>,
      TError,
      void,
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useUsersMarkFtueInitiatedHook>>>, TError, void, TContext> => {
  const mutationOptions = useUsersMarkFtueInitiatedMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Record how the one-shot post-signup FTUE resolved (idempotent — first write wins)
 */
export const useUsersSetFtueStateHook = () => {
  const usersSetFtueState = useCustomInstance<UserProfileDto>();

  return useCallback(
    (updateFtueStateDto: UpdateFtueStateDto) => {
      return usersSetFtueState({
        url: `/users/me/ftue-state`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: updateFtueStateDto,
      });
    },
    [usersSetFtueState],
  );
};

export const useUsersSetFtueStateMutationOptions = <TError = void, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUsersSetFtueStateHook>>>,
    TError,
    { data: UpdateFtueStateDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUsersSetFtueStateHook>>>,
  TError,
  { data: UpdateFtueStateDto },
  TContext
> => {
  const mutationKey = ['usersSetFtueState'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const usersSetFtueState = useUsersSetFtueStateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUsersSetFtueStateHook>>>,
    { data: UpdateFtueStateDto }
  > = (props) => {
    const { data } = props ?? {};

    return usersSetFtueState(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type UsersSetFtueStateMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUsersSetFtueStateHook>>>>;
export type UsersSetFtueStateMutationBody = UpdateFtueStateDto;
export type UsersSetFtueStateMutationError = void;

/**
 * @summary Record how the one-shot post-signup FTUE resolved (idempotent — first write wins)
 */
export const useUsersSetFtueState = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useUsersSetFtueStateHook>>>,
      TError,
      { data: UpdateFtueStateDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useUsersSetFtueStateHook>>>,
  TError,
  { data: UpdateFtueStateDto },
  TContext
> => {
  const mutationOptions = useUsersSetFtueStateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List active withdraw methods
 */
export const useWithdrawalListMethodsHook = () => {
  const withdrawalListMethods = useCustomInstance<WithdrawMethodResponseDto[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return withdrawalListMethods({ url: `/withdrawals/methods`, method: 'GET', signal });
    },
    [withdrawalListMethods],
  );
};

export const getWithdrawalListMethodsQueryKey = () => {
  return [`/withdrawals/methods`] as const;
};

export const useWithdrawalListMethodsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useWithdrawalListMethodsHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useWithdrawalListMethodsHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWithdrawalListMethodsQueryKey();

  const withdrawalListMethods = useWithdrawalListMethodsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useWithdrawalListMethodsHook>>>> = ({ signal }) =>
    withdrawalListMethods(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useWithdrawalListMethodsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WithdrawalListMethodsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useWithdrawalListMethodsHook>>>
>;
export type WithdrawalListMethodsQueryError = unknown;

export function useWithdrawalListMethods<
  TData = Awaited<ReturnType<ReturnType<typeof useWithdrawalListMethodsHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useWithdrawalListMethodsHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useWithdrawalListMethodsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useWithdrawalListMethodsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWithdrawalListMethods<
  TData = Awaited<ReturnType<ReturnType<typeof useWithdrawalListMethodsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useWithdrawalListMethodsHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useWithdrawalListMethodsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useWithdrawalListMethodsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWithdrawalListMethods<
  TData = Awaited<ReturnType<ReturnType<typeof useWithdrawalListMethodsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useWithdrawalListMethodsHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List active withdraw methods
 */

export function useWithdrawalListMethods<
  TData = Awaited<ReturnType<ReturnType<typeof useWithdrawalListMethodsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useWithdrawalListMethodsHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useWithdrawalListMethodsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Get the current user wallet balance (the cash available to withdraw)
 */
export const useWithdrawalGetBalanceHook = () => {
  const withdrawalGetBalance = useCustomInstance<WalletBalanceResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return withdrawalGetBalance({ url: `/withdrawals/balance`, method: 'GET', signal });
    },
    [withdrawalGetBalance],
  );
};

export const getWithdrawalGetBalanceQueryKey = () => {
  return [`/withdrawals/balance`] as const;
};

export const useWithdrawalGetBalanceQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useWithdrawalGetBalanceHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useWithdrawalGetBalanceHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWithdrawalGetBalanceQueryKey();

  const withdrawalGetBalance = useWithdrawalGetBalanceHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useWithdrawalGetBalanceHook>>>> = ({ signal }) =>
    withdrawalGetBalance(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useWithdrawalGetBalanceHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WithdrawalGetBalanceQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useWithdrawalGetBalanceHook>>>
>;
export type WithdrawalGetBalanceQueryError = unknown;

export function useWithdrawalGetBalance<
  TData = Awaited<ReturnType<ReturnType<typeof useWithdrawalGetBalanceHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useWithdrawalGetBalanceHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useWithdrawalGetBalanceHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useWithdrawalGetBalanceHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWithdrawalGetBalance<
  TData = Awaited<ReturnType<ReturnType<typeof useWithdrawalGetBalanceHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useWithdrawalGetBalanceHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useWithdrawalGetBalanceHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useWithdrawalGetBalanceHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWithdrawalGetBalance<
  TData = Awaited<ReturnType<ReturnType<typeof useWithdrawalGetBalanceHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useWithdrawalGetBalanceHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the current user wallet balance (the cash available to withdraw)
 */

export function useWithdrawalGetBalance<
  TData = Awaited<ReturnType<ReturnType<typeof useWithdrawalGetBalanceHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useWithdrawalGetBalanceHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useWithdrawalGetBalanceQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Submit a withdrawal request — debits the wallet at submit
 */
export const useWithdrawalCreateHook = () => {
  const withdrawalCreate = useCustomInstance<WithdrawalResponseDto>();

  return useCallback(
    (createWithdrawalDto: CreateWithdrawalDto, signal?: AbortSignal) => {
      return withdrawalCreate({
        url: `/withdrawals`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createWithdrawalDto,
        signal,
      });
    },
    [withdrawalCreate],
  );
};

export const useWithdrawalCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useWithdrawalCreateHook>>>,
    TError,
    { data: CreateWithdrawalDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useWithdrawalCreateHook>>>,
  TError,
  { data: CreateWithdrawalDto },
  TContext
> => {
  const mutationKey = ['withdrawalCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const withdrawalCreate = useWithdrawalCreateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useWithdrawalCreateHook>>>,
    { data: CreateWithdrawalDto }
  > = (props) => {
    const { data } = props ?? {};

    return withdrawalCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WithdrawalCreateMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useWithdrawalCreateHook>>>>;
export type WithdrawalCreateMutationBody = CreateWithdrawalDto;
export type WithdrawalCreateMutationError = unknown;

/**
 * @summary Submit a withdrawal request — debits the wallet at submit
 */
export const useWithdrawalCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useWithdrawalCreateHook>>>,
      TError,
      { data: CreateWithdrawalDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useWithdrawalCreateHook>>>,
  TError,
  { data: CreateWithdrawalDto },
  TContext
> => {
  const mutationOptions = useWithdrawalCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List the current user withdrawals
 */
export const useWithdrawalListHook = () => {
  const withdrawalList = useCustomInstance<WithdrawalResponseDto[]>();

  return useCallback(
    (params?: WithdrawalListParams, signal?: AbortSignal) => {
      return withdrawalList({ url: `/withdrawals`, method: 'GET', params, signal });
    },
    [withdrawalList],
  );
};

export const getWithdrawalListQueryKey = (params?: WithdrawalListParams) => {
  return [`/withdrawals`, ...(params ? [params] : [])] as const;
};

export const useWithdrawalListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useWithdrawalListHook>>>,
  TError = unknown,
>(
  params?: WithdrawalListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useWithdrawalListHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getWithdrawalListQueryKey(params);

  const withdrawalList = useWithdrawalListHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useWithdrawalListHook>>>> = ({ signal }) =>
    withdrawalList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useWithdrawalListHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type WithdrawalListQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useWithdrawalListHook>>>>;
export type WithdrawalListQueryError = unknown;

export function useWithdrawalList<TData = Awaited<ReturnType<ReturnType<typeof useWithdrawalListHook>>>, TError = unknown>(
  params: undefined | WithdrawalListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useWithdrawalListHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useWithdrawalListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useWithdrawalListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWithdrawalList<TData = Awaited<ReturnType<ReturnType<typeof useWithdrawalListHook>>>, TError = unknown>(
  params?: WithdrawalListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useWithdrawalListHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useWithdrawalListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useWithdrawalListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useWithdrawalList<TData = Awaited<ReturnType<ReturnType<typeof useWithdrawalListHook>>>, TError = unknown>(
  params?: WithdrawalListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useWithdrawalListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List the current user withdrawals
 */

export function useWithdrawalList<TData = Awaited<ReturnType<ReturnType<typeof useWithdrawalListHook>>>, TError = unknown>(
  params?: WithdrawalListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useWithdrawalListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useWithdrawalListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Cancel a PENDING withdrawal — refunds the wallet
 */
export const useWithdrawalCancelHook = () => {
  const withdrawalCancel = useCustomInstance<WithdrawalResponseDto>();

  return useCallback(
    (id: string) => {
      return withdrawalCancel({ url: `/withdrawals/${id}`, method: 'DELETE' });
    },
    [withdrawalCancel],
  );
};

export const useWithdrawalCancelMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useWithdrawalCancelHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useWithdrawalCancelHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['withdrawalCancel'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const withdrawalCancel = useWithdrawalCancelHook();

  const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useWithdrawalCancelHook>>>, { id: string }> = (
    props,
  ) => {
    const { id } = props ?? {};

    return withdrawalCancel(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type WithdrawalCancelMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useWithdrawalCancelHook>>>>;

export type WithdrawalCancelMutationError = unknown;

/**
 * @summary Cancel a PENDING withdrawal — refunds the wallet
 */
export const useWithdrawalCancel = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useWithdrawalCancelHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useWithdrawalCancelHook>>>, TError, { id: string }, TContext> => {
  const mutationOptions = useWithdrawalCancelMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Mint a Pay.com setup session so the SDK can tokenize a new withdrawal method. Cards live in Pay.com's vault — same source the deposit flow reads from. Pass `paymentMethodType: 'us_bank_account'` for the Plaid bank-account flow.
 */
export const useWithdrawalCreateSetupSessionHook = () => {
  const withdrawalCreateSetupSession = useCustomInstance<WithdrawalSetupSessionResponseDto>();

  return useCallback(
    (createWithdrawalSetupSessionDto: CreateWithdrawalSetupSessionDto, signal?: AbortSignal) => {
      return withdrawalCreateSetupSession({
        url: `/withdrawals/setup-session`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createWithdrawalSetupSessionDto,
        signal,
      });
    },
    [withdrawalCreateSetupSession],
  );
};

export const useWithdrawalCreateSetupSessionMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useWithdrawalCreateSetupSessionHook>>>,
    TError,
    { data: CreateWithdrawalSetupSessionDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useWithdrawalCreateSetupSessionHook>>>,
  TError,
  { data: CreateWithdrawalSetupSessionDto },
  TContext
> => {
  const mutationKey = ['withdrawalCreateSetupSession'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const withdrawalCreateSetupSession = useWithdrawalCreateSetupSessionHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useWithdrawalCreateSetupSessionHook>>>,
    { data: CreateWithdrawalSetupSessionDto }
  > = (props) => {
    const { data } = props ?? {};

    return withdrawalCreateSetupSession(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type WithdrawalCreateSetupSessionMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useWithdrawalCreateSetupSessionHook>>>
>;
export type WithdrawalCreateSetupSessionMutationBody = CreateWithdrawalSetupSessionDto;
export type WithdrawalCreateSetupSessionMutationError = unknown;

/**
 * @summary Mint a Pay.com setup session so the SDK can tokenize a new withdrawal method. Cards live in Pay.com's vault — same source the deposit flow reads from. Pass `paymentMethodType: 'us_bank_account'` for the Plaid bank-account flow.
 */
export const useWithdrawalCreateSetupSession = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useWithdrawalCreateSetupSessionHook>>>,
      TError,
      { data: CreateWithdrawalSetupSessionDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useWithdrawalCreateSetupSessionHook>>>,
  TError,
  { data: CreateWithdrawalSetupSessionDto },
  TContext
> => {
  const mutationOptions = useWithdrawalCreateSetupSessionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * Unified surface items built on the new assignment/variation/reward model. GIFT → gift set; OFFER → offer.options set; MESSAGE → both null. Powers the monetization bar.
 * @summary Return the monetization items currently deliverable to the current player (monetization bar)
 */
export const useMonetizationSurfacesHook = () => {
  const monetizationSurfaces = useCustomInstance<SurfaceItemDto[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return monetizationSurfaces({ url: `/monetization/surfaces`, method: 'GET', signal });
    },
    [monetizationSurfaces],
  );
};

export const getMonetizationSurfacesQueryKey = () => {
  return [`/monetization/surfaces`] as const;
};

export const useMonetizationSurfacesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useMonetizationSurfacesHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMonetizationSurfacesHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMonetizationSurfacesQueryKey();

  const monetizationSurfaces = useMonetizationSurfacesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useMonetizationSurfacesHook>>>> = ({ signal }) =>
    monetizationSurfaces(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useMonetizationSurfacesHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type MonetizationSurfacesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useMonetizationSurfacesHook>>>
>;
export type MonetizationSurfacesQueryError = unknown;

export function useMonetizationSurfaces<
  TData = Awaited<ReturnType<ReturnType<typeof useMonetizationSurfacesHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMonetizationSurfacesHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useMonetizationSurfacesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useMonetizationSurfacesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMonetizationSurfaces<
  TData = Awaited<ReturnType<ReturnType<typeof useMonetizationSurfacesHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMonetizationSurfacesHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useMonetizationSurfacesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useMonetizationSurfacesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMonetizationSurfaces<
  TData = Awaited<ReturnType<ReturnType<typeof useMonetizationSurfacesHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMonetizationSurfacesHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Return the monetization items currently deliverable to the current player (monetization bar)
 */

export function useMonetizationSurfaces<
  TData = Awaited<ReturnType<ReturnType<typeof useMonetizationSurfacesHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMonetizationSurfacesHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useMonetizationSurfacesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * The same items as /monetization/surfaces, filtered to type === 'OFFER'. Reuses the identical OFFER object shape so the deposit screen and the monetization bar render from the same objects.
 * @summary Return the deliverable OFFER surface items for the current player (deposit screen)
 */
export const useMonetizationDepositOffersHook = () => {
  const monetizationDepositOffers = useCustomInstance<SurfaceItemDto[]>();

  return useCallback(
    (signal?: AbortSignal) => {
      return monetizationDepositOffers({ url: `/monetization/surfaces/deposit-offers`, method: 'GET', signal });
    },
    [monetizationDepositOffers],
  );
};

export const getMonetizationDepositOffersQueryKey = () => {
  return [`/monetization/surfaces/deposit-offers`] as const;
};

export const useMonetizationDepositOffersQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useMonetizationDepositOffersHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMonetizationDepositOffersHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getMonetizationDepositOffersQueryKey();

  const monetizationDepositOffers = useMonetizationDepositOffersHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useMonetizationDepositOffersHook>>>> = ({ signal }) =>
    monetizationDepositOffers(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useMonetizationDepositOffersHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type MonetizationDepositOffersQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useMonetizationDepositOffersHook>>>
>;
export type MonetizationDepositOffersQueryError = unknown;

export function useMonetizationDepositOffers<
  TData = Awaited<ReturnType<ReturnType<typeof useMonetizationDepositOffersHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMonetizationDepositOffersHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useMonetizationDepositOffersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useMonetizationDepositOffersHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMonetizationDepositOffers<
  TData = Awaited<ReturnType<ReturnType<typeof useMonetizationDepositOffersHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMonetizationDepositOffersHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useMonetizationDepositOffersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useMonetizationDepositOffersHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useMonetizationDepositOffers<
  TData = Awaited<ReturnType<ReturnType<typeof useMonetizationDepositOffersHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMonetizationDepositOffersHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Return the deliverable OFFER surface items for the current player (deposit screen)
 */

export function useMonetizationDepositOffers<
  TData = Awaited<ReturnType<ReturnType<typeof useMonetizationDepositOffersHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useMonetizationDepositOffersHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useMonetizationDepositOffersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Record that the player has seen this experience (idempotent on clientEventId)
 */
export const useMonetizationRecordImpressionHook = () => {
  const monetizationRecordImpression = useCustomInstance<UserExperienceStateDto>();

  return useCallback(
    (id: string, recordImpressionDto: RecordImpressionDto, signal?: AbortSignal) => {
      return monetizationRecordImpression({
        url: `/monetization/experiences/${id}/impressions`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: recordImpressionDto,
        signal,
      });
    },
    [monetizationRecordImpression],
  );
};

export const useMonetizationRecordImpressionMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useMonetizationRecordImpressionHook>>>,
    TError,
    { id: string; data: RecordImpressionDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useMonetizationRecordImpressionHook>>>,
  TError,
  { id: string; data: RecordImpressionDto },
  TContext
> => {
  const mutationKey = ['monetizationRecordImpression'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const monetizationRecordImpression = useMonetizationRecordImpressionHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useMonetizationRecordImpressionHook>>>,
    { id: string; data: RecordImpressionDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return monetizationRecordImpression(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type MonetizationRecordImpressionMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useMonetizationRecordImpressionHook>>>
>;
export type MonetizationRecordImpressionMutationBody = RecordImpressionDto;
export type MonetizationRecordImpressionMutationError = unknown;

/**
 * @summary Record that the player has seen this experience (idempotent on clientEventId)
 */
export const useMonetizationRecordImpression = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useMonetizationRecordImpressionHook>>>,
      TError,
      { id: string; data: RecordImpressionDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useMonetizationRecordImpressionHook>>>,
  TError,
  { id: string; data: RecordImpressionDto },
  TContext
> => {
  const mutationOptions = useMonetizationRecordImpressionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * When `actionType === 'claim'` on a GIFT experience, the api re-resolves the player's variation, loads its 1:1 GiftReward, and mints scoped/expiring cash-back inside a single transaction. Other action types record the event without moving money.
 * @summary Record a player action (CTA click / claim) — idempotent on clientEventId
 */
export const useMonetizationRecordActionHook = () => {
  const monetizationRecordAction = useCustomInstance<UserExperienceStateDto>();

  return useCallback(
    (id: string, recordActionDto: RecordActionDto, signal?: AbortSignal) => {
      return monetizationRecordAction({
        url: `/monetization/experiences/${id}/actions`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: recordActionDto,
        signal,
      });
    },
    [monetizationRecordAction],
  );
};

export const useMonetizationRecordActionMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useMonetizationRecordActionHook>>>,
    TError,
    { id: string; data: RecordActionDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useMonetizationRecordActionHook>>>,
  TError,
  { id: string; data: RecordActionDto },
  TContext
> => {
  const mutationKey = ['monetizationRecordAction'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const monetizationRecordAction = useMonetizationRecordActionHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useMonetizationRecordActionHook>>>,
    { id: string; data: RecordActionDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return monetizationRecordAction(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type MonetizationRecordActionMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useMonetizationRecordActionHook>>>
>;
export type MonetizationRecordActionMutationBody = RecordActionDto;
export type MonetizationRecordActionMutationError = unknown;

/**
 * @summary Record a player action (CTA click / claim) — idempotent on clientEventId
 */
export const useMonetizationRecordAction = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useMonetizationRecordActionHook>>>,
      TError,
      { id: string; data: RecordActionDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useMonetizationRecordActionHook>>>,
  TError,
  { id: string; data: RecordActionDto },
  TContext
> => {
  const mutationOptions = useMonetizationRecordActionMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * UNAUTHENTICATED. Returns the ordered, slot-pinned, capped set of ACTIVE, in-window banners for the requested surface, resolved against a zero-PII anonymous LaunchDarkly context. NEVER accepts a userId — a signed-in player uses GET /banners/lobby instead. Only banner data is ever returned; any resolution error yields an empty list. Query params (other than `surface`) are passed through solely to satisfy a banner's lander query-param condition. Work is bounded by the global banner cap.
 * @summary Resolve message-page banners for a GUEST (pre-auth) visitor
 */
export const useBannerBannersHook = () => {
  const bannerBanners = useCustomInstance<BannersResponseDto>();

  return useCallback(
    (params?: BannerBannersParams, signal?: AbortSignal) => {
      return bannerBanners({ url: `/banners`, method: 'GET', params, signal });
    },
    [bannerBanners],
  );
};

export const getBannerBannersQueryKey = (params?: BannerBannersParams) => {
  return [`/banners`, ...(params ? [params] : [])] as const;
};

export const useBannerBannersQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useBannerBannersHook>>>,
  TError = unknown,
>(
  params?: BannerBannersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useBannerBannersHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBannerBannersQueryKey(params);

  const bannerBanners = useBannerBannersHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useBannerBannersHook>>>> = ({ signal }) =>
    bannerBanners(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useBannerBannersHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BannerBannersQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useBannerBannersHook>>>>;
export type BannerBannersQueryError = unknown;

export function useBannerBanners<TData = Awaited<ReturnType<ReturnType<typeof useBannerBannersHook>>>, TError = unknown>(
  params: undefined | BannerBannersParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useBannerBannersHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useBannerBannersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useBannerBannersHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBannerBanners<TData = Awaited<ReturnType<ReturnType<typeof useBannerBannersHook>>>, TError = unknown>(
  params?: BannerBannersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useBannerBannersHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useBannerBannersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useBannerBannersHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBannerBanners<TData = Awaited<ReturnType<ReturnType<typeof useBannerBannersHook>>>, TError = unknown>(
  params?: BannerBannersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useBannerBannersHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Resolve message-page banners for a GUEST (pre-auth) visitor
 */

export function useBannerBanners<TData = Awaited<ReturnType<ReturnType<typeof useBannerBannersHook>>>, TError = unknown>(
  params?: BannerBannersParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useBannerBannersHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useBannerBannersQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Authed variant of GET /banners: resolves LOBBY banners against the player's own LaunchDarkly context (personalised targeting). Reuses the same shared resolver as the guest endpoint. Query params never gate LOBBY banners.
 * @summary Resolve LOBBY message-page banners for the signed-in player
 */
export const useBannerLobbyBannersHook = () => {
  const bannerLobbyBanners = useCustomInstance<BannersResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return bannerLobbyBanners({ url: `/banners/lobby`, method: 'GET', signal });
    },
    [bannerLobbyBanners],
  );
};

export const getBannerLobbyBannersQueryKey = () => {
  return [`/banners/lobby`] as const;
};

export const useBannerLobbyBannersQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useBannerLobbyBannersHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useBannerLobbyBannersHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBannerLobbyBannersQueryKey();

  const bannerLobbyBanners = useBannerLobbyBannersHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useBannerLobbyBannersHook>>>> = ({ signal }) =>
    bannerLobbyBanners(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useBannerLobbyBannersHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BannerLobbyBannersQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useBannerLobbyBannersHook>>>>;
export type BannerLobbyBannersQueryError = unknown;

export function useBannerLobbyBanners<
  TData = Awaited<ReturnType<ReturnType<typeof useBannerLobbyBannersHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useBannerLobbyBannersHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useBannerLobbyBannersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useBannerLobbyBannersHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBannerLobbyBanners<
  TData = Awaited<ReturnType<ReturnType<typeof useBannerLobbyBannersHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useBannerLobbyBannersHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useBannerLobbyBannersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useBannerLobbyBannersHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBannerLobbyBanners<
  TData = Awaited<ReturnType<ReturnType<typeof useBannerLobbyBannersHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useBannerLobbyBannersHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Resolve LOBBY message-page banners for the signed-in player
 */

export function useBannerLobbyBanners<
  TData = Awaited<ReturnType<ReturnType<typeof useBannerLobbyBannersHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useBannerLobbyBannersHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useBannerLobbyBannersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List banner message pages (optionally filtered by status / surface)
 */
export const useBannerAdminListHook = () => {
  const bannerAdminList = useCustomInstance<AdminBannerDto[]>();

  return useCallback(
    (params?: BannerAdminListParams, signal?: AbortSignal) => {
      return bannerAdminList({ url: `/admin/banners`, method: 'GET', params, signal });
    },
    [bannerAdminList],
  );
};

export const getBannerAdminListQueryKey = (params?: BannerAdminListParams) => {
  return [`/admin/banners`, ...(params ? [params] : [])] as const;
};

export const useBannerAdminListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useBannerAdminListHook>>>,
  TError = unknown,
>(
  params?: BannerAdminListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useBannerAdminListHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBannerAdminListQueryKey(params);

  const bannerAdminList = useBannerAdminListHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useBannerAdminListHook>>>> = ({ signal }) =>
    bannerAdminList(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useBannerAdminListHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BannerAdminListQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useBannerAdminListHook>>>>;
export type BannerAdminListQueryError = unknown;

export function useBannerAdminList<TData = Awaited<ReturnType<ReturnType<typeof useBannerAdminListHook>>>, TError = unknown>(
  params: undefined | BannerAdminListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useBannerAdminListHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useBannerAdminListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useBannerAdminListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBannerAdminList<TData = Awaited<ReturnType<ReturnType<typeof useBannerAdminListHook>>>, TError = unknown>(
  params?: BannerAdminListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useBannerAdminListHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useBannerAdminListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useBannerAdminListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBannerAdminList<TData = Awaited<ReturnType<ReturnType<typeof useBannerAdminListHook>>>, TError = unknown>(
  params?: BannerAdminListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useBannerAdminListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List banner message pages (optionally filtered by status / surface)
 */

export function useBannerAdminList<TData = Awaited<ReturnType<ReturnType<typeof useBannerAdminListHook>>>, TError = unknown>(
  params?: BannerAdminListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useBannerAdminListHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useBannerAdminListQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create a banner (INACTIVE). Provisions + applies LD segment targeting when segmentKeys are supplied.
 */
export const useBannerAdminCreateHook = () => {
  const bannerAdminCreate = useCustomInstance<AdminBannerDto>();

  return useCallback(
    (createBannerDto: CreateBannerDto, signal?: AbortSignal) => {
      return bannerAdminCreate({
        url: `/admin/banners`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createBannerDto,
        signal,
      });
    },
    [bannerAdminCreate],
  );
};

export const useBannerAdminCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useBannerAdminCreateHook>>>,
    TError,
    { data: CreateBannerDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useBannerAdminCreateHook>>>,
  TError,
  { data: CreateBannerDto },
  TContext
> => {
  const mutationKey = ['bannerAdminCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const bannerAdminCreate = useBannerAdminCreateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useBannerAdminCreateHook>>>,
    { data: CreateBannerDto }
  > = (props) => {
    const { data } = props ?? {};

    return bannerAdminCreate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BannerAdminCreateMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useBannerAdminCreateHook>>>>;
export type BannerAdminCreateMutationBody = CreateBannerDto;
export type BannerAdminCreateMutationError = unknown;

/**
 * @summary Create a banner (INACTIVE). Provisions + applies LD segment targeting when segmentKeys are supplied.
 */
export const useBannerAdminCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useBannerAdminCreateHook>>>,
      TError,
      { data: CreateBannerDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useBannerAdminCreateHook>>>,
  TError,
  { data: CreateBannerDto },
  TContext
> => {
  const mutationOptions = useBannerAdminCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get the global banner cap
 */
export const useBannerAdminGetConfigHook = () => {
  const bannerAdminGetConfig = useCustomInstance<BannerConfigResponseDto>();

  return useCallback(
    (signal?: AbortSignal) => {
      return bannerAdminGetConfig({ url: `/admin/banners/config`, method: 'GET', signal });
    },
    [bannerAdminGetConfig],
  );
};

export const getBannerAdminGetConfigQueryKey = () => {
  return [`/admin/banners/config`] as const;
};

export const useBannerAdminGetConfigQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useBannerAdminGetConfigHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useBannerAdminGetConfigHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBannerAdminGetConfigQueryKey();

  const bannerAdminGetConfig = useBannerAdminGetConfigHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useBannerAdminGetConfigHook>>>> = ({ signal }) =>
    bannerAdminGetConfig(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useBannerAdminGetConfigHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BannerAdminGetConfigQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useBannerAdminGetConfigHook>>>
>;
export type BannerAdminGetConfigQueryError = unknown;

export function useBannerAdminGetConfig<
  TData = Awaited<ReturnType<ReturnType<typeof useBannerAdminGetConfigHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useBannerAdminGetConfigHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useBannerAdminGetConfigHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useBannerAdminGetConfigHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBannerAdminGetConfig<
  TData = Awaited<ReturnType<ReturnType<typeof useBannerAdminGetConfigHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useBannerAdminGetConfigHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useBannerAdminGetConfigHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useBannerAdminGetConfigHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBannerAdminGetConfig<
  TData = Awaited<ReturnType<ReturnType<typeof useBannerAdminGetConfigHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useBannerAdminGetConfigHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the global banner cap
 */

export function useBannerAdminGetConfig<
  TData = Awaited<ReturnType<ReturnType<typeof useBannerAdminGetConfigHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useBannerAdminGetConfigHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useBannerAdminGetConfigQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Set the global banner cap
 */
export const useBannerAdminUpdateConfigHook = () => {
  const bannerAdminUpdateConfig = useCustomInstance<BannerConfigResponseDto>();

  return useCallback(
    (updateBannerConfigDto: UpdateBannerConfigDto) => {
      return bannerAdminUpdateConfig({
        url: `/admin/banners/config`,
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        data: updateBannerConfigDto,
      });
    },
    [bannerAdminUpdateConfig],
  );
};

export const useBannerAdminUpdateConfigMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useBannerAdminUpdateConfigHook>>>,
    TError,
    { data: UpdateBannerConfigDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useBannerAdminUpdateConfigHook>>>,
  TError,
  { data: UpdateBannerConfigDto },
  TContext
> => {
  const mutationKey = ['bannerAdminUpdateConfig'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const bannerAdminUpdateConfig = useBannerAdminUpdateConfigHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useBannerAdminUpdateConfigHook>>>,
    { data: UpdateBannerConfigDto }
  > = (props) => {
    const { data } = props ?? {};

    return bannerAdminUpdateConfig(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BannerAdminUpdateConfigMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useBannerAdminUpdateConfigHook>>>
>;
export type BannerAdminUpdateConfigMutationBody = UpdateBannerConfigDto;
export type BannerAdminUpdateConfigMutationError = unknown;

/**
 * @summary Set the global banner cap
 */
export const useBannerAdminUpdateConfig = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useBannerAdminUpdateConfigHook>>>,
      TError,
      { data: UpdateBannerConfigDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useBannerAdminUpdateConfigHook>>>,
  TError,
  { data: UpdateBannerConfigDto },
  TContext
> => {
  const mutationOptions = useBannerAdminUpdateConfigMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Get a single banner message page
 */
export const useBannerAdminGetHook = () => {
  const bannerAdminGet = useCustomInstance<AdminBannerDto>();

  return useCallback(
    (id: string, signal?: AbortSignal) => {
      return bannerAdminGet({ url: `/admin/banners/${id}`, method: 'GET', signal });
    },
    [bannerAdminGet],
  );
};

export const getBannerAdminGetQueryKey = (id: string) => {
  return [`/admin/banners/${id}`] as const;
};

export const useBannerAdminGetQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useBannerAdminGetHook>>>,
  TError = unknown,
>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useBannerAdminGetHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBannerAdminGetQueryKey(id);

  const bannerAdminGet = useBannerAdminGetHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useBannerAdminGetHook>>>> = ({ signal }) =>
    bannerAdminGet(id, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useBannerAdminGetHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BannerAdminGetQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useBannerAdminGetHook>>>>;
export type BannerAdminGetQueryError = unknown;

export function useBannerAdminGet<TData = Awaited<ReturnType<ReturnType<typeof useBannerAdminGetHook>>>, TError = unknown>(
  id: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useBannerAdminGetHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useBannerAdminGetHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useBannerAdminGetHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBannerAdminGet<TData = Awaited<ReturnType<ReturnType<typeof useBannerAdminGetHook>>>, TError = unknown>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useBannerAdminGetHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useBannerAdminGetHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useBannerAdminGetHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBannerAdminGet<TData = Awaited<ReturnType<ReturnType<typeof useBannerAdminGetHook>>>, TError = unknown>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useBannerAdminGetHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get a single banner message page
 */

export function useBannerAdminGet<TData = Awaited<ReturnType<ReturnType<typeof useBannerAdminGetHook>>>, TError = unknown>(
  id: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useBannerAdminGetHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useBannerAdminGetQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update a banner. segmentKeys re-applies LD targeting (non-empty = gate; empty = clear to broadcast; omitted = unchanged).
 */
export const useBannerAdminUpdateHook = () => {
  const bannerAdminUpdate = useCustomInstance<AdminBannerDto>();

  return useCallback(
    (id: string, updateBannerDto: UpdateBannerDto) => {
      return bannerAdminUpdate({
        url: `/admin/banners/${id}`,
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' },
        data: updateBannerDto,
      });
    },
    [bannerAdminUpdate],
  );
};

export const useBannerAdminUpdateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useBannerAdminUpdateHook>>>,
    TError,
    { id: string; data: UpdateBannerDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useBannerAdminUpdateHook>>>,
  TError,
  { id: string; data: UpdateBannerDto },
  TContext
> => {
  const mutationKey = ['bannerAdminUpdate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const bannerAdminUpdate = useBannerAdminUpdateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useBannerAdminUpdateHook>>>,
    { id: string; data: UpdateBannerDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return bannerAdminUpdate(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BannerAdminUpdateMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useBannerAdminUpdateHook>>>>;
export type BannerAdminUpdateMutationBody = UpdateBannerDto;
export type BannerAdminUpdateMutationError = unknown;

/**
 * @summary Update a banner. segmentKeys re-applies LD targeting (non-empty = gate; empty = clear to broadcast; omitted = unchanged).
 */
export const useBannerAdminUpdate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useBannerAdminUpdateHook>>>,
      TError,
      { id: string; data: UpdateBannerDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useBannerAdminUpdateHook>>>,
  TError,
  { id: string; data: UpdateBannerDto },
  TContext
> => {
  const mutationOptions = useBannerAdminUpdateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Delete a banner message page
 */
export const useBannerAdminRemoveHook = () => {
  const bannerAdminRemove = useCustomInstance<void>();

  return useCallback(
    (id: string) => {
      return bannerAdminRemove({ url: `/admin/banners/${id}`, method: 'DELETE' });
    },
    [bannerAdminRemove],
  );
};

export const useBannerAdminRemoveMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useBannerAdminRemoveHook>>>,
    TError,
    { id: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useBannerAdminRemoveHook>>>,
  TError,
  { id: string },
  TContext
> => {
  const mutationKey = ['bannerAdminRemove'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const bannerAdminRemove = useBannerAdminRemoveHook();

  const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useBannerAdminRemoveHook>>>, { id: string }> = (
    props,
  ) => {
    const { id } = props ?? {};

    return bannerAdminRemove(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type BannerAdminRemoveMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useBannerAdminRemoveHook>>>>;

export type BannerAdminRemoveMutationError = unknown;

/**
 * @summary Delete a banner message page
 */
export const useBannerAdminRemove = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useBannerAdminRemoveHook>>>,
      TError,
      { id: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<Awaited<ReturnType<ReturnType<typeof useBannerAdminRemoveHook>>>, TError, { id: string }, TContext> => {
  const mutationOptions = useBannerAdminRemoveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Change a banner's lifecycle status (activate / deactivate / draft)
 */
export const useBannerAdminChangeStatusHook = () => {
  const bannerAdminChangeStatus = useCustomInstance<AdminBannerDto>();

  return useCallback(
    (id: string, changeBannerStatusDto: ChangeBannerStatusDto, signal?: AbortSignal) => {
      return bannerAdminChangeStatus({
        url: `/admin/banners/${id}/status`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: changeBannerStatusDto,
        signal,
      });
    },
    [bannerAdminChangeStatus],
  );
};

export const useBannerAdminChangeStatusMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useBannerAdminChangeStatusHook>>>,
    TError,
    { id: string; data: ChangeBannerStatusDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useBannerAdminChangeStatusHook>>>,
  TError,
  { id: string; data: ChangeBannerStatusDto },
  TContext
> => {
  const mutationKey = ['bannerAdminChangeStatus'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const bannerAdminChangeStatus = useBannerAdminChangeStatusHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useBannerAdminChangeStatusHook>>>,
    { id: string; data: ChangeBannerStatusDto }
  > = (props) => {
    const { id, data } = props ?? {};

    return bannerAdminChangeStatus(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type BannerAdminChangeStatusMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useBannerAdminChangeStatusHook>>>
>;
export type BannerAdminChangeStatusMutationBody = ChangeBannerStatusDto;
export type BannerAdminChangeStatusMutationError = unknown;

/**
 * @summary Change a banner's lifecycle status (activate / deactivate / draft)
 */
export const useBannerAdminChangeStatus = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useBannerAdminChangeStatusHook>>>,
      TError,
      { id: string; data: ChangeBannerStatusDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useBannerAdminChangeStatusHook>>>,
  TError,
  { id: string; data: ChangeBannerStatusDto },
  TContext
> => {
  const mutationOptions = useBannerAdminChangeStatusMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Assign a GIFT experience to a user (FLOW assign contract)
 */
export const useLiveOpsAssignGiftHook = () => {
  const liveOpsAssignGift = useCustomInstance<void>();

  return useCallback(
    (assignExperienceDto: AssignExperienceDto, signal?: AbortSignal) => {
      return liveOpsAssignGift({
        url: `/live-ops/assign-gift`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: assignExperienceDto,
        signal,
      });
    },
    [liveOpsAssignGift],
  );
};

export const useLiveOpsAssignGiftMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useLiveOpsAssignGiftHook>>>,
    TError,
    { data: AssignExperienceDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useLiveOpsAssignGiftHook>>>,
  TError,
  { data: AssignExperienceDto },
  TContext
> => {
  const mutationKey = ['liveOpsAssignGift'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const liveOpsAssignGift = useLiveOpsAssignGiftHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useLiveOpsAssignGiftHook>>>,
    { data: AssignExperienceDto }
  > = (props) => {
    const { data } = props ?? {};

    return liveOpsAssignGift(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LiveOpsAssignGiftMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useLiveOpsAssignGiftHook>>>>;
export type LiveOpsAssignGiftMutationBody = AssignExperienceDto;
export type LiveOpsAssignGiftMutationError = unknown;

/**
 * @summary Assign a GIFT experience to a user (FLOW assign contract)
 */
export const useLiveOpsAssignGift = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useLiveOpsAssignGiftHook>>>,
      TError,
      { data: AssignExperienceDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useLiveOpsAssignGiftHook>>>,
  TError,
  { data: AssignExperienceDto },
  TContext
> => {
  const mutationOptions = useLiveOpsAssignGiftMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Assign an OFFER experience to a user (FLOW assign contract)
 */
export const useLiveOpsAssignOfferHook = () => {
  const liveOpsAssignOffer = useCustomInstance<void>();

  return useCallback(
    (assignExperienceDto: AssignExperienceDto, signal?: AbortSignal) => {
      return liveOpsAssignOffer({
        url: `/live-ops/assign-offer`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: assignExperienceDto,
        signal,
      });
    },
    [liveOpsAssignOffer],
  );
};

export const useLiveOpsAssignOfferMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useLiveOpsAssignOfferHook>>>,
    TError,
    { data: AssignExperienceDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useLiveOpsAssignOfferHook>>>,
  TError,
  { data: AssignExperienceDto },
  TContext
> => {
  const mutationKey = ['liveOpsAssignOffer'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const liveOpsAssignOffer = useLiveOpsAssignOfferHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useLiveOpsAssignOfferHook>>>,
    { data: AssignExperienceDto }
  > = (props) => {
    const { data } = props ?? {};

    return liveOpsAssignOffer(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LiveOpsAssignOfferMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useLiveOpsAssignOfferHook>>>
>;
export type LiveOpsAssignOfferMutationBody = AssignExperienceDto;
export type LiveOpsAssignOfferMutationError = unknown;

/**
 * @summary Assign an OFFER experience to a user (FLOW assign contract)
 */
export const useLiveOpsAssignOffer = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useLiveOpsAssignOfferHook>>>,
      TError,
      { data: AssignExperienceDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useLiveOpsAssignOfferHook>>>,
  TError,
  { data: AssignExperienceDto },
  TContext
> => {
  const mutationOptions = useLiveOpsAssignOfferMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Assign a MESSAGE experience to a user (FLOW assign contract)
 */
export const useLiveOpsAssignMessageHook = () => {
  const liveOpsAssignMessage = useCustomInstance<void>();

  return useCallback(
    (assignExperienceDto: AssignExperienceDto, signal?: AbortSignal) => {
      return liveOpsAssignMessage({
        url: `/live-ops/assign-message`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: assignExperienceDto,
        signal,
      });
    },
    [liveOpsAssignMessage],
  );
};

export const useLiveOpsAssignMessageMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useLiveOpsAssignMessageHook>>>,
    TError,
    { data: AssignExperienceDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useLiveOpsAssignMessageHook>>>,
  TError,
  { data: AssignExperienceDto },
  TContext
> => {
  const mutationKey = ['liveOpsAssignMessage'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const liveOpsAssignMessage = useLiveOpsAssignMessageHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useLiveOpsAssignMessageHook>>>,
    { data: AssignExperienceDto }
  > = (props) => {
    const { data } = props ?? {};

    return liveOpsAssignMessage(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type LiveOpsAssignMessageMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useLiveOpsAssignMessageHook>>>
>;
export type LiveOpsAssignMessageMutationBody = AssignExperienceDto;
export type LiveOpsAssignMessageMutationError = unknown;

/**
 * @summary Assign a MESSAGE experience to a user (FLOW assign contract)
 */
export const useLiveOpsAssignMessage = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useLiveOpsAssignMessageHook>>>,
      TError,
      { data: AssignExperienceDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useLiveOpsAssignMessageHook>>>,
  TError,
  { data: AssignExperienceDto },
  TContext
> => {
  const mutationOptions = useLiveOpsAssignMessageMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary List assignable GIFT experiences
 */
export const useLiveOpsListGiftsHook = () => {
  const liveOpsListGifts = useCustomInstance<void>();

  return useCallback(
    (signal?: AbortSignal) => {
      return liveOpsListGifts({ url: `/live-ops/gift`, method: 'GET', signal });
    },
    [liveOpsListGifts],
  );
};

export const getLiveOpsListGiftsQueryKey = () => {
  return [`/live-ops/gift`] as const;
};

export const useLiveOpsListGiftsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useLiveOpsListGiftsHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLiveOpsListGiftsHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLiveOpsListGiftsQueryKey();

  const liveOpsListGifts = useLiveOpsListGiftsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useLiveOpsListGiftsHook>>>> = ({ signal }) =>
    liveOpsListGifts(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useLiveOpsListGiftsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LiveOpsListGiftsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useLiveOpsListGiftsHook>>>>;
export type LiveOpsListGiftsQueryError = unknown;

export function useLiveOpsListGifts<
  TData = Awaited<ReturnType<ReturnType<typeof useLiveOpsListGiftsHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLiveOpsListGiftsHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useLiveOpsListGiftsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useLiveOpsListGiftsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLiveOpsListGifts<
  TData = Awaited<ReturnType<ReturnType<typeof useLiveOpsListGiftsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLiveOpsListGiftsHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useLiveOpsListGiftsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useLiveOpsListGiftsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLiveOpsListGifts<
  TData = Awaited<ReturnType<ReturnType<typeof useLiveOpsListGiftsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLiveOpsListGiftsHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List assignable GIFT experiences
 */

export function useLiveOpsListGifts<
  TData = Awaited<ReturnType<ReturnType<typeof useLiveOpsListGiftsHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLiveOpsListGiftsHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useLiveOpsListGiftsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List assignable OFFER experiences
 */
export const useLiveOpsListOffersHook = () => {
  const liveOpsListOffers = useCustomInstance<void>();

  return useCallback(
    (signal?: AbortSignal) => {
      return liveOpsListOffers({ url: `/live-ops/offer`, method: 'GET', signal });
    },
    [liveOpsListOffers],
  );
};

export const getLiveOpsListOffersQueryKey = () => {
  return [`/live-ops/offer`] as const;
};

export const useLiveOpsListOffersQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useLiveOpsListOffersHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLiveOpsListOffersHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLiveOpsListOffersQueryKey();

  const liveOpsListOffers = useLiveOpsListOffersHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useLiveOpsListOffersHook>>>> = ({ signal }) =>
    liveOpsListOffers(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useLiveOpsListOffersHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LiveOpsListOffersQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useLiveOpsListOffersHook>>>>;
export type LiveOpsListOffersQueryError = unknown;

export function useLiveOpsListOffers<
  TData = Awaited<ReturnType<ReturnType<typeof useLiveOpsListOffersHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLiveOpsListOffersHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useLiveOpsListOffersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useLiveOpsListOffersHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLiveOpsListOffers<
  TData = Awaited<ReturnType<ReturnType<typeof useLiveOpsListOffersHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLiveOpsListOffersHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useLiveOpsListOffersHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useLiveOpsListOffersHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLiveOpsListOffers<
  TData = Awaited<ReturnType<ReturnType<typeof useLiveOpsListOffersHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLiveOpsListOffersHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List assignable OFFER experiences
 */

export function useLiveOpsListOffers<
  TData = Awaited<ReturnType<ReturnType<typeof useLiveOpsListOffersHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLiveOpsListOffersHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useLiveOpsListOffersQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary List assignable MESSAGE experiences
 */
export const useLiveOpsListMessagesHook = () => {
  const liveOpsListMessages = useCustomInstance<void>();

  return useCallback(
    (signal?: AbortSignal) => {
      return liveOpsListMessages({ url: `/live-ops/message`, method: 'GET', signal });
    },
    [liveOpsListMessages],
  );
};

export const getLiveOpsListMessagesQueryKey = () => {
  return [`/live-ops/message`] as const;
};

export const useLiveOpsListMessagesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useLiveOpsListMessagesHook>>>,
  TError = unknown,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLiveOpsListMessagesHook>>>, TError, TData>>;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getLiveOpsListMessagesQueryKey();

  const liveOpsListMessages = useLiveOpsListMessagesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useLiveOpsListMessagesHook>>>> = ({ signal }) =>
    liveOpsListMessages(signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useLiveOpsListMessagesHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type LiveOpsListMessagesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useLiveOpsListMessagesHook>>>>;
export type LiveOpsListMessagesQueryError = unknown;

export function useLiveOpsListMessages<
  TData = Awaited<ReturnType<ReturnType<typeof useLiveOpsListMessagesHook>>>,
  TError = unknown,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLiveOpsListMessagesHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useLiveOpsListMessagesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useLiveOpsListMessagesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLiveOpsListMessages<
  TData = Awaited<ReturnType<ReturnType<typeof useLiveOpsListMessagesHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLiveOpsListMessagesHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useLiveOpsListMessagesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useLiveOpsListMessagesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useLiveOpsListMessages<
  TData = Awaited<ReturnType<ReturnType<typeof useLiveOpsListMessagesHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLiveOpsListMessagesHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List assignable MESSAGE experiences
 */

export function useLiveOpsListMessages<
  TData = Awaited<ReturnType<ReturnType<typeof useLiveOpsListMessagesHook>>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useLiveOpsListMessagesHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useLiveOpsListMessagesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Autocomplete suggestions for a partial US address or city
 */
export const useGoogleAddressAutocompleteHook = () => {
  const googleAddressAutocomplete = useCustomInstance<AddressSuggestionsResponseDto>();

  return useCallback(
    (params: GoogleAddressAutocompleteParams, signal?: AbortSignal) => {
      return googleAddressAutocomplete({ url: `/address/autocomplete`, method: 'GET', params, signal });
    },
    [googleAddressAutocomplete],
  );
};

export const getGoogleAddressAutocompleteQueryKey = (params: GoogleAddressAutocompleteParams) => {
  return [`/address/autocomplete`, ...(params ? [params] : [])] as const;
};

export const useGoogleAddressAutocompleteQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGoogleAddressAutocompleteHook>>>,
  TError = unknown,
>(
  params: GoogleAddressAutocompleteParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGoogleAddressAutocompleteHook>>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGoogleAddressAutocompleteQueryKey(params);

  const googleAddressAutocomplete = useGoogleAddressAutocompleteHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGoogleAddressAutocompleteHook>>>> = ({ signal }) =>
    googleAddressAutocomplete(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGoogleAddressAutocompleteHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GoogleAddressAutocompleteQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGoogleAddressAutocompleteHook>>>
>;
export type GoogleAddressAutocompleteQueryError = unknown;

export function useGoogleAddressAutocomplete<
  TData = Awaited<ReturnType<ReturnType<typeof useGoogleAddressAutocompleteHook>>>,
  TError = unknown,
>(
  params: GoogleAddressAutocompleteParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGoogleAddressAutocompleteHook>>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGoogleAddressAutocompleteHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGoogleAddressAutocompleteHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGoogleAddressAutocomplete<
  TData = Awaited<ReturnType<ReturnType<typeof useGoogleAddressAutocompleteHook>>>,
  TError = unknown,
>(
  params: GoogleAddressAutocompleteParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGoogleAddressAutocompleteHook>>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGoogleAddressAutocompleteHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGoogleAddressAutocompleteHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGoogleAddressAutocomplete<
  TData = Awaited<ReturnType<ReturnType<typeof useGoogleAddressAutocompleteHook>>>,
  TError = unknown,
>(
  params: GoogleAddressAutocompleteParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGoogleAddressAutocompleteHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Autocomplete suggestions for a partial US address or city
 */

export function useGoogleAddressAutocomplete<
  TData = Awaited<ReturnType<ReturnType<typeof useGoogleAddressAutocompleteHook>>>,
  TError = unknown,
>(
  params: GoogleAddressAutocompleteParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGoogleAddressAutocompleteHook>>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGoogleAddressAutocompleteQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Resolve a Google place ID to a structured address (street/city/state/zip)
 */
export const useGoogleAddressDetailsHook = () => {
  const googleAddressDetails = useCustomInstance<PlaceDetailsResponseDto>();

  return useCallback(
    (params: GoogleAddressDetailsParams, signal?: AbortSignal) => {
      return googleAddressDetails({ url: `/address/details`, method: 'GET', params, signal });
    },
    [googleAddressDetails],
  );
};

export const getGoogleAddressDetailsQueryKey = (params: GoogleAddressDetailsParams) => {
  return [`/address/details`, ...(params ? [params] : [])] as const;
};

export const useGoogleAddressDetailsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGoogleAddressDetailsHook>>>,
  TError = unknown,
>(
  params: GoogleAddressDetailsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGoogleAddressDetailsHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGoogleAddressDetailsQueryKey(params);

  const googleAddressDetails = useGoogleAddressDetailsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGoogleAddressDetailsHook>>>> = ({ signal }) =>
    googleAddressDetails(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGoogleAddressDetailsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GoogleAddressDetailsQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGoogleAddressDetailsHook>>>
>;
export type GoogleAddressDetailsQueryError = unknown;

export function useGoogleAddressDetails<
  TData = Awaited<ReturnType<ReturnType<typeof useGoogleAddressDetailsHook>>>,
  TError = unknown,
>(
  params: GoogleAddressDetailsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGoogleAddressDetailsHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGoogleAddressDetailsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGoogleAddressDetailsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGoogleAddressDetails<
  TData = Awaited<ReturnType<ReturnType<typeof useGoogleAddressDetailsHook>>>,
  TError = unknown,
>(
  params: GoogleAddressDetailsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGoogleAddressDetailsHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGoogleAddressDetailsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGoogleAddressDetailsHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGoogleAddressDetails<
  TData = Awaited<ReturnType<ReturnType<typeof useGoogleAddressDetailsHook>>>,
  TError = unknown,
>(
  params: GoogleAddressDetailsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGoogleAddressDetailsHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Resolve a Google place ID to a structured address (street/city/state/zip)
 */

export function useGoogleAddressDetails<
  TData = Awaited<ReturnType<ReturnType<typeof useGoogleAddressDetailsHook>>>,
  TError = unknown,
>(
  params: GoogleAddressDetailsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGoogleAddressDetailsHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGoogleAddressDetailsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Resolve a US 5-digit ZIP code to its canonical city and state
 */
export const useGoogleAddressZipLookupHook = () => {
  const googleAddressZipLookup = useCustomInstance<ZipLookupResponseDto>();

  return useCallback(
    (params: GoogleAddressZipLookupParams, signal?: AbortSignal) => {
      return googleAddressZipLookup({ url: `/address/zip-lookup`, method: 'GET', params, signal });
    },
    [googleAddressZipLookup],
  );
};

export const getGoogleAddressZipLookupQueryKey = (params: GoogleAddressZipLookupParams) => {
  return [`/address/zip-lookup`, ...(params ? [params] : [])] as const;
};

export const useGoogleAddressZipLookupQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGoogleAddressZipLookupHook>>>,
  TError = unknown,
>(
  params: GoogleAddressZipLookupParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGoogleAddressZipLookupHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGoogleAddressZipLookupQueryKey(params);

  const googleAddressZipLookup = useGoogleAddressZipLookupHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGoogleAddressZipLookupHook>>>> = ({ signal }) =>
    googleAddressZipLookup(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGoogleAddressZipLookupHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GoogleAddressZipLookupQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGoogleAddressZipLookupHook>>>
>;
export type GoogleAddressZipLookupQueryError = unknown;

export function useGoogleAddressZipLookup<
  TData = Awaited<ReturnType<ReturnType<typeof useGoogleAddressZipLookupHook>>>,
  TError = unknown,
>(
  params: GoogleAddressZipLookupParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGoogleAddressZipLookupHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGoogleAddressZipLookupHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGoogleAddressZipLookupHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGoogleAddressZipLookup<
  TData = Awaited<ReturnType<ReturnType<typeof useGoogleAddressZipLookupHook>>>,
  TError = unknown,
>(
  params: GoogleAddressZipLookupParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGoogleAddressZipLookupHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGoogleAddressZipLookupHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGoogleAddressZipLookupHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGoogleAddressZipLookup<
  TData = Awaited<ReturnType<ReturnType<typeof useGoogleAddressZipLookupHook>>>,
  TError = unknown,
>(
  params: GoogleAddressZipLookupParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGoogleAddressZipLookupHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Resolve a US 5-digit ZIP code to its canonical city and state
 */

export function useGoogleAddressZipLookup<
  TData = Awaited<ReturnType<ReturnType<typeof useGoogleAddressZipLookupHook>>>,
  TError = unknown,
>(
  params: GoogleAddressZipLookupParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGoogleAddressZipLookupHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGoogleAddressZipLookupQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Validate and standardize a US billing address
 */
export const useGoogleAddressValidateHook = () => {
  const googleAddressValidate = useCustomInstance<ValidateAddressResponseDto>();

  return useCallback(
    (validateAddressDto: ValidateAddressDto, signal?: AbortSignal) => {
      return googleAddressValidate({
        url: `/address/validate`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: validateAddressDto,
        signal,
      });
    },
    [googleAddressValidate],
  );
};

export const useGoogleAddressValidateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useGoogleAddressValidateHook>>>,
    TError,
    { data: ValidateAddressDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useGoogleAddressValidateHook>>>,
  TError,
  { data: ValidateAddressDto },
  TContext
> => {
  const mutationKey = ['googleAddressValidate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const googleAddressValidate = useGoogleAddressValidateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useGoogleAddressValidateHook>>>,
    { data: ValidateAddressDto }
  > = (props) => {
    const { data } = props ?? {};

    return googleAddressValidate(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type GoogleAddressValidateMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGoogleAddressValidateHook>>>
>;
export type GoogleAddressValidateMutationBody = ValidateAddressDto;
export type GoogleAddressValidateMutationError = unknown;

/**
 * @summary Validate and standardize a US billing address
 */
export const useGoogleAddressValidate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useGoogleAddressValidateHook>>>,
      TError,
      { data: ValidateAddressDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useGoogleAddressValidateHook>>>,
  TError,
  { data: ValidateAddressDto },
  TContext
> => {
  const mutationOptions = useGoogleAddressValidateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Published footer for a country, falling back to the Default
 */
export const useFooterGetHook = () => {
  const footerGet = useCustomInstance<PublicFooterDto>();

  return useCallback(
    (params?: FooterGetParams, signal?: AbortSignal) => {
      return footerGet({ url: `/footer`, method: 'GET', params, signal });
    },
    [footerGet],
  );
};

export const getFooterGetQueryKey = (params?: FooterGetParams) => {
  return [`/footer`, ...(params ? [params] : [])] as const;
};

export const useFooterGetQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useFooterGetHook>>>, TError = unknown>(
  params?: FooterGetParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFooterGetHook>>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getFooterGetQueryKey(params);

  const footerGet = useFooterGetHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useFooterGetHook>>>> = ({ signal }) =>
    footerGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useFooterGetHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type FooterGetQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useFooterGetHook>>>>;
export type FooterGetQueryError = unknown;

export function useFooterGet<TData = Awaited<ReturnType<ReturnType<typeof useFooterGetHook>>>, TError = unknown>(
  params: undefined | FooterGetParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFooterGetHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useFooterGetHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useFooterGetHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFooterGet<TData = Awaited<ReturnType<ReturnType<typeof useFooterGetHook>>>, TError = unknown>(
  params?: FooterGetParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFooterGetHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useFooterGetHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useFooterGetHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useFooterGet<TData = Awaited<ReturnType<ReturnType<typeof useFooterGetHook>>>, TError = unknown>(
  params?: FooterGetParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFooterGetHook>>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Published footer for a country, falling back to the Default
 */

export function useFooterGet<TData = Awaited<ReturnType<ReturnType<typeof useFooterGetHook>>>, TError = unknown>(
  params?: FooterGetParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useFooterGetHook>>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useFooterGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Published Buy In popup footer for a country, falling back to the Default
 */
export const useBuyInFooterGetHook = () => {
  const buyInFooterGet = useCustomInstance<PublicFooterDto>();

  return useCallback(
    (params?: BuyInFooterGetParams, signal?: AbortSignal) => {
      return buyInFooterGet({ url: `/buy-in-footer`, method: 'GET', params, signal });
    },
    [buyInFooterGet],
  );
};

export const getBuyInFooterGetQueryKey = (params?: BuyInFooterGetParams) => {
  return [`/buy-in-footer`, ...(params ? [params] : [])] as const;
};

export const useBuyInFooterGetQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useBuyInFooterGetHook>>>,
  TError = unknown,
>(
  params?: BuyInFooterGetParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useBuyInFooterGetHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getBuyInFooterGetQueryKey(params);

  const buyInFooterGet = useBuyInFooterGetHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useBuyInFooterGetHook>>>> = ({ signal }) =>
    buyInFooterGet(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useBuyInFooterGetHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type BuyInFooterGetQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useBuyInFooterGetHook>>>>;
export type BuyInFooterGetQueryError = unknown;

export function useBuyInFooterGet<TData = Awaited<ReturnType<ReturnType<typeof useBuyInFooterGetHook>>>, TError = unknown>(
  params: undefined | BuyInFooterGetParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useBuyInFooterGetHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useBuyInFooterGetHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useBuyInFooterGetHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBuyInFooterGet<TData = Awaited<ReturnType<ReturnType<typeof useBuyInFooterGetHook>>>, TError = unknown>(
  params?: BuyInFooterGetParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useBuyInFooterGetHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useBuyInFooterGetHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useBuyInFooterGetHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useBuyInFooterGet<TData = Awaited<ReturnType<ReturnType<typeof useBuyInFooterGetHook>>>, TError = unknown>(
  params?: BuyInFooterGetParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useBuyInFooterGetHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Published Buy In popup footer for a country, falling back to the Default
 */

export function useBuyInFooterGet<TData = Awaited<ReturnType<ReturnType<typeof useBuyInFooterGetHook>>>, TError = unknown>(
  params?: BuyInFooterGetParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useBuyInFooterGetHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useBuyInFooterGetQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Top-level comments on an event, newest first (cursor-paginated, first replies embedded)
 */
export const useCommentsListHook = () => {
  const commentsList = useCustomInstance<CommentListResponseDto>();

  return useCallback(
    (eventId: string, params?: CommentsListParams, signal?: AbortSignal) => {
      return commentsList({ url: `/prediction-market/events/${eventId}/comments`, method: 'GET', params, signal });
    },
    [commentsList],
  );
};

export const getCommentsListQueryKey = (eventId: string, params?: CommentsListParams) => {
  return [`/prediction-market/events/${eventId}/comments`, ...(params ? [params] : [])] as const;
};

export const useCommentsListQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useCommentsListHook>>>,
  TError = unknown,
>(
  eventId: string,
  params?: CommentsListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCommentsListHook>>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCommentsListQueryKey(eventId, params);

  const commentsList = useCommentsListHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useCommentsListHook>>>> = ({ signal }) =>
    commentsList(eventId, params, signal);

  return { queryKey, queryFn, enabled: !!eventId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useCommentsListHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CommentsListQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCommentsListHook>>>>;
export type CommentsListQueryError = unknown;

export function useCommentsList<TData = Awaited<ReturnType<ReturnType<typeof useCommentsListHook>>>, TError = unknown>(
  eventId: string,
  params: undefined | CommentsListParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCommentsListHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useCommentsListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useCommentsListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCommentsList<TData = Awaited<ReturnType<ReturnType<typeof useCommentsListHook>>>, TError = unknown>(
  eventId: string,
  params?: CommentsListParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCommentsListHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useCommentsListHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useCommentsListHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCommentsList<TData = Awaited<ReturnType<ReturnType<typeof useCommentsListHook>>>, TError = unknown>(
  eventId: string,
  params?: CommentsListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCommentsListHook>>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Top-level comments on an event, newest first (cursor-paginated, first replies embedded)
 */

export function useCommentsList<TData = Awaited<ReturnType<ReturnType<typeof useCommentsListHook>>>, TError = unknown>(
  eventId: string,
  params?: CommentsListParams,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCommentsListHook>>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useCommentsListQueryOptions(eventId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Post a comment (or a reply via `parentId`). KYC-gated and rate-limited.
 */
export const useCommentsCreateHook = () => {
  const commentsCreate = useCustomInstance<CommentResponseDto>();

  return useCallback(
    (eventId: string, createCommentDto: CreateCommentDto, signal?: AbortSignal) => {
      return commentsCreate({
        url: `/prediction-market/events/${eventId}/comments`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: createCommentDto,
        signal,
      });
    },
    [commentsCreate],
  );
};

export const useCommentsCreateMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCommentsCreateHook>>>,
    TError,
    { eventId: string; data: CreateCommentDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCommentsCreateHook>>>,
  TError,
  { eventId: string; data: CreateCommentDto },
  TContext
> => {
  const mutationKey = ['commentsCreate'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const commentsCreate = useCommentsCreateHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCommentsCreateHook>>>,
    { eventId: string; data: CreateCommentDto }
  > = (props) => {
    const { eventId, data } = props ?? {};

    return commentsCreate(eventId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CommentsCreateMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCommentsCreateHook>>>>;
export type CommentsCreateMutationBody = CreateCommentDto;
export type CommentsCreateMutationError = unknown;

/**
 * @summary Post a comment (or a reply via `parentId`). KYC-gated and rate-limited.
 */
export const useCommentsCreate = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useCommentsCreateHook>>>,
      TError,
      { eventId: string; data: CreateCommentDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCommentsCreateHook>>>,
  TError,
  { eventId: string; data: CreateCommentDto },
  TContext
> => {
  const mutationOptions = useCommentsCreateMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Replies under a top-level comment, oldest first (cursor-paginated)
 */
export const useCommentsRepliesHook = () => {
  const commentsReplies = useCustomInstance<CommentListResponseDto>();

  return useCallback(
    (commentId: string, params?: CommentsRepliesParams, signal?: AbortSignal) => {
      return commentsReplies({ url: `/prediction-market/comments/${commentId}/replies`, method: 'GET', params, signal });
    },
    [commentsReplies],
  );
};

export const getCommentsRepliesQueryKey = (commentId: string, params?: CommentsRepliesParams) => {
  return [`/prediction-market/comments/${commentId}/replies`, ...(params ? [params] : [])] as const;
};

export const useCommentsRepliesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useCommentsRepliesHook>>>,
  TError = unknown,
>(
  commentId: string,
  params?: CommentsRepliesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCommentsRepliesHook>>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCommentsRepliesQueryKey(commentId, params);

  const commentsReplies = useCommentsRepliesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useCommentsRepliesHook>>>> = ({ signal }) =>
    commentsReplies(commentId, params, signal);

  return { queryKey, queryFn, enabled: !!commentId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useCommentsRepliesHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CommentsRepliesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCommentsRepliesHook>>>>;
export type CommentsRepliesQueryError = unknown;

export function useCommentsReplies<TData = Awaited<ReturnType<ReturnType<typeof useCommentsRepliesHook>>>, TError = unknown>(
  commentId: string,
  params: undefined | CommentsRepliesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCommentsRepliesHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useCommentsRepliesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useCommentsRepliesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCommentsReplies<TData = Awaited<ReturnType<ReturnType<typeof useCommentsRepliesHook>>>, TError = unknown>(
  commentId: string,
  params?: CommentsRepliesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCommentsRepliesHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useCommentsRepliesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useCommentsRepliesHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCommentsReplies<TData = Awaited<ReturnType<ReturnType<typeof useCommentsRepliesHook>>>, TError = unknown>(
  commentId: string,
  params?: CommentsRepliesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCommentsRepliesHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Replies under a top-level comment, oldest first (cursor-paginated)
 */

export function useCommentsReplies<TData = Awaited<ReturnType<ReturnType<typeof useCommentsRepliesHook>>>, TError = unknown>(
  commentId: string,
  params?: CommentsRepliesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCommentsRepliesHook>>>, TError, TData>>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useCommentsRepliesQueryOptions(commentId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Caller's per-event comment state (liked ids + ban) — companion to the public list
 */
export const useCommentsMeHook = () => {
  const commentsMe = useCustomInstance<CommentsMeResponseDto>();

  return useCallback(
    (eventId: string, signal?: AbortSignal) => {
      return commentsMe({ url: `/prediction-market/events/${eventId}/comments/me`, method: 'GET', signal });
    },
    [commentsMe],
  );
};

export const getCommentsMeQueryKey = (eventId: string) => {
  return [`/prediction-market/events/${eventId}/comments/me`] as const;
};

export const useCommentsMeQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useCommentsMeHook>>>,
  TError = unknown,
>(
  eventId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCommentsMeHook>>>, TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getCommentsMeQueryKey(eventId);

  const commentsMe = useCommentsMeHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useCommentsMeHook>>>> = ({ signal }) =>
    commentsMe(eventId, signal);

  return { queryKey, queryFn, enabled: !!eventId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useCommentsMeHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type CommentsMeQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCommentsMeHook>>>>;
export type CommentsMeQueryError = unknown;

export function useCommentsMe<TData = Awaited<ReturnType<ReturnType<typeof useCommentsMeHook>>>, TError = unknown>(
  eventId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCommentsMeHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useCommentsMeHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useCommentsMeHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCommentsMe<TData = Awaited<ReturnType<ReturnType<typeof useCommentsMeHook>>>, TError = unknown>(
  eventId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCommentsMeHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useCommentsMeHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useCommentsMeHook>>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCommentsMe<TData = Awaited<ReturnType<ReturnType<typeof useCommentsMeHook>>>, TError = unknown>(
  eventId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCommentsMeHook>>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Caller's per-event comment state (liked ids + ban) — companion to the public list
 */

export function useCommentsMe<TData = Awaited<ReturnType<ReturnType<typeof useCommentsMeHook>>>, TError = unknown>(
  eventId: string,
  options?: { query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useCommentsMeHook>>>, TError, TData>> },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useCommentsMeQueryOptions(eventId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Soft-delete the caller's own comment
 */
export const useCommentsRemoveHook = () => {
  const commentsRemove = useCustomInstance<void>();

  return useCallback(
    (commentId: string) => {
      return commentsRemove({ url: `/prediction-market/comments/${commentId}`, method: 'DELETE' });
    },
    [commentsRemove],
  );
};

export const useCommentsRemoveMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCommentsRemoveHook>>>,
    TError,
    { commentId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCommentsRemoveHook>>>,
  TError,
  { commentId: string },
  TContext
> => {
  const mutationKey = ['commentsRemove'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const commentsRemove = useCommentsRemoveHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCommentsRemoveHook>>>,
    { commentId: string }
  > = (props) => {
    const { commentId } = props ?? {};

    return commentsRemove(commentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CommentsRemoveMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCommentsRemoveHook>>>>;

export type CommentsRemoveMutationError = unknown;

/**
 * @summary Soft-delete the caller's own comment
 */
export const useCommentsRemove = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useCommentsRemoveHook>>>,
      TError,
      { commentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCommentsRemoveHook>>>,
  TError,
  { commentId: string },
  TContext
> => {
  const mutationOptions = useCommentsRemoveMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Like a comment (idempotent). KYC-gated and rate-limited.
 */
export const useCommentsLikeHook = () => {
  const commentsLike = useCustomInstance<CommentLikeResponseDto>();

  return useCallback(
    (commentId: string) => {
      return commentsLike({ url: `/prediction-market/comments/${commentId}/like`, method: 'PUT' });
    },
    [commentsLike],
  );
};

export const useCommentsLikeMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCommentsLikeHook>>>,
    TError,
    { commentId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCommentsLikeHook>>>,
  TError,
  { commentId: string },
  TContext
> => {
  const mutationKey = ['commentsLike'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const commentsLike = useCommentsLikeHook();

  const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCommentsLikeHook>>>, { commentId: string }> = (
    props,
  ) => {
    const { commentId } = props ?? {};

    return commentsLike(commentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CommentsLikeMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCommentsLikeHook>>>>;

export type CommentsLikeMutationError = unknown;

/**
 * @summary Like a comment (idempotent). KYC-gated and rate-limited.
 */
export const useCommentsLike = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useCommentsLikeHook>>>,
      TError,
      { commentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCommentsLikeHook>>>,
  TError,
  { commentId: string },
  TContext
> => {
  const mutationOptions = useCommentsLikeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Remove a like (idempotent). Rate-limited.
 */
export const useCommentsUnlikeHook = () => {
  const commentsUnlike = useCustomInstance<CommentLikeResponseDto>();

  return useCallback(
    (commentId: string) => {
      return commentsUnlike({ url: `/prediction-market/comments/${commentId}/like`, method: 'DELETE' });
    },
    [commentsUnlike],
  );
};

export const useCommentsUnlikeMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCommentsUnlikeHook>>>,
    TError,
    { commentId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCommentsUnlikeHook>>>,
  TError,
  { commentId: string },
  TContext
> => {
  const mutationKey = ['commentsUnlike'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const commentsUnlike = useCommentsUnlikeHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCommentsUnlikeHook>>>,
    { commentId: string }
  > = (props) => {
    const { commentId } = props ?? {};

    return commentsUnlike(commentId);
  };

  return { mutationFn, ...mutationOptions };
};

export type CommentsUnlikeMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCommentsUnlikeHook>>>>;

export type CommentsUnlikeMutationError = unknown;

/**
 * @summary Remove a like (idempotent). Rate-limited.
 */
export const useCommentsUnlike = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useCommentsUnlikeHook>>>,
      TError,
      { commentId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCommentsUnlikeHook>>>,
  TError,
  { commentId: string },
  TContext
> => {
  const mutationOptions = useCommentsUnlikeMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};

/**
 * @summary Report a comment to moderation. KYC-gated and rate-limited.
 */
export const useCommentsReportHook = () => {
  const commentsReport = useCustomInstance<void>();

  return useCallback(
    (commentId: string, reportCommentDto: ReportCommentDto, signal?: AbortSignal) => {
      return commentsReport({
        url: `/prediction-market/comments/${commentId}/report`,
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        data: reportCommentDto,
        signal,
      });
    },
    [commentsReport],
  );
};

export const useCommentsReportMutationOptions = <TError = unknown, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCommentsReportHook>>>,
    TError,
    { commentId: string; data: ReportCommentDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useCommentsReportHook>>>,
  TError,
  { commentId: string; data: ReportCommentDto },
  TContext
> => {
  const mutationKey = ['commentsReport'];
  const { mutation: mutationOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const commentsReport = useCommentsReportHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useCommentsReportHook>>>,
    { commentId: string; data: ReportCommentDto }
  > = (props) => {
    const { commentId, data } = props ?? {};

    return commentsReport(commentId, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type CommentsReportMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCommentsReportHook>>>>;
export type CommentsReportMutationBody = ReportCommentDto;
export type CommentsReportMutationError = unknown;

/**
 * @summary Report a comment to moderation. KYC-gated and rate-limited.
 */
export const useCommentsReport = <TError = unknown, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<ReturnType<typeof useCommentsReportHook>>>,
      TError,
      { commentId: string; data: ReportCommentDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useCommentsReportHook>>>,
  TError,
  { commentId: string; data: ReportCommentDto },
  TContext
> => {
  const mutationOptions = useCommentsReportMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
